{
 "_": "도구 소스에서 뽑은 정본 DSL. 손으로 고치지 않는다 — node scripts/dsl/build-all.mjs 로 다시 뽑는다.",
 "builtAt": "2026-10-22",
 "sources": {
  "math2d": "/root/dev/git.cemware.com/mathcore/mathcore-api",
  "math3d": "/root/dev/git.cemware.com/mathcore/module/math3d/src/app/math3d/command-manager/commands/object.cmd.ts"
 },
 "exprGrammar": {
  "source": {
   "lexer": "/root/dev/git.cemware.com/mathcore/module/mathcore/packages/expression/src/main/lexer.ts",
   "parser": "/root/dev/git.cemware.com/mathcore/module/mathcore/packages/expression/src/main/math-expression.ts",
   "nodes": [
    "nodes-basic.ts",
    "nodes-exponential.ts",
    "nodes-logarithm.ts",
    "nodes-trigonometry.ts",
    "nodes.ts"
   ]
  },
  "tokens": [
   {
    "name": "EOF",
    "literal": "special marker for the end of token stream"
   },
   {
    "name": "OR",
    "literal": "'or', '또는'"
   },
   {
    "name": "AND",
    "literal": "'and', '이고'"
   },
   {
    "name": "DECIMAL_NUMBER",
    "literal": "'123.456'"
   },
   {
    "name": "PI",
    "literal": "\\pi"
   },
   {
    "name": "IDENTIFIER",
    "literal": "starts with alpha and optionally followed by underscore for subscripts"
   },
   {
    "name": "LATEX_FRAC",
    "literal": "'\\frac"
   },
   {
    "name": "LATEX_SQRT",
    "literal": "'\\sqrt'"
   },
   {
    "name": "LATEX_INTEGRAL",
    "literal": "'\\int'"
   },
   {
    "name": "OPENING_BRACE",
    "literal": "'{'"
   },
   {
    "name": "CLOSING_BRACE",
    "literal": "'}'"
   },
   {
    "name": "OPENING_PAREN",
    "literal": "'('"
   },
   {
    "name": "CLOSING_PAREN",
    "literal": "')'"
   },
   {
    "name": "OPENING_VERT_BAR",
    "literal": "'left|'"
   },
   {
    "name": "CLOSING_VERT_BAR",
    "literal": "'right|'"
   },
   {
    "name": "RAW_VERT_BAR",
    "literal": "'|'"
   },
   {
    "name": "EQUAL",
    "literal": "'='"
   },
   {
    "name": "GREATER",
    "literal": "'>'"
   },
   {
    "name": "LESS",
    "literal": "'<'"
   },
   {
    "name": "GREATER_OR_EQUAL",
    "literal": "'>='"
   },
   {
    "name": "LESS_OR_EQUAL",
    "literal": "'<='"
   },
   {
    "name": "COMMA",
    "literal": "','"
   },
   {
    "name": "UNDERSCORE",
    "literal": "'_'"
   },
   {
    "name": "HAT",
    "literal": "'^'"
   },
   {
    "name": "PLUS",
    "literal": "'+'"
   },
   {
    "name": "MINUS",
    "literal": "'-'"
   },
   {
    "name": "MULTIPLY",
    "literal": "'*'"
   },
   {
    "name": "DIVIDE",
    "literal": "'/'"
   },
   {
    "name": "PRIME",
    "literal": "'\\prime'"
   },
   {
    "name": "DIFFERENTIAL_D",
    "literal": "'\\differentialD'"
   }
  ],
  "commands": [
   "and",
   "arccos",
   "arcsin",
   "arctan",
   "cdot",
   "cos",
   "cosh",
   "cot",
   "csc",
   "differentialD",
   "div",
   "frac",
   "ge",
   "int",
   "le",
   "left",
   "ln",
   "log",
   "mleft",
   "mright",
   "or",
   "pi",
   "prime",
   "right",
   "sec",
   "sin",
   "sinh",
   "sqrt",
   "tan",
   "tanh",
   "times"
  ],
  "keywords": [
   "or",
   "또는",
   "and",
   "이고"
  ],
  "relations": [
   "=",
   ">",
   "<",
   "\\le",
   "\\ge"
  ],
  "conditionList": {
   "open": "{",
   "separator": ",",
   "close": "}",
   "relations": [
    "=",
    ">",
    "<",
    ">=",
    "<="
   ]
  },
  "definiteIntegral": "\\int_{a}^{b} f(x) \\differentialD x",
  "categories": [
   "EMPTY",
   "INVALID",
   "FUNCTION_DEFINITION",
   "DIRECT_PARAMETER_DEFINITION",
   "INDIRECT_PARAMETER_DEFINITION",
   "FUNCTIONAL_EQUATION",
   "GENERIC_EQUATION",
   "FUNCTIONAL_EXPRESSION",
   "IMMEDIATE_EXPRESSION"
  ],
  "nodeKinds": [
   "ACosNode",
   "ASinNode",
   "ATanNode",
   "AbsNode",
   "AddNode",
   "ConditionListNode",
   "ConstantNode",
   "CosNode",
   "CoshNode",
   "CotNode",
   "CscNode",
   "DefiniteIntegralNode",
   "DifferentialFunctionNode",
   "DirectDefiniteIntegralNode",
   "DirectParameterDefinitionNode",
   "DivideNode",
   "FullBoundedConditionNode",
   "FunctionDefinitionNode",
   "FunctionNode",
   "FunctionalEquationNode",
   "FunctionalExpressionNode",
   "GenericEquationNode",
   "HalfBoundedConditionNode",
   "ImmediateExpressionNode",
   "IndirectParameterDefinitionNode",
   "IntegralNode",
   "LnNode",
   "LogNode",
   "MultiplyNode",
   "NegationNode",
   "ParameterNode",
   "PowerNode",
   "SecNode",
   "SinNode",
   "SinhNode",
   "SqrtNode",
   "SubtractNode",
   "TanNode",
   "TanhNode",
   "VariableNode"
  ],
  "functions": [
   "arccos",
   "arcsin",
   "arctan",
   "cos",
   "cosh",
   "cot",
   "csc",
   "e",
   "f",
   "g",
   "h",
   "ln",
   "log",
   "sec",
   "sin",
   "sinh",
   "tan",
   "tanh",
   "x",
   "y"
  ],
  "derivative": "f'(x) 또는 \\prime",
  "absolute": "|x| 또는 \\left| x \\right|",
  "relationsLexer": [
   "=",
   ">",
   "<",
   ">=",
   "<="
  ]
 },
 "counts": {
  "math2d": 69,
  "math3d": 115,
  "unknownTypes": 0,
  "exprCommands": 31,
  "withUsage": 184,
  "usageUnknown": 92
 },
 "commentedOut": {
  "point.lineTracing": "대수 그래프를 대상으로 호출해도 개체를 만들지 못한다(2026-10-16 실측: 대상 3종, 위치 3곳, 이름 있음과 없음 모두 호출이 undefined 를 돌려줌). mathcore 쪽 동작 이상일 가능성이 높아 mathcore 확인 전까지 파이프라인에 알리지 않는다. 곡선 위 점은 point.pointOnObject 로 대신한다",
  "circle.ellipse": "정의대로 호출해도 팩토리가 개체를 돌려주지 않고 개체도 getAllObjects 목록에 보이지 않아 id 로 가리킬 수 없다(2026-10-19 도구별 정상 호출 시험: 받는 종류의 점 셋으로 호출했으나 id 없음). 같은 호출을 되풀이하면 엔진 안에 개체만 늘어난다. 근거 [docs/palette/circle.md]. 타원이 필요하면 점과 대수 식으로 대신한다",
  "circle.chord": "정의대로 호출해도 팩토리가 개체를 돌려주지 않고 요청한 이름의 개체가 화면에 서지 않는다(2026-10-19 도구별 정상 호출 시험: 성공으로 보고됐으나 이름의 개체 없음, 실행기가 보조 점을 주 개체로 오인했음). 근거 [docs/palette/circle.md]. 현은 linear.segment 로 대신한다"
 },
 "acceptsOverride": {
  "linear.tangentLine": {
   "circleID": {
    "accepts": [
     "circle",
     "polynomial",
     "ellipse"
    ],
    "reason": "원뿐 아니라 대수 곡선과 타원도 받는다(부등식은 못 받는다) [src:docs/palette/linear.md:493]"
   },
   "pointIDOrSegmentID": {
    "accepts": [
     "point",
     "linear",
     "axis"
    ],
    "reason": "점이면 지나는 접선, linear 전부와 두 축이면 같은 기울기의 접선이다 [src:docs/palette/linear.md:390]"
   }
  },
  "linear.parallel": {
   "segmentID": {
    "accepts": [
     "linear",
     "axis"
    ],
    "reason": "선분에 한정되지 않고 linear 전부와 두 축을 받는다 [src:docs/palette/linear.md:292]"
   }
  },
  "linear.perpendicular": {
   "linearID": {
    "accepts": [
     "linear",
     "axis"
    ],
    "reason": "linear 전부와 두 축을 받는다 [src:docs/palette/linear.md:510]"
   }
  },
  "linear.vectorFromPoint": {
   "vectorID": {
    "accepts": [
     "vector",
     "linear"
    ],
    "reason": "벡터만이 아니라 좌표가 있는 개체(선분, 직선 등)를 받는다 [src:docs/palette/linear.md:928]"
   }
  },
  "transform.lineSymmetry": {
   "linearID": {
    "accepts": [
     "linear",
     "axis"
    ],
    "reason": "linear 전부와 문자열 0:xAxis, 0:yAxis 를 받는다 [src:docs/palette/polygon-transform.md:262]"
   },
   "originObjectID": {
    "accepts": [
     "point",
     "linear",
     "circle",
     "chord",
     "polygon",
     "ellipse",
     "polynomial"
    ],
    "reason": "원본으로 고를 수 있는 것은 점, 선, 원, 현, 다각형, 타원, 대수 곡선이다. 부등식을 원본으로 주면 화면 스레드가 멈추고 슬라이더와 벡터는 복사본이 서지 않는다 [src:docs/palette/polygon-transform.md:229]"
   }
  },
  "point.intersect": {
   "objectID1": {
    "accepts": [
     "linear",
     "circle",
     "polynomial",
     "ellipse",
     "axis"
    ],
    "reason": "교점이 지원하는 종류는 선, 원, 대수 곡선, 타원, 축이고 다각형, 점, 슬라이더는 undefined 다 [src:docs/palette/algebraric-point.md:355]"
   },
   "objectID2": {
    "accepts": [
     "linear",
     "circle",
     "polynomial",
     "ellipse",
     "axis"
    ],
    "reason": "교점이 지원하는 종류는 선, 원, 대수 곡선, 타원, 축이고 다각형, 점, 슬라이더는 undefined 다 [src:docs/palette/algebraric-point.md:355]"
   }
  },
  "point.pointOnObject": {
   "objectId": {
    "accepts": [
     "circle",
     "linear",
     "polygon",
     "ellipse",
     "polynomial",
     "bezierCurve"
    ],
    "reason": "점과 없는 id 는 undefined 이고 못 쓰는 대상은 무효 개체가 선다 [src:docs/palette/algebraric-point.md:291]"
   }
  },
  "measure.area": {
   "objectID": {
    "accepts": [
     "circle",
     "polygon"
    ],
    "reason": "원(호, 부채꼴, 반원, 활꼴 포함)과 다각형만 받는다. 타원은 세우는 도구가 개체 id 를 돌려주지 않아 대상이 될 수 없고, 선분, 벡터, 점, 곡선은 개체가 서지 않는다. [src:정합성 measure-deco: scripts/pipeline/semantic/measure-deco.mjs 의 '타원은 circle.ellipse 가 id 를 돌려주지 않고 개체 목록에도 없어 넓이를 잴 대상으로 삼을 수 없다', '종류 seg/line/ray/vec/point/curve/nonexist 는 개체가 서지 않는다']"
   }
  },
  "measure.lengthByObjectId": {
   "objectID": {
    "accepts": [
     "linear",
     "circle",
     "polygon"
    ],
    "reason": "선분, 원, 다각형을 받는다. 타원은 id 를 얻을 수 없고 직선과 반직선은 undefined 다 [src:docs/palette/measure-deco.md:115]"
   }
  },
  "circle.compassWithCircle": {
   "circleID": {
    "accepts": [
     "circle",
     "linear"
    ],
    "reason": "원 자리에 선분을 줘도 유효하다(반지름은 선분 길이) [src:docs/palette/circle.md:312]"
   }
  },
  "circle.compassWithSegment": {
   "segmentID": {
    "accepts": [
     "linear",
     "circle"
    ],
    "reason": "선분 자리에 원을 줘도 유효하다(반지름은 원 반지름) [src:docs/palette/circle.md:312]"
   }
  },
  "transform.pointSymmetry": {
   "originObjectID": {
    "accepts": [
     "point",
     "linear",
     "circle",
     "chord",
     "polygon",
     "ellipse",
     "polynomial"
    ],
    "reason": "원본으로 고를 수 있는 것은 점, 선, 원, 현, 다각형, 타원, 대수 곡선이다. 부등식을 원본으로 주면 화면 스레드가 멈추고 슬라이더와 벡터는 복사본이 서지 않는다 [src:docs/palette/polygon-transform.md:229]"
   }
  },
  "transform.rotation": {
   "originObjectID": {
    "accepts": [
     "point",
     "linear",
     "circle",
     "chord",
     "polygon",
     "ellipse",
     "polynomial"
    ],
    "reason": "원본으로 고를 수 있는 것은 점, 선, 원, 현, 다각형, 타원, 대수 곡선이다. 부등식을 원본으로 주면 화면 스레드가 멈추고 슬라이더와 벡터는 복사본이 서지 않는다 [src:docs/palette/polygon-transform.md:229]"
   }
  },
  "transform.translation": {
   "originObjectID": {
    "accepts": [
     "point",
     "linear",
     "circle",
     "chord",
     "polygon",
     "ellipse",
     "polynomial"
    ],
    "reason": "원본으로 고를 수 있는 것은 점, 선, 원, 현, 다각형, 타원, 대수 곡선이다. 부등식을 원본으로 주면 화면 스레드가 멈추고 슬라이더와 벡터는 복사본이 서지 않는다 [src:docs/palette/polygon-transform.md:229]"
   }
  },
  "transform.scale": {
   "originObjectID": {
    "accepts": [
     "point",
     "linear",
     "circle",
     "chord",
     "polygon",
     "ellipse",
     "polynomial"
    ],
    "reason": "원본으로 고를 수 있는 것은 점, 선, 원, 현, 다각형, 타원, 대수 곡선이다. 부등식을 원본으로 주면 화면 스레드가 멈추고 슬라이더와 벡터는 복사본이 서지 않는다 [src:docs/palette/polygon-transform.md:229]"
   }
  },
  "object.addPointOnObject": {
   "referenceID1": {
    "accepts": [
     "linear",
     "plane",
     "circular",
     "sphere",
     "cylindroconical"
    ],
    "reason": "실제 동작으로 확인 [src:정합성 math3d-kinds: scripts/pipeline/kind-matrix3d.mjs 의 시험 object.addPointOnObject 에 장면 개체 종류 조합 22건을 넣어 유효 14건(증거 evidence/runs/2026-10-22/math3d/kind-matrix3d-3.json)]"
   }
  },
  "object.addParallelLine": {
   "referenceID1": {
    "accepts": [
     "linear"
    ],
    "reason": "실제 동작으로 확인 [src:정합성 math3d-kinds: scripts/pipeline/kind-matrix3d.mjs 의 시험 object.addParallelLine 에 장면 개체 종류 조합 22건을 넣어 유효 8건(증거 evidence/runs/2026-10-22/math3d/kind-matrix3d-3.json)]"
   }
  },
  "object.addPerpendicularLine": {
   "referenceID1": {
    "accepts": [
     "linear",
     "plane",
     "circular"
    ],
    "reason": "실제 동작으로 확인 [src:정합성 math3d-kinds: scripts/pipeline/kind-matrix3d.mjs 의 시험 object.addPerpendicularLine 에 장면 개체 종류 조합 22건을 넣어 유효 8건(증거 evidence/runs/2026-10-22/math3d/kind-matrix3d-3.json)]"
   }
  },
  "object.addCircleFromPointAndAxis": {
   "referenceID1": {
    "accepts": [
     "linear"
    ],
    "reason": "실제 동작으로 확인 [src:정합성 math3d-kinds: scripts/pipeline/kind-matrix3d.mjs 의 시험 object.addCircleFromPointAndAxis 에 장면 개체 종류 조합 22건을 넣어 유효 8건(증거 evidence/runs/2026-10-22/math3d/kind-matrix3d-3.json)]"
   }
  },
  "object.addPlaneFromPointAndLinear": {
   "referenceID1": {
    "accepts": [
     "point",
     "linear"
    ],
    "reason": "실제 동작으로 확인 [src:정합성 math3d-kinds: scripts/pipeline/kind-matrix3d.mjs 의 시험 object.addPlaneFromPointAndLinear 에 장면 개체 종류 조합 462건을 넣어 유효 64건(증거 evidence/runs/2026-10-22/math3d/kind-matrix3d-3.json)]"
   },
   "referenceID2": {
    "accepts": [
     "point",
     "linear"
    ],
    "reason": "실제 동작으로 확인 [src:정합성 math3d-kinds: scripts/pipeline/kind-matrix3d.mjs 의 시험 object.addPlaneFromPointAndLinear 에 장면 개체 종류 조합 462건을 넣어 유효 64건(증거 evidence/runs/2026-10-22/math3d/kind-matrix3d-3.json)]"
   }
  },
  "object.addPlaneFromTwoLinears": {
   "referenceID1": {
    "accepts": [
     "linear"
    ],
    "reason": "실제 동작으로 확인 [src:정합성 math3d-kinds: scripts/pipeline/kind-matrix3d.mjs 의 시험 object.addPlaneFromTwoLinears 에 장면 개체 종류 조합 462건을 넣어 유효 18건(증거 evidence/runs/2026-10-22/math3d/kind-matrix3d-3.json)]"
   },
   "referenceID2": {
    "accepts": [
     "linear"
    ],
    "reason": "실제 동작으로 확인 [src:정합성 math3d-kinds: scripts/pipeline/kind-matrix3d.mjs 의 시험 object.addPlaneFromTwoLinears 에 장면 개체 종류 조합 462건을 넣어 유효 18건(증거 evidence/runs/2026-10-22/math3d/kind-matrix3d-3.json)]"
   }
  },
  "object.addPointIntersection": {
   "referenceID1": {
    "accepts": [
     "linear",
     "plane",
     "sphere"
    ],
    "reason": "실제 동작으로 확인 [src:정합성 math3d-kinds: scripts/pipeline/kind-matrix3d.mjs 의 시험 object.addPointIntersection 에 장면 개체 종류 조합 462건을 넣어 유효 46건(증거 evidence/runs/2026-10-22/math3d/kind-matrix3d-3.json)]"
   },
   "referenceID2": {
    "accepts": [
     "linear",
     "plane",
     "sphere"
    ],
    "reason": "실제 동작으로 확인 [src:정합성 math3d-kinds: scripts/pipeline/kind-matrix3d.mjs 의 시험 object.addPointIntersection 에 장면 개체 종류 조합 462건을 넣어 유효 46건(증거 evidence/runs/2026-10-22/math3d/kind-matrix3d-3.json)]"
   }
  },
  "object.addMeasurement": {
   "relativeObjects": {
    "accepts": [
     "point",
     "plane",
     "sphere",
     "polyhedron",
     "cylindroconical"
    ],
    "reason": "실제 동작으로 확인 [src:정합성 math3d-kinds: scripts/pipeline/kind-matrix3d.mjs 의 시험 object.addMeasurement 에 장면 개체 종류 조합 2036건을 넣어 유효 298건(증거 evidence/runs/2026-10-22/math3d/kind-matrix3d-3.json)]"
   }
  },
  "object.addText3D": {
   "relativeObjects": {
    "accepts": [
     "point",
     "plane",
     "sphere",
     "polyhedron",
     "cylindroconical"
    ],
    "reason": "실제 동작으로 확인 [src:정합성 math3d-kinds: scripts/pipeline/kind-matrix3d.mjs 의 시험 object.addText3D 에 장면 개체 종류 조합 3054건을 넣어 유효 509건(증거 evidence/runs/2026-10-22/math3d/kind-matrix3d-3.json)]"
   }
  },
  "object.addTransformObject": {
   "targetId": {
    "accepts": [
     "point",
     "linear",
     "plane",
     "circular",
     "sphere",
     "polyhedron",
     "cylindroconical"
    ],
    "reason": "실제 동작으로 확인 [src:정합성 math3d-kinds: scripts/pipeline/kind-matrix3d.mjs 의 시험 object.addTransformObject 에 장면 개체 종류 조합 3234건을 넣어 유효 640건(증거 evidence/runs/2026-10-22/math3d/kind-matrix3d-3.json)]"
   },
   "pivotId": {
    "accepts": [
     "point",
     "linear",
     "plane"
    ],
    "reason": "실제 동작으로 확인 [src:정합성 math3d-kinds: scripts/pipeline/kind-matrix3d.mjs 의 시험 object.addTransformObject 에 장면 개체 종류 조합 3234건을 넣어 유효 640건(증거 evidence/runs/2026-10-22/math3d/kind-matrix3d-3.json)]"
   }
  }
 },
 "usageCommon": {},
 "usageUnknown": [
  {
   "name": "algebraric",
   "items": [
    "용도"
   ]
  },
  {
   "name": "circle.compassWithSegment",
   "items": [
    "용도"
   ]
  },
  {
   "name": "circle.compassWithThreePoint",
   "items": [
    "용도"
   ]
  },
  {
   "name": "circle.semiCircle",
   "items": [
    "용도"
   ]
  },
  {
   "name": "deco.annotationBySegment",
   "items": [
    "용도"
   ]
  },
  {
   "name": "deco.lengthByTwoPoints",
   "items": [
    "용도"
   ]
  },
  {
   "name": "etc.text",
   "items": [
    "용도"
   ]
  },
  {
   "name": "etc.textLatex",
   "items": [
    "용도"
   ]
  },
  {
   "name": "etc.slider",
   "items": [
    "용도"
   ]
  },
  {
   "name": "etc.checkbox",
   "items": [
    "용도"
   ]
  },
  {
   "name": "etc.image",
   "items": [
    "용도"
   ]
  },
  {
   "name": "linear.perpendicularBisectorByTwoPoint",
   "items": [
    "용도"
   ]
  },
  {
   "name": "measure.lengthByTwoPointsID",
   "items": [
    "용도"
   ]
  },
  {
   "name": "point.middlePointByTwoPoint",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.setGeneratePosition",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.makeGroup",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.destroyGroup",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.addMiddlePointFromTwoPoint",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.addDefaultLine",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.addTangentLine",
   "items": [
    "curveID 받는 종류"
   ]
  },
  {
   "name": "object.addDefaultPlane",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.addPlaneFromPointAndLinear",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.addPlaneFromTwoLinears",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.addPlaneFromPolygon",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.addPyramidFromPolygon",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.addPrismFromPolygon",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.addRegularTetrahedronFromPolygon",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.addRegularCubeFromPolygon",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.addAlgebraic",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.addTransformObject",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.updateTransformObject",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.setDecoControlPoint",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.setDecoShapeType",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.setDecoParallelDirection",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.setCheckboxTitle",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.setCheckboxObjectList",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.getSliderIdBySymbol",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.setLayer2DNormalizedPosition",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.setSliderValue",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.setSliderAnimationPlayingState",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.setSliderMinValue",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.setSliderMaxValue",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.setSliderStepValue",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.setSliderAnimationSpeed",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.setSliderAnimationDirection",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.setSliderCategory",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.setSliderSymbol",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.setCheckboxValue",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.setAlgebraicExpression",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.setPointPosition",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.setObjectPositions",
   "items": [
    "용도",
    "하는 일"
   ]
  },
  {
   "name": "object.deleteAllTrails",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.clearAllTrails",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.setTextPosition",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.setTextRotation",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.setTextProperty",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.setImagePosition",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.setImageSize",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.setImageRotation",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.setImageFlipX",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.setImageFlipY",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.setImageProperty",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.setHoverState",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.selectObject",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.selectObjects",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.unselectObject",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.unselectObjects",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.unselectAllObjects",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.hideObject",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.showObject",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.setTrailState",
   "items": [
    "용도"
   ]
  },
  {
   "name": "variable.getVariables",
   "items": [
    "용도"
   ]
  },
  {
   "name": "variable.getVariable",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.setObjectDefaultProperty",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.setPointSize",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.setPointShape",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.setColor",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.setMovable",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.setLinearWidth",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.setLinearDashed",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.setOpacity",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.setName",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.setGridXVisible",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.setGridXColor",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.setGridYVisible",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.setGridYColor",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.setLabelCaption",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.setLabelSize",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.setLabelVisibleType",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.setLabelColor",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.setSphereRadius",
   "items": [
    "용도"
   ]
  },
  {
   "name": "object.setCylindroconicalRadius",
   "items": [
    "용도"
   ]
  }
 ],
 "entries": [
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "algebraric",
   "path": [
    "algebraric"
   ],
   "params": [
    {
     "name": "expression",
     "type": "expr",
     "optional": false
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "packages-base/algebraric-factory.ts",
   "usage": [
    "용도: 대수 탭의 수식 입력창에 식을 치는 것과 같다. 식 문자열 하나로 곡선, 부등식 영역, 정적분 값, 매개 정의, 점을 만든다. [src:정합성 alg-point: scripts/pipeline/semantic/alg-point.mjs: 대수식 입력 화면: 대수 탭의 입력창은 수식 입력 math-field 하나이고 | 대수 입력창 y=x^2 와 팩토리 algebraric 는 같은 대수 개체 | /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d-ui/src/tab/algebra/index.tsx:178-199]",
    "호출: factory.algebraric → advanced.createAlgebraicObject [src:mathcore-api/object-factory/packages-base/algebraric-factory.ts:8-12] [src:base2d/base-advanced-api/index.ts:2275-2358]",
    "만드는 것, 조건부(this.typingParser.isValid()): polynomial 1개 [src:base2d/base-advanced-api/index.ts:2281] — 보임(기본값) [src:object-manager/objects/polynomial.ts:64], 색 null as null | Color(configs.algebraicColor) [src:base2d/base-advanced-api/configs.ts:131], 선 두께 2(configs.algebraicStrokeWidth) [src:base2d/base-advanced-api/configs.ts:137]",
    "함께 생김, 조건부(this.typingParser.isValid()): text(nameText) 1개 (경유 createNameTextByPolynomial) [src:base2d/base-advanced-api/index.ts:3339] — 숨김 [src:base2d/base-advanced-api/index.ts:3349], 위치 오프셋(화면 px) [24, -24] || [16, -16] [src:base2d/base-advanced-api/index.ts:3341], 크기 16(configs.nametextSize) [src:base2d/base-advanced-api/configs.ts:92], 색 #000(configs.nametextColor) [src:base2d/base-advanced-api/configs.ts:93], latex=true [src:base2d/base-advanced-api/index.ts:3350], 매인 개체 [object.id] [src:base2d/base-advanced-api/index.ts:3342]",
    "다른 갈래에서 대신 만드는 것, 조건부(this.typingLexer.isEmpty() 그리고 this.typingLexer.process(expression)): polynomial 1개 [src:base2d/base-advanced-api/index.ts:2299] — 보임(기본값) [src:object-manager/objects/polynomial.ts:64], 색 null as null | Color(configs.algebraicColor) [src:base2d/base-advanced-api/configs.ts:131], 선 두께 2(configs.algebraicStrokeWidth) [src:base2d/base-advanced-api/configs.ts:137]",
    "다른 갈래에서 대신 만드는 것, 조건부(firstToken.type === TokenType.OPENING_PAREN && la… 그리고 this.typingLexer.process(expression)): point(point) 1개 (경유 createPoint) [src:base2d/base-advanced-api/index.ts:2479] — 보임(기본값) [src:object-manager/objects/point.ts:91], 크기 9(configs.pointSize) [src:base2d/base-advanced-api/configs.ts:85], 색 #fe7701(configs.pointColor) [src:base2d/base-advanced-api/configs.ts:86]",
    "다른 갈래에서 대신 만드는 것, 조건부(firstToken.type === TokenType.OPENING_PAREN && la… 그리고 this.typingLexer.process(expression)): text(nameText) 1개 (경유 createPoint → createNameText) [src:base2d/base-advanced-api/index.ts:3266] — 보임(기본값) [src:object-manager/objects/text.ts:63], 위치 오프셋(화면 px) [16, -16] [src:base2d/base-advanced-api/index.ts:3268], 크기 16(configs.nametextSize) [src:base2d/base-advanced-api/configs.ts:92], 글꼴 'KaTeX'(configs.nametextFont) [src:base2d/base-advanced-api/configs.ts:94], 색 #000(configs.nametextColor) [src:base2d/base-advanced-api/configs.ts:93], 매인 개체 [point.id] [src:base2d/base-advanced-api/index.ts:3269]",
    "다른 갈래에서 대신 만드는 것, 조건부(this.typingLexer.process(expression)): polynomial 1개 [src:base2d/base-advanced-api/index.ts:2327] — 보임(기본값) [src:object-manager/objects/polynomial.ts:64], 색 null as null | Color(configs.algebraicColor) [src:base2d/base-advanced-api/configs.ts:131], 선 두께 2(configs.algebraicStrokeWidth) [src:base2d/base-advanced-api/configs.ts:137]",
    "다른 갈래에서 대신 만드는 것: polynomial 1개 [src:base2d/base-advanced-api/index.ts:2344] — 보임(기본값) [src:object-manager/objects/polynomial.ts:64], 색 null as null | Color(configs.algebraicColor) [src:base2d/base-advanced-api/configs.ts:131], 선 두께 2(configs.algebraicStrokeWidth) [src:base2d/base-advanced-api/configs.ts:137]",
    "참고: 정적분 식 \\int_{a}^{b} 식 dx 를 식으로 주면(문항 표기 그대로 주면 코드가 mathcore 표기로 바꾼다) mathcore 가 값을 계산하는 개체가 서고 값은 소수 넷째 자리까지다. 곡선 아래 넓이는 이 식으로 얻는다 [src:docs/palette/algebraric-point.md:103]",
    "참고: 부등호는 <, >, \\le, \\ge 만 읽힌다. <= 와 >= 글자는 읽히지 않아 식이 무효가 되고(개체는 서지만 그려지지 않는다), \\leq 는 \\le 뒤의 q 를 기호로 읽어 슬라이더 q 가 말없이 선다. 조건 {…} 안에서도 <= 는 무효다. [src:정합성 alg-point: scripts/pipeline/semantic/alg-point.mjs: 는 무효(<=, >= 문자열은 읽히지 않는다) | 슬라이더 q 가 몰래 선다 | 조건 ${e} 는 무효]",
    "참고: 정적분은 \\int_{a}^{b} 식 \\differentialD x 로 쓰고, 식이 덧셈이면 괄호로 감싼다(\\int_{0}^{1}(x+1)\\differentialD x). dx 나 f(x) 호출은 읽히지 않고, 분모에 변수가 든 분수의 적분은 값이 NaN 이다. 아래끝이 위끝보다 커도 읽혀 값이 음수가 된다. 정적분 식과 부등식은 영역이라 point.intersect, point.pointOnObject 의 대상이 되지 못한다(점이 서도 무효). [src:정합성 alg-point: scripts/pipeline/semantic/alg-point.mjs: 정적분 표기 ${e} 은 무효이거나 값이 NaN | 정적분 아래끝이 위끝보다 커도 유효 | 부등식이나 정적분 대수와의 교점은 그릇과 보조 점이 서되 전부 무효 | 정적분 대수 위의 점도 개체가 서되 isValid false]",
    "참고: 조건은 식 바로 뒤 {…} 에 쓰는 x 또는 y 의 구간이다. 같은 변수의 조건을 둘 쓰면({x>0,x<2}) 식이 무효이므로 {0<x<2} 한 식으로 쓴다. 열린 구간과 닫힌 구간은 구별되지 않는다(0<x<2 와 0\\le x\\le 2 가 같다). 구간 밖의 교점은 point.intersect 에서 빠진다. [src:정합성 alg-point: scripts/pipeline/semantic/alg-point.mjs: 조건 ${e} 는 무효 | 조건에서 열린 구간과 닫힌 구간은 구별되지 않는다 | 조건 밖 교점은 걸러진다]",
    "참고: 식 안의 영문 한 글자는 x, y, e(상수), 함수 이름이 아니면 매개 기호다. 같은 이름의 슬라이더나 정의가 없으면 값 1, 범위 -10에서 10 짜리 슬라이더가 말없이 선다. 역슬래시 없이 sin x 처럼 쓰면 s, i, n 이 각각 슬라이더가 되므로 \\sin, \\ln, \\sqrt{} 로 쓴다. 슬라이더가 필요하면 etc.slider 를 이 식보다 먼저 세운다. [src:정합성 alg-point: scripts/pipeline/semantic/alg-point.mjs: 역슬래시 없는 sin 은 슬라이더 s, i, n 이 몰래 선다 | 슬라이더 없이 y=bx 를 먼저 세우면 값 1 | 슬라이더 a 를 먼저 세우면 y=ax 는 유효하고 슬라이더가 더 서지 않는다]",
    "참고: a=3 꼴 매개 정의는 값을 읽을 수 있는 속성(immediateValue)이 0 이고 point.basic 의 좌표 식에서도 보이지 않는다. 같은 이름의 etc.slider 와 함께 두면 그 이름을 쓰는 식이 무효가 된다. 값이 필요하면 식에 숫자로 쓴다. [src:정합성 alg-point: scripts/pipeline/semantic/alg-point.mjs: a=3 은 매개 정의(갈래 3)이고 immediateValue 가 0 | algebraric a=3 으로 정의한 a 는 점 좌표 식에서 보이지 않는다 | algebraric c=3 으로 매개를 정의한 뒤 etc.slider c 를 세우면]",
    "참고: \\frac 은 중괄호 둘이 필요하고(\\frac12 는 무효), n제곱근 \\sqrt[3]{x} 는 읽히지 않으므로 x^{1/3} 로 쓴다. 함수 정의의 인수는 x 나 y 만 된다(f(t)=t^2 는 무효). [src:정합성 alg-point: scripts/pipeline/semantic/alg-point.mjs: \\frac 은 중괄호 둘이 필요하다 | \\sqrt3{x} 는 읽히지 않는다 | 거듭제곱근은 x^{1/3} 꼴로 쓰면 유효 | 함수 머리의 인수는 x, y 만]",
    "참고: 식은 입력창과 달리 보정 없이 그대로 읽힌다. \\frac12 는 \\frac{1}{2} 로, 적분 끝은 dx 가 아니라 \\differentialD x 로 직접 쓴다(입력창은 이것들을 고쳐 보낸다). 식 안에 (x,y) 모양이 있어도 점으로 가로채지 않는다(입력창은 f(x,y)=x+y 를 점으로 만든다). [src:정합성 alg-point: scripts/pipeline/semantic/alg-point.mjs: 입력창은 \\frac12 를 \\frac{1}{2} 로 고쳐 보내지만 팩토리는 고치지 않는다 | 입력창은 dx 로 쓴 정적분을 | 입력창은 식 안의 (x,y) 모양을 점 명령으로 가로챈다 | /root/dev/git.cemware.com/mathcore/module/mathcore/lib/common-ui/src/common/editor.tsx:231-307]",
    "생성 결과: 괄호 점 (1,2) 를 주면 곡선이 아니라 점이 서고 name 은 버려진다. \\& 로 이은 연립 식은 개체 하나이고 name 이 버려지며 등식이 섞이면 무효다. 읽히지 않는 식은 호출이 성공해도 무효 개체(isValid false)가 서므로 호출 성공은 곡선이 섰다는 뜻이 아니다. [src:정합성 alg-point: scripts/pipeline/semantic/alg-point.mjs: 괄호 점 (1,2) 는 대수 개체가 아니라 점이 서고 | \\& 로 이은 연립 부등식은 개체 하나이고 | 연립에 등식이 섞이면 무효 | 못 읽는 식 y=x^ 도 undefined 가 아니라]"
   ],
   "range": [
    "expression: 형식 String [src:mathcore-api/object-factory/packages-base/algebraric-factory.ts:9] [src:mathcore-api/object-factory/object-types.ts:92]",
    "name?: 형식 String | Undefined [src:mathcore-api/object-factory/packages-base/algebraric-factory.ts:10] [src:mathcore-api/object-factory/object-types.ts:93]; 생략하면 this.getNewObjectName() [src:base2d/base-advanced-api/index.ts:2276]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): size=1, domain='', position=undefined, delta=[0, 0], patterns={ type: PatternType.FIL…, expressionCategory=CategoryType.EMPTY, expressionType=0, expressionCode='', javascriptCode='', inequalityExists=false, inequalitySign='=', inequalityCode='', immediateValue=0, conditionList=null 외 3개 [src:object-manager/objects/polynomial.ts:67-89]"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "circle.circleWithCenter",
   "path": [
    "circle",
    "circleWithCenter"
   ],
   "params": [
    {
     "name": "centerPointID",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "pointOnCircleID",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "packages-base/circle-factory.ts",
   "usage": [
    "용도(도구 UI 설명): 원 : 중심과 한 점 — 중심을 선택한 후 원이 그려질 한 점을 선택하세요. [src:base2d-ui/src/tab/tools/configs/base2d-geometry.ts:240]",
    "호출: factory.circle.circleWithCenter → advanced.createCircleCenterPoint [src:mathcore-api/object-factory/packages-base/circle-factory.ts:8-13] [src:base2d/base-advanced-api/index.ts:3760-3770]",
    "앞에 있어야 하는 것: centerPointID = point [src:mathcore-api/object-factory/packages-base/circle-factory.ts:8-13]",
    "앞에 있어야 하는 것: pointOnCircleID = point [src:mathcore-api/object-factory/packages-base/circle-factory.ts:8-13]",
    "만드는 것: circle(circleCenterPoint) 1개 [src:base2d/base-advanced-api/index.ts:3761] — 보임(기본값) [src:object-manager/objects/circle.ts:79], 색 null as null | Color(configs.circleColor) [src:base2d/base-advanced-api/configs.ts:128], 매인 개체 [centerPointID, pointOnCircleID] [src:base2d/base-advanced-api/index.ts:3768]",
    "참고: 캔버스에서는 점을 두 번 눌러(첫 클릭이 중심, 둘째 클릭이 원 위의 점) 만들고 둘째 클릭에서 원이 선다. 빈 곳을 누르면 점도 새로 만들어지지만 이 도구는 점 id 만 받으므로 두 점을 먼저 세우고, 같은 점을 두 번 눌러 만드는 원은 캔버스에 없다(팩토리는 반지름 0 원이 선다). [src:정합성 circle: 버튼: lib/base2d-ui/src/tab/tools/configs/base2d-geometry.ts:237(기하 탭, 원과 곡선, 「원 : 중심과 한 점」). 이벤트: /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d-tools/src/tools/math2d-tools/tool-circle-center-point.ts:39-77(pointerDown 에서 점 선택 또는 생성, :51 같은 점 무시, :66 createCircleCenterPoint(첫째, 둘째)), :79-97(pointerMove 는 미리보기만). 시험: scripts/pipeline/semantic/circle.mjs 의 「캔버스 circleWithCenter: ...」]"
   ],
   "range": [
    "centerPointID: 형식 String [src:mathcore-api/object-factory/packages-base/circle-factory.ts:9] [src:mathcore-api/object-factory/object-types.ts:92]",
    "pointOnCircleID: 형식 String [src:mathcore-api/object-factory/packages-base/circle-factory.ts:10] [src:mathcore-api/object-factory/object-types.ts:92]",
    "name?: 형식 String | Undefined [src:mathcore-api/object-factory/packages-base/circle-factory.ts:11] [src:mathcore-api/object-factory/object-types.ts:93]; 생략하면 this.getNewObjectName() [src:base2d/base-advanced-api/index.ts:3767]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): position=[0, 0], startPosition=[0, 0], endPosition=[0, 0], radius=1, angleRange=[0, 2 * Math.PI], auxiliarySegments=[] [src:object-manager/objects/circle.ts:82-87]"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "circle.circleWithCenterAndRadius",
   "path": [
    "circle",
    "circleWithCenterAndRadius"
   ],
   "params": [
    {
     "name": "pointID",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "radius",
     "type": "number|string",
     "optional": false
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "packages-base/circle-factory.ts",
   "usage": [
    "용도(도구 UI 설명): 원 : 중심과 반지름 — 중심을 선택한 후 반지름을 입력하세요. [src:base2d-ui/src/tab/tools/configs/base2d-geometry.ts:249]",
    "호출: factory.circle.circleWithCenterAndRadius → advanced.createCircleCenterRadius [src:mathcore-api/object-factory/packages-base/circle-factory.ts:15-20] [src:base2d/base-advanced-api/index.ts:3736-3749]",
    "앞에 있어야 하는 것: pointID = point [src:mathcore-api/object-factory/packages-base/circle-factory.ts:15-20]",
    "만드는 것: circle(circleCenterRadius) 1개 [src:base2d/base-advanced-api/index.ts:3738] — 보임(기본값) [src:object-manager/objects/circle.ts:79], 색 null as null | Color(configs.circleColor) [src:base2d/base-advanced-api/configs.ts:128], 매인 개체 [pointID] [src:base2d/base-advanced-api/index.ts:3746]",
    "참고: 0 이하의 수와 빈 문자열도 오류 없이 반지름 0 이하인 원으로 서므로 양수만 준다. 중심 자리에 점이 아닌 개체(선분, 곡선, 다각형 등)의 id 를 주면 위치 없는 원이 유효로 서서 이미 그려진 점과 이름표가 화면에서 사라진다. [src:정합성 circle: scripts/pipeline/semantic/circle.mjs 의 시험 「반지름 수 0: 오류 없이 유효한 원, 반지름 0」, 「반지름 음수 -2: 오류 없이 유효한 원, 반지름 -2」, 「중심에 선분을 주면 위치 없는 유효 원이 서고(position 없음) 이미 있던 점과 이름표가 화면에서 사라진다」]",
    "참고: 캔버스에서는 점 하나를 누르면 반지름 입력창이 열리고 입력값(수 또는 식 문자열)이 이 도구의 radius 인자로 그대로 쓰인다. 입력이 0 이거나 취소하면 원이 안 서지만 이 도구는 반지름 0 원도 세우므로 양수만 준다. [src:정합성 circle: 버튼: base2d-geometry.ts:246(「원 : 중심과 반지름」). 이벤트: /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d-tools/src/tools/math2d-tools/tool-circle-center-radius.ts:61-67(점 하나 뒤 promptManager.prompt('circleCenterRadius'), :65 if (radius) 일 때만 createCircleCenterRadius(점, 값)). 시험: circle.mjs 의 「캔버스 circleWithCenterAndRadius: ...」]"
   ],
   "range": [
    "pointID: 형식 String [src:mathcore-api/object-factory/packages-base/circle-factory.ts:16] [src:mathcore-api/object-factory/object-types.ts:92]",
    "radius: 형식 Number | String [src:mathcore-api/object-factory/packages-base/circle-factory.ts:17] [src:mathcore-api/object-factory/object-types.ts:105]; 숫자가 아닌 문자열이면 슬라이더 연결식으로 들어가 그 값을 따라 움직인다 [src:base2d/base-advanced-api/index.ts:644-654]",
    "name?: 형식 String | Undefined [src:mathcore-api/object-factory/packages-base/circle-factory.ts:18] [src:mathcore-api/object-factory/object-types.ts:93]; 생략하면 this.getNewObjectName() [src:base2d/base-advanced-api/index.ts:3744]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): position=[0, 0], startPosition=[0, 0], endPosition=[0, 0], angleRange=[0, 2 * Math.PI], auxiliarySegments=[] [src:object-manager/objects/circle.ts:82-87]",
    "radius 가 수이면 그대로 반지름이다. 문자열이면 식으로 계산되고(\\sqrt, 분수, 거듭제곱, 곱 생략 가능) 이미 선 슬라이더나 측정 값의 이름(한 글자 또는 k_1 꼴)을 쓰면 그 값에 연결되어 값이 바뀔 때 반지름이 따라 바뀐다. 없는 이름이나 읽지 못하는 식은 오류 없이 반지름 0 인 원이 서므로 이미 선 이름만 쓴다. [src:정합성 circle: scripts/pipeline/semantic/circle.mjs 의 시험 「문자열 반지름 ... 은 식으로 평가」, 「슬라이더 a=4 로 바꾸면 'a' 는 4, '2a+1' 은 9 로 따라 움직임」, 「두 글자 이름 'n1'(값 2) 은 연결되지 않아 반지름 0 인 유효한 원」, 「반지름 없는 이름 zz: 오류 없이 유효한 원, 반지름 0」]"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "circle.circleThroughThreePoints",
   "path": [
    "circle",
    "circleThroughThreePoints"
   ],
   "params": [
    {
     "name": "pointID1",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "pointID2",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "pointID3",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "packages-base/circle-factory.ts",
   "usage": [
    "용도(도구 UI 설명): 원 : 세 점 — 원이 그려질 세 점을 선택하세요. [src:base2d-ui/src/tab/tools/configs/base2d-geometry.ts:259]",
    "호출: factory.circle.circleThroughThreePoints → advanced.createCircleTriangleCircumCircle [src:mathcore-api/object-factory/packages-base/circle-factory.ts:22-28] [src:base2d/base-advanced-api/index.ts:3863-3873]",
    "앞에 있어야 하는 것: pointID1 = point [src:mathcore-api/object-factory/packages-base/circle-factory.ts:22-28]",
    "앞에 있어야 하는 것: pointID2 = point [src:mathcore-api/object-factory/packages-base/circle-factory.ts:22-28]",
    "앞에 있어야 하는 것: pointID3 = point [src:mathcore-api/object-factory/packages-base/circle-factory.ts:22-28]",
    "만드는 것: circle(triangleCircumCircle) 1개 [src:base2d/base-advanced-api/index.ts:3864] — 보임(기본값) [src:object-manager/objects/circle.ts:79], 색 null as null | Color(configs.circleColor) [src:base2d/base-advanced-api/configs.ts:128], 매인 개체 [pointID1, pointID2, pointID3] [src:base2d/base-advanced-api/index.ts:3871]",
    "참고: 세 점이 일직선이거나 겹치면 위치와 반지름이 계산되지 않는 원이 유효로 서서 그려지지 않는다. 세 점은 서로 다르고 일직선이 아니게 준다. 입력 점이 무효(호 밖 교점 후보 등)여도 원은 유효로 선다. [src:정합성 circle: scripts/pipeline/semantic/circle.mjs 의 시험 「일직선 세 점: 유효로 서고 position, radius 가 NaN」, 「겹친 점: 유효로 서고 NaN」, 「무효 점을 줘도 외접원은 isValid=true 로 선다(무효가 전파되지 않음)」]",
    "참고: 캔버스에서는 점을 세 번 눌러 만들고 셋째 클릭에서 원이 서며, 마우스 이동은 셋째 점 자리에 따라 바뀌는 미리보기 원만 그린다. 인자 순서가 클릭 순서이고 셋은 서로 다른 점이어야 하며 일직선은 피한다. [src:정합성 circle: 버튼: base2d-geometry.ts:256(「원 : 세 점」). 이벤트: /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d-tools/src/tools/math2d-tools/tool-triangle-circum-circle.ts:39-81(:63-69 세 점이 차면 createCircleTriangleCircumCircle(p0,p1,p2)), :83-108(pointerMove 미리보기). 시험: circle.mjs 의 「캔버스 circleThroughThreePoints: ...」]"
   ],
   "range": [
    "pointID1: 형식 String [src:mathcore-api/object-factory/packages-base/circle-factory.ts:23] [src:mathcore-api/object-factory/object-types.ts:92]",
    "pointID2: 형식 String [src:mathcore-api/object-factory/packages-base/circle-factory.ts:24] [src:mathcore-api/object-factory/object-types.ts:92]",
    "pointID3: 형식 String [src:mathcore-api/object-factory/packages-base/circle-factory.ts:25] [src:mathcore-api/object-factory/object-types.ts:92]",
    "name?: 형식 String | Undefined [src:mathcore-api/object-factory/packages-base/circle-factory.ts:26] [src:mathcore-api/object-factory/object-types.ts:93]; 생략하면 this.getNewObjectName() [src:base2d/base-advanced-api/index.ts:3870]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): position=[0, 0], startPosition=[0, 0], endPosition=[0, 0], radius=1, angleRange=[0, 2 * Math.PI], auxiliarySegments=[] [src:object-manager/objects/circle.ts:82-87]"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "circle.compassWithCircle",
   "path": [
    "circle",
    "compassWithCircle"
   ],
   "params": [
    {
     "name": "circleID",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "circle"
      },
      {
       "type": "linear"
      }
     ]
    },
    {
     "name": "centerPointID",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "packages-base/circle-factory.ts",
   "usage": [
    "용도(도구 UI 설명): 원 : 컴퍼스 — 반지름이 될 선분 또는 원 또는 두 점을 선택한 후, 새로운 원을 만들 위치를 선택하세요. [src:base2d-ui/src/tab/tools/configs/base2d-geometry.ts:269]",
    "호출: factory.circle.compassWithCircle → advanced.createCompassByCircle [src:mathcore-api/object-factory/packages-base/circle-factory.ts:30-35] [src:base2d/base-advanced-api/index.ts:4017-4019]",
    "앞에 있어야 하는 것: circleID = circle [src:mathcore-api/object-factory/packages-base/circle-factory.ts:30-35]",
    "앞에 있어야 하는 것: centerPointID = point [src:mathcore-api/object-factory/packages-base/circle-factory.ts:30-35]",
    "만드는 것: circle(compass) 1개 (경유 createCompassBySegment) [src:base2d/base-advanced-api/index.ts:3988] — 보임(기본값) [src:object-manager/objects/circle.ts:79], 색 null as null | Color(configs.circleColor) [src:base2d/base-advanced-api/configs.ts:128], 매인 개체 [circleID, centerPointID] [src:base2d/base-advanced-api/index.ts:3995]",
    "참고: 첫째 인자가 원(호, 부채꼴, 활꼴 포함)이면 그 반지름을, 선분이면 그 길이를 반지름으로 하는 새 원이 둘째 인자의 점에 선다. 직선과 반직선은 무효이고, 벡터, 타원, 곡선, 다각형, 슬라이더는 반지름 1 인 원점 중심 원이 서므로 주지 않는다. 대상의 반지름이나 길이가 바뀌면 따라 바뀐다. compassWithSegment 와 같은 계산이다. [src:정합성 circle: scripts/pipeline/semantic/circle.mjs 의 시험 「첫 자리에 선분: 반지름 5 의 유효한 원(이 도구 이름과 무관)」, 「종류 circleID.line」, 「종류 circleID.vector」, 「종류 circleID.curve」, 「원의 반지름이 바뀌면 컴퍼스가 따라온다」]",
    "참고: 캔버스의 「원 : 컴퍼스」 버튼 하나가 세 컴퍼스를 모두 맡는다. 첫 클릭이 원이면 둘째 클릭(점)이 중심이고, 그 원의 반지름으로 새 원이 서며, 이때 부르는 함수는 compassWithSegment 와 같다. 첫 클릭이 빈 곳이면 아무것도 만들어지지 않는다. [src:정합성 circle: 버튼: base2d-geometry.ts:266. 이벤트: /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d-tools/src/tools/math2d-tools/tool-compass.ts:55-139(:61-70 첫 클릭의 종류로 모드 결정, :102-123 선분 또는 원 모드는 createCompassBySegment(대상, 중심) 로 호출), :141-185(미리보기). 시험: circle.mjs 의 「캔버스 compassWithCircle: ...」, 「캔버스 compass: 첫 클릭이 빈 곳이면 ...」]"
   ],
   "range": [
    "circleID: 형식 String [src:mathcore-api/object-factory/packages-base/circle-factory.ts:31] [src:mathcore-api/object-factory/object-types.ts:92]",
    "centerPointID: 형식 String [src:mathcore-api/object-factory/packages-base/circle-factory.ts:32] [src:mathcore-api/object-factory/object-types.ts:92]",
    "name?: 형식 String | Undefined [src:mathcore-api/object-factory/packages-base/circle-factory.ts:33] [src:mathcore-api/object-factory/object-types.ts:93]; 생략하면 this.getNewObjectName()(createCompassBySegment) [src:base2d/base-advanced-api/index.ts:3994]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): position=[0, 0], startPosition=[0, 0], endPosition=[0, 0], radius=1, angleRange=[0, 2 * Math.PI], auxiliarySegments=[] [src:object-manager/objects/circle.ts:82-87]"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "circle.compassWithSegment",
   "path": [
    "circle",
    "compassWithSegment"
   ],
   "params": [
    {
     "name": "segmentID",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "linear"
      },
      {
       "type": "circle"
      }
     ]
    },
    {
     "name": "centerPointID",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "packages-base/circle-factory.ts",
   "usage": [
    "용도: 반지름이 될 선분(원도 가능)과 중심이 될 점을 주면 그 반지름의 새 원(컴퍼스)이 그 점에 선다. [src:정합성 circle: scripts/pipeline/semantic/circle.mjs 의 시험 「반지름은 선분 길이의 반지름이고 중심은 둘째 인자」]",
    "호출: factory.circle.compassWithSegment → advanced.createCompassBySegment [src:mathcore-api/object-factory/packages-base/circle-factory.ts:37-42] [src:base2d/base-advanced-api/index.ts:3987-3997]",
    "앞에 있어야 하는 것: segmentID = linear(segment) [src:mathcore-api/object-factory/packages-base/circle-factory.ts:37-42]",
    "앞에 있어야 하는 것: centerPointID = point [src:mathcore-api/object-factory/packages-base/circle-factory.ts:37-42]",
    "만드는 것: circle(compass) 1개 [src:base2d/base-advanced-api/index.ts:3988] — 보임(기본값) [src:object-manager/objects/circle.ts:79], 색 null as null | Color(configs.circleColor) [src:base2d/base-advanced-api/configs.ts:128], 매인 개체 [segmentID, centerPointID] [src:base2d/base-advanced-api/index.ts:3995]",
    "참고: 첫째 인자가 선분이면 그 길이를, 원(호, 부채꼴, 활꼴 포함)이면 그 반지름을 반지름으로 삼는다. 직선과 반직선은 무효이고, 벡터, 타원, 곡선, 다각형, 슬라이더는 반지름 1 인 원점 중심 원이 서므로 주지 않는다. 선분 길이가 바뀌면 따라 바뀐다. [src:정합성 circle: scripts/pipeline/semantic/circle.mjs 의 시험 「첫 자리에 원: 반지름 2 의 유효한 원(이 도구 이름과 무관)」, 「종류 segmentID.ray」, 「종류 segmentID.polygon」, 「선분 끝을 옮기면 반지름이 따라온다」]",
    "참고: 캔버스에서는 선분(segment, segmentWithGivenLength 만 선택 가능, 직선과 반직선은 못 고른다)을 먼저 누르고 둘째 클릭(점)이 중심이며, 선분 길이가 반지름이 되어 둘째 클릭에서 원이 선다. 인자 순서는 [선분, 중심 점]이다. [src:정합성 circle: 버튼: base2d-geometry.ts:266(컴퍼스 하나). 이벤트: /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d-tools/src/tools/math2d-tools/tool-compass.ts:40-47(enter: 선택 가능 종류), :101-123(createCompassBySegment). 시험: circle.mjs 의 「캔버스 compassWithSegment: ...」]"
   ],
   "range": [
    "segmentID: 형식 String [src:mathcore-api/object-factory/packages-base/circle-factory.ts:38] [src:mathcore-api/object-factory/object-types.ts:92]",
    "centerPointID: 형식 String [src:mathcore-api/object-factory/packages-base/circle-factory.ts:39] [src:mathcore-api/object-factory/object-types.ts:92]",
    "name?: 형식 String | Undefined [src:mathcore-api/object-factory/packages-base/circle-factory.ts:40] [src:mathcore-api/object-factory/object-types.ts:93]; 생략하면 this.getNewObjectName() [src:base2d/base-advanced-api/index.ts:3994]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): position=[0, 0], startPosition=[0, 0], endPosition=[0, 0], radius=1, angleRange=[0, 2 * Math.PI], auxiliarySegments=[] [src:object-manager/objects/circle.ts:82-87]"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "circle.compassWithThreePoint",
   "path": [
    "circle",
    "compassWithThreePoint"
   ],
   "params": [
    {
     "name": "pointID1",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "pointID2",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "centerPointID",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "packages-base/circle-factory.ts",
   "usage": [
    "용도: 앞 두 점 사이의 거리를 반지름으로 하는 새 원이 셋째 점(중심)에 선다(컴퍼스). 앞 두 점이나 중심이 움직이면 따라온다. [src:정합성 circle: scripts/pipeline/semantic/circle.mjs 의 시험 「반지름은 앞 두 점의 거리, 중심은 셋째 점」, 「앞 두 점을 옮기면 반지름이 따라온다」]",
    "호출: factory.circle.compassWithThreePoint → advanced.createCompassByThreePoint [src:mathcore-api/object-factory/packages-base/circle-factory.ts:44-50] [src:base2d/base-advanced-api/index.ts:3959-3969]",
    "앞에 있어야 하는 것: pointID1 = point [src:mathcore-api/object-factory/packages-base/circle-factory.ts:44-50]",
    "앞에 있어야 하는 것: pointID2 = point [src:mathcore-api/object-factory/packages-base/circle-factory.ts:44-50]",
    "앞에 있어야 하는 것: centerPointID = point [src:mathcore-api/object-factory/packages-base/circle-factory.ts:44-50]",
    "만드는 것: circle(compass) 1개 [src:base2d/base-advanced-api/index.ts:3960] — 보임(기본값) [src:object-manager/objects/circle.ts:79], 색 null as null | Color(configs.circleColor) [src:base2d/base-advanced-api/configs.ts:128], 매인 개체 [pointID1, pointID2, centerPointID] [src:base2d/base-advanced-api/index.ts:3967]",
    "참고: 앞 두 점의 순서는 결과에 영향이 없다. 같은 점 둘이면 반지름 0 인 원이 선다. 앞 두 자리와 중심 자리에는 점만 준다(첫째 자리에 선분이나 원을 주면 그 길이나 반지름을 쓰는 다른 형식으로 읽힌다). [src:정합성 circle: scripts/pipeline/semantic/circle.mjs 의 시험 「앞 두 점의 순서는 결과에 영향이 없다」, 「같은 두 점이면 반지름 0 인 유효한 원」, 「종류 pointID1.segment」]",
    "참고: 캔버스에서는 첫 클릭이 점이면 점 모드로 점 둘(앞 두 점)을 누른 뒤 셋째 클릭(점 또는 빈 곳의 새 점)이 중심이 되고, 셋째 클릭에서 원이 선다. 마우스 이동은 셋째 클릭 위치에 놓일 원을 미리 보여 주기만 한다. [src:정합성 circle: 버튼: base2d-geometry.ts:266(컴퍼스 하나). 이벤트: /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d-tools/src/tools/math2d-tools/tool-compass.ts:71-100(:91-93 createCompassByThreePoint(p0,p1,p2)), :147-166(미리보기). 시험: circle.mjs 의 「캔버스 compassWithThreePoint: ...」]"
   ],
   "range": [
    "pointID1: 형식 String [src:mathcore-api/object-factory/packages-base/circle-factory.ts:45] [src:mathcore-api/object-factory/object-types.ts:92]",
    "pointID2: 형식 String [src:mathcore-api/object-factory/packages-base/circle-factory.ts:46] [src:mathcore-api/object-factory/object-types.ts:92]",
    "centerPointID: 형식 String [src:mathcore-api/object-factory/packages-base/circle-factory.ts:47] [src:mathcore-api/object-factory/object-types.ts:92]",
    "name?: 형식 String | Undefined [src:mathcore-api/object-factory/packages-base/circle-factory.ts:48] [src:mathcore-api/object-factory/object-types.ts:93]; 생략하면 this.getNewObjectName() [src:base2d/base-advanced-api/index.ts:3966]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): position=[0, 0], startPosition=[0, 0], endPosition=[0, 0], radius=1, angleRange=[0, 2 * Math.PI], auxiliarySegments=[] [src:object-manager/objects/circle.ts:82-87]"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "circle.arc",
   "path": [
    "circle",
    "arc"
   ],
   "params": [
    {
     "name": "centerPointID",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "startPointID",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "endPointID",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "packages-base/circle-factory.ts",
   "usage": [
    "용도(도구 UI 설명): 호 — 중심과 두 점을 선택하세요. [src:base2d-ui/src/tab/tools/configs/base2d-geometry.ts:280]",
    "호출: factory.circle.arc → advanced.createArc [src:mathcore-api/object-factory/packages-base/circle-factory.ts:52-58] [src:base2d/base-advanced-api/index.ts:4021-4032]",
    "앞에 있어야 하는 것: centerPointID = point [src:mathcore-api/object-factory/packages-base/circle-factory.ts:52-58]",
    "앞에 있어야 하는 것: startPointID = point [src:mathcore-api/object-factory/packages-base/circle-factory.ts:52-58]",
    "앞에 있어야 하는 것: endPointID = point [src:mathcore-api/object-factory/packages-base/circle-factory.ts:52-58]",
    "만드는 것: circle(arc) 1개 [src:base2d/base-advanced-api/index.ts:4023] — 보임(기본값) [src:object-manager/objects/circle.ts:79], 색 null as null | Color(configs.circleColor) [src:base2d/base-advanced-api/configs.ts:128], 매인 개체 [centerPointID, startPointID, endPointID, auxilia… [src:base2d/base-advanced-api/index.ts:4030]",
    "함께 생김: point(auxiliary) 1개 (경유 createAuxiliaryPoint) [src:base2d/base-advanced-api/index.ts:2556] — 보임(기본값) [src:object-manager/objects/point.ts:91], 크기 9(configs.pointSize) [src:base2d/base-advanced-api/configs.ts:85], 색 #6e6868(configs.intersectionPointColor) [src:base2d/base-advanced-api/configs.ts:112]",
    "함께 생김: text(nameText) 1개 (경유 createAuxiliaryPoint → createNameText) [src:base2d/base-advanced-api/index.ts:3266] — 보임(기본값) [src:object-manager/objects/text.ts:63], 위치 오프셋(화면 px) [16, -16] [src:base2d/base-advanced-api/index.ts:3268], 크기 16(configs.nametextSize) [src:base2d/base-advanced-api/configs.ts:92], 글꼴 'KaTeX'(configs.nametextFont) [src:base2d/base-advanced-api/configs.ts:94], 색 #000(configs.nametextColor) [src:base2d/base-advanced-api/configs.ts:93], 매인 개체 [point.id] [src:base2d/base-advanced-api/index.ts:3269]",
    "참고: 시작점이 반지름을 정하고 끝점은 방향만 정한다. 시작에서 끝까지 반시계 방향이다 [src:docs/palette/circle.md:126]",
    "참고: 끝점은 원 위에 있지 않아도 방향만 쓰인다. 시작점과 끝점이 중심에서 같은 방향이면 호가 아니라 한 바퀴로 계산되어 길이와 넓이가 원 전체 값이 된다. 시작과 끝을 바꾸면 보완 호가 선다. measure.area 는 호의 부채꼴 넓이를, measure.lengthByObjectId 는 호의 길이를 낸다. [src:정합성 circle: scripts/pipeline/semantic/circle.mjs 의 시험 「arc(O,A,E) 끝점이 원 안: 방향만 쓰인다」, 「arc(O,A,H) 시작 방향과 끝 방향이 같다(0도)」, 「arc(O,B,A) 시작과 끝을 바꾸면 3/4 원」, 「파이프라인 경유: 호 a1 의 넓이 3.14, 길이 3.14」]",
    "참고: 캔버스에서는 점을 세 번 눌러 만들고 인자 순서가 클릭 순서(중심, 시작점, 끝 방향)이며 셋째 클릭에서 호가 선다. 둘째 클릭 뒤 마우스를 움직이면 시작점에서 끝 방향까지의 호가 미리보기로 그려진다. 같은 점을 두 번 누르면 두 번째는 무시된다. [src:정합성 circle: 버튼: base2d-geometry.ts:277(「호」). 이벤트: /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d-tools/src/tools/math2d-tools/tool-arc.ts:39-78(:51 같은 점 무시, :64-66 createArc(p0,p1,p2), :70 활성화), :80-112(pointerMove: 1점 뒤 점선 원, 2점 뒤 호). 시험: circle.mjs 의 「캔버스 arc: ...」]",
    "생성 결과: 호 하나와 함께 보조 점 1개(끝 방향으로 원 위에 투영된 호의 끝, 자동 이름 대문자)와 그 이름표가 선다. 보조 선분은 없다. 보조 점은 다음 미사용 대문자를 가져가므로 문항의 점을 호보다 먼저 세운다(뒤에 세우면 이름이 같은 점이 둘이 된다). [src:정합성 circle: scripts/pipeline/semantic/circle.mjs 의 시험 「함께 서는 보조 점 1」, 「함께 서는 이름표(text) 1」, 「함께 서는 보조 선분 0」, 「보조 점이 다음 미사용 대문자 이름을 가져가고, 같은 이름의 문항 점을 뒤에 세우면 이름이 같은 점이 둘 생긴다」]"
   ],
   "range": [
    "centerPointID: 형식 String [src:mathcore-api/object-factory/packages-base/circle-factory.ts:53] [src:mathcore-api/object-factory/object-types.ts:92]",
    "startPointID: 형식 String [src:mathcore-api/object-factory/packages-base/circle-factory.ts:54] [src:mathcore-api/object-factory/object-types.ts:92]",
    "endPointID: 형식 String [src:mathcore-api/object-factory/packages-base/circle-factory.ts:55] [src:mathcore-api/object-factory/object-types.ts:92]",
    "name?: 형식 String | Undefined [src:mathcore-api/object-factory/packages-base/circle-factory.ts:56] [src:mathcore-api/object-factory/object-types.ts:93]; 생략하면 this.getNewObjectName() [src:base2d/base-advanced-api/index.ts:4029]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): position=[0, 0], startPosition=[0, 0], endPosition=[0, 0], radius=1, angleRange=[0, 2 * Math.PI], auxiliarySegments=[] [src:object-manager/objects/circle.ts:82-87]"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "circle.arcThroughThreePoints",
   "path": [
    "circle",
    "arcThroughThreePoints"
   ],
   "params": [
    {
     "name": "pointID1",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "pointID2",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "pointID3",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "packages-base/circle-factory.ts",
   "usage": [
    "용도: 세 점을 지나는 호. 첫째와 셋째 점이 호의 양 끝이고 둘째 점이 호가 지나는 점이다. 그림은 항상 시계 반대 방향 호이다. [src:정합성 circle: scripts/pipeline/semantic/circle.mjs 의 시험 「난수 세 점 40개: 모두 외접원 중심과 반지름이 맞고 둘째 점이 호 위에 있다」, 「양 끝은 첫째와 셋째 점」]",
    "호출: factory.circle.arcThroughThreePoints → advanced.createTriangleCircumArc [src:mathcore-api/object-factory/packages-base/circle-factory.ts:60-66] [src:base2d/base-advanced-api/index.ts:3924-3934]",
    "앞에 있어야 하는 것: pointID1 = point [src:mathcore-api/object-factory/packages-base/circle-factory.ts:60-66]",
    "앞에 있어야 하는 것: pointID2 = point [src:mathcore-api/object-factory/packages-base/circle-factory.ts:60-66]",
    "앞에 있어야 하는 것: pointID3 = point [src:mathcore-api/object-factory/packages-base/circle-factory.ts:60-66]",
    "만드는 것: circle(triangleCircumArc) 1개 [src:base2d/base-advanced-api/index.ts:3925] — 보임(기본값) [src:object-manager/objects/circle.ts:79], 색 null as null | Color(configs.circleColor) [src:base2d/base-advanced-api/configs.ts:128], 매인 개체 [pointID1, pointID2, pointID3] [src:base2d/base-advanced-api/index.ts:3932]",
    "참고: measure.area 와 measure.lengthByObjectId 는 호가 아니라 원 전체의 값(πr², 2πr)을 낸다. 호의 길이나 부채꼴 넓이가 필요하면 arc 나 fan 을 쓴다. 둘째 점이나 셋째 점이 첫째 점과 같은 x 또는 같은 y 에 있으면 둘째 점을 지나지 않는 쪽 호가 서는 경우가 있다. 일직선이거나 겹친 세 점은 계산되지 않는 원이 유효로 선다. [src:정합성 circle: scripts/pipeline/semantic/circle.mjs 의 시험 「반원 호 (A,B,C) 의 길이는 반원 호의 3.14 가 아니라 원 둘레 12.57」, 「((0,0),(3,0),(2,-3)): 시계 반대로 시작에서 끝까지 가면 둘째 점을 지난다」(실패로 남김), 「일직선 세 점: 유효로 서고 NaN」]",
    "참고: 캔버스에서는 점을 세 번 눌러 만들고 인자 순서가 클릭 순서(호의 한 끝, 호가 지나는 점, 다른 끝)이며 셋째 클릭에서 호가 선다. 마우스 이동은 마우스 위치를 셋째 점으로 본 호를 미리 그린다. [src:정합성 circle: 버튼: base2d-geometry.ts:286(「호(외접원)」). 이벤트: /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d-tools/src/tools/math2d-tools/tool-triangle-circum-arc.ts:44-84(:68-72 createTriangleCircumArc(p0,p1,p2)), :86-108. 시험: circle.mjs 의 「캔버스 arcThroughThreePoints: ...」]"
   ],
   "range": [
    "pointID1: 형식 String [src:mathcore-api/object-factory/packages-base/circle-factory.ts:61] [src:mathcore-api/object-factory/object-types.ts:92]",
    "pointID2: 형식 String [src:mathcore-api/object-factory/packages-base/circle-factory.ts:62] [src:mathcore-api/object-factory/object-types.ts:92]",
    "pointID3: 형식 String [src:mathcore-api/object-factory/packages-base/circle-factory.ts:63] [src:mathcore-api/object-factory/object-types.ts:92]",
    "name?: 형식 String | Undefined [src:mathcore-api/object-factory/packages-base/circle-factory.ts:64] [src:mathcore-api/object-factory/object-types.ts:93]; 생략하면 this.getNewObjectName() [src:base2d/base-advanced-api/index.ts:3931]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): position=[0, 0], startPosition=[0, 0], endPosition=[0, 0], radius=1, angleRange=[0, 2 * Math.PI], auxiliarySegments=[] [src:object-manager/objects/circle.ts:82-87]"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "circle.fan",
   "path": [
    "circle",
    "fan"
   ],
   "params": [
    {
     "name": "centerPointID",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "startPointID",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "endPointID",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "packages-base/circle-factory.ts",
   "usage": [
    "용도(도구 UI 설명): 부채꼴 — 중심과 두 점을 선택하세요. [src:base2d-ui/src/tab/tools/configs/base2d-geometry.ts:280]",
    "호출: factory.circle.fan → advanced.createFan [src:mathcore-api/object-factory/packages-base/circle-factory.ts:68-74] [src:base2d/base-advanced-api/index.ts:4112-4149]",
    "앞에 있어야 하는 것: centerPointID = point [src:mathcore-api/object-factory/packages-base/circle-factory.ts:68-74]",
    "앞에 있어야 하는 것: startPointID = point [src:mathcore-api/object-factory/packages-base/circle-factory.ts:68-74]",
    "앞에 있어야 하는 것: endPointID = point [src:mathcore-api/object-factory/packages-base/circle-factory.ts:68-74]",
    "만드는 것: circle(fan) 1개 [src:base2d/base-advanced-api/index.ts:4133] — 보임(기본값) [src:object-manager/objects/circle.ts:79], 색 color [src:base2d/base-advanced-api/index.ts:4136], 매인 개체 [ centerPointID, startPointID, endPointID, auxili… [src:base2d/base-advanced-api/index.ts:4143]",
    "함께 생김: point(auxiliary) 1개 (경유 createAuxiliaryPoint) [src:base2d/base-advanced-api/index.ts:2556] — 보임(기본값) [src:object-manager/objects/point.ts:91], 크기 9(configs.pointSize) [src:base2d/base-advanced-api/configs.ts:85], 색 #6e6868(configs.intersectionPointColor) [src:base2d/base-advanced-api/configs.ts:112]",
    "함께 생김: text(nameText) 1개 (경유 createAuxiliaryPoint → createNameText) [src:base2d/base-advanced-api/index.ts:3266] — 보임(기본값) [src:object-manager/objects/text.ts:63], 위치 오프셋(화면 px) [16, -16] [src:base2d/base-advanced-api/index.ts:3268], 크기 16(configs.nametextSize) [src:base2d/base-advanced-api/configs.ts:92], 글꼴 'KaTeX'(configs.nametextFont) [src:base2d/base-advanced-api/configs.ts:94], 색 #000(configs.nametextColor) [src:base2d/base-advanced-api/configs.ts:93], 매인 개체 [point.id] [src:base2d/base-advanced-api/index.ts:3269]",
    "함께 생김, 조건부(isLineSymmetry): linear(segment) 여러 개(반복문) (경유 createAuxiliarySegment) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [centerPointID, auxiliaryPointID] [src:base2d/base-advanced-api/index.ts:3579]",
    "함께 생김, 조건부(!(isLineSymmetry)): linear(segment) 1개 (경유 createAuxiliarySegment) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [centerPointID, startPointID] [src:base2d/base-advanced-api/index.ts:3579]",
    "참고: 시작점이 반지름을 정하고 끝점은 방향만 정한다. 시작에서 끝까지 반시계 방향이다 [src:docs/palette/circle.md:126]",
    "참고: measure.area 는 부채꼴 넓이를, measure.lengthByObjectId 는 호의 길이(두 반지름 선분은 제외)를 낸다. 끝점은 방향만 정하고 시작점과 끝점이 같은 방향이면 한 바퀴(원 전체)로 계산된다. [src:정합성 circle: scripts/pipeline/semantic/circle.mjs 의 시험 「fan(O,A,B) 1사분면 4분원: 넓이 (부채꼴) 3.14」, 「길이는 호의 길이 3.14」, 「fan(O,A,H) 시작 방향과 끝 방향이 같다(0도)」]",
    "참고: 캔버스에서는 점을 세 번 눌러(중심, 시작점, 끝 방향) 만들고 셋째 클릭에서 부채꼴과 보조 선분 둘이 함께 서서 활성화된다. 캔버스는 isLineSymmetry 를 쓰지 않으며 이 도구도 받지 않는다. [src:정합성 circle: 버튼: base2d-geometry.ts:296(「부채꼴」). 이벤트: /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d-tools/src/tools/math2d-tools/tool-fan.ts:44-93(:70-74 createFan(p0,p1,p2), :87-92 부채꼴과 auxiliarySegments 를 활성화), :95-152. 시험: circle.mjs 의 「캔버스 fan: ...」]",
    "생성 결과: 부채꼴 하나(면이 채워짐)와 함께 보조 점 1개와 그 이름표, 보조 선분 2개([중심, 시작점], [중심, 끝 방향의 원 위 점])가 선다. isLineSymmetry 는 받지 않는다(네 번째 자리는 이름). 보조 점은 다음 미사용 대문자를 가져가므로 문항의 점을 먼저 세운다. [src:정합성 circle: scripts/pipeline/semantic/circle.mjs 의 시험 「함께 서는 보조 선분 2」, 「부채꼴 보조 선분 2개: 중심,시작점, 중심,보조점」, 「면이 채워진다(patterns.type FILL=0)」, 「부채꼴은 isLineSymmetry 를 받지 않는다」]"
   ],
   "range": [
    "centerPointID: 형식 String [src:mathcore-api/object-factory/packages-base/circle-factory.ts:69] [src:mathcore-api/object-factory/object-types.ts:92]",
    "startPointID: 형식 String [src:mathcore-api/object-factory/packages-base/circle-factory.ts:70] [src:mathcore-api/object-factory/object-types.ts:92]",
    "endPointID: 형식 String [src:mathcore-api/object-factory/packages-base/circle-factory.ts:71] [src:mathcore-api/object-factory/object-types.ts:92]",
    "name?: 형식 String | Undefined [src:mathcore-api/object-factory/packages-base/circle-factory.ts:72] [src:mathcore-api/object-factory/object-types.ts:93]; 생략하면 this.getNewObjectName() [src:base2d/base-advanced-api/index.ts:4116]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): position=[0, 0], startPosition=[0, 0], endPosition=[0, 0], radius=1, angleRange=[0, 2 * Math.PI] [src:object-manager/objects/circle.ts:82-86]"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "circle.semiCircle",
   "path": [
    "circle",
    "semiCircle"
   ],
   "params": [
    {
     "name": "centerPointID",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "startPointID",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "endPointID",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "isLineSymmetry",
     "type": "boolean",
     "optional": true
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "packages-base/circle-factory.ts",
   "usage": [
    "용도: 활꼴(호와 그 현으로 둘러싸인 도형). 반원이 되려면 시작점과 끝점이 중심에 대해 지름의 양 끝에 있어야 한다. [src:정합성 circle: scripts/pipeline/semantic/circle.mjs 의 시험 「시작과 끝이 지름의 양 끝이면 반원: 현이 지름이고 넓이 2π」, 「semiCircle(O,A,B) 1사분면 4분원: 넓이 (활꼴) 1.14」]",
    "호출: factory.circle.semiCircle → advanced.createSegmentOfACircle [src:mathcore-api/object-factory/packages-base/circle-factory.ts:76-83] [src:base2d/base-advanced-api/index.ts:4175-4205]",
    "앞에 있어야 하는 것: centerPointID = point [src:mathcore-api/object-factory/packages-base/circle-factory.ts:76-83]",
    "앞에 있어야 하는 것: startPointID = point [src:mathcore-api/object-factory/packages-base/circle-factory.ts:76-83]",
    "앞에 있어야 하는 것: endPointID = point [src:mathcore-api/object-factory/packages-base/circle-factory.ts:76-83]",
    "만드는 것: circle(segmentOfACircle) 1개 [src:base2d/base-advanced-api/index.ts:4192] — 보임(기본값) [src:object-manager/objects/circle.ts:79], 색 color [src:base2d/base-advanced-api/index.ts:4195], 매인 개체 [ centerPointID, startPointID, endPointID, auxili… [src:base2d/base-advanced-api/index.ts:4199]",
    "함께 생김: point(auxiliary) 1개 (경유 createAuxiliaryPoint) [src:base2d/base-advanced-api/index.ts:2556] — 보임(기본값) [src:object-manager/objects/point.ts:91], 크기 9(configs.pointSize) [src:base2d/base-advanced-api/configs.ts:85], 색 #6e6868(configs.intersectionPointColor) [src:base2d/base-advanced-api/configs.ts:112]",
    "함께 생김: text(nameText) 1개 (경유 createAuxiliaryPoint → createNameText) [src:base2d/base-advanced-api/index.ts:3266] — 보임(기본값) [src:object-manager/objects/text.ts:63], 위치 오프셋(화면 px) [16, -16] [src:base2d/base-advanced-api/index.ts:3268], 크기 16(configs.nametextSize) [src:base2d/base-advanced-api/configs.ts:92], 글꼴 'KaTeX'(configs.nametextFont) [src:base2d/base-advanced-api/configs.ts:94], 색 #000(configs.nametextColor) [src:base2d/base-advanced-api/configs.ts:93], 매인 개체 [point.id] [src:base2d/base-advanced-api/index.ts:3269]",
    "함께 생김, 조건부(isLineSymmetry): linear(segment) 1개 (경유 createAuxiliarySegment) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [endPointID, auxiliaryPointID] [src:base2d/base-advanced-api/index.ts:3579]",
    "함께 생김, 조건부(!(isLineSymmetry)): linear(segment) 1개 (경유 createAuxiliarySegment) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [startPointID, auxiliaryPointID] [src:base2d/base-advanced-api/index.ts:3579]",
    "참고: 반원이 아니라 활꼴(호와 그 현으로 둘러싸인 도형)이다. 시작에서 끝까지 반시계 방향이다 [src:docs/palette/circle.md:70]",
    "참고: measure.area 는 활꼴 넓이(부채꼴에서 삼각형을 뺀 값, 큰 활꼴 포함)를, measure.lengthByObjectId 는 호의 길이(현은 제외)를 낸다. [src:정합성 circle: scripts/pipeline/semantic/circle.mjs 의 시험 「semiCircle(O,B,A) 시작과 끝을 바꾸면 3/4 원: 넓이 (활꼴) 11.42」, 「길이는 호의 길이」, 「파이프라인 경유: 활꼴 g1 의 넓이 1.14, 호 길이 3.14」]",
    "참고: 캔버스의 「활꼴」 버튼은 점을 세 번 눌러(중심, 시작점, 끝 방향) 만들고 셋째 클릭에서 활꼴과 보조 선분(현)이 선다. 캔버스는 인자 3개만 넘기므로 isLineSymmetry 는 항상 false 이고, true 는 이 도구를 직접 부를 때만 쓸 수 있다. [src:정합성 circle: 버튼: base2d-geometry.ts:305(「활꼴」), UI 이름 대응은 mathcore-api/src/app/math2d/tool-manager.ts:103(circle/semiCircle -> segmentOfACircle). 이벤트: /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d-tools/src/tools/math2d-tools/tool-segment-of-a-circle.ts:39-88(:65-69 createSegmentOfACircle(p0,p1,p2) 인자 3개), :90-143. 시험: circle.mjs 의 「캔버스 semiCircle: ...」]",
    "생성 결과: 활꼴 하나와 함께 보조 점 1개, 그 이름표, 보조 선분 1개가 선다. 선분은 isLineSymmetry 가 false(생략)이면 [시작점, 끝 방향의 원 위 점]이고 true 이면 [끝점, 끝 방향의 원 위 점]이다. 보조 점은 다음 미사용 대문자를 가져가므로 문항의 점을 먼저 세운다. [src:정합성 circle: scripts/pipeline/semantic/circle.mjs 의 시험 「활꼴 보조 선분 1개: 시작점,보조점 (현)」, 「isLineSymmetry=false: 현은 시작점, 끝 방향의 원 위 점」, 「isLineSymmetry=true: 선분은 끝점, 끝 방향의 원 위 점」]"
   ],
   "range": [
    "centerPointID: 형식 String [src:mathcore-api/object-factory/packages-base/circle-factory.ts:77] [src:mathcore-api/object-factory/object-types.ts:92]",
    "startPointID: 형식 String [src:mathcore-api/object-factory/packages-base/circle-factory.ts:78] [src:mathcore-api/object-factory/object-types.ts:92]",
    "endPointID: 형식 String [src:mathcore-api/object-factory/packages-base/circle-factory.ts:79] [src:mathcore-api/object-factory/object-types.ts:92]",
    "isLineSymmetry?: 형식 Boolean [src:mathcore-api/object-factory/packages-base/circle-factory.ts:80] [src:mathcore-api/object-factory/object-types.ts:95]; 생략하면 false(createSegmentOfACircle) [src:base2d/base-advanced-api/index.ts:4176]",
    "name?: 형식 String | Undefined [src:mathcore-api/object-factory/packages-base/circle-factory.ts:81] [src:mathcore-api/object-factory/object-types.ts:93]; 생략하면 this.getNewObjectName() [src:base2d/base-advanced-api/index.ts:4179]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): position=[0, 0], startPosition=[0, 0], endPosition=[0, 0], radius=1, angleRange=[0, 2 * Math.PI] [src:object-manager/objects/circle.ts:82-86]",
    "isLineSymmetry 는 boolean 이고 호가 아니라 보조 선분만 바꾼다. true 에서 끝점이 원 위에 있으면 선분 길이가 0 이라 현이 그려지지 않으므로 false(생략)로 둔다. 문자열을 주면 예외이다. [src:정합성 circle: scripts/pipeline/semantic/circle.mjs 의 시험 「isLineSymmetry 는 선분 하나만 바꾸고 호 속성은 같다」, 「끝점이 원 위이면 isLineSymmetry=true 의 선분은 두 끝이 같은 길이 0」, 「네 번째 인자에 문자열을 주면 동기 예외(boolean 만)」]"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "deco.annotationBySegment",
   "path": [
    "deco",
    "annotationBySegment"
   ],
   "params": [
    {
     "name": "segmentID",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "linear",
       "category": "segment"
      }
     ]
    },
    {
     "name": "offsetPosition",
     "type": "point2",
     "optional": false
    }
   ],
   "source": "packages-base/deco-factory.ts",
   "usage": [
    "용도: 선분 한 개 옆에 점선 곡선(설명선) 하나와 글자 a 하나를 단다. 곡선의 양 끝은 선분의 두 끝점이다. 길이 같은 값을 적는 도구가 아니다. [src:정합성 measure-deco: scripts/pipeline/semantic/measure-deco.mjs 의 'AB (0,0)-(4,0), 마우스 2,1: 라벨 글자 「a」 text 1개, 위치는 곡선 정점'; mathcore deco-annotation.ts:79-91]",
    "호출: factory.deco.annotationBySegment → advanced.createDecoAnnotationBySegment [src:mathcore-api/object-factory/packages-base/deco-factory.ts:8-12] [src:base2d/base-advanced-api/index.ts:4319-4334]",
    "앞에 있어야 하는 것: segmentID = linear(segment) [src:mathcore-api/object-factory/packages-base/deco-factory.ts:8-12]",
    "만드는 것: decoAnnotation 1개 [src:base2d/base-advanced-api/index.ts:4320] — 보임(기본값) [src:object-manager/objects/deco-annotation.ts:33], 색 #000(configs.decoAnnotatoinColor) [src:base2d/base-advanced-api/configs.ts:145], 매인 개체 [segmentID] [src:base2d/base-advanced-api/index.ts:4323]",
    "함께 생김: text(decoText) 1개 (경유 createDecoText) [src:base2d/base-advanced-api/index.ts:3245] — 보임(기본값) [src:object-manager/objects/text.ts:63], 위치 오프셋(화면 px) [0, 0] [src:base2d/base-advanced-api/index.ts:3248], 크기 15(configs.decotextSize) [src:base2d/base-advanced-api/configs.ts:123], latex=true [src:base2d/base-advanced-api/index.ts:3252], 매인 개체 [object.id] [src:base2d/base-advanced-api/index.ts:3250]",
    "참고: offsetPosition 은 설명선을 놓을 쪽의 한 점의 월드 좌표이고 선분과의 수직 거리만 쓰인다. 라벨은 a 로 고정이다 [src:docs/palette/measure-deco.md:259]",
    "참고: 곡선이 선분에서 가장 멀어지는 곳(글자 a 의 자리)은 offsetPosition 점의 수직 거리의 절반이다. 선분 중점에서 수직으로 h 만큼 띄우려면 중점에서 수직으로 2h 떨어진 점을 준다(예: (0,0)-(4,0) 에 [2,1] 이면 곡선 정점은 (2,0.5)). 점이 선분 어느 쪽에 있는지가 곡선이 휘는 쪽을 정하고, 선 위의 점이면 곡선이 펴져 선분과 겹친다. [src:정합성 measure-deco: scripts/pipeline/semantic/measure-deco.mjs 의 '곡선 정점은 제어점이 아니라 중점과 제어점의 가운데: 선분에서 마우스 거리의 절반만 떨어진다(2,1 은 0.5)', '반대쪽 2,-3', '선 위 마우스(2,0)는 제어점이 선분 중점이라 휘지 않는다', '2,1 와 100,1 은 같은 제어점']",
    "참고: 직선, 반직선, 길이지정선분, 수선, 접선도 유효하게 선다. 벡터, 점, 원, 다각형, 곡선, 없는 id 를 주면 개체가 서도 무효여서 그려지지 않는다. [src:정합성 measure-deco: scripts/pipeline/semantic/measure-deco.mjs 의 '종류 line/ray/sgl/perp/tanL: 유효', '종류 vec/point/circ/poly/curve/nonexist: 개체는 서지만 무효']",
    "참고: 캔버스의 설명선 도구에서 선분을 클릭해 고른 뒤(첫 클릭, 아직 개체 없음) 설명선을 놓을 자리를 한 번 더 클릭하는 동작에 해당하고, 두 번째 클릭의 월드 좌표가 offsetPosition 이 된다. 선분을 고른 뒤의 마우스 이동은 임시 점선 곡선만 그리고 개체를 만들지 않는다. [src:정합성 measure-deco: scripts/pipeline/semantic/measure-deco.mjs 의 '캔버스: 선분 클릭(첫 클릭)은 선분을 고르기만 하고 설명선은 아직 없다', '캔버스: 선분을 고른 뒤 두 번째 클릭에서 createDecoAnnotationBySegment(선분 id, 클릭의 월드 좌표) 생성', '캔버스: 선분을 고른 뒤 마우스 이동은 임시 점선 곡선만 그린다', '캔버스 설명선 = 팩토리 deco.annotationBySegment'; /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d-tools/src/tools/math2d-tools/tool-deco-annotation.ts:49-104 (pointerDown), :106-150 (pointerMove); base2d-geometry.ts:537-548 (탭 기하 > 묶음 꾸미기 > 설명선)]",
    "생성 결과: 개체 두 개가 선다: 설명선(decoAnnotation)과 글자 a(LaTeX)로 된 text 하나. 반환 id 는 설명선의 것이다. 글자는 a 로 고정이고 인자로 바꿀 수 없다. [src:정합성 measure-deco: scripts/pipeline/semantic/measure-deco.mjs 의 '라벨 글자 「a」 text 1개' 와 '만드는 개체: decoAnnotation 1개와 text(decoText) 1개']"
   ],
   "range": [
    "segmentID: 형식 String [src:mathcore-api/object-factory/packages-base/deco-factory.ts:9] [src:mathcore-api/object-factory/object-types.ts:92]",
    "offsetPosition: 형식 (Number, Number) [src:mathcore-api/object-factory/packages-base/deco-factory.ts:10] [src:mathcore-api/object-factory/object-types.ts:99]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): strokeWidth=1, position=[0, 0], p1Position=[0, 0], p2Position=[0, 0], shape=0 [src:object-manager/objects/deco-annotation.ts:35-40]"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "deco.annotationByTwoPoints",
   "path": [
    "deco",
    "annotationByTwoPoints"
   ],
   "params": [
    {
     "name": "pointID1",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "pointID2",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "offsetPosition",
     "type": "point2",
     "optional": false
    }
   ],
   "source": "packages-base/deco-factory.ts",
   "usage": [
    "용도: 점 둘을 잇는 점선 곡선(설명선) 하나와 글자 a 하나를 단다. 곡선의 양 끝이 두 점이다. 선분 옆에 달려면 그 선분의 두 끝점을 준다. [src:정합성 measure-deco: scripts/pipeline/semantic/measure-deco.mjs 의 'A(0,0) B(4,0) 마우스 2,1: 제어점 (2,1)', 'ab: 설명선 1개와 라벨 「a」 text 1개가 서고']",
    "호출: factory.deco.annotationByTwoPoints → advanced.createDecoAnnotationByTwoPoint [src:mathcore-api/object-factory/packages-base/deco-factory.ts:14-19] [src:base2d/base-advanced-api/index.ts:4302-4317]",
    "앞에 있어야 하는 것: pointID1 = point [src:mathcore-api/object-factory/packages-base/deco-factory.ts:14-19]",
    "앞에 있어야 하는 것: pointID2 = point [src:mathcore-api/object-factory/packages-base/deco-factory.ts:14-19]",
    "만드는 것: decoAnnotation 1개 [src:base2d/base-advanced-api/index.ts:4303] — 보임(기본값) [src:object-manager/objects/deco-annotation.ts:33], 색 #000(configs.decoAnnotatoinColor) [src:base2d/base-advanced-api/configs.ts:145], 매인 개체 [pointID1, pointID2] [src:base2d/base-advanced-api/index.ts:4306]",
    "함께 생김: text(decoText) 1개 (경유 createDecoText) [src:base2d/base-advanced-api/index.ts:3245] — 보임(기본값) [src:object-manager/objects/text.ts:63], 위치 오프셋(화면 px) [0, 0] [src:base2d/base-advanced-api/index.ts:3248], 크기 15(configs.decotextSize) [src:base2d/base-advanced-api/configs.ts:123], latex=true [src:base2d/base-advanced-api/index.ts:3252], 매인 개체 [object.id] [src:base2d/base-advanced-api/index.ts:3250]",
    "참고: offsetPosition 은 설명선을 놓을 쪽의 한 점의 월드 좌표이고 선분과의 수직 거리만 쓰인다. 라벨은 a 로 고정이다 [src:docs/palette/measure-deco.md:259]",
    "참고: 곡선이 두 점을 잇는 직선에서 가장 멀어지는 곳(글자 a 의 자리)은 offsetPosition 점의 수직 거리의 절반이다. 중점에서 수직으로 h 만큼 띄우려면 2h 떨어진 점을 준다(예: (0,0),(4,0) 에 [2,1] 이면 정점은 (2,0.5)). 점 둘의 순서는 위치에 영향이 없고 점이 직선 어느 쪽에 있는지가 곡선이 휘는 쪽을 정한다. [src:정합성 measure-deco: scripts/pipeline/semantic/measure-deco.mjs 의 '점 순서를 바꿔도 같은 제어점', '비스듬 (0,0)-(4,3) 마우스 0,3: 제어점 (0.56, 3.42)']",
    "참고: 점 자리에는 점 두 개만 준다. 첫째 인자에 선분을 주면 둘째 인자는 무시되고 그 선분의 양 끝점이 쓰이며, 첫째가 점이고 둘째가 선분이면 무효다. 같은 점 둘이면 퇴화한 곡선이 유효하게 선다. [src:정합성 measure-deco: scripts/pipeline/semantic/measure-deco.mjs 의 '(선분 AB, 점 D): 둘째 인자 D 는 무시되고 끝점은 선분 AB 의 A, B', '(점, 선분): 무효', '같은 점 둘 (A,A): 퇴화한 곡선이지만 유효로 선다'; mathcore deco-annotation.ts:57-73]",
    "참고: 캔버스의 설명선 도구에서 점 둘을 차례로 클릭해 고른 뒤 설명선을 놓을 자리를 한 번 더 클릭(세 번째 클릭)하는 동작에 해당하고, 그 클릭의 월드 좌표가 offsetPosition 이 된다. 점 하나만 고른 상태에서 선분을 클릭하면 무시된다. [src:정합성 measure-deco: scripts/pipeline/semantic/measure-deco.mjs 의 '캔버스: 점 하나를 고른 뒤 선분 클릭은 무시되고, 점 둘을 고른 순간에는 아직 설명선이 없다', '캔버스: 점 둘을 고른 뒤 세 번째 클릭에서 createDecoAnnotationByTwoPoint(p1,p2,클릭 월드 좌표) 생성', '캔버스 점 둘 설명선 = 팩토리 deco.annotationByTwoPoints'; /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d-tools/src/tools/math2d-tools/tool-deco-annotation.ts:55-98]",
    "생성 결과: 개체 두 개가 선다: 설명선(decoAnnotation)과 글자 a(LaTeX)로 된 text 하나. 반환 id 는 설명선의 것이다. 글자는 a 로 고정이고 인자로 바꿀 수 없다. [src:정합성 measure-deco: scripts/pipeline/semantic/measure-deco.mjs 의 'ab: 설명선 1개와 라벨 「a」 text 1개가 서고 점 둘의 RO 에 들어간다']"
   ],
   "range": [
    "pointID1: 형식 String [src:mathcore-api/object-factory/packages-base/deco-factory.ts:15] [src:mathcore-api/object-factory/object-types.ts:92]",
    "pointID2: 형식 String [src:mathcore-api/object-factory/packages-base/deco-factory.ts:16] [src:mathcore-api/object-factory/object-types.ts:92]",
    "offsetPosition: 형식 (Number, Number) [src:mathcore-api/object-factory/packages-base/deco-factory.ts:17] [src:mathcore-api/object-factory/object-types.ts:99]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): strokeWidth=1, position=[0, 0], p1Position=[0, 0], p2Position=[0, 0], shape=0 [src:object-manager/objects/deco-annotation.ts:35-40]"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "deco.lengthByObject",
   "path": [
    "deco",
    "lengthByObject"
   ],
   "params": [
    {
     "name": "targetObjectID",
     "type": "ref",
     "optional": false,
     "accepts": "any"
    }
   ],
   "source": "packages-base/deco-factory.ts",
   "usage": [
    "용도(도구 UI 설명): 길이 — 길이를 만들 선을 선택하세요. [src:base2d-ui/src/tab/tools/configs/base2d-geometry.ts:563]",
    "호출: factory.deco.lengthByObject → advanced.createDecoLength [src:mathcore-api/object-factory/packages-base/deco-factory.ts:21-24] [src:base2d/base-advanced-api/index.ts:4260-4272]",
    "앞에 있어야 하는 것: targetObjectID = 아무 개체 [src:mathcore-api/object-factory/packages-base/deco-factory.ts:21-24]",
    "만드는 것: decoLength 1개 [src:base2d/base-advanced-api/index.ts:4261] — 보임(기본값) [src:object-manager/objects/deco-length.ts:28], 색 #000(configs.decoLengthColor) [src:base2d/base-advanced-api/configs.ts:143], 매인 개체 [targetObjectID] [src:base2d/base-advanced-api/index.ts:4264]",
    "함께 생김: text(nameText) 1개 (경유 createNameTextByDeco) [src:base2d/base-advanced-api/index.ts:3290] — 숨김 [src:base2d/base-advanced-api/index.ts:3301], 위치 오프셋(화면 px) [24, 24] || [16, -16] [src:base2d/base-advanced-api/index.ts:3292], 크기 16(configs.nametextSize) [src:base2d/base-advanced-api/configs.ts:92], 글꼴 'KaTeX'(configs.nametextFont) [src:base2d/base-advanced-api/configs.ts:94], 색 #000(configs.nametextColor) [src:base2d/base-advanced-api/configs.ts:93], 매인 개체 [object.id] [src:base2d/base-advanced-api/index.ts:3293]",
    "참고: 길이 숫자가 아니라 같은 길이임을 보이는 눈금 표식이다. 숫자는 쓰지 못한다 [src:docs/palette/measure-deco.md:293]"
   ],
   "range": [
    "targetObjectID: 형식 String [src:mathcore-api/object-factory/packages-base/deco-factory.ts:22] [src:mathcore-api/object-factory/object-types.ts:92]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): position=[0, 0], criterionDirection=0, tickNumber=2 [src:object-manager/objects/deco-length.ts:30-32]"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "deco.lengthByTwoPoints",
   "path": [
    "deco",
    "lengthByTwoPoints"
   ],
   "params": [
    {
     "name": "pointID1",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "pointID2",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "packages-base/deco-factory.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: factory.deco.lengthByTwoPoints → advanced.createDecoLengthByTwoPointID [src:mathcore-api/object-factory/packages-base/deco-factory.ts:26-31] [src:base2d/base-advanced-api/index.ts:4274-4286]",
    "앞에 있어야 하는 것: pointID1 = point [src:mathcore-api/object-factory/packages-base/deco-factory.ts:26-31]",
    "앞에 있어야 하는 것: pointID2 = point [src:mathcore-api/object-factory/packages-base/deco-factory.ts:26-31]",
    "만드는 것: decoLength 1개 [src:base2d/base-advanced-api/index.ts:4275] — 보임(기본값) [src:object-manager/objects/deco-length.ts:28], 색 #000(configs.decoLengthColor) [src:base2d/base-advanced-api/configs.ts:143], 매인 개체 [pointID1, pointID2] [src:base2d/base-advanced-api/index.ts:4278]",
    "함께 생김: text(nameText) 1개 (경유 createNameTextByDeco) [src:base2d/base-advanced-api/index.ts:3290] — 숨김 [src:base2d/base-advanced-api/index.ts:3301], 위치 오프셋(화면 px) [24, 24] || [16, -16] [src:base2d/base-advanced-api/index.ts:3292], 크기 16(configs.nametextSize) [src:base2d/base-advanced-api/configs.ts:92], 글꼴 'KaTeX'(configs.nametextFont) [src:base2d/base-advanced-api/configs.ts:94], 색 #000(configs.nametextColor) [src:base2d/base-advanced-api/configs.ts:93], 매인 개체 [object.id] [src:base2d/base-advanced-api/index.ts:3293]",
    "참고: 길이 숫자가 아니라 같은 길이임을 보이는 눈금 표식이다. 숫자는 쓰지 못한다 [src:docs/palette/measure-deco.md:293]"
   ],
   "range": [
    "pointID1: 형식 String [src:mathcore-api/object-factory/packages-base/deco-factory.ts:27] [src:mathcore-api/object-factory/object-types.ts:92]",
    "pointID2: 형식 String [src:mathcore-api/object-factory/packages-base/deco-factory.ts:28] [src:mathcore-api/object-factory/object-types.ts:92]",
    "name?: 형식 String | Undefined [src:mathcore-api/object-factory/packages-base/deco-factory.ts:29] [src:mathcore-api/object-factory/object-types.ts:93]; advanced.createDecoLengthByTwoPointID 가 받지만 본문에서 쓰지 않는다, 넣어도 무시된다 [src:base2d/base-advanced-api/index.ts:4274-4286]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): position=[0, 0], criterionDirection=0, tickNumber=2 [src:object-manager/objects/deco-length.ts:30-32]"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "deco.direction",
   "path": [
    "deco",
    "direction"
   ],
   "params": [
    {
     "name": "targetObjectID",
     "type": "ref",
     "optional": false,
     "accepts": "any"
    },
    {
     "name": "position",
     "type": "point2",
     "optional": false
    }
   ],
   "source": "packages-base/deco-factory.ts",
   "usage": [
    "용도(도구 UI 설명): 평행 — 평행을 만들 선을 선택하세요. [src:base2d-ui/src/tab/tools/configs/base2d-geometry.ts:553]",
    "호출: factory.deco.direction → advanced.createDecoDirection [src:mathcore-api/object-factory/packages-base/deco-factory.ts:33-39] [src:base2d/base-advanced-api/index.ts:4242-4258]",
    "앞에 있어야 하는 것: targetObjectID = 아무 개체 [src:mathcore-api/object-factory/packages-base/deco-factory.ts:33-39]",
    "만드는 것: decoDirection 1개 [src:base2d/base-advanced-api/index.ts:4243] — 보임(기본값) [src:object-manager/objects/deco-direction.ts:30], 크기 12(configs.decoDirectionSize) [src:base2d/base-advanced-api/configs.ts:140], 색 #000(configs.decoDirectionColor) [src:base2d/base-advanced-api/configs.ts:141], 매인 개체 [targetObject.raw.id] [src:base2d/base-advanced-api/index.ts:4247]",
    "함께 생김: text(nameText) 1개 (경유 createNameTextByDeco) [src:base2d/base-advanced-api/index.ts:3290] — 숨김 [src:base2d/base-advanced-api/index.ts:3301], 위치 오프셋(화면 px) [24, 24] || [16, -16] [src:base2d/base-advanced-api/index.ts:3292], 크기 16(configs.nametextSize) [src:base2d/base-advanced-api/configs.ts:92], 글꼴 'KaTeX'(configs.nametextFont) [src:base2d/base-advanced-api/configs.ts:94], 색 #000(configs.nametextColor) [src:base2d/base-advanced-api/configs.ts:93], 매인 개체 [object.id] [src:base2d/base-advanced-api/index.ts:3293]"
   ],
   "range": [
    "targetObjectID: 형식 String [src:mathcore-api/object-factory/packages-base/deco-factory.ts:34] [src:mathcore-api/object-factory/object-types.ts:92]",
    "position: 형식 (Number, Number) [src:mathcore-api/object-factory/packages-base/deco-factory.ts:35] [src:mathcore-api/object-factory/object-types.ts:99]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): criterionAngle=0, plusDirection=0 [src:object-manager/objects/deco-direction.ts:34-35]"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "deco.angle",
   "path": [
    "deco",
    "angle"
   ],
   "params": [
    {
     "name": "pointID1",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "pointID2",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "pointID3",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    }
   ],
   "source": "packages-base/deco-factory.ts",
   "usage": [
    "용도(도구 UI 설명): 각도 — 각도를 만들 세 점을 선택하세요. [src:base2d-ui/src/tab/tools/configs/base2d-geometry.ts:573]",
    "호출: factory.deco.angle → advanced.createDecoAngle [src:mathcore-api/object-factory/packages-base/deco-factory.ts:41-46] [src:base2d/base-advanced-api/index.ts:4288-4300]",
    "앞에 있어야 하는 것: pointID1 = point [src:mathcore-api/object-factory/packages-base/deco-factory.ts:41-46]",
    "앞에 있어야 하는 것: pointID2 = point [src:mathcore-api/object-factory/packages-base/deco-factory.ts:41-46]",
    "앞에 있어야 하는 것: pointID3 = point [src:mathcore-api/object-factory/packages-base/deco-factory.ts:41-46]",
    "만드는 것: decoAngle 1개 [src:base2d/base-advanced-api/index.ts:4289] — 보임(기본값) [src:object-manager/objects/deco-angle.ts:38], 색 #ff0000(configs.decoAngleColor) [src:base2d/base-advanced-api/configs.ts:144], 매인 개체 [pointID1, pointID2, pointID3] [src:base2d/base-advanced-api/index.ts:4292]",
    "함께 생김: text(nameText) 1개 (경유 createNameTextByDeco) [src:base2d/base-advanced-api/index.ts:3290] — 숨김 [src:base2d/base-advanced-api/index.ts:3301], 위치 오프셋(화면 px) [24, 24] || [16, -16] [src:base2d/base-advanced-api/index.ts:3292], 크기 16(configs.nametextSize) [src:base2d/base-advanced-api/configs.ts:92], 글꼴 'KaTeX'(configs.nametextFont) [src:base2d/base-advanced-api/configs.ts:94], 색 #000(configs.nametextColor) [src:base2d/base-advanced-api/configs.ts:93], 매인 개체 [object.id] [src:base2d/base-advanced-api/index.ts:3293]",
    "참고: 반시계로 90도가 되는 점 순서일 때만 직각 표시가 되고 그 밖의 각은 점 하나만 찍힌다 [src:docs/palette/measure-deco.md:341]"
   ],
   "range": [
    "pointID1: 형식 String [src:mathcore-api/object-factory/packages-base/deco-factory.ts:42] [src:mathcore-api/object-factory/object-types.ts:92]",
    "pointID2: 형식 String [src:mathcore-api/object-factory/packages-base/deco-factory.ts:43] [src:mathcore-api/object-factory/object-types.ts:92]",
    "pointID3: 형식 String [src:mathcore-api/object-factory/packages-base/deco-factory.ts:44] [src:mathcore-api/object-factory/object-types.ts:92]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): size=10, position=[0, 0], startDirection=vec2.create(), endDirection=vec2.create(), centerDirection=vec2.create(), betweenAngle=0, startAngle=0, endAngle=0, roundNumber=0, radius=20, strokeWidth=1, isRightAngleOn=true [src:object-manager/objects/deco-angle.ts:40-51]",
    "값 자르기: d.startAngle < 0 → d.startAngle = 2 * Math.PI + d.startAngle [src:object-manager/objects/deco-angle.ts:111]",
    "값 자르기: d.endAngle < 0 → d.endAngle = 2 * Math.PI + d.endAngle [src:object-manager/objects/deco-angle.ts:114]"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "etc.text",
   "path": [
    "etc",
    "text"
   ],
   "params": [
    {
     "name": "x",
     "type": "number|string",
     "optional": false
    },
    {
     "name": "y",
     "type": "number|string",
     "optional": false
    },
    {
     "name": "text",
     "type": "string",
     "optional": false
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "packages-base/etc-factory.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: factory.etc.text → advanced.createText [src:mathcore-api/object-factory/packages-base/etc-factory.ts:8-14] [src:base2d/base-advanced-api/index.ts:3191-3214]",
    "만드는 것: text 1개 [src:base2d/base-advanced-api/index.ts:3203] — 보임(기본값) [src:object-manager/objects/text.ts:63], 크기 16(configs.textSize) [src:base2d/base-advanced-api/configs.ts:89], 글꼴 'D2coding' [src:base2d/base-advanced-api/index.ts:3208], 색 #000(configs.textColor) [src:base2d/base-advanced-api/configs.ts:90], latex=false [src:base2d/base-advanced-api/index.ts:3206], isScreenCoord=true [src:base2d/base-advanced-api/index.ts:3212]"
   ],
   "range": [
    "x: 형식 Number | String [src:mathcore-api/object-factory/packages-base/etc-factory.ts:9] [src:mathcore-api/object-factory/object-types.ts:105]; 숫자가 아닌 문자열이면 슬라이더 연결식으로 들어가 그 값을 따라 움직인다 [src:base2d/base-advanced-api/index.ts:644-654]",
    "y: 형식 Number | String [src:mathcore-api/object-factory/packages-base/etc-factory.ts:10] [src:mathcore-api/object-factory/object-types.ts:105]; 숫자가 아닌 문자열이면 슬라이더 연결식으로 들어가 그 값을 따라 움직인다 [src:base2d/base-advanced-api/index.ts:644-654]",
    "text: 형식 String [src:mathcore-api/object-factory/packages-base/etc-factory.ts:11] [src:mathcore-api/object-factory/object-types.ts:92]",
    "name?: 형식 String | Undefined [src:mathcore-api/object-factory/packages-base/etc-factory.ts:12] [src:mathcore-api/object-factory/object-types.ts:93]; 생략하면 this.getNewObjectName() [src:base2d/base-advanced-api/index.ts:3209]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): bold=false, italic=false, underline=false, style='', relatedPosition=[0, 0], rotation=0, dynamicText='' [src:object-manager/objects/text.ts:66-78]"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "etc.textLatex",
   "path": [
    "etc",
    "textLatex"
   ],
   "params": [
    {
     "name": "x",
     "type": "number|string",
     "optional": false
    },
    {
     "name": "y",
     "type": "number|string",
     "optional": false
    },
    {
     "name": "text",
     "type": "string",
     "optional": false
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "packages-base/etc-factory.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: factory.etc.textLatex → advanced.createLatexText [src:mathcore-api/object-factory/packages-base/etc-factory.ts:16-22] [src:base2d/base-advanced-api/index.ts:3216-3235]",
    "만드는 것: text 1개 [src:base2d/base-advanced-api/index.ts:3226] — 보임(기본값) [src:object-manager/objects/text.ts:63], 크기 16(configs.textSize) [src:base2d/base-advanced-api/configs.ts:89], 색 #000(configs.textColor) [src:base2d/base-advanced-api/configs.ts:90], latex=true [src:base2d/base-advanced-api/index.ts:3233]"
   ],
   "range": [
    "x: 형식 Number | String [src:mathcore-api/object-factory/packages-base/etc-factory.ts:17] [src:mathcore-api/object-factory/object-types.ts:105]; 숫자가 아닌 문자열이면 슬라이더 연결식으로 들어가 그 값을 따라 움직인다 [src:base2d/base-advanced-api/index.ts:644-654]",
    "y: 형식 Number | String [src:mathcore-api/object-factory/packages-base/etc-factory.ts:18] [src:mathcore-api/object-factory/object-types.ts:105]; 숫자가 아닌 문자열이면 슬라이더 연결식으로 들어가 그 값을 따라 움직인다 [src:base2d/base-advanced-api/index.ts:644-654]",
    "text: 형식 String [src:mathcore-api/object-factory/packages-base/etc-factory.ts:19] [src:mathcore-api/object-factory/object-types.ts:92]",
    "name?: 형식 String | Undefined [src:mathcore-api/object-factory/packages-base/etc-factory.ts:20] [src:mathcore-api/object-factory/object-types.ts:93]; 생략하면 this.getNewObjectName() [src:base2d/base-advanced-api/index.ts:3229]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): bold=false, italic=false, underline=false, style='', isScreenCoord=false, relatedPosition=[0, 0], rotation=0, font='NanumSquareR', dynamicText='' [src:object-manager/objects/text.ts:66-78]"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "etc.slider",
   "path": [
    "etc",
    "slider"
   ],
   "params": [
    {
     "name": "x",
     "type": "number",
     "optional": false
    },
    {
     "name": "y",
     "type": "number",
     "optional": false
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "packages-base/etc-factory.ts",
   "usage": [
    "용도: 월드 좌표 (x, y) 에 값을 조절하는 슬라이더 하나를 만든다. 슬라이더 이름이 식의 기호 이름이 되어 그 기호를 이 슬라이더 값으로 계산하게 한다. 캔버스에서는 빈 곳을 한 번 누르면 서고 그때 도구가 선택 도구로 돌아간다. [src:정합성 alg-point: scripts/pipeline/semantic/alg-point.mjs: 캔버스 버튼: 기하 탭 기본도구 묶음의 「슬라이더 (Y)」 | 도구가 선택 도구로 돌아가므로 두 번째 클릭은 슬라이더를 더 만들지 않는다 | /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d-tools/src/tools/math2d-tools/tool-slider.ts:16-21]",
    "호출: factory.etc.slider → advanced.createSlider [src:mathcore-api/object-factory/packages-base/etc-factory.ts:24-30] [src:base2d/base-advanced-api/index.ts:3059-3073]",
    "만드는 것: slider 1개 [src:base2d/base-advanced-api/index.ts:3062] — 보임(기본값) [src:object-manager/objects/slider.ts:41], 색 this.getNewObjectColor() [src:base2d/base-advanced-api/index.ts:3066], 매인 개체 [] [src:base2d/base-advanced-api/index.ts:3069]",
    "참고: 연결: 이 슬라이더의 name 을 다른 개체의 식 안 기호 이름으로 쓰면 그 개체가 슬라이더 값으로 계산된다. 슬라이더를 그 식보다 먼저 세운다 [src:object-manager/objects/common.ts:87-100]",
    "참고: 값 0, 범위 -10에서 10, 눈금 0.1 로 고정이고 인자로 바꿀 수 없다 [src:docs/palette/etc-motion.md:44]",
    "참고: 식과 연결되는 이름은 영문 한 글자(a, K)나 a_1 꼴이다. algebraric 의 식에서 x 는 변수, e 는 상수라 연결되지 않고, 여러 글자 이름은 어디에도 연결되지 않는다. 이름을 생략하면 a, b, c, d, i, j 순으로 붙는다. [src:정합성 alg-point: scripts/pipeline/semantic/alg-point.mjs: 이름 a_1 과 대문자 K 슬라이더도 연결된다 | 이름 x 인 슬라이더는 식에서 연결되지 않는다 | 이름 e 인 슬라이더는 식 y=e 에 연결되지 않는다 | 이름을 생략하거나 빈 글자로 주면 자동 이름]",
    "참고: 한 기호 이름에 슬라이더는 하나만 둔다. 같은 이름의 슬라이더가 이미 있거나(식이 말없이 세운 것 포함) algebraric 로 그 이름을 a=3 처럼 정의해 두었으면, 새 슬라이더를 세우는 순간 그 이름을 쓰는 식이 무효가 된다. [src:정합성 alg-point: scripts/pipeline/semantic/alg-point.mjs: 식이 만든 자동 슬라이더 b 가 있는 채로 etc.slider 이름 b 를 또 세우면 식이 무효 | algebraric c=3 으로 매개를 정의한 뒤 etc.slider c 를 세우면]",
    "참고: 호출로 값을 바꿀 수 없어 값은 0 이다(캔버스에서는 선택 도구로 손잡이를 끌어 바꾸지만 JSON 호출에는 값 인자도 값을 바꾸는 도구도 없다). 이 이름을 쓴 식은 그 기호를 0 으로 놓고 그려진다(y=ax 는 y=0, 점 (a,a+1) 은 (0,1)). [src:정합성 alg-point: scripts/pipeline/semantic/alg-point.mjs: runCalls 경로: 슬라이더를 세운 뒤 y=ax 를 세우면 | 슬라이더 a(값 0) 에 묶인 점은 처음에 (0,1), (0,0) | 캔버스 선택 도구로 슬라이더 손잡이를 막대 길이 | /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d-tools/src/tool.ts:1688-1705]"
   ],
   "range": [
    "x: 형식 Number [src:mathcore-api/object-factory/packages-base/etc-factory.ts:25] [src:mathcore-api/object-factory/object-types.ts:94]",
    "y: 형식 Number [src:mathcore-api/object-factory/packages-base/etc-factory.ts:26] [src:mathcore-api/object-factory/object-types.ts:94]",
    "name?: 형식 String | Undefined [src:mathcore-api/object-factory/packages-base/etc-factory.ts:27] [src:mathcore-api/object-factory/object-types.ts:93]; 생략하면 this.getNewSliderName() [src:base2d/base-advanced-api/index.ts:3060]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): value=0, min=-10, max=10, step=0.1, animation={ active: false, direct…, length=70, fixed=false [src:object-manager/objects/slider.ts:45-57]",
    "값 자르기: s.value = Math.max(s.min, Math.min(s.max, s.value)) [src:object-manager/objects/slider.ts:69]"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "etc.checkbox",
   "path": [
    "etc",
    "checkbox"
   ],
   "params": [
    {
     "name": "x",
     "type": "number|string",
     "optional": false
    },
    {
     "name": "y",
     "type": "number|string",
     "optional": false
    },
    {
     "name": "name",
     "type": "string",
     "optional": false
    }
   ],
   "source": "packages-base/etc-factory.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: factory.etc.checkbox → advanced.createCheckbox [src:mathcore-api/object-factory/packages-base/etc-factory.ts:32-37] [src:base2d/base-advanced-api/index.ts:4336-4356]",
    "만드는 것: checkbox 1개 [src:base2d/base-advanced-api/index.ts:4342] — 보임(기본값) [src:object-manager/objects/checkbox.ts:41], 색 #fe7701(configs.checkboxColor) [src:base2d/base-advanced-api/configs.ts:125]",
    "함께 생김: text(nameText) 1개 (경유 createNameTextByCheckbox) [src:base2d/base-advanced-api/index.ts:3315] — 보임(기본값) [src:object-manager/objects/text.ts:63], 위치 오프셋(화면 px) [24, 24] || [16, -16] [src:base2d/base-advanced-api/index.ts:3317], 크기 16(configs.nametextSize) [src:base2d/base-advanced-api/configs.ts:92], 글꼴 'KaTeX'(configs.nametextFont) [src:base2d/base-advanced-api/configs.ts:94], 색 #000(configs.nametextColor) [src:base2d/base-advanced-api/configs.ts:93], 매인 개체 [object.id] [src:base2d/base-advanced-api/index.ts:3318]",
    "참고: 보이고 숨길 대상을 정하는 인자가 이 도구에 없다. 대상은 속성 checkboxConnectInfo 로만 정해진다 [src:object-manager/objects/checkbox.ts:32]"
   ],
   "range": [
    "x: 형식 Number | String [src:mathcore-api/object-factory/packages-base/etc-factory.ts:33] [src:mathcore-api/object-factory/object-types.ts:105]; 숫자가 아닌 문자열이면 슬라이더 연결식으로 들어가 그 값을 따라 움직인다 [src:base2d/base-advanced-api/index.ts:644-654]",
    "y: 형식 Number | String [src:mathcore-api/object-factory/packages-base/etc-factory.ts:34] [src:mathcore-api/object-factory/object-types.ts:105]; 숫자가 아닌 문자열이면 슬라이더 연결식으로 들어가 그 값을 따라 움직인다 [src:base2d/base-advanced-api/index.ts:644-654]",
    "name: 형식 String [src:mathcore-api/object-factory/packages-base/etc-factory.ts:35] [src:mathcore-api/object-factory/object-types.ts:92]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): fixScreen=true, checkboxConnectInfo={} [src:object-manager/objects/checkbox.ts:46-47]"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "etc.image",
   "path": [
    "etc",
    "image"
   ],
   "params": [
    {
     "name": "x",
     "type": "number|string",
     "optional": false
    },
    {
     "name": "y",
     "type": "number|string",
     "optional": false
    },
    {
     "name": "src",
     "type": "string",
     "optional": false
    },
    {
     "name": "ratio",
     "type": "number",
     "optional": false
    },
    {
     "name": "fileName",
     "type": "string",
     "optional": false
    }
   ],
   "source": "packages-base/etc-factory.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: factory.etc.image → advanced.createImage [src:mathcore-api/object-factory/packages-base/etc-factory.ts:39-46] [src:base2d/base-advanced-api/index.ts:4358-4384]",
    "만드는 것: image 1개 [src:base2d/base-advanced-api/index.ts:4371] — 보임(기본값) [src:object-manager/objects/image.ts:37], isScreenCoord=false [src:base2d/base-advanced-api/index.ts:4378]"
   ],
   "range": [
    "x: 형식 Number | String [src:mathcore-api/object-factory/packages-base/etc-factory.ts:40] [src:mathcore-api/object-factory/object-types.ts:105]; 숫자가 아닌 문자열이면 슬라이더 연결식으로 들어가 그 값을 따라 움직인다 [src:base2d/base-advanced-api/index.ts:644-654]",
    "y: 형식 Number | String [src:mathcore-api/object-factory/packages-base/etc-factory.ts:41] [src:mathcore-api/object-factory/object-types.ts:105]; 숫자가 아닌 문자열이면 슬라이더 연결식으로 들어가 그 값을 따라 움직인다 [src:base2d/base-advanced-api/index.ts:644-654]",
    "src: 형식 String [src:mathcore-api/object-factory/packages-base/etc-factory.ts:42] [src:mathcore-api/object-factory/object-types.ts:92]",
    "ratio: 형식 Number [src:mathcore-api/object-factory/packages-base/etc-factory.ts:43] [src:mathcore-api/object-factory/object-types.ts:94]",
    "fileName: 형식 String [src:mathcore-api/object-factory/packages-base/etc-factory.ts:44] [src:mathcore-api/object-factory/object-types.ts:92]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): domain='이미지', angle=0, flipX=false, flipY=false, isBackgroundImage=false, opacity=1 [src:object-manager/objects/image.ts:45-52]"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "etc.drawing",
   "path": [
    "etc",
    "drawing"
   ],
   "params": [
    {
     "name": "points",
     "type": "point2[]",
     "optional": false
    }
   ],
   "source": "packages-base/etc-factory.ts",
   "usage": [
    "용도(도구 UI 설명): 자유곡선 — 마우스를 드래그하여 쓰거나 그려보세요. [src:base2d-ui/src/tab/tools/configs/base2d-geometry.ts:609]",
    "호출: factory.etc.drawing → advanced.createDrawingObject [src:mathcore-api/object-factory/packages-base/etc-factory.ts:48-55] [src:base2d/base-advanced-api/index.ts:4232-4240]",
    "만드는 것: drawing 1개 [src:base2d/base-advanced-api/index.ts:4233] — 보임(공통 기본값) [src:object-manager/objects/common.ts:38], 색 null as null | Color(configs.drawingColor) [src:base2d/base-advanced-api/configs.ts:130], 선 두께 2(configs.drawingStrokeWidth) [src:base2d/base-advanced-api/configs.ts:135]"
   ],
   "range": [
    "points: 형식 (Number, Number) [src:mathcore-api/object-factory/packages-base/etc-factory.ts:51] [src:mathcore-api/object-factory/object-types.ts:99]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): upper='자유곡선' [src:object-manager/objects/drawing.ts:42]"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "etc.bezierCurve",
   "path": [
    "etc",
    "bezierCurve"
   ],
   "params": [
    {
     "name": "pointID1",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "pointID2",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "packages-base/etc-factory.ts",
   "usage": [
    "용도(도구 UI 설명): 베지어 곡선 — 두 점을 선택하여 베지어 곡선을 그려보세요. [src:base2d-ui/src/tab/tools/configs/base2d-geometry.ts:583]",
    "호출: factory.etc.bezierCurve → advanced.createBezierCurve [src:mathcore-api/object-factory/packages-base/etc-factory.ts:57-62] [src:base2d/base-advanced-api/index.ts:3794-3801]",
    "앞에 있어야 하는 것: pointID1 = point [src:mathcore-api/object-factory/packages-base/etc-factory.ts:57-62]",
    "앞에 있어야 하는 것: pointID2 = point [src:mathcore-api/object-factory/packages-base/etc-factory.ts:57-62]",
    "만드는 것: bezierCurve(bezierCurve) 1개 [src:base2d/base-advanced-api/index.ts:3795] — 보임(기본값) [src:object-manager/objects/bezier-curve.ts:29], 색 null as null | Color(configs.bezierColor) [src:base2d/base-advanced-api/configs.ts:129], 매인 개체 [pointID1, pointID2] [src:base2d/base-advanced-api/index.ts:3799]"
   ],
   "range": [
    "pointID1: 형식 String [src:mathcore-api/object-factory/packages-base/etc-factory.ts:58] [src:mathcore-api/object-factory/object-types.ts:92]",
    "pointID2: 형식 String [src:mathcore-api/object-factory/packages-base/etc-factory.ts:59] [src:mathcore-api/object-factory/object-types.ts:92]",
    "name?: 형식 String | Undefined [src:mathcore-api/object-factory/packages-base/etc-factory.ts:60] [src:mathcore-api/object-factory/object-types.ts:93]; 생략하면 this.getNewObjectName() [src:base2d/base-advanced-api/index.ts:3798]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): strokeWidth=2, endCoordinates=[[0, 0], [0, 0]], handleCoordinates=[[0, 0], [0, 0]] [src:object-manager/objects/bezier-curve.ts:31-33]"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "etc.inequation",
   "path": [
    "etc",
    "inequation"
   ],
   "params": [
    {
     "name": "pointID",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "packages-base/etc-factory.ts",
   "usage": [
    "용도(도구 UI 설명): 부등식 — 두 점을 선택하여 부등식을 표현해보세요. [src:base2d-ui/src/tab/tools/configs/base2d-geometry.ts:593]",
    "호출: factory.etc.inequation → advanced.createInequation [src:mathcore-api/object-factory/packages-base/etc-factory.ts:64-68] [src:base2d/base-advanced-api/index.ts:3853-3861]",
    "앞에 있어야 하는 것: pointID = point [src:mathcore-api/object-factory/packages-base/etc-factory.ts:64-68]",
    "만드는 것: inequation(inequation) 1개 [src:base2d/base-advanced-api/index.ts:3855] — 보임(기본값) [src:object-manager/objects/inequation.ts:27], 색 color [src:base2d/base-advanced-api/index.ts:3857], 매인 개체 [pointID] [src:base2d/base-advanced-api/index.ts:3859]"
   ],
   "range": [
    "pointID: 형식 String [src:mathcore-api/object-factory/packages-base/etc-factory.ts:65] [src:mathcore-api/object-factory/object-types.ts:92]",
    "name?: 형식 String | Undefined [src:mathcore-api/object-factory/packages-base/etc-factory.ts:66] [src:mathcore-api/object-factory/object-types.ts:93]; 생략하면 this.getNewObjectName() [src:base2d/base-advanced-api/index.ts:3858]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): strokeWidth=2, endCoordinates=[[0, 0], [0, 0]] [src:object-manager/objects/inequation.ts:29-30]"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "linear.segment",
   "path": [
    "linear",
    "segment"
   ],
   "params": [
    {
     "name": "pointID1",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "pointID2",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "packages-base/linear-factory.ts",
   "usage": [
    "용도(도구 UI 설명): 선분 — 두 점을 선택하세요. [src:base2d-ui/src/tab/tools/configs/base2d-geometry.ts:126]",
    "호출: factory.linear.segment → advanced.createSegment [src:mathcore-api/object-factory/packages-base/linear-factory.ts:8-13] [src:base2d/base-advanced-api/index.ts:3514-3516]",
    "앞에 있어야 하는 것: pointID1 = point [src:mathcore-api/object-factory/packages-base/linear-factory.ts:8-13]",
    "앞에 있어야 하는 것: pointID2 = point [src:mathcore-api/object-factory/packages-base/linear-factory.ts:8-13]",
    "만드는 것: linear(segment) 1개 (경유 createLinear) [src:base2d/base-advanced-api/index.ts:3358] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 null as null | Color(configs.linearColor) [src:base2d/base-advanced-api/configs.ts:127], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [pointID1, pointID2] [src:base2d/base-advanced-api/index.ts:3362]",
    "참고: 캔버스의 선분 도구(기하 탭 선 묶음, 단축키 s)에서 점을 두 번 누르는 동작에 해당하고 둘째 클릭에서 선분이 선다. 빈 곳을 누르면 점도 새로 만들어지지만 이 도구는 점 id 만 받으므로 두 점을 먼저 세운다. 같은 점 둘은 캔버스에서 무시되고 마우스 이동은 미리보기만 그린다. [src:정합성 linear: scripts/pipeline/semantic/linear.mjs 캔버스 재현, tool-segment.ts:39-66]"
   ],
   "range": [
    "pointID1: 형식 String [src:mathcore-api/object-factory/packages-base/linear-factory.ts:9] [src:mathcore-api/object-factory/object-types.ts:92]",
    "pointID2: 형식 String [src:mathcore-api/object-factory/packages-base/linear-factory.ts:10] [src:mathcore-api/object-factory/object-types.ts:92]",
    "name?: 형식 String | Undefined [src:mathcore-api/object-factory/packages-base/linear-factory.ts:11] [src:mathcore-api/object-factory/object-types.ts:93]; 생략하면 this.getNewObjectName()(createLinear) [src:base2d/base-advanced-api/index.ts:3363]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): coordinates=[[0, 0], [0, 0]], givenLengthCurrenAngle=0 [src:object-manager/objects/linear.ts:79-80]"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "linear.line",
   "path": [
    "linear",
    "line"
   ],
   "params": [
    {
     "name": "pointID1",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "pointID2",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "packages-base/linear-factory.ts",
   "usage": [
    "용도(도구 UI 설명): 직선 — 두 점을 선택하세요. [src:base2d-ui/src/tab/tools/configs/base2d-geometry.ts:126]",
    "호출: factory.linear.line → advanced.createLine [src:mathcore-api/object-factory/packages-base/linear-factory.ts:15-20] [src:base2d/base-advanced-api/index.ts:3584-3586]",
    "앞에 있어야 하는 것: pointID1 = point [src:mathcore-api/object-factory/packages-base/linear-factory.ts:15-20]",
    "앞에 있어야 하는 것: pointID2 = point [src:mathcore-api/object-factory/packages-base/linear-factory.ts:15-20]",
    "만드는 것: linear(line) 1개 (경유 createLinear) [src:base2d/base-advanced-api/index.ts:3358] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 null as null | Color(configs.linearColor) [src:base2d/base-advanced-api/configs.ts:127], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [pointID1, pointID2] [src:base2d/base-advanced-api/index.ts:3362]",
    "참고: 점 자리에는 점만 준다. 점이 아닌 개체가 점 자리에 가면 mathcore 가 개체를 유효한 채 세우고 예외를 내 장면이 오염되므로, 대조기가 인자 종류를 실행 전에 검사해 반려한다(2026-10-20 실측: 점 자리의 곡선은 실행 0건으로 반려, 두 점 직선으로 lineSymmetry 가 정확히 섬). 직선이 필요한 문항(y=x 대칭 등)은 이 도구로 세운다 [src:docs/palette/linear.md:132]"
   ],
   "range": [
    "pointID1: 형식 String [src:mathcore-api/object-factory/packages-base/linear-factory.ts:16] [src:mathcore-api/object-factory/object-types.ts:92]",
    "pointID2: 형식 String [src:mathcore-api/object-factory/packages-base/linear-factory.ts:17] [src:mathcore-api/object-factory/object-types.ts:92]",
    "name?: 형식 String | Undefined [src:mathcore-api/object-factory/packages-base/linear-factory.ts:18] [src:mathcore-api/object-factory/object-types.ts:93]; 생략하면 this.getNewObjectName()(createLinear) [src:base2d/base-advanced-api/index.ts:3363]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): coordinates=[[0, 0], [0, 0]], givenLengthCurrenAngle=0 [src:object-manager/objects/linear.ts:79-80]"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "linear.ray",
   "path": [
    "linear",
    "ray"
   ],
   "params": [
    {
     "name": "pointID1",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "pointID2",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "packages-base/linear-factory.ts",
   "usage": [
    "용도(도구 UI 설명): 반직선 — 두 점을 선택하세요. [src:base2d-ui/src/tab/tools/configs/base2d-geometry.ts:126]",
    "호출: factory.linear.ray → advanced.createRay [src:mathcore-api/object-factory/packages-base/linear-factory.ts:22-27] [src:base2d/base-advanced-api/index.ts:3592-3594]",
    "앞에 있어야 하는 것: pointID1 = point [src:mathcore-api/object-factory/packages-base/linear-factory.ts:22-27]",
    "앞에 있어야 하는 것: pointID2 = point [src:mathcore-api/object-factory/packages-base/linear-factory.ts:22-27]",
    "만드는 것: linear(ray) 1개 (경유 createLinear) [src:base2d/base-advanced-api/index.ts:3358] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 null as null | Color(configs.linearColor) [src:base2d/base-advanced-api/configs.ts:127], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [pointID1, pointID2] [src:base2d/base-advanced-api/index.ts:3362]",
    "참고: 점 자리에는 점만 준다. 점이 아닌 개체가 점 자리에 가면 mathcore 가 개체를 유효한 채 세우고 예외를 내 장면이 오염되므로, 대조기가 인자 종류를 실행 전에 검사해 반려한다(2026-10-20 실측: 점 자리의 곡선은 실행 0건으로 반려, 두 점 직선으로 lineSymmetry 가 정확히 섬). 반직선이 필요한 문항은 이 도구로 세운다 [src:docs/palette/linear.md:132]"
   ],
   "range": [
    "pointID1: 형식 String [src:mathcore-api/object-factory/packages-base/linear-factory.ts:23] [src:mathcore-api/object-factory/object-types.ts:92]",
    "pointID2: 형식 String [src:mathcore-api/object-factory/packages-base/linear-factory.ts:24] [src:mathcore-api/object-factory/object-types.ts:92]",
    "name?: 형식 String | Undefined [src:mathcore-api/object-factory/packages-base/linear-factory.ts:25] [src:mathcore-api/object-factory/object-types.ts:93]; 생략하면 this.getNewObjectName()(createLinear) [src:base2d/base-advanced-api/index.ts:3363]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): coordinates=[[0, 0], [0, 0]], givenLengthCurrenAngle=0 [src:object-manager/objects/linear.ts:79-80]"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "linear.parallel",
   "path": [
    "linear",
    "parallel"
   ],
   "params": [
    {
     "name": "pointID",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "segmentID",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "linear"
      },
      {
       "type": "axis"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "packages-base/linear-factory.ts",
   "usage": [
    "용도(도구 UI 설명): 평행선 — 평행이 될 선을 선택하고 만들 위치를 선택하거나, 만들 위치를 선택하고 평행이 될 선을 선택하세요. [src:base2d-ui/src/tab/tools/configs/base2d-geometry.ts:163]",
    "호출: factory.linear.parallel → advanced.createParallel [src:mathcore-api/object-factory/packages-base/linear-factory.ts:29-34] [src:base2d/base-advanced-api/index.ts:3600-3602]",
    "앞에 있어야 하는 것: pointID = point [src:mathcore-api/object-factory/packages-base/linear-factory.ts:29-34]",
    "앞에 있어야 하는 것: segmentID = linear(segment) [src:mathcore-api/object-factory/packages-base/linear-factory.ts:29-34]",
    "만드는 것: linear(parallel) 1개 (경유 createLinear) [src:base2d/base-advanced-api/index.ts:3358] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 null as null | Color(configs.linearColor) [src:base2d/base-advanced-api/configs.ts:127], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [pointID, segmentID] [src:base2d/base-advanced-api/index.ts:3362]",
    "참고: pointID 를 지나고 segmentID 와 평행한 끝없는 직선 하나가 선다(선분이 아니다). 기준 선의 길이나 끝점 위치는 방향 말고는 쓰이지 않고, 기준 선을 옮기면 평행선이 따라간다. [src:정합성 linear: scripts/pipeline/semantic/linear.mjs 의 linear.parallel: '기준 선분 PQ 의 평행선이 R 을 지나고 방향이 PQ 와 평행하다', '새 개체가 category parallel 인 linear 하나뿐이다', '기준 선분의 끝점을 옮기면 평행선이 따라 바뀐다'; 끝없는 직선: mathcore/module/mathcore/packages/renderer/src/layers/graphics/decoration/linear.ts:259-264; 캔버스 대조: scripts/pipeline/semantic/linear.mjs 의 '캔버스 평행선' (선 → 점, 점 → 선, 선 → 빈 곳, x축 → 점 모두 같은 직선), tool-parallel.ts:113 / tool-perpendicular.ts:113]",
    "참고: 캔버스의 평행선 도구(단축키 q)에서 기준 선과 지나는 점을 순서에 상관없이 하나씩 누르는 동작에 해당하고 둘이 모이는 클릭에서 선다. 빈 곳을 누르면 그 자리에 점이 새로 선다. 이 도구는 점 id 와 선 id 를 받으므로 둘을 먼저 세운다. 결과는 양쪽으로 끝없는 직선이다. [src:정합성 linear: scripts/pipeline/semantic/linear.mjs 캔버스 재현, tool-parallel.ts:47-120]"
   ],
   "range": [
    "pointID: 형식 String [src:mathcore-api/object-factory/packages-base/linear-factory.ts:30] [src:mathcore-api/object-factory/object-types.ts:92]",
    "segmentID: 형식 String [src:mathcore-api/object-factory/packages-base/linear-factory.ts:31] [src:mathcore-api/object-factory/object-types.ts:92]",
    "name?: 형식 String | Undefined [src:mathcore-api/object-factory/packages-base/linear-factory.ts:32] [src:mathcore-api/object-factory/object-types.ts:93]; 생략하면 this.getNewObjectName()(createLinear) [src:base2d/base-advanced-api/index.ts:3363]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): coordinates=[[0, 0], [0, 0]], givenLengthCurrenAngle=0 [src:object-manager/objects/linear.ts:79-80]"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "linear.bisectorLine",
   "path": [
    "linear",
    "bisectorLine"
   ],
   "params": [
    {
     "name": "pointID1",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "pointID2",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "pointID3",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "packages-base/linear-factory.ts",
   "usage": [
    "용도(도구 UI 설명): 각의 이등분선 — 세 점을 선택하세요. [src:base2d-ui/src/tab/tools/configs/base2d-geometry.ts:190]",
    "호출: factory.linear.bisectorLine → advanced.createBisectorLine [src:mathcore-api/object-factory/packages-base/linear-factory.ts:36-42] [src:base2d/base-advanced-api/index.ts:3655-3657]",
    "앞에 있어야 하는 것: pointID1 = point [src:mathcore-api/object-factory/packages-base/linear-factory.ts:36-42]",
    "앞에 있어야 하는 것: pointID2 = point [src:mathcore-api/object-factory/packages-base/linear-factory.ts:36-42]",
    "앞에 있어야 하는 것: pointID3 = point [src:mathcore-api/object-factory/packages-base/linear-factory.ts:36-42]",
    "만드는 것: linear(bisectorLine) 1개 (경유 createLinear) [src:base2d/base-advanced-api/index.ts:3358] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 null as null | Color(configs.linearColor) [src:base2d/base-advanced-api/configs.ts:127], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [pointID1, pointID2, pointID3] [src:base2d/base-advanced-api/index.ts:3362]",
    "참고: pointID2 가 각의 꼭짓점이고 pointID1, pointID3 는 각의 두 변 위의 점이다(변의 길이는 결과에 영향이 없다). 결과는 꼭짓점을 지나는 끝없는 직선 하나이고 선분이나 반직선이 아니다. 세 점이 한 직선 위에 있고 꼭짓점이 가운데이면 방향이 없는 직선이 유효로 서지만 그려지지 않는다. [src:정합성 linear: scripts/pipeline/semantic/linear.mjs 의 linear.bisectorLine: '각의 이등분선이 둘째 점(꼭짓점)을 지나고 방향이 두 변의 단위벡터 합이다', '꼭짓점은 둘째 인자다', '평각(세 점이 한 직선)이면 이등분선은 그 직선에 수직(y 방향)'(실패: coordinates 두 점이 같음); 끝없는 직선: mathcore/module/mathcore/packages/renderer/src/layers/graphics/decoration/linear.ts:259-264; 캔버스 대조: scripts/pipeline/semantic/linear.mjs 의 '캔버스 각의 이등분선: 셋째 클릭에서 하나가 서고 둘째로 누른 점이 꼭짓점'; tool-bisector-line.ts:66-68]",
    "참고: 캔버스의 각의 이등분선 도구(단축키 n)에서 점 셋을 시작점, 꼭짓점, 끝점 순서로 누르는 동작에 해당하고 셋째 클릭에서 선다. 둘째 점이 꼭짓점이다. 이 도구는 점 id 셋을 받으므로 세 점을 먼저 세우고 같은 순서로 준다. [src:정합성 linear: scripts/pipeline/semantic/linear.mjs 캔버스 재현, tool-bisector-line.ts:39-81]"
   ],
   "range": [
    "pointID1: 형식 String [src:mathcore-api/object-factory/packages-base/linear-factory.ts:37] [src:mathcore-api/object-factory/object-types.ts:92]",
    "pointID2: 형식 String [src:mathcore-api/object-factory/packages-base/linear-factory.ts:38] [src:mathcore-api/object-factory/object-types.ts:92]",
    "pointID3: 형식 String [src:mathcore-api/object-factory/packages-base/linear-factory.ts:39] [src:mathcore-api/object-factory/object-types.ts:92]",
    "name?: 형식 String | Undefined [src:mathcore-api/object-factory/packages-base/linear-factory.ts:40] [src:mathcore-api/object-factory/object-types.ts:93]; 생략하면 this.getNewObjectName()(createLinear) [src:base2d/base-advanced-api/index.ts:3363]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): coordinates=[[0, 0], [0, 0]], givenLengthCurrenAngle=0 [src:object-manager/objects/linear.ts:79-80]"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "linear.tangentLine",
   "path": [
    "linear",
    "tangentLine"
   ],
   "params": [
    {
     "name": "circleID",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "circle"
      },
      {
       "type": "polynomial"
      },
      {
       "type": "ellipse"
      }
     ]
    },
    {
     "name": "pointIDOrSegmentID",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      },
      {
       "type": "linear"
      },
      {
       "type": "axis"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "packages-base/linear-factory.ts",
   "usage": [
    "용도(도구 UI 설명): 접선 — 접선을 생성할 곡선(원, 타원, 대수 그래프)을 선택하고 접선이 지나는 점 또는 접선의 기울기가 될 선을 선택하세요. [src:base2d-ui/src/tab/tools/configs/base2d-geometry.ts:199]",
    "호출: factory.linear.tangentLine → advanced.createTangentLine [src:mathcore-api/object-factory/packages-base/linear-factory.ts:44-49] [src:base2d/base-advanced-api/index.ts:3680-3720]",
    "앞에 있어야 하는 것: circleID = circle [src:mathcore-api/object-factory/packages-base/linear-factory.ts:44-49]",
    "앞에 있어야 하는 것: pointIDOrSegmentID = point 또는 linear(segment) [src:mathcore-api/object-factory/packages-base/linear-factory.ts:44-49]",
    "만드는 것: linear(tangentLine) 1개 [src:base2d/base-advanced-api/index.ts:3683] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 color [src:base2d/base-advanced-api/index.ts:3686], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [circleID, pointIDOrSegmentID] [src:base2d/base-advanced-api/index.ts:3687]",
    "함께 생김: linear(tangentLine) 1개 [src:base2d/base-advanced-api/index.ts:3693] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 color [src:base2d/base-advanced-api/index.ts:3696], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [circleID, pointIDOrSegmentID] [src:base2d/base-advanced-api/index.ts:3697]",
    "참고: 개체 둘(접선 t1, t2)이 선다. 둘째 인자가 점이면 그 점을 지나는 접선, 선이면 그 선과 기울기가 같은 접선이다 [src:docs/palette/linear.md:390]",
    "참고: 둘째 인자가 점이면 곡선 밖의 점은 접선 최대 둘, 곡선 위의 점(식 값의 절댓값이 1e-4 미만)은 접선 하나, 곡선 안쪽의 점은 접선이 없다(무효). 어림한 좌표를 곡선 위의 점으로 쓰면 안쪽으로 어긋나 접선이 서지 않으므로, 곡선 위의 점은 point.pointOnObject 로 세운 점을 쓴다. 호와 부채꼴은 접점이 호 위에 있는 접선만 유효하다. 이 도구는 점 id 가 이미 있어야 하므로(캔버스처럼 빈 곳을 눌러 점을 만들어 주지 않는다) 접선이 지날 점을 먼저 세운다. [src:정합성 linear: scripts/pipeline/semantic/linear.mjs 의 linear.tangentLine: '곡선에서 5e-5 떨어진 점은 곡선 위로 읽혀 접선 하나(t1 유효, t2 무효)가 선다', '곡선에서 0.004 위(곡선 안쪽)에 있는 점이면 접선이 서지 않는다', '원 안의 점이면 두 접선 모두 무효', 'point.pointOnObject 로 세운 곡선 위의 점이면 그 점의 접선(기울기 2x)이 선다', '호(중심 (0,0), 반지름 3, 제1사분면)와 바깥점 (5,0): 호 위의 접점 (1.8,2.4) 접선 하나만 유효'; 캔버스 대조: scripts/pipeline/semantic/linear.mjs 의 '캔버스 접선' 절(곡선 → 빈 곳 클릭이 새 점과 접선 둘을 만든다), tool-tangent-line.ts:104-119]",
    "참고: 점 밖에서 그은 두 접선 중 수직선은 놓칠 수 있다(예: 중심 (1,-1), 반지름 3 인 원과 점 (4,3)에서 t2 가 무효). 수직 접선이 필요하면 둘째 인자로 문자열 0:yAxis 를 주어 y축과 평행한 접선 둘을 세운다. [src:정합성 linear: scripts/pipeline/semantic/linear.mjs 의 linear.tangentLine: '수직 접선이 있는 바깥점 (4,3)에서 접선 둘이 모두 선다'(실패: t1 만 유효), '원 + y축 문자열이면 수직 접선 둘 x = cx ± r']",
    "참고: 캔버스의 접선 도구(alt+u)에서 곡선을 먼저 누르고 접선이 지날 점(또는 기울기가 될 선, 축)을 누르는 동작에 해당하고 둘째 클릭에서 접선이 선다. 빈 곳을 누르면 그 자리에 점이 새로 선다. 이 도구는 곡선 id 와 점 id 를 받으므로 곡선과 점을 먼저 세운다. 곡선 위의 점이 필요하면 point.pointOnObject 로 세운 점을 준다. [src:정합성 linear: scripts/pipeline/semantic/linear.mjs 캔버스 재현, tool-tangent-line.ts:70-119]",
    "생성 결과: 접선 개체 둘(t1, t2)이 서고 호출이 돌려주는 id 는 t1 하나다. 접점이 하나뿐이면 t2 는 무효이고, 호나 부채꼴에서는 t1 이 무효이고 t2 가 유효할 수 있다. t2 는 이름으로 가리킬 수 없어 둘째 접선은 후속 호출에서 참조하지 못한다. [src:정합성 linear: scripts/pipeline/semantic/linear.mjs 의 linear.tangentLine: '새 개체가 tangentLine linear 둘이다(t1, t2)', '반환 id 는 t1(tangentLiseState 1)이고 pairObjectId 가 t2 를 가리킨다', '실행기 경유: 등록되는 선 개체는 t1 하나뿐이고 t2 는 이름으로 가리킬 수 없다', '부채꼴과 바깥점 (5,0): 호 위의 접점 (1.8,2.4) 접선 하나만 유효(t1 이 무효일 수 있다)'; 캔버스 대조: scripts/pipeline/semantic/linear.mjs 의 '캔버스 접선: 곡선 → 빈 곳 순서면 둘째 클릭에서 새 점 하나와 접선 개체 둘(t1, t2)이 서고 팩토리와 같은 접선 둘'; tool-tangent-line.ts:119 (advanced.createTangentLine, 반환 id 는 t1 하나)]"
   ],
   "range": [
    "circleID: 형식 String [src:mathcore-api/object-factory/packages-base/linear-factory.ts:45] [src:mathcore-api/object-factory/object-types.ts:92]",
    "pointIDOrSegmentID: 형식 String [src:mathcore-api/object-factory/packages-base/linear-factory.ts:46] [src:mathcore-api/object-factory/object-types.ts:92]",
    "name?: 형식 String | Undefined [src:mathcore-api/object-factory/packages-base/linear-factory.ts:47] [src:mathcore-api/object-factory/object-types.ts:93]; 생략하면 this.getNewObjectName() [src:base2d/base-advanced-api/index.ts:3685]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): coordinates=[[0, 0], [0, 0]], givenLengthCurrenAngle=0 [src:object-manager/objects/linear.ts:79-80]"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "linear.perpendicular",
   "path": [
    "linear",
    "perpendicular"
   ],
   "params": [
    {
     "name": "linearID",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "linear"
      },
      {
       "type": "axis"
      }
     ]
    },
    {
     "name": "pointID",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "packages-base/linear-factory.ts",
   "usage": [
    "용도(도구 UI 설명): 수선 — 수직이 될 선을 선택하고 만들 위치를 선택하거나, 만들 위치를 선택하고 수직이 될 선을 선택하세요. [src:base2d-ui/src/tab/tools/configs/base2d-geometry.ts:172]",
    "호출: factory.linear.perpendicular → advanced.createPerpendicular [src:mathcore-api/object-factory/packages-base/linear-factory.ts:51-56] [src:base2d/base-advanced-api/index.ts:3616-3618]",
    "앞에 있어야 하는 것: linearID = linear [src:mathcore-api/object-factory/packages-base/linear-factory.ts:51-56]",
    "앞에 있어야 하는 것: pointID = point [src:mathcore-api/object-factory/packages-base/linear-factory.ts:51-56]",
    "만드는 것: linear(perpendicular) 1개 (경유 createLinear) [src:base2d/base-advanced-api/index.ts:3358] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 null as null | Color(configs.linearColor) [src:base2d/base-advanced-api/configs.ts:127], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [linearID, pointID] [src:base2d/base-advanced-api/index.ts:3362]",
    "참고: pointID 를 지나고 linearID 에 수직인 끝없는 직선 하나만 선다(선분이 아니고 수선의 발 점도 서지 않으므로 발이 필요하면 point.intersect 로 교점을 따로 세운다). [src:정합성 linear: scripts/pipeline/semantic/linear.mjs 의 linear.perpendicular: '수선이 R 을 지나고 PQ 와 직교한다', '새 개체가 category perpendicular 인 linear 하나뿐이다(수선의 발 점은 만들지 않는다)'; 끝없는 직선: mathcore/module/mathcore/packages/renderer/src/layers/graphics/decoration/linear.ts:259-264; 캔버스 대조: scripts/pipeline/semantic/linear.mjs 의 '캔버스 수선' (선 → 점, 점 → 선, 선 → 빈 곳, x축 → 점 모두 같은 직선), tool-parallel.ts:113 / tool-perpendicular.ts:113]",
    "참고: 캔버스의 수선 도구(단축키 w)에서 기준 선과 지나는 점을 순서에 상관없이 하나씩 누르는 동작에 해당하고 둘이 모이는 클릭에서 선다. 이 도구는 선 id 와 점 id 를 받으므로 둘을 먼저 세운다. 결과는 양쪽으로 끝없는 직선이다. [src:정합성 linear: scripts/pipeline/semantic/linear.mjs 캔버스 재현, tool-perpendicular.ts:47-121]"
   ],
   "range": [
    "linearID: 형식 String [src:mathcore-api/object-factory/packages-base/linear-factory.ts:52] [src:mathcore-api/object-factory/object-types.ts:92]",
    "pointID: 형식 String [src:mathcore-api/object-factory/packages-base/linear-factory.ts:53] [src:mathcore-api/object-factory/object-types.ts:92]",
    "name?: 형식 String | Undefined [src:mathcore-api/object-factory/packages-base/linear-factory.ts:54] [src:mathcore-api/object-factory/object-types.ts:93]; 생략하면 this.getNewObjectName()(createLinear) [src:base2d/base-advanced-api/index.ts:3363]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): coordinates=[[0, 0], [0, 0]], givenLengthCurrenAngle=0 [src:object-manager/objects/linear.ts:79-80]"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "linear.perpendicularBisectorBySegment",
   "path": [
    "linear",
    "perpendicularBisectorBySegment"
   ],
   "params": [
    {
     "name": "segmentID",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "linear",
       "category": "segment"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "packages-base/linear-factory.ts",
   "usage": [
    "용도(도구 UI 설명): 수직이등분선 — 두 점 또는 한 선분을 선택하세요. [src:base2d-ui/src/tab/tools/configs/base2d-geometry.ts:181]",
    "호출: factory.linear.perpendicularBisectorBySegment → advanced.createPerpendicularAtMidpointBySegmentID [src:mathcore-api/object-factory/packages-base/linear-factory.ts:58-62] [src:base2d/base-advanced-api/index.ts:3640-3642]",
    "앞에 있어야 하는 것: segmentID = linear(segment) [src:mathcore-api/object-factory/packages-base/linear-factory.ts:58-62]",
    "만드는 것: linear(perpendicularAtMidpoint) 1개 (경유 createLinear) [src:base2d/base-advanced-api/index.ts:3358] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 null as null | Color(configs.linearColor) [src:base2d/base-advanced-api/configs.ts:127], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [segmentID] [src:base2d/base-advanced-api/index.ts:3362]",
    "참고: 선분 id 를 넣는다. 결과는 그 선분의 중점을 지나고 선분에 수직인 끝없는 직선 하나다. 직선이나 반직선 id 를 넣으면 그 선을 정한 두 점의 중점을 지나는 수선이 서므로 의도와 다를 수 있다. [src:정합성 linear: scripts/pipeline/semantic/linear.mjs 의 linear.perpendicularBisectorBySegment: '수직이등분선이 PQ 의 중점 (3,3)을 지나고 PQ 와 직교한다', '직선 id 를 넣으면 그 직선을 정의한 두 점의 중점을 지나는 수선이 선다(직선 자체의 중점이 아니다)', '반직선 id 를 넣어도 정의 두 점의 중점 수선이 선다'; 캔버스 대조: scripts/pipeline/semantic/linear.mjs 의 '캔버스 수직이등분선: 선분을 첫 클릭으로 누르면...', '직선(category line)을 누르면 선분 방식이 아니라 직선 위의 새 점만 서고 개체는 안 선다'(캔버스는 선분만 받는다); tool-perpendicular-at-midpoint.ts:51-80]",
    "참고: 캔버스의 수직이등분선 도구(단축키 b)에서 선분을 한 번 누르는 동작에 해당하고 그 클릭에서 바로 선다. 캔버스는 선분(segment, segmentWithGivenLength)만 고를 수 있다. 같은 버튼에서 점 둘을 누르면 linear.perpendicularBisectorByTwoPoint 쪽이다. [src:정합성 linear: scripts/pipeline/semantic/linear.mjs 캔버스 재현, tool-perpendicular-at-midpoint.ts:51-80]"
   ],
   "range": [
    "segmentID: 형식 String [src:mathcore-api/object-factory/packages-base/linear-factory.ts:59] [src:mathcore-api/object-factory/object-types.ts:92]",
    "name?: 형식 String | Undefined [src:mathcore-api/object-factory/packages-base/linear-factory.ts:60] [src:mathcore-api/object-factory/object-types.ts:93]; 생략하면 this.getNewObjectName()(createLinear) [src:base2d/base-advanced-api/index.ts:3363]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): coordinates=[[0, 0], [0, 0]], givenLengthCurrenAngle=0 [src:object-manager/objects/linear.ts:79-80]"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "linear.perpendicularBisectorByTwoPoint",
   "path": [
    "linear",
    "perpendicularBisectorByTwoPoint"
   ],
   "params": [
    {
     "name": "pointID1",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "pointID2",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "packages-base/linear-factory.ts",
   "usage": [
    "용도: 수직이등분선: 두 점 pointID1, pointID2 의 중점을 지나고 두 점을 잇는 선에 수직인 끝없는 직선 하나를 세운다(점 순서는 결과에 영향이 없다). [src:정합성 linear: scripts/pipeline/semantic/linear.mjs 의 linear.perpendicularBisectorByTwoPoint: '두 점 P, Q 의 중점 (3,3)을 지나고 PQ 와 직교한다', '두 점 순서를 바꿔도 같은 직선'; 캔버스 도구 근거: docs/palette/linear.md:180 (tool-perpendicular-at-midpoint.ts:88-92); 캔버스 대조: scripts/pipeline/semantic/linear.mjs 의 '캔버스 수직이등분선: 점 둘을 누르면 둘째 클릭에서 하나가 서고 팩토리 두 점 방식과 같다'; tool-perpendicular-at-midpoint.ts:90-92]",
    "호출: factory.linear.perpendicularBisectorByTwoPoint → advanced.createPerpendicularAtMidpointByTwoPointID [src:mathcore-api/object-factory/packages-base/linear-factory.ts:64-69] [src:base2d/base-advanced-api/index.ts:3632-3634]",
    "앞에 있어야 하는 것: pointID1 = point [src:mathcore-api/object-factory/packages-base/linear-factory.ts:64-69]",
    "앞에 있어야 하는 것: pointID2 = point [src:mathcore-api/object-factory/packages-base/linear-factory.ts:64-69]",
    "만드는 것: linear(perpendicularAtMidpoint) 1개 (경유 createLinear) [src:base2d/base-advanced-api/index.ts:3358] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 null as null | Color(configs.linearColor) [src:base2d/base-advanced-api/configs.ts:127], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [pointID1, pointID2] [src:base2d/base-advanced-api/index.ts:3362]",
    "참고: 캔버스의 수직이등분선 도구(단축키 b)에서 점 둘을 차례로 누르는 동작에 해당하고 둘째 클릭에서 선다. 빈 곳을 누르면 점이 새로 선다. 이 도구는 점 id 둘을 받으므로 두 점을 먼저 세운다. 결과는 두 점을 잇는 선분의 수직이등분선(끝없는 직선)이다. [src:정합성 linear: scripts/pipeline/semantic/linear.mjs 캔버스 재현, tool-perpendicular-at-midpoint.ts:51-105]"
   ],
   "range": [
    "pointID1: 형식 String [src:mathcore-api/object-factory/packages-base/linear-factory.ts:65] [src:mathcore-api/object-factory/object-types.ts:92]",
    "pointID2: 형식 String [src:mathcore-api/object-factory/packages-base/linear-factory.ts:66] [src:mathcore-api/object-factory/object-types.ts:92]",
    "name?: 형식 String | Undefined [src:mathcore-api/object-factory/packages-base/linear-factory.ts:67] [src:mathcore-api/object-factory/object-types.ts:93]; 생략하면 this.getNewObjectName()(createLinear) [src:base2d/base-advanced-api/index.ts:3363]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): coordinates=[[0, 0], [0, 0]], givenLengthCurrenAngle=0 [src:object-manager/objects/linear.ts:79-80]"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "linear.vector",
   "path": [
    "linear",
    "vector"
   ],
   "params": [
    {
     "name": "pointID1",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "pointID2",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "packages-base/linear-factory.ts",
   "usage": [
    "용도(도구 UI 설명): 벡터 — 시작점을 선택한 후 끝점을 선택하세요. [src:base2d-ui/src/tab/tools/configs/base2d-geometry.ts:215]",
    "호출: factory.linear.vector → advanced.createVector [src:mathcore-api/object-factory/packages-base/linear-factory.ts:71-76] [src:base2d/base-advanced-api/index.ts:3494-3502]",
    "앞에 있어야 하는 것: pointID1 = point [src:mathcore-api/object-factory/packages-base/linear-factory.ts:71-76]",
    "앞에 있어야 하는 것: pointID2 = point [src:mathcore-api/object-factory/packages-base/linear-factory.ts:71-76]",
    "만드는 것: vector(vector) 1개 [src:base2d/base-advanced-api/index.ts:3495] — 보임(기본값) [src:object-manager/objects/vector.ts:57], 색 null as null | Color(configs.linearColor) [src:base2d/base-advanced-api/configs.ts:127], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [pointID1, pointID2] [src:base2d/base-advanced-api/index.ts:3499]",
    "참고: pointID1 이 시작점, pointID2 가 끝점이다. 결과는 type 이 vector 인 개체라 선(linear)을 받는 자리(평행선, 수선, 수직이등분선, 접선의 둘째 인자)에 넣으면 무효이고, 벡터를 받는 linear.vectorFromPoint 의 vectorID 에만 쓸 수 있다. [src:정합성 linear: scripts/pipeline/semantic/linear.mjs 의 linear.vector: 'coordinates = 시작점(pointID1), 끝점(pointID2)', '벡터는 선 자리(평행선 기준)에서 선으로 읽히지 않아 무효', testLinearAsInput 의 '선 자리에 vectorAsLinear 결과를 넣으면 무효(벡터는 선이 아니다)'; 캔버스 대조: scripts/pipeline/semantic/linear.mjs 의 '캔버스 벡터: 점 둘을 누르면 둘째 클릭에서 벡터 하나가 서고 시작점은 먼저 누른 점'; tool-vector.ts:64]",
    "참고: 캔버스의 벡터 도구(단축키 v)에서 시작점과 끝점을 차례로 누르는 동작에 해당하고 둘째 클릭에서 선다. 첫째 인자가 시작점이다. 이 도구는 점 id 둘을 받으므로 두 점을 먼저 세운다. [src:정합성 linear: scripts/pipeline/semantic/linear.mjs 캔버스 재현, tool-vector.ts:39-76]"
   ],
   "range": [
    "pointID1: 형식 String [src:mathcore-api/object-factory/packages-base/linear-factory.ts:72] [src:mathcore-api/object-factory/object-types.ts:92]",
    "pointID2: 형식 String [src:mathcore-api/object-factory/packages-base/linear-factory.ts:73] [src:mathcore-api/object-factory/object-types.ts:92]",
    "name?: 형식 String | Undefined [src:mathcore-api/object-factory/packages-base/linear-factory.ts:74] [src:mathcore-api/object-factory/object-types.ts:93]; 생략하면 this.getNewObjectName() [src:base2d/base-advanced-api/index.ts:3500]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): coordinates=[[0, 0], [0, 0]], givenLengthCurrenAngle=0, vectorAngle=0, vectorRadius=0, vectorHeadPosition=[0, 0] [src:object-manager/objects/vector.ts:60-64]"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "linear.vectorFromPoint",
   "path": [
    "linear",
    "vectorFromPoint"
   ],
   "params": [
    {
     "name": "pointID",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "vectorID",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "vector"
      },
      {
       "type": "linear"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "packages-base/linear-factory.ts",
   "usage": [
    "용도(도구 UI 설명): 시작점과 벡터 — 점과 벡터를 선택합니다. [src:base2d-ui/src/tab/tools/configs/base2d-geometry.ts:224]",
    "호출: factory.linear.vectorFromPoint → advanced.createStartingPointVector [src:mathcore-api/object-factory/packages-base/linear-factory.ts:78-83] [src:base2d/base-advanced-api/index.ts:3504-3512]",
    "앞에 있어야 하는 것: pointID = point [src:mathcore-api/object-factory/packages-base/linear-factory.ts:78-83]",
    "앞에 있어야 하는 것: vectorID = vector [src:mathcore-api/object-factory/packages-base/linear-factory.ts:78-83]",
    "만드는 것: vector(startingPointVector) 1개 [src:base2d/base-advanced-api/index.ts:3505] — 보임(기본값) [src:object-manager/objects/vector.ts:57], 색 null as null | Color(configs.linearColor) [src:base2d/base-advanced-api/configs.ts:127], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [pointID, vectorID] [src:base2d/base-advanced-api/index.ts:3509]",
    "참고: 새 벡터의 시작점이 pointID 이고 끝점은 pointID + (vectorID 의 끝점 - 시작점)이다(크기와 방향을 복사한다). vectorID 에 선분, 직선, 반직선을 주면 그 선의 첫째 점에서 둘째 점으로 가는 방향을 쓴다. [src:정합성 linear: scripts/pipeline/semantic/linear.mjs 의 linear.vectorFromPoint: '시점이 pointID 의 위치 R 이고 종점이 R + (Q-P) = (6,1)이다', 'vectorID 에 선분을 넣으면 선분의 coordinates 차(끝점2-끝점1)만큼의 벡터가 선다', 'vectorID 에 반직선(Q 에서 P 로)을 넣으면 P-Q 방향'; 캔버스 대조: scripts/pipeline/semantic/linear.mjs 의 '캔버스 시작점과 벡터' (점 → 벡터, 벡터 → 점 모두 팩토리와 같은 결과; 캔버스는 선분을 벡터로 고를 수 없고 팩토리는 받는다); tool-starting-point-vector.ts:88]",
    "참고: 캔버스의 시작점과 벡터 도구(shift+v)에서 점과 벡터를 순서에 상관없이 누르는 동작에 해당하고 둘이 모이는 클릭에서 선다. 캔버스는 벡터 자리에 벡터(linear.vector 로 세운 것)만 고를 수 있다. 이 도구는 점 id 와 벡터 id 를 받으므로 둘을 먼저 세운다. [src:정합성 linear: scripts/pipeline/semantic/linear.mjs 캔버스 재현, tool-starting-point-vector.ts:46-98]"
   ],
   "range": [
    "pointID: 형식 String [src:mathcore-api/object-factory/packages-base/linear-factory.ts:79] [src:mathcore-api/object-factory/object-types.ts:92]",
    "vectorID: 형식 String [src:mathcore-api/object-factory/packages-base/linear-factory.ts:80] [src:mathcore-api/object-factory/object-types.ts:92]",
    "name?: 형식 String | Undefined [src:mathcore-api/object-factory/packages-base/linear-factory.ts:81] [src:mathcore-api/object-factory/object-types.ts:93]; 생략하면 this.getNewObjectName() [src:base2d/base-advanced-api/index.ts:3510]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): coordinates=[[0, 0], [0, 0]], givenLengthCurrenAngle=0, vectorAngle=0, vectorRadius=0, vectorHeadPosition=[0, 0] [src:object-manager/objects/vector.ts:60-64]"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "linear.segmentOfGivenLength",
   "path": [
    "linear",
    "segmentOfGivenLength"
   ],
   "params": [
    {
     "name": "pointID1",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "pointID2",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "givenLength",
     "type": "number|string",
     "optional": false
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "packages-base/linear-factory.ts",
   "usage": [
    "용도(도구 UI 설명): 주어진 길이의 선분 — 한 점을 선택 후 선분의 길이를 입력하세요. [src:base2d-ui/src/tab/tools/configs/base2d-geometry.ts:135]",
    "호출: factory.linear.segmentOfGivenLength → advanced.createSegmentWithGivenLength [src:mathcore-api/object-factory/packages-base/linear-factory.ts:85-91] [src:base2d/base-advanced-api/index.ts:3468-3472]",
    "앞에 있어야 하는 것: pointID1 = point [src:mathcore-api/object-factory/packages-base/linear-factory.ts:85-91]",
    "앞에 있어야 하는 것: pointID2 = point [src:mathcore-api/object-factory/packages-base/linear-factory.ts:85-91]",
    "만드는 것: linear(segmentWithGivenLength) 1개 (경유 createLinear) [src:base2d/base-advanced-api/index.ts:3358] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 null as null | Color(configs.linearColor) [src:base2d/base-advanced-api/configs.ts:127], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [pointID1, pointID2] [src:base2d/base-advanced-api/index.ts:3362]",
    "참고: 둘째 점의 위치를 덮어써 첫째 점 오른쪽 수평으로 보낸다. 둘째 점은 새로 세운 점이어야 한다 [src:docs/palette/linear.md:57]",
    "참고: pointID2 는 호출 뒤 pointID1 + (길이, 0) 으로 옮겨지고, 이 점을 쓰는 다른 개체(선분, 다각형 등)도 함께 끌려간다. pointID1 과 pointID2 에 같은 점을 넣으면 그 점이 길이만큼 거듭 이동하고 선분 길이가 0 이 된다. 캔버스 도구는 둘째 점을 방향을 바꿀 수 있는 전용 점으로 새로 만들지만 이 도구로는 방향을 정할 수 없고 항상 오른쪽 수평이다. 결과는 유한 선분이다. [src:정합성 linear: scripts/pipeline/semantic/linear.mjs 의 linear.segmentOfGivenLength: '둘째 점이 첫째 점 오른쪽 수평 거리 3 인 (4,2)로 옮겨진다', '둘째 점을 다른 선분의 끝점으로 쓰면 그 선분의 끝이 (13,10)으로 끌려간다', 'p1 = p2 같은 id 를 넣으면 점이 길이만큼 이동하며 선분 길이 0 이 된다'; 이미 반영됨: 오른쪽 수평 고정과 새 점 조건은 data/dsl/overlay.json 의 usageNotes; 캔버스 대조: 'givenLength 점을 끌면 길이 3 을 유지한 채 방향이 바뀐다'(캔버스 주어진 길이), tool-segment-with-given-length.ts:66-70 (createGivenLengthPoint(0, 0) 로 둘째 점 생성)]",
    "참고: 캔버스의 주어진 길이의 선분 도구(shift+s)에서 점 하나를 누르면 길이 입력창이 열리고 확인하면 그 길이의 선분이 선다. 캔버스는 둘째 점을 새로 만들고 이 도구는 둘째 점 id 를 받아 그 점을 첫째 점 오른쪽 수평으로 옮기므로, 둘째 점은 다른 개체가 쓰지 않는 새 점으로 세워 준다. [src:정합성 linear: scripts/pipeline/semantic/linear.mjs 캔버스 재현, tool-segment-with-given-length.ts:42-77]"
   ],
   "range": [
    "pointID1: 형식 String [src:mathcore-api/object-factory/packages-base/linear-factory.ts:86] [src:mathcore-api/object-factory/object-types.ts:92]",
    "pointID2: 형식 String [src:mathcore-api/object-factory/packages-base/linear-factory.ts:87] [src:mathcore-api/object-factory/object-types.ts:92]",
    "givenLength: 형식 Number | String [src:mathcore-api/object-factory/packages-base/linear-factory.ts:88] [src:mathcore-api/object-factory/object-types.ts:105]; 숫자가 아닌 문자열이면 슬라이더 연결식으로 들어가 그 값을 따라 움직인다 [src:base2d/base-advanced-api/index.ts:644-654]",
    "name?: 형식 String | Undefined [src:mathcore-api/object-factory/packages-base/linear-factory.ts:89] [src:mathcore-api/object-factory/object-types.ts:93]; 생략하면 this.getNewObjectName()(createLinear) [src:base2d/base-advanced-api/index.ts:3363]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): coordinates=[[0, 0], [0, 0]], givenLengthCurrenAngle=0 [src:object-manager/objects/linear.ts:79-80]",
    "givenLength 는 0 이상의 수이거나 슬라이더 이름이 든 식 문자열이다(캔버스 입력창도 최소 0, 기본 2, 단위 없는 월드 길이). 숫자만 쓴 문자열도 식으로 계산되고, 슬라이더 이름이 아닌 글자나 깨진 식은 오류 없이 길이 0 선분이 유효로 서므로 문자열은 이미 세운 슬라이더 이름만으로 쓴다. 음수는 첫째 점의 왼쪽으로 가지만 쓰지 않는다. [src:정합성 linear: scripts/pipeline/semantic/linear.mjs 의 linear.segmentOfGivenLength: '음수 길이 -2 이면 둘째 점이 왼쪽 (-1,2)로 간다', '문자열 \"3\" 는 식으로 계산되어 길이 3', '없는 이름 \"zz\" 는 오류 없이 길이 0 선분이 유효로 선다', '깨진 식 \"3+\" 도 오류 없이 길이 0 선분이 유효로 선다', '슬라이더를 7 로 바꾸면 선분이 따라가 길이 7', 'NaN 길이는 형식 예외이고 개체가 서지 않는다'; 캔버스 입력창: mathcore/module/mathcore/lib/base2d-ui/src/modal/modals/create-segment-with-given-length-modal/index.tsx:5-12 (defaultValue 2, min 0, step 1, sliderConnectable), tool-segment-with-given-length.ts:64-70]"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "linear.trendLine",
   "path": [
    "linear",
    "trendLine"
   ],
   "params": [
    {
     "name": "pointIDs",
     "type": "ref[]",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "packages-base/linear-factory.ts",
   "usage": [
    "용도(도구 UI 설명): 추세선 — 마우스를 드래그하여 선택한 점으로 추세선을 생성합니다. [src:base2d-ui/src/tab/tools/configs/base2d-geometry.ts:209]",
    "호출: factory.linear.trendLine → advanced.createTrendLine [src:mathcore-api/object-factory/packages-base/linear-factory.ts:93-97] [src:base2d/base-advanced-api/index.ts:3518-3520]",
    "앞에 있어야 하는 것: pointIDs ref[] = point [src:mathcore-api/object-factory/packages-base/linear-factory.ts:93-97]",
    "만드는 것: linear(trendLine) 1개 (경유 createTrendLine2) [src:base2d/base-advanced-api/index.ts:3388] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 null as null | Color(configs.linearColor) [src:base2d/base-advanced-api/configs.ts:127], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [...pointIDs] [src:base2d/base-advanced-api/index.ts:3392]",
    "참고: 점이 둘 이상이고 x 좌표가 두 값 이상이어야 한다. 결과는 y 를 x 에 회귀한 최소제곱 끝없는 직선이다(computed 는 기울기를 소수 둘째 자리로 반올림한 글). 점이 하나이거나 비면 무효 개체가 서고, x 가 모두 같거나 같은 점만 주면 유효로 서지만 좌표가 NaN 이라 그려지지 않는다. [src:정합성 linear: scripts/pipeline/semantic/linear.mjs 의 linear.trendLine: '최소제곱(y 를 x 에 회귀) 기울기', '점 1개이면 개체는 서지만 무효', '점 0개(빈 배열)이면 개체는 서지만 무효', 'x 가 모두 같은 점들이면 회귀가 정의되지 않아 무효여야 한다'(실패: 유효, 좌표 NaN), '같은 점만 두 번 주면 회귀가 정의되지 않아 무효여야 한다'(실패); 끝없는 직선: mathcore/module/mathcore/packages/renderer/src/layers/graphics/decoration/linear.ts:259-264; 캔버스 대조: scripts/pipeline/semantic/linear.mjs 의 '캔버스 추세선: 사각형 안의 점 4개로 추세선 하나가 서고 팩토리와 같다', '점 하나만 감싸게 끌면 무효 추세선이 선다'; tool-trend-line.ts:30-57]",
    "참고: 캔버스의 추세선 도구는 클릭이 아니라 끌기다. 마우스를 눌러 사각형을 끌고 뗄 때 그 안의 점들을 모아 추세선이 선다. 이 도구는 점 id 목록을 받으므로 점들을 먼저 세우고 그 id 를 준다. 점이 둘 이상이고 x 가 모두 같지 않아야 뜻이 있다. [src:정합성 linear: scripts/pipeline/semantic/linear.mjs 캔버스 재현, tool-trend-line.ts:21-57]"
   ],
   "range": [
    "pointIDs: 형식 [String] [src:mathcore-api/object-factory/packages-base/linear-factory.ts:94] [src:mathcore-api/object-factory/object-types.ts:96]",
    "name?: 형식 String | Undefined [src:mathcore-api/object-factory/packages-base/linear-factory.ts:95] [src:mathcore-api/object-factory/object-types.ts:93]; 생략하면 this.getNewObjectName()(createTrendLine2) [src:base2d/base-advanced-api/index.ts:3394]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): coordinates=[[0, 0], [0, 0]], givenLengthCurrenAngle=0 [src:object-manager/objects/linear.ts:79-80]"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "measure.lengthByObjectId",
   "path": [
    "measure",
    "lengthByObjectId"
   ],
   "params": [
    {
     "name": "objectID",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "linear"
      },
      {
       "type": "circle"
      },
      {
       "type": "polygon"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "packages-base/measure-factory.ts",
   "usage": [
    "용도: 선분, 원, 호, 부채꼴, 반원, 활꼴, 다각형 하나의 길이를 잰다. 선분은 길이, 원은 둘레, 호와 부채꼴과 반원과 활꼴은 호의 길이만(반지름과 현은 넣지 않는다), 다각형은 둘레다. 점 둘 사이의 거리는 measure.lengthByTwoPointsID 로 잰다. [src:정합성 measure-deco: scripts/pipeline/semantic/measure-deco.mjs 의 '호 90도 r=4 는 2π 6.28', '부채꼴 90도 r=4 는 호 길이만 6.28', '반원(semiCircle 180도) r=4 는 호 길이 4π 12.57', '다각형 3-4-5 삼각형 둘레 12', '원둘레 r=2 는 4π 12.57'; mathcore measure-length.ts:242-262]",
    "호출: factory.measure.lengthByObjectId → advanced.createMeasureLengthById [src:mathcore-api/object-factory/packages-base/measure-factory.ts:9-21] [src:base2d/base-advanced-api/index.ts:2855-2868]",
    "앞에 있어야 하는 것: objectID = 아무 개체 [src:mathcore-api/object-factory/packages-base/measure-factory.ts:9-21]",
    "본문이 거르는 종류: linear, circle, polygon, ellipse [src:mathcore-api/object-factory/packages-base/measure-factory.ts:9-21]",
    "만드는 것: measureLength(measureLength) 1개 [src:base2d/base-advanced-api/index.ts:2858] — 보임(기본값) [src:object-manager/objects/measure-length.ts:59], 크기 15(configs.measuretextSize) [src:base2d/base-advanced-api/configs.ts:124], 색 #000(configs.textColor) [src:base2d/base-advanced-api/configs.ts:90], 매인 개체 [objectID] [src:base2d/base-advanced-api/index.ts:2864]",
    "참고: 선 중에서는 linear.segment 로 세운 선분만 받는다. 길이지정선분, 수선, 평행선, 접선, 벡터를 주면 개체가 서지 않는다(undefined). 타원은 세울 수 없어 대상이 될 수 없다. [src:정합성 measure-deco: scripts/pipeline/semantic/measure-deco.mjs 의 '종류 line/ray/vec/sgl/perp/par/tanL/point/curve/nonexist 는 개체가 서지 않는다(선분 category 만 받는다)'; mathcore measure-factory.ts:15]",
    "참고: 세 점 호(circle.arcThroughThreePoints)를 주면 호 길이가 아니라 원 전체 둘레가 나온다. 호 길이는 circle.arc, circle.fan, circle.semiCircle 로 세운 호에서 잰다. [src:정합성 measure-deco: scripts/pipeline/semantic/measure-deco.mjs 의 '세 점 호(arcThroughThreePoints)는 호 길이가 아니라 원 전체 둘레가 나온다(사실 고정)'(반원 모양 호 r=4 에서 25.13); mathcore measure-length.ts:242]",
    "참고: 캔버스의 길이 도구(버튼 길이)에서 선분, 원 둘레선, 다각형 안쪽을 한 번 클릭하는 동작에 해당하고 클릭 한 번에 바로 선다. 측정 글자는 클릭 위치가 아니라 선분 중점, 원 중심, 다각형 중심에 놓인다. 다각형을 만들면 변 선분도 함께 서므로 다각형 id 를 주면 둘레, 변 선분 id 를 주면 그 변의 길이다. [src:정합성 measure-deco: scripts/pipeline/semantic/measure-deco.mjs 의 '캔버스: 선분 한 번 클릭 = createMeasureLengthById(선분 id, \"segment\") 즉시 생성', '캔버스: 다각형 내부 클릭 = kind \"polygon\"', '캔버스: 다각형 변 클릭은 ... 변 선분', '측정 글자 위치는 마우스가 아니라 대상 중심'; /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d-tools/src/tools/math2d-tools/tool-measure-length.ts:109-135 (pointerDown), base2d-geometry.ts:441-451 (탭 기하 > 묶음 측정과 변환 > 길이), tool-manager.ts:119]"
   ],
   "range": [
    "objectID: 형식 String [src:mathcore-api/object-factory/packages-base/measure-factory.ts:10] [src:mathcore-api/object-factory/object-types.ts:92]",
    "name?: 형식 String | Undefined [src:mathcore-api/object-factory/packages-base/measure-factory.ts:11] [src:mathcore-api/object-factory/object-types.ts:93]; 생략하면 this.getNewObjectName() [src:base2d/base-advanced-api/index.ts:2856]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): position=[0, 0], relatedPosition=[0, 0], length=0 [src:object-manager/objects/measure-length.ts:62-64]",
    "값은 측정 개체의 length 속성에 담기고, 단위는 점 좌표와 같은 눈금이며, 소수 둘째 자리로 반올림된다(예: (0,0)-(1,1) 선분은 1.41). [src:정합성 measure-deco: scripts/pipeline/semantic/measure-deco.mjs 의 '선분 (0,0)-(1,1) 길이 1.41(둘째 자리 반올림)', 'readMeasurements 가 같은 값을 읽는다'; mathcore measure-length.ts:211]"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "measure.lengthByTwoPointsID",
   "path": [
    "measure",
    "lengthByTwoPointsID"
   ],
   "params": [
    {
     "name": "pointID1",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "pointID2",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "packages-base/measure-factory.ts",
   "usage": [
    "용도: 점 둘 사이의 직선 거리를 선분을 세우지 않고 바로 잰다. [src:정합성 measure-deco: scripts/pipeline/semantic/measure-deco.mjs 의 '(0,0)-(3,4) 거리 5', '(-2,3)-(4,-5) 거리 10'; mathcore measure-length.ts:172-173]",
    "호출: factory.measure.lengthByTwoPointsID → advanced.createMeasureLengthByTwoPointsID [src:mathcore-api/object-factory/packages-base/measure-factory.ts:23-28] [src:base2d/base-advanced-api/index.ts:2899-2917]",
    "앞에 있어야 하는 것: pointID1 = point [src:mathcore-api/object-factory/packages-base/measure-factory.ts:23-28]",
    "앞에 있어야 하는 것: pointID2 = point [src:mathcore-api/object-factory/packages-base/measure-factory.ts:23-28]",
    "만드는 것: measureLength(measureLength) 1개 [src:base2d/base-advanced-api/index.ts:2907] — 보임(기본값) [src:object-manager/objects/measure-length.ts:59], 크기 15(configs.measuretextSize) [src:base2d/base-advanced-api/configs.ts:124], 색 #000(configs.textColor) [src:base2d/base-advanced-api/configs.ts:90], 매인 개체 [pointID1, pointID2] [src:base2d/base-advanced-api/index.ts:2913]",
    "참고: 점 자리에 점이 아닌 개체나 없는 id 를 주면 개체가 서도 무효여서 값 0 이고 그려지지 않는다. [src:정합성 measure-deco: scripts/pipeline/semantic/measure-deco.mjs 의 '점 자리 입력 segFirst/segSecond/circFirst/nonexist/nameAsId' 와 '무효 개체의 길이는 0 이고 readMeasurements 가 읽지 않는다']",
    "참고: 캔버스의 길이 도구에서 점 A 와 점 B 를 차례로 클릭하는 동작에 해당하고 두 번째 클릭에서 선다(같은 도구에서 선분이나 원을 클릭하면 measure.lengthByObjectId 쪽이다). 같은 점 두 번은 캔버스로 만들 수 없고 이 호출로만 길이 0 이 선다. [src:정합성 measure-deco: scripts/pipeline/semantic/measure-deco.mjs 의 '캔버스: 점 A 클릭 뒤 점 B 클릭 = createMeasureLengthByTwoPointsID(A,B,\"twoPoints\")', '캔버스: 같은 점을 두 번 누르면 아무것도 만들지 않는다', '캔버스 점 두 번 클릭 = 팩토리 lengthByTwoPointsID(A,B)'; /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d-tools/src/tools/math2d-tools/tool-measure-length.ts:91-108]"
   ],
   "range": [
    "pointID1: 형식 String [src:mathcore-api/object-factory/packages-base/measure-factory.ts:24] [src:mathcore-api/object-factory/object-types.ts:92]",
    "pointID2: 형식 String [src:mathcore-api/object-factory/packages-base/measure-factory.ts:25] [src:mathcore-api/object-factory/object-types.ts:92]",
    "name?: 형식 String | Undefined [src:mathcore-api/object-factory/packages-base/measure-factory.ts:26] [src:mathcore-api/object-factory/object-types.ts:93]; 생략하면 this.getNewObjectName() [src:base2d/base-advanced-api/index.ts:2905]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): position=[0, 0], relatedPosition=[0, 0], length=0 [src:object-manager/objects/measure-length.ts:62-64]",
    "값은 측정 개체의 length 속성에 담기고, 단위는 점 좌표와 같은 눈금이며, 소수 둘째 자리로 반올림된다(예: (1,1)-(2,2) 는 1.41). 점 순서와 무관하다. 같은 점 둘이면 0 이 유효하게 선다. [src:정합성 measure-deco: scripts/pipeline/semantic/measure-deco.mjs 의 '(1,1)-(2,2) 거리 1.41', '점 순서를 바꿔도 같은 값', '같은 점 두 번은 길이 0 이고 유효']"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "measure.angle",
   "path": [
    "measure",
    "angle"
   ],
   "params": [
    {
     "name": "pointID1",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "pointID2",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "pointID3",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    }
   ],
   "source": "packages-base/measure-factory.ts",
   "usage": [
    "용도(도구 UI 설명): 각도 — 각도를 측정할 세 점을 선택하세요. [src:base2d-ui/src/tab/tools/configs/base2d-geometry.ts:457]",
    "호출: factory.measure.angle → advanced.createMeasureAngleById [src:mathcore-api/object-factory/packages-base/measure-factory.ts:30-35] [src:base2d/base-advanced-api/index.ts:3156-3164]",
    "앞에 있어야 하는 것: pointID1 = point [src:mathcore-api/object-factory/packages-base/measure-factory.ts:30-35]",
    "앞에 있어야 하는 것: pointID2 = point [src:mathcore-api/object-factory/packages-base/measure-factory.ts:30-35]",
    "앞에 있어야 하는 것: pointID3 = point [src:mathcore-api/object-factory/packages-base/measure-factory.ts:30-35]",
    "만드는 것: measureAngle 1개 [src:base2d/base-advanced-api/index.ts:3157] — 보임(기본값) [src:object-manager/objects/measure-angle.ts:39], 크기 15(configs.measuretextSize) [src:base2d/base-advanced-api/configs.ts:124], 색 #000(configs.textColor) [src:base2d/base-advanced-api/configs.ts:90], 매인 개체 [pointID1, pointID2, pointID3] [src:base2d/base-advanced-api/index.ts:3161]",
    "참고: 둘째 점이 꼭짓점이다. 꼭짓점에서 첫째 점 쪽을 시작으로 셋째 점 쪽까지 반시계로 잰 도(0 초과 360 이하)라서 점 순서를 바꾸면 360 에서 뺀 값이 나온다 [src:docs/palette/measure-deco.md:177]",
    "참고: 삼각형 ABC 의 꼭짓점 B 의 내각은 A, B, C 가 반시계 순서로 놓였으면 (C, B, A), 시계 순서로 놓였으면 (A, B, C) 로 준다. 반대 순서로 주면 360 에서 내각을 뺀 값이 나온다. 예: A(0,3), B(0,0), C(4,0) 는 반시계 순서이고 (A,B,C) 는 270, (C,B,A) 는 90 이다. [src:정합성 measure-deco: scripts/pipeline/semantic/measure-deco.mjs 의 '직각삼각형 B=(0,0) 의 내각 (A,B,C) 는 270', '직각삼각형 B 의 내각 (C,B,A) 는 90', 'A=(0,3) 에서 (B,A,C) 53.13', 'A 에서 (C,A,B) 306.87']",
    "참고: 서로 다른 세 점만 준다. 꼭짓점이 첫째 점이나 셋째 점과 같은 위치이면 정의되지 않는 각인데도 개체가 서고 의미 없는 값이 나온다(예: 꼭짓점과 셋째 점이 같으면 180). [src:정합성 measure-deco: scripts/pipeline/semantic/measure-deco.mjs 의 '(A,A,C) 는 영벡터를 0도 방향으로 읽어 90', '(A,B,B) 는 영벡터를 0도 방향으로 읽어 180'; mathcore measure-angle.ts:163-186]",
    "참고: 캔버스의 각도 도구에서 점 셋을 차례로 클릭하는 동작에 해당하고 클릭 순서가 (첫 점, 꼭짓점, 셋째 점)이며 셋째 점 클릭에서 선다. 값이 정확히 90 이면 화면에 호 대신 직각 표시가 그려진다. 글자는 꼭짓점에서 월드 (0.2,-0.2) 떨어진 곳에 놓인다. [src:정합성 measure-deco: scripts/pipeline/semantic/measure-deco.mjs 의 '캔버스: 세 번째 점 클릭에서 createMeasureAngleById(p1,p2,p3) 생성', '캔버스 세 점 클릭 = 팩토리 measure.angle(p1,p2,p3)', '화면: 각 값이 정확히 90 이면 반지름 20px 호 대신 직각 표시를 그리고'; /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d-tools/src/tools/math2d-tools/tool-measure-angle.ts:40-72; renderer measure-angle.ts:64]"
   ],
   "range": [
    "pointID1: 형식 String [src:mathcore-api/object-factory/packages-base/measure-factory.ts:31] [src:mathcore-api/object-factory/object-types.ts:92]",
    "pointID2: 형식 String [src:mathcore-api/object-factory/packages-base/measure-factory.ts:32] [src:mathcore-api/object-factory/object-types.ts:92]",
    "pointID3: 형식 String [src:mathcore-api/object-factory/packages-base/measure-factory.ts:33] [src:mathcore-api/object-factory/object-types.ts:92]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): position=[0, 0], startDirection=vec2.create(), endDirection=vec2.create(), centerDirection=vec2.create(), betweenAngle=0, startAngle=0, endAngle=0, radius=20, relatedPosition=[0.2, -0.2], angle=0, criterionPosition=[0, 0] [src:object-manager/objects/measure-angle.ts:42-52]",
    "값 자르기: m.startAngle < 0 → m.startAngle = 2 * Math.PI + m.startAngle [src:object-manager/objects/measure-angle.ts:180]",
    "값 자르기: m.endAngle < 0 → m.endAngle = 2 * Math.PI + m.endAngle [src:object-manager/objects/measure-angle.ts:183]",
    "값은 측정 개체의 angle 속성에 담기고, 단위는 도, 소수 둘째 자리 반올림이다. 범위는 0 초과 360 이하이며 평각은 180, 두 변이 같은 방향이면 0 이 아니라 360 이다. [src:정합성 measure-deco: scripts/pipeline/semantic/measure-deco.mjs 의 '(X,O,Z) 평각 180', '(X,O,X2) 같은 방향은 0 이 아니라 360', '값은 항상 0 초과 360 이하, 소수 둘째 자리'; mathcore measure-angle.ts:195-196]"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "measure.area",
   "path": [
    "measure",
    "area"
   ],
   "params": [
    {
     "name": "objectID",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "circle"
      },
      {
       "type": "polygon"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "packages-base/measure-factory.ts",
   "usage": [
    "용도: 원, 호, 부채꼴, 반원, 활꼴, 다각형 하나의 넓이를 잰다. 원은 πr², 호와 부채꼴은 부채꼴 영역의 넓이(호만이 아니라 두 반지름 사이 전체), 반원과 활꼴(circle.semiCircle)은 호와 현 사이 영역의 넓이다. [src:정합성 measure-deco: scripts/pipeline/semantic/measure-deco.mjs 의 '호 90도 r=4 는 호가 아니라 부채꼴 넓이 4π 12.57', '호 270도 r=4 는 부채꼴 넓이 12π 37.70', '반원 r=4 넓이 8π 25.13', '활꼴 90도 r=4 넓이 = 부채꼴 4π - 삼각형 8 = 4.57', '활꼴 135도 r=4 넓이 13.19'; mathcore measure-area.ts:152-177]",
    "호출: factory.measure.area → advanced.createMeasureAreaById [src:mathcore-api/object-factory/packages-base/measure-factory.ts:37-48] [src:base2d/base-advanced-api/index.ts:3020-3032]",
    "앞에 있어야 하는 것: objectID = 아무 개체 [src:mathcore-api/object-factory/packages-base/measure-factory.ts:37-48]",
    "본문이 거르는 종류: circle, polygon, ellipse [src:mathcore-api/object-factory/packages-base/measure-factory.ts:37-48]",
    "만드는 것: measureArea 1개 [src:base2d/base-advanced-api/index.ts:3023] — 보임(기본값) [src:object-manager/objects/measure-area.ts:48], 크기 15(configs.measuretextSize) [src:base2d/base-advanced-api/configs.ts:124], 색 #000(configs.textColor) [src:base2d/base-advanced-api/configs.ts:90], 매인 개체 [objectID] [src:base2d/base-advanced-api/index.ts:3028]",
    "참고: 곡선 아래 넓이는 이 도구로 못 잰다. algebraric 에 정적분 식을 주어 얻는다 [src:docs/palette/measure-deco.md:206]",
    "참고: 세 점 호(circle.arcThroughThreePoints)를 주면 호 영역이 아니라 원 전체 넓이(πr²)가 나온다. [src:정합성 measure-deco: scripts/pipeline/semantic/measure-deco.mjs 의 '세 점 호(arcThroughThreePoints)의 넓이는 원 전체 πr² (50.27) 가 나온다(사실 고정)'; mathcore measure-area.ts:152,158]",
    "참고: 변이 서로 교차하는 다각형(꼭짓점 순서가 꼬인 것)은 부호가 상쇄되어 실제 넓이보다 작거나 0 이 나온다. 꼭짓점은 둘레를 따라 차례로 준다. [src:정합성 measure-deco: scripts/pipeline/semantic/measure-deco.mjs 의 '변이 서로 교차하는 다각형(나비넥타이)은 부호가 상쇄되어 실제 넓이 2 가 아니라 0 이 나온다(사실 고정)'; mathcore measure-area.ts:210-229]",
    "참고: 캔버스의 넓이 도구에서 원 둘레선이나 다각형 안쪽을 한 번 클릭하는 동작에 해당한다(원 안쪽, 다각형 변, 선분 클릭은 아무것도 만들지 않는다). 측정 글자는 클릭 위치가 아니라 원 중심이나 다각형 중심에 놓인다. [src:정합성 measure-deco: scripts/pipeline/semantic/measure-deco.mjs 의 '캔버스: 선분, 원 내부, 다각형 변 클릭은 아무것도 만들지 않는다', '캔버스: 원 둘레 한 번 클릭 = createMeasureAreaById(원, \"circle\")', '캔버스: 다각형 내부 한 번 클릭'; /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d-tools/src/tools/math2d-tools/tool-measure-area.ts:40-77]"
   ],
   "range": [
    "objectID: 형식 String [src:mathcore-api/object-factory/packages-base/measure-factory.ts:38] [src:mathcore-api/object-factory/object-types.ts:92]",
    "name?: 형식 String | Undefined [src:mathcore-api/object-factory/packages-base/measure-factory.ts:39] [src:mathcore-api/object-factory/object-types.ts:93]; 생략하면 this.getNewObjectName() [src:base2d/base-advanced-api/index.ts:3021]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): position=[0, 0], relatedPosition=[0, 0], area=0 [src:object-manager/objects/measure-area.ts:51-53]",
    "값은 측정 개체의 area 속성에 담기고, 단위는 점 좌표 눈금의 제곱이며, 소수 둘째 자리로 반올림된다(예: 한 변 4 인 정육각형은 41.57). 다각형은 꼭짓점이 시계든 반시계든 같은 양수다. [src:정합성 measure-deco: scripts/pipeline/semantic/measure-deco.mjs 의 '정육각형 변 4 넓이 41.57', '꼭짓점 시계 방향이어도 6(절댓값)'; mathcore measure-area.ts:229]"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "measure.gradient",
   "path": [
    "measure",
    "gradient"
   ],
   "params": [
    {
     "name": "linearID",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "linear"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "packages-base/measure-factory.ts",
   "usage": [
    "용도: 선 하나(선분, 수선, 평행선, 접선 등)의 기울기 dy/dx 를 잰다. 점 둘의 기울기는 먼저 linear.segment 로 선분을 세우고 그 선분을 준다. [src:정합성 measure-deco: scripts/pipeline/semantic/measure-deco.mjs 의 '선분 (0,0)-(4,3) 기울기 0.75', '수선 -1.33', '평행선 0.75', '원 (0,0) r=5 위 점 (3,4) 의 접선 기울기 -0.75', '종류 point: 개체는 서지만 무효']",
    "호출: factory.measure.gradient → advanced.createMeasureGradientById [src:mathcore-api/object-factory/packages-base/measure-factory.ts:50-54] [src:base2d/base-advanced-api/index.ts:2944-2956]",
    "앞에 있어야 하는 것: linearID = linear [src:mathcore-api/object-factory/packages-base/measure-factory.ts:50-54]",
    "만드는 것: measureGradient 1개 [src:base2d/base-advanced-api/index.ts:2947] — 보임(기본값) [src:object-manager/objects/measure-gradient.ts:45], 크기 15(configs.measuretextSize) [src:base2d/base-advanced-api/configs.ts:124], 색 #000(configs.textColor) [src:base2d/base-advanced-api/configs.ts:90], 매인 개체 [linearID] [src:base2d/base-advanced-api/index.ts:2952]",
    "참고: 선이 아닌 것(점, 벡터, 원, 다각형, 대수 곡선)을 주면 개체가 서도 무효여서 값 0 이고 그려지지 않는다. 호출은 실패하지 않으므로 선인지 먼저 확인한다. [src:정합성 measure-deco: scripts/pipeline/semantic/measure-deco.mjs 의 '종류 vec/point/circ/poly/curve/nonexist: 개체는 서지만 무효', '무효 개체는 readMeasurements 가 읽지 않는다']",
    "참고: 캔버스의 기울기 도구는 선 하나를 클릭하거나(이 호출에 해당) 점 둘을 차례로 클릭해서(이 호출로는 못 만든다) 잰다. 점 둘의 기울기가 필요하면 먼저 linear.segment 를 세우고 그 선분을 준다. 값은 같고, 세로 두 점은 클릭 순서로 Infinity 나 -Infinity 가 갈린다. [src:정합성 measure-deco: scripts/pipeline/semantic/measure-deco.mjs 의 '캔버스: 점 둘 클릭 = createMeasureGradientByTwoPointsId(p1,p2,\"twoPoints\") (팩토리에 없는 호출), 값은 같은 선분의 0.5', '팩토리 measure.gradient 는 kind 가 \"linear\" 로 고정이라 점 id 를 주면 무효 개체', '캔버스: 두 점 세로 기울기는 클릭 순서로 부호가 갈린다'; /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d-tools/src/tools/math2d-tools/tool-measure-gradient.ts:43-86; mathcore-api measure-factory.ts:50-54]"
   ],
   "range": [
    "linearID: 형식 String [src:mathcore-api/object-factory/packages-base/measure-factory.ts:51] [src:mathcore-api/object-factory/object-types.ts:92]",
    "name?: 형식 String | Undefined [src:mathcore-api/object-factory/packages-base/measure-factory.ts:52] [src:mathcore-api/object-factory/object-types.ts:93]; 생략하면 this.getNewObjectName() [src:base2d/base-advanced-api/index.ts:2945]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): position=[0, 0], relatedPosition=[0, 0], gradient=0 [src:object-manager/objects/measure-gradient.ts:48-50]",
    "값은 측정 개체의 gradient 속성에 담기고, 무차원 (y2-y1)/(x2-x1) 이며 소수 둘째 자리로 반올림된다(예: 1/3 은 0.33). 비세로선은 선분을 어느 방향으로 세워도 같다. 세로선은 부호가 선을 세운 점 순서로 갈려 아래에서 위로 세우면 Infinity, 위에서 아래로 세우면 -Infinity 이며 이 값은 잰 값으로 읽히지 않는다. [src:정합성 measure-deco: scripts/pipeline/semantic/measure-deco.mjs 의 '선분을 반대 순서로 세워도 0.75', '선분 (0,0)-(3,1) 기울기 0.33', '세로 선분의 기울기는 Infinity 이고 개체는 유효하게 선다', '세로 선분은 readMeasurements 가 읽지 않는다'; mathcore measure-gradient.ts:188-189; scripts/pipeline/semantic/measure-deco.mjs 의 '세로 선분을 위에서 아래로 세우면 -Infinity (부호는 선분을 세운 점 순서가 정한다)']"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "motion.bezierCurveMotion",
   "path": [
    "motion",
    "bezierCurveMotion"
   ],
   "params": [
    {
     "name": "pointID1",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "pointID2",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "packages-base/motion-factory.ts",
   "usage": [
    "용도(도구 UI 설명): 베지어 경로 — 경로를 그리고 이동할 객체를 선택하세요. [src:base2d-ui/src/tab/tools/configs/base2d-geometry.ts:629]",
    "호출: factory.motion.bezierCurveMotion → advanced.createBezierCurveMotion [src:mathcore-api/object-factory/packages-base/motion-factory.ts:8-13] [src:base2d/base-advanced-api/index.ts:3803-3809]",
    "앞에 있어야 하는 것: pointID1 = point [src:mathcore-api/object-factory/packages-base/motion-factory.ts:8-13]",
    "앞에 있어야 하는 것: pointID2 = point [src:mathcore-api/object-factory/packages-base/motion-factory.ts:8-13]",
    "만드는 것: bezierCurveMotion(bezierCurveMotion) 1개 [src:base2d/base-advanced-api/index.ts:3804] — 보임(기본값) [src:object-manager/objects/bezier-curve-motion.ts:31], 매인 개체 [pointID1, pointID2] [src:base2d/base-advanced-api/index.ts:3807]"
   ],
   "range": [
    "pointID1: 형식 String [src:mathcore-api/object-factory/packages-base/motion-factory.ts:9] [src:mathcore-api/object-factory/object-types.ts:92]",
    "pointID2: 형식 String [src:mathcore-api/object-factory/packages-base/motion-factory.ts:10] [src:mathcore-api/object-factory/object-types.ts:92]",
    "name?: 형식 String | Undefined [src:mathcore-api/object-factory/packages-base/motion-factory.ts:11] [src:mathcore-api/object-factory/object-types.ts:93]; 생략하면 this.getNewObjectName() [src:base2d/base-advanced-api/index.ts:3806]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): color=[0, 0, 0, 0.3], strokeWidth=2, endCoordinates=[[0, 0], [0, 0]], handleCoordinates=[[0, 0], [0, 0]], animation={ active: false, speed:…, motionConnectInfo=[] [src:object-manager/objects/bezier-curve-motion.ts:32-44]"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "motion.segmentMotion",
   "path": [
    "motion",
    "segmentMotion"
   ],
   "params": [
    {
     "name": "pointID1",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "pointID2",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "packages-base/motion-factory.ts",
   "usage": [
    "용도(도구 UI 설명): 선분 경로 — 경로를 그리고 이동할 객체를 선택하세요. [src:base2d-ui/src/tab/tools/configs/base2d-geometry.ts:629]",
    "호출: factory.motion.segmentMotion → advanced.createSegmentMotion [src:mathcore-api/object-factory/packages-base/motion-factory.ts:15-20] [src:base2d/base-advanced-api/index.ts:3811-3817]",
    "앞에 있어야 하는 것: pointID1 = point [src:mathcore-api/object-factory/packages-base/motion-factory.ts:15-20]",
    "앞에 있어야 하는 것: pointID2 = point [src:mathcore-api/object-factory/packages-base/motion-factory.ts:15-20]",
    "만드는 것: segmentMotion(segmentMotion) 1개 [src:base2d/base-advanced-api/index.ts:3812] — 보임(기본값) [src:object-manager/objects/segment-motion.ts:29], 매인 개체 [pointID1, pointID2] [src:base2d/base-advanced-api/index.ts:3815]"
   ],
   "range": [
    "pointID1: 형식 String [src:mathcore-api/object-factory/packages-base/motion-factory.ts:16] [src:mathcore-api/object-factory/object-types.ts:92]",
    "pointID2: 형식 String [src:mathcore-api/object-factory/packages-base/motion-factory.ts:17] [src:mathcore-api/object-factory/object-types.ts:92]",
    "name?: 형식 String | Undefined [src:mathcore-api/object-factory/packages-base/motion-factory.ts:18] [src:mathcore-api/object-factory/object-types.ts:93]; 생략하면 this.getNewObjectName() [src:base2d/base-advanced-api/index.ts:3814]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): color=[0, 0, 0, 0.3], strokeWidth=2, animation={ active: false, speed:…, motionConnectInfo=[], coordinates=[[0, 0], [0, 0]] [src:object-manager/objects/segment-motion.ts:30-41]"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "motion.rotateMotion",
   "path": [
    "motion",
    "rotateMotion"
   ],
   "params": [
    {
     "name": "pointID1",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "angle",
     "type": "number",
     "optional": false
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "packages-base/motion-factory.ts",
   "usage": [
    "용도(도구 UI 설명): 점을 중심으로 하는 회전 경로 — 회전 각도를 설정하고 회전할 객체를 선택하세요. [src:base2d-ui/src/tab/tools/configs/base2d-geometry.ts:659]",
    "호출: factory.motion.rotateMotion → advanced.createRotateMotion [src:mathcore-api/object-factory/packages-base/motion-factory.ts:22-27] [src:base2d/base-advanced-api/index.ts:3819-3826]",
    "앞에 있어야 하는 것: pointID1 = point [src:mathcore-api/object-factory/packages-base/motion-factory.ts:22-27]",
    "만드는 것: rotateMotion(rotateMotion) 1개 [src:base2d/base-advanced-api/index.ts:3820] — 보임(기본값) [src:object-manager/objects/rotate-motion.ts:30], 매인 개체 [pointID1] [src:base2d/base-advanced-api/index.ts:3823]"
   ],
   "range": [
    "pointID1: 형식 String [src:mathcore-api/object-factory/packages-base/motion-factory.ts:23] [src:mathcore-api/object-factory/object-types.ts:92]",
    "angle: 형식 Number [src:mathcore-api/object-factory/packages-base/motion-factory.ts:24] [src:mathcore-api/object-factory/object-types.ts:94]",
    "name?: 형식 String | Undefined [src:mathcore-api/object-factory/packages-base/motion-factory.ts:25] [src:mathcore-api/object-factory/object-types.ts:93]; 생략하면 this.getNewObjectName() [src:base2d/base-advanced-api/index.ts:3822]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): color=[0, 0, 0, 0.3], strokeWidth=2, animation={ active: false, speed:…, motionConnectInfo=[], position=[0, 0], borderSize=2 [src:object-manager/objects/rotate-motion.ts:31-43]"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "motion.circleMotion",
   "path": [
    "motion",
    "circleMotion"
   ],
   "params": [
    {
     "name": "pointID1",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "pointID2",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "packages-base/motion-factory.ts",
   "usage": [
    "용도(도구 UI 설명): 원 경로 — 경로를 그리고 이동할 객체를 선택하세요. [src:base2d-ui/src/tab/tools/configs/base2d-geometry.ts:629]",
    "호출: factory.motion.circleMotion → advanced.createCircleMotion [src:mathcore-api/object-factory/packages-base/motion-factory.ts:29-34] [src:base2d/base-advanced-api/index.ts:3828-3834]",
    "앞에 있어야 하는 것: pointID1 = point [src:mathcore-api/object-factory/packages-base/motion-factory.ts:29-34]",
    "앞에 있어야 하는 것: pointID2 = point [src:mathcore-api/object-factory/packages-base/motion-factory.ts:29-34]",
    "만드는 것: circleMotion(cricleMotion) 1개 [src:base2d/base-advanced-api/index.ts:3829] — 보임(기본값) [src:object-manager/objects/circle-motion.ts:38], 매인 개체 [pointID1, pointID2] [src:base2d/base-advanced-api/index.ts:3832]"
   ],
   "range": [
    "pointID1: 형식 String [src:mathcore-api/object-factory/packages-base/motion-factory.ts:30] [src:mathcore-api/object-factory/object-types.ts:92]",
    "pointID2: 형식 String [src:mathcore-api/object-factory/packages-base/motion-factory.ts:31] [src:mathcore-api/object-factory/object-types.ts:92]",
    "name?: 형식 String | Undefined [src:mathcore-api/object-factory/packages-base/motion-factory.ts:32] [src:mathcore-api/object-factory/object-types.ts:93]; 생략하면 this.getNewObjectName() [src:base2d/base-advanced-api/index.ts:3831]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): color=[0, 0, 0, 0.3], strokeWidth=2, animation={ active: false, speed:…, motionConnectInfo=[], coordinates=[[0, 0], [0, 0]], radius=1, borderSize=2, angleRange=[0, 2 * Math.PI], position=[0, 0] [src:object-manager/objects/circle-motion.ts:39-54]"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "motion.arcMotion",
   "path": [
    "motion",
    "arcMotion"
   ],
   "params": [
    {
     "name": "pointID1",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "pointID2",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "pointID3",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "packages-base/motion-factory.ts",
   "usage": [
    "용도(도구 UI 설명): 호 경로 — 경로를 그리고 이동할 객체를 선택하세요. [src:base2d-ui/src/tab/tools/configs/base2d-geometry.ts:629]",
    "호출: factory.motion.arcMotion → advanced.createArcMotion [src:mathcore-api/object-factory/packages-base/motion-factory.ts:36-42] [src:base2d/base-advanced-api/index.ts:3836-3843]",
    "앞에 있어야 하는 것: pointID1 = point [src:mathcore-api/object-factory/packages-base/motion-factory.ts:36-42]",
    "앞에 있어야 하는 것: pointID2 = point [src:mathcore-api/object-factory/packages-base/motion-factory.ts:36-42]",
    "앞에 있어야 하는 것: pointID3 = point [src:mathcore-api/object-factory/packages-base/motion-factory.ts:36-42]",
    "만드는 것: arcMotion(arcMotion) 1개 [src:base2d/base-advanced-api/index.ts:3838] — 보임(기본값) [src:object-manager/objects/arc-motion.ts:39], 매인 개체 [pointID1, pointID2, pointID3, auxiliaryPointID] [src:base2d/base-advanced-api/index.ts:3841]",
    "함께 생김: point(auxiliary) 1개 (경유 createAuxiliaryPoint) [src:base2d/base-advanced-api/index.ts:2556] — 보임(기본값) [src:object-manager/objects/point.ts:91], 크기 9(configs.pointSize) [src:base2d/base-advanced-api/configs.ts:85], 색 #6e6868(configs.intersectionPointColor) [src:base2d/base-advanced-api/configs.ts:112]",
    "함께 생김: text(nameText) 1개 (경유 createAuxiliaryPoint → createNameText) [src:base2d/base-advanced-api/index.ts:3266] — 보임(기본값) [src:object-manager/objects/text.ts:63], 위치 오프셋(화면 px) [16, -16] [src:base2d/base-advanced-api/index.ts:3268], 크기 16(configs.nametextSize) [src:base2d/base-advanced-api/configs.ts:92], 글꼴 'KaTeX'(configs.nametextFont) [src:base2d/base-advanced-api/configs.ts:94], 색 #000(configs.nametextColor) [src:base2d/base-advanced-api/configs.ts:93], 매인 개체 [point.id] [src:base2d/base-advanced-api/index.ts:3269]"
   ],
   "range": [
    "pointID1: 형식 String [src:mathcore-api/object-factory/packages-base/motion-factory.ts:37] [src:mathcore-api/object-factory/object-types.ts:92]",
    "pointID2: 형식 String [src:mathcore-api/object-factory/packages-base/motion-factory.ts:38] [src:mathcore-api/object-factory/object-types.ts:92]",
    "pointID3: 형식 String [src:mathcore-api/object-factory/packages-base/motion-factory.ts:39] [src:mathcore-api/object-factory/object-types.ts:92]",
    "name?: 형식 String | Undefined [src:mathcore-api/object-factory/packages-base/motion-factory.ts:40] [src:mathcore-api/object-factory/object-types.ts:93]; 생략하면 this.getNewObjectName() [src:base2d/base-advanced-api/index.ts:3840]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): color=[0, 0, 0, 0.3], strokeWidth=2, animation={ active: false, speed:…, motionConnectInfo=[], radius=1, borderSize=2, angleRange=[0, 2 * Math.PI], position=[0, 0], startPosition=[0, 0], endPosition=[0, 0] [src:object-manager/objects/arc-motion.ts:40-56]"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "motion.ellipseMotion",
   "path": [
    "motion",
    "ellipseMotion"
   ],
   "params": [
    {
     "name": "pointID1",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "pointID2",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "pointID3",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "packages-base/motion-factory.ts",
   "usage": [
    "용도(도구 UI 설명): 타원 경로 — 경로를 그리고 이동할 객체를 선택하세요. [src:base2d-ui/src/tab/tools/configs/base2d-geometry.ts:629]",
    "호출: factory.motion.ellipseMotion → advanced.createEllipseMotion [src:mathcore-api/object-factory/packages-base/motion-factory.ts:44-50] [src:base2d/base-advanced-api/index.ts:3845-3851]",
    "앞에 있어야 하는 것: pointID1 = point [src:mathcore-api/object-factory/packages-base/motion-factory.ts:44-50]",
    "앞에 있어야 하는 것: pointID2 = point [src:mathcore-api/object-factory/packages-base/motion-factory.ts:44-50]",
    "앞에 있어야 하는 것: pointID3 = point [src:mathcore-api/object-factory/packages-base/motion-factory.ts:44-50]",
    "만드는 것: ellipseMotion(ellipseMotion) 1개 [src:base2d/base-advanced-api/index.ts:3846] — 보임(기본값) [src:object-manager/objects/ellipse-motion.ts:38], 매인 개체 [pointID1, pointID2, pointID3] [src:base2d/base-advanced-api/index.ts:3849]"
   ],
   "range": [
    "pointID1: 형식 String [src:mathcore-api/object-factory/packages-base/motion-factory.ts:45] [src:mathcore-api/object-factory/object-types.ts:92]",
    "pointID2: 형식 String [src:mathcore-api/object-factory/packages-base/motion-factory.ts:46] [src:mathcore-api/object-factory/object-types.ts:92]",
    "pointID3: 형식 String [src:mathcore-api/object-factory/packages-base/motion-factory.ts:47] [src:mathcore-api/object-factory/object-types.ts:92]",
    "name?: 형식 String | Undefined [src:mathcore-api/object-factory/packages-base/motion-factory.ts:48] [src:mathcore-api/object-factory/object-types.ts:93]; 생략하면 this.getNewObjectName() [src:base2d/base-advanced-api/index.ts:3848]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): color=[0, 0, 0, 0.3], position=[0, 0], animation={ active: false, speed:…, motionConnectInfo=[], borderSize=2, majorAxis=0, minorAxis=0, angle=0, fociPositions=[[0, 0], [0, 0]], endPosition=[0, 0] [src:object-manager/objects/ellipse-motion.ts:39-55]"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "motion.motionPlay",
   "path": [
    "motion",
    "motionPlay"
   ],
   "params": [
    {
     "name": "x",
     "type": "number|string",
     "optional": false
    },
    {
     "name": "y",
     "type": "number|string",
     "optional": false
    },
    {
     "name": "name",
     "type": "string",
     "optional": false
    }
   ],
   "source": "packages-base/motion-factory.ts",
   "usage": [
    "용도(도구 UI 설명): 실행 — 모션 실행 버튼을 만드세요. [src:base2d-ui/src/tab/tools/configs/base2d-geometry.ts:623]",
    "호출: factory.motion.motionPlay → advanced.createMotionPlay [src:mathcore-api/object-factory/packages-base/motion-factory.ts:52-57] [src:base2d/base-advanced-api/index.ts:3099-3120]",
    "만드는 것: motionPlay 1개 [src:base2d/base-advanced-api/index.ts:3105] — 보임(기본값) [src:object-manager/objects/motion-play.ts:28], 색 #fe7701(configs.checkboxColor) [src:base2d/base-advanced-api/configs.ts:125]",
    "함께 생김: text(nameText) 1개 (경유 createNameTextByMotionPlay) [src:base2d/base-advanced-api/index.ts:3085] — 보임(기본값) [src:object-manager/objects/text.ts:63], 위치 오프셋(화면 px) [24, 24] || [16, -16] [src:base2d/base-advanced-api/index.ts:3087], 크기 16(configs.nametextSize) [src:base2d/base-advanced-api/configs.ts:92], 글꼴 'KaTeX'(configs.nametextFont) [src:base2d/base-advanced-api/configs.ts:94], 색 #000(configs.nametextColor) [src:base2d/base-advanced-api/configs.ts:93], 매인 개체 [object.id] [src:base2d/base-advanced-api/index.ts:3088]"
   ],
   "range": [
    "x: 형식 Number | String [src:mathcore-api/object-factory/packages-base/motion-factory.ts:53] [src:mathcore-api/object-factory/object-types.ts:105]; 숫자가 아닌 문자열이면 슬라이더 연결식으로 들어가 그 값을 따라 움직인다 [src:base2d/base-advanced-api/index.ts:644-654]",
    "y: 형식 Number | String [src:mathcore-api/object-factory/packages-base/motion-factory.ts:54] [src:mathcore-api/object-factory/object-types.ts:105]; 숫자가 아닌 문자열이면 슬라이더 연결식으로 들어가 그 값을 따라 움직인다 [src:base2d/base-advanced-api/index.ts:644-654]",
    "name: 형식 String [src:mathcore-api/object-factory/packages-base/motion-factory.ts:55] [src:mathcore-api/object-factory/object-types.ts:92]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): fixScreen=true, animation={ active: false, isForw…, motionConnectInfo=[] [src:object-manager/objects/motion-play.ts:32-39]"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "point.basic",
   "path": [
    "point",
    "basic"
   ],
   "params": [
    {
     "name": "x",
     "type": "number|string",
     "optional": false
    },
    {
     "name": "y",
     "type": "number|string",
     "optional": false
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "packages-base/point-factory.ts",
   "usage": [
    "용도: 좌표 (x, y) 에 자유 점 하나를 만든다. 곡선 위의 점은 point.pointOnObject, 두 곡선의 교점은 point.intersect 로 만든다. [src:정합성 alg-point: scripts/pipeline/semantic/alg-point.mjs: 캔버스 버튼: 기하 탭 점 묶음의 「점 (D)」 | /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d-ui/src/tab/tools/configs/base2d-geometry.ts:54-62]",
    "호출: factory.point.basic → advanced.createPoint [src:mathcore-api/object-factory/packages-base/point-factory.ts:9-14] [src:base2d/base-advanced-api/index.ts:2474-2495]",
    "만드는 것: point(point) 1개 [src:base2d/base-advanced-api/index.ts:2479] — 보임(기본값) [src:object-manager/objects/point.ts:91], 크기 9(configs.pointSize) [src:base2d/base-advanced-api/configs.ts:85], 색 #fe7701(configs.pointColor) [src:base2d/base-advanced-api/configs.ts:86]",
    "함께 생김: text(nameText) 1개 (경유 createNameText) [src:base2d/base-advanced-api/index.ts:3266] — 보임(기본값) [src:object-manager/objects/text.ts:63], 위치 오프셋(화면 px) [16, -16] [src:base2d/base-advanced-api/index.ts:3268], 크기 16(configs.nametextSize) [src:base2d/base-advanced-api/configs.ts:92], 글꼴 'KaTeX'(configs.nametextFont) [src:base2d/base-advanced-api/configs.ts:94], 색 #000(configs.nametextColor) [src:base2d/base-advanced-api/configs.ts:93], 매인 개체 [point.id] [src:base2d/base-advanced-api/index.ts:3269]",
    "참고: 문자열 좌표에서 이미 선 슬라이더에 없는 이름, 모르는 변수(x), 여러 글자나 그리스 글자 이름, 계산 결과가 NaN 인 식(\\sqrt{-1})은 에러 없이 그 좌표가 0 이 되고 점은 유효로 선다. 슬라이더는 etc.slider 로 먼저 세워야 하고 algebraric 의 a=3 은 보이지 않는다. [src:정합성 alg-point: scripts/pipeline/semantic/alg-point.mjs: 없는 슬라이더 이름이나 모르는 변수 x 는 조용히 0 | 계산 결과가 NaN(\\sqrt{-1}) 이면 0 으로 남고 유효로 선다 | 여러 글자 이름이나 그리스 글자는 0 으로 읽힌다]",
    "참고: 읽히지 않는 문자열 좌표(1+, 1,5)는 호출이 성공해도 점이 무효(isValid false)로 선다. [src:정합성 alg-point: scripts/pipeline/semantic/alg-point.mjs: 못 읽는 식 \"1+\", \"1,5\" 는 점이 서되 isValid false]",
    "참고: 캔버스의 점 도구는 곡선 위를 누르면 대상 위의 점을, 두 곡선이 만나는 자리를 누르면 교점을 만들지만 point.basic 은 항상 자유 점이다. 곡선에 묶인 점은 point.pointOnObject, 교점은 point.intersect 로 만든다. [src:정합성 alg-point: scripts/pipeline/semantic/alg-point.mjs: 캔버스 점 도구로 곡선 위를 누르면 자유 점이 아니라 대상 위의 점 | 캔버스 점 도구로 두 곡선이 만나는 자리를 누르면 교점이 선다 | /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d-tools/src/tool.ts:1377-1530]"
   ],
   "range": [
    "x: 형식 Number | String [src:mathcore-api/object-factory/packages-base/point-factory.ts:10] [src:mathcore-api/object-factory/object-types.ts:105]; 숫자가 아닌 문자열이면 슬라이더 연결식으로 들어가 그 값을 따라 움직인다 [src:base2d/base-advanced-api/index.ts:644-654]",
    "y: 형식 Number | String [src:mathcore-api/object-factory/packages-base/point-factory.ts:11] [src:mathcore-api/object-factory/object-types.ts:105]; 숫자가 아닌 문자열이면 슬라이더 연결식으로 들어가 그 값을 따라 움직인다 [src:base2d/base-advanced-api/index.ts:644-654]",
    "name?: 형식 String | Undefined [src:mathcore-api/object-factory/packages-base/point-factory.ts:12] [src:mathcore-api/object-factory/object-types.ts:93]; 생략하면 this.getNewPointName() [src:base2d/base-advanced-api/index.ts:2477]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): traceColor=undefined, imoji=0, domain='점', angle=0 [src:object-manager/objects/point.ts:93-99]",
    "x 와 y 는 수이거나 수식 문자열이다. 문자열은 LaTeX 수식으로 계산되어 좌표가 되며(\\sqrt{2}, \\frac{1}{2}, \\pi, 1/3, 2^{3}, \\sin(\\pi/6), \\ln 2, e, 2+3, \\frac{\\sqrt{3}}{2} 가능) 이미 선 슬라이더 이름이 들어 있으면 그 값을 따라 움직인다. [src:정합성 alg-point: scripts/pipeline/semantic/alg-point.mjs: 문자열 좌표는 LaTeX 식으로 평가된다 | 슬라이더 a 를 3 으로 바꾸면 (a,a+1)=(3,4)]"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "point.pointOnObject",
   "path": [
    "point",
    "pointOnObject"
   ],
   "params": [
    {
     "name": "objectId",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "circle"
      },
      {
       "type": "linear"
      },
      {
       "type": "polygon"
      },
      {
       "type": "ellipse"
      },
      {
       "type": "polynomial"
      },
      {
       "type": "bezierCurve"
      }
     ]
    },
    {
     "name": "position",
     "type": "point2",
     "optional": false
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "packages-base/point-factory.ts",
   "usage": [
    "용도: 대상 개체 id 와 어림 좌표 position 으로 대상에 묶인 점을 하나 만든다(원, 선, 다각형, 곡선). 캔버스에서 대상을 한 번 클릭하는 것에 해당하고 클릭한 세계 좌표가 position 이다. [src:정합성 alg-point: scripts/pipeline/semantic/alg-point.mjs: 캔버스 버튼: 기하 탭 점 묶음의 「대상 위의 점 (Shift+D)」 | 캔버스로 만든 곡선 위의 점과 point.pointOnObject(곡선, 클릭 좌표)는 종류와 좌표가 같다 | /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d-tools/src/tools/math2d-tools/tool-point-on-object.ts:29-61]",
    "호출: factory.point.pointOnObject → advanced.createPointOnObjectById [src:mathcore-api/object-factory/packages-base/point-factory.ts:16-21] [src:base2d/base-advanced-api/index.ts:2782-2794]",
    "앞에 있어야 하는 것: objectId = 아무 개체 [src:mathcore-api/object-factory/packages-base/point-factory.ts:16-21]",
    "만드는 것, 조건부(targetObject.raw.type !== POINT_TYPE 그리고 targetObject): point(pointOnObject) 1개 (경유 createPointOnObject) [src:base2d/base-advanced-api/index.ts:2729] — 보임(기본값) [src:object-manager/objects/point.ts:91], 크기 9(configs.pointSize) [src:base2d/base-advanced-api/configs.ts:85], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 매인 개체 [targetObject.raw.id] [src:base2d/base-advanced-api/index.ts:2735]",
    "함께 생김, 조건부(targetObject.raw.type !== POINT_TYPE 그리고 targetObject): text(nameText) 1개 (경유 createPointOnObject → createNameText) [src:base2d/base-advanced-api/index.ts:3266] — 보임(기본값) [src:object-manager/objects/text.ts:63], 위치 오프셋(화면 px) [16, -16] [src:base2d/base-advanced-api/index.ts:3268], 크기 16(configs.nametextSize) [src:base2d/base-advanced-api/configs.ts:92], 글꼴 'KaTeX'(configs.nametextFont) [src:base2d/base-advanced-api/configs.ts:94], 색 #000(configs.nametextColor) [src:base2d/base-advanced-api/configs.ts:93], 매인 개체 [point.id] [src:base2d/base-advanced-api/index.ts:3269]",
    "참고: 대상은 원, 선, 다각형, 타원, 베지어 곡선, 부등식이 없는 대수 그래프(음함수 포함)다 [src:object-manager/objects/point.ts:794-804]",
    "참고: 새 개체는 대상과 서로 관련 개체로 묶여, 이 점을 옮기면 이 점을 쓰는 접선, 교점, 측정이 다시 계산된다 [src:object-manager/manager.ts:654-681]",
    "참고: position 은 초기 위치가 아니라 어림 좌표이고 곡선의 정의역은 무시한다. 실수 영점이 없는 식 위에는 올리지 않는다(화면이 멈춘다) [src:docs/palette/algebraric-point.md:292]",
    "참고: position 이 대상 종류마다 다르게 쓰인다. 선분은 어림 위치를 선분에 수선으로 내려 양 끝으로 자르고, 직선은 수선의 발, 반직선은 시작점 쪽만 자른다. 원은 중심에서 어림 위치 방향으로 반지름만큼 간 점이며 어림 위치가 중심이면 점이 중심에 선다(원 위가 아님). 다각형은 어림 위치가 안쪽이면 변 위로 옮기지 않고 그대로 둔다. [src:정합성 alg-point: scripts/pipeline/semantic/alg-point.mjs: 선분 AB 에 어림 | 직선 AB 에 어림 | 반직선 AB 에 (-3,0) | 원 위의 점은 어림 위치가 중심 자신이면 | 다각형 안쪽 어림 위치는 변 위로 옮겨지지 않고]",
    "참고: 변이 수직인 다각형(꼭짓점의 x 가 같은 변)은 바깥 어림 위치가 변이 아니라 변의 연장선 위로 나가고, 호는 각도 범위 밖 어림 위치가 가까운 끝이 아닌 다른 끝으로 갈 수 있다. 이런 대상 위의 점은 어림 좌표 대신 변이나 호 위의 정확한 좌표를 준다. [src:정합성 alg-point: scripts/pipeline/semantic/alg-point.mjs: 수직 변이 있는 다각형에서는 변의 연장선 위로 나간다 | 수직 변(x 가 같은 두 꼭짓점)이 있으면 | 호의 각도 범위 밖 어림 위치는 가까운 끝점으로 가지 않는 경우가 있다]",
    "참고: 곡선 위의 정확한 좌표를 주면 그 자리에 선다. 곡선 근처 좌표를 주면 가장 가까운 점이 아니라 어림 위치에서 찾아 간 곡선 위의 점이 된다(y=x^2 에 (2,0) 을 주면 참 최근접과 다른 점). [src:정합성 alg-point: scripts/pipeline/semantic/alg-point.mjs: position 은 가까운 점으로의 정확한 사영이 아니다 | 곡선 위 정확한 좌표 (1,1) 를 주면 그대로 선다]",
    "참고: 좌표축 위의 점은 이 도구로 만들 수 없다(축 id 는 undefined). 캔버스는 축을 눌러 축 위의 점을 만들지만 팩토리는 축을 대상으로 받지 않는다. x 축 위의 점은 point.basic 의 (x, 0) 으로 만든다. [src:정합성 alg-point: scripts/pipeline/semantic/alg-point.mjs: 캔버스: x 축을 클릭하면 축 위의 점이 선다 | /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d-tools/src/tools/math2d-tools/tool-point-on-object.ts:32-37]"
   ],
   "range": [
    "objectId: 형식 String [src:mathcore-api/object-factory/packages-base/point-factory.ts:17] [src:mathcore-api/object-factory/object-types.ts:92]",
    "position: 형식 (Number, Number) [src:mathcore-api/object-factory/packages-base/point-factory.ts:18] [src:mathcore-api/object-factory/object-types.ts:99]",
    "name?: 형식 String | Undefined [src:mathcore-api/object-factory/packages-base/point-factory.ts:19] [src:mathcore-api/object-factory/object-types.ts:93]; 생략하면 this.getNewPointName()(createPointOnObject) [src:base2d/base-advanced-api/index.ts:2727]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): traceColor=undefined, imoji=0, domain='점', angle=0 [src:object-manager/objects/point.ts:93-99]"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "point.intersect",
   "path": [
    "point",
    "intersect"
   ],
   "params": [
    {
     "name": "objectID1",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "linear"
      },
      {
       "type": "circle"
      },
      {
       "type": "polynomial"
      },
      {
       "type": "ellipse"
      },
      {
       "type": "axis"
      }
     ]
    },
    {
     "name": "objectID2",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "linear"
      },
      {
       "type": "circle"
      },
      {
       "type": "polynomial"
      },
      {
       "type": "ellipse"
      },
      {
       "type": "axis"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "packages-base/point-factory.ts",
   "usage": [
    "용도: 두 개체 id 의 교점을 만든다(선, 원, 곡선, 좌표축). 캔버스에서 서로 다른 두 개체를 차례로 누르는 것에 해당한다. 쥐어야 하는 점은 교점마다 선 보조 점이므로 한 점이 필요하면 유효한 보조 점 가운데 좌표로 고른다. [src:정합성 alg-point: scripts/pipeline/semantic/alg-point.mjs: 캔버스 버튼: 기하 탭 점 묶음의 「교점 (Alt+D)」 | 캔버스로 만든 교점과 point.intersect(f, g) 는 같은 유효 보조 점 위치 | /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d-tools/src/tools/math2d-tools/tool-intersection-point.ts:61-88]",
    "호출: factory.point.intersect → advanced.createIntersectionPoint [src:mathcore-api/object-factory/packages-base/point-factory.ts:23-27] [src:base2d/base-advanced-api/index.ts:2570-2625]",
    "앞에 있어야 하는 것: objectID1 = 아무 개체 [src:mathcore-api/object-factory/packages-base/point-factory.ts:23-27]",
    "앞에 있어야 하는 것: objectID2 = 아무 개체 [src:mathcore-api/object-factory/packages-base/point-factory.ts:23-27]",
    "만드는 것: point(intersectionPoint) 1개 [src:base2d/base-advanced-api/index.ts:2615] — 보임(기본값) [src:object-manager/objects/point.ts:91], 크기 0 [src:base2d/base-advanced-api/index.ts:2618], 색 #6e6868(configs.intersectionPointColor) [src:base2d/base-advanced-api/configs.ts:112], 매인 개체 [objectID1, objectID2, ...auxiliaryPoints] [src:base2d/base-advanced-api/index.ts:2620]",
    "함께 생김: point(auxiliary) 여러 개(반복문) (경유 createAuxiliaryPoint(반복)) [src:base2d/base-advanced-api/index.ts:2556] — 보임(기본값) [src:object-manager/objects/point.ts:91], 크기 9(configs.pointSize) [src:base2d/base-advanced-api/configs.ts:85], 색 #6e6868(configs.intersectionPointColor) [src:base2d/base-advanced-api/configs.ts:112]",
    "함께 생김: text(nameText) 여러 개(반복문) (경유 createAuxiliaryPoint(반복) → createNameText) [src:base2d/base-advanced-api/index.ts:3266] — 보임(기본값) [src:object-manager/objects/text.ts:63], 위치 오프셋(화면 px) [16, -16] [src:base2d/base-advanced-api/index.ts:3268], 크기 16(configs.nametextSize) [src:base2d/base-advanced-api/configs.ts:92], 글꼴 'KaTeX'(configs.nametextFont) [src:base2d/base-advanced-api/configs.ts:94], 색 #000(configs.nametextColor) [src:base2d/base-advanced-api/configs.ts:93], 매인 개체 [point.id] [src:base2d/base-advanced-api/index.ts:3269]",
    "참고: 돌려받는 개체는 보이지 않는 그릇이고 보이는 교점은 자동 이름이 붙은 보조 점이다(최대 5개, 원점에 가까운 것부터). 교점이 없으면 점이 서지 않는다 [src:docs/palette/algebraric-point.md:366]",
    "참고: 보이는 교점은 보조 점이고 개수는 쌍으로 정해진다: 선과 선 1개, 선과 원 2개, 원과 원 2개, 곡선이 낀 쌍은 5개(교점이 아닌 자리는 무효). 교점이 5개를 넘으면 초과분이 말없이 버려진다(sin x 와 y=0). 첫 보조 점만 원점에서 가장 가까운 교점이고 나머지 순서는 발견 순서라 x 순서가 아니다. [src:정합성 alg-point: scripts/pipeline/semantic/alg-point.mjs: 직선×직선은 보조 점 1개 | 직선 y=1 × 원(반지름 2) 교점 | ${lbl}: 보조 점은 5개가 서고 | 교점이 보조 점 수(5)보다 많으면 초과분은 조용히 버려진다 | 유효 보조 점의 순서는 x 순서가 아니라]",
    "참고: 교점이 없으면(평행한 직선, 닿지 않는 곡선) 그릇과 보조 점이 모두 무효로 서고 호출은 성공으로 돌아오므로 유효한 보조 점이 있는지 따로 확인해야 한다. 접점(중근)은 좌표에 1e-4 안팎의 오차가 있다. [src:정합성 alg-point: scripts/pipeline/semantic/alg-point.mjs: 교점이 없으면 그릇과 보조 점 5개가 서고 전부 isValid false | 평행한 두 직선은 보조 점 1개가 서고 isValid false | 접점(중근)의 좌표는 정확하지 않다]",
    "참고: 선분과 반직선은 그 범위 안의 교점만 유효하고, 정의역 조건 {…} 이 있는 곡선은 구간 안의 교점만 유효하다. [src:정합성 alg-point: scripts/pipeline/semantic/alg-point.mjs: 선분 y=2 (x∈-3,0) × y=x^2 은 선분이 덮는 교점 | 반직선 (0,2)→(3,2) × y=x^2 는 (√2,2) 하나만 유효 | 조건 밖 교점은 걸러진다]",
    "참고: 서로 다른 두 개체가 필요하다. 같은 개체 둘을 주면 캔버스는 무시하지만 팩토리는 뜻 없는 점을 세운다. 부등식 대수, 점은 두 도구 모두 대상이 아니다. [src:정합성 alg-point: scripts/pipeline/semantic/alg-point.mjs: 캔버스 교점 도구: 같은 개체를 다시 클릭하면 무시된다 | 캔버스 교점 도구: 부등식 대수는 대상이 아니라 무시된다 | /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d-tools/src/tools/math2d-tools/tool-intersection-point.ts:72-86]",
    "생성 결과: name 은 보이지 않는 그릇에만 붙는다. 화면에 보이는 교점은 자동 이름(A, B 순)이 붙은 보조 점이라 name 으로 문항의 점 이름을 얻을 수 없다. [src:정합성 alg-point: scripts/pipeline/semantic/alg-point.mjs: 요청한 이름 X 는 보이지 않는 그릇에만 붙고 | 돌려받는 개체는 category intersectionPoint, 크기 0]"
   ],
   "range": [
    "objectID1: 형식 String [src:mathcore-api/object-factory/packages-base/point-factory.ts:24] [src:mathcore-api/object-factory/object-types.ts:92]",
    "objectID2: 형식 String [src:mathcore-api/object-factory/packages-base/point-factory.ts:25] [src:mathcore-api/object-factory/object-types.ts:92]",
    "name?: 팩토리 형식 검사 없음 [src:mathcore-api/object-factory/packages-base/point-factory.ts:23-27]; 생략하면 this.getNewPointName() [src:base2d/base-advanced-api/index.ts:2607]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): traceColor=undefined, shape=PointShape.Circle, imoji=0, position=[0, 0], domain='점', angle=0 [src:object-manager/objects/point.ts:93-99]",
    "경고만 찍고 계속: 'object is not exists' [src:base2d/base-advanced-api/index.ts:2580]",
    "경고만 찍고 계속: 'cannot create intersection point' [src:base2d/base-advanced-api/index.ts:2603]",
    "지원하지 않는 쌍(다각형, 점, 슬라이더, 벡터, 없는 id)은 경고를 찍고 아무 개체도 만들지 않으며 undefined 를 돌려준다. 계속 진행하지 않는다. [src:정합성 alg-point: scripts/pipeline/semantic/alg-point.mjs: 다각형, 점, 슬라이더, 없는 id 는 undefined | 벡터는 undefined]"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "point.middlePointBySegment",
   "path": [
    "point",
    "middlePointBySegment"
   ],
   "params": [
    {
     "name": "segmentID",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "linear",
       "category": "segment"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "packages-base/point-factory.ts",
   "usage": [
    "용도: 선분 id 하나의 중점을 만든다(두 점의 중점은 point.middlePointByTwoPoint). 캔버스에서 선분을 한 번 누르는 것에 해당한다. [src:정합성 alg-point: scripts/pipeline/semantic/alg-point.mjs: 캔버스 버튼: 기하 탭 점 묶음의 「중점 (Ctrl+Alt+D)」 | 캔버스로 만든 선분 중점과 point.middlePointBySegment 는 같은 종류와 좌표 | /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d-tools/src/tools/math2d-tools/tool-center-point.ts:76-82]",
    "호출: factory.point.middlePointBySegment → advanced.createCenterPointBySegmentID [src:mathcore-api/object-factory/packages-base/point-factory.ts:29-33] [src:base2d/base-advanced-api/index.ts:2836-2853]",
    "앞에 있어야 하는 것: segmentID = linear(segment) [src:mathcore-api/object-factory/packages-base/point-factory.ts:29-33]",
    "만드는 것: point(centerPoint) 1개 [src:base2d/base-advanced-api/index.ts:2839] — 보임(기본값) [src:object-manager/objects/point.ts:91], 크기 9(configs.pointSize) [src:base2d/base-advanced-api/configs.ts:85], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 매인 개체 [segmentID] [src:base2d/base-advanced-api/index.ts:2844]",
    "함께 생김: text(nameText) 1개 (경유 createNameText) [src:base2d/base-advanced-api/index.ts:3266] — 보임(기본값) [src:object-manager/objects/text.ts:63], 위치 오프셋(화면 px) [16, -16] [src:base2d/base-advanced-api/index.ts:3268], 크기 16(configs.nametextSize) [src:base2d/base-advanced-api/configs.ts:92], 글꼴 'KaTeX'(configs.nametextFont) [src:base2d/base-advanced-api/configs.ts:94], 색 #000(configs.nametextColor) [src:base2d/base-advanced-api/configs.ts:93], 매인 개체 [point.id] [src:base2d/base-advanced-api/index.ts:3269]",
    "참고: 직선과 반직선도 받지만 결과는 선 자체의 중점이 아니라 그 선을 정의한 두 점의 중점이다. 선이 아닌 대상(벡터, 다각형, 원, 곡선, 점)을 주면 점이 서되 무효다. [src:정합성 alg-point: scripts/pipeline/semantic/alg-point.mjs: 직선과 반직선도 받는다 | 선분류가 아닌 대상(벡터, 다각형, 원, 곡선, 점, 슬라이더)]"
   ],
   "range": [
    "segmentID: 형식 String [src:mathcore-api/object-factory/packages-base/point-factory.ts:30] [src:mathcore-api/object-factory/object-types.ts:92]",
    "name?: 형식 String | Undefined [src:mathcore-api/object-factory/packages-base/point-factory.ts:31] [src:mathcore-api/object-factory/object-types.ts:93]; 생략하면 this.getNewPointName() [src:base2d/base-advanced-api/index.ts:2837]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): traceColor=undefined, shape=PointShape.Circle, imoji=0, position=[0, 0], domain='점', angle=0 [src:object-manager/objects/point.ts:93-99]"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "point.middlePointByTwoPoint",
   "path": [
    "point",
    "middlePointByTwoPoint"
   ],
   "params": [
    {
     "name": "pointID1",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "pointID2",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "packages-base/point-factory.ts",
   "usage": [
    "용도: 이미 선 두 점의 id 로 중점을 만든다(선분의 중점은 point.middlePointBySegment). 캔버스에서 점 둘을 차례로 누르는 것에 해당하며, 캔버스는 빈 곳을 누르면 그 자리에 새 점을 세워 쓰지만 이 도구는 점 id 만 받는다. [src:정합성 alg-point: scripts/pipeline/semantic/alg-point.mjs: 캔버스 중점 도구: 둘째 점 Q 를 클릭하는 순간 중점이 선다 | 캔버스 중점 도구: 빈 곳 둘째 클릭에 새 점이 하나 더 서고 | /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d-tools/src/tools/math2d-tools/tool-center-point.ts:94-102]",
    "호출: factory.point.middlePointByTwoPoint → advanced.createCenterPointByTwoPointID [src:mathcore-api/object-factory/packages-base/point-factory.ts:35-40] [src:base2d/base-advanced-api/index.ts:2683-2704]",
    "앞에 있어야 하는 것: pointID1 = point [src:mathcore-api/object-factory/packages-base/point-factory.ts:35-40]",
    "앞에 있어야 하는 것: pointID2 = point [src:mathcore-api/object-factory/packages-base/point-factory.ts:35-40]",
    "만드는 것: point(centerPoint) 1개 [src:base2d/base-advanced-api/index.ts:2690] — 보임(기본값) [src:object-manager/objects/point.ts:91], 크기 9(configs.pointSize) [src:base2d/base-advanced-api/configs.ts:85], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 매인 개체 [pointID1, pointID2] [src:base2d/base-advanced-api/index.ts:2695]",
    "함께 생김: text(nameText) 1개 (경유 createNameText) [src:base2d/base-advanced-api/index.ts:3266] — 보임(기본값) [src:object-manager/objects/text.ts:63], 위치 오프셋(화면 px) [16, -16] [src:base2d/base-advanced-api/index.ts:3268], 크기 16(configs.nametextSize) [src:base2d/base-advanced-api/configs.ts:92], 글꼴 'KaTeX'(configs.nametextFont) [src:base2d/base-advanced-api/configs.ts:94], 색 #000(configs.nametextColor) [src:base2d/base-advanced-api/configs.ts:93], 매인 개체 [point.id] [src:base2d/base-advanced-api/index.ts:3269]",
    "참고: 점 자리에 point.intersect 가 돌려준 id(보이지 않는 그릇)나 교점이 없어 무효인 보조 점을 주면 그 위치 (0,0) 을 점으로 읽어 유효한 중점이 서고 좌표가 틀린다. 교점의 중점이 필요하면 유효한 교점 점의 id 를 쓴다. [src:정합성 alg-point: scripts/pipeline/semantic/alg-point.mjs: 교점 그릇 id 를 점 자리에 주면 유효한 중점이 서고 | 교점이 없어 무효인 보조 점을 주어도 유효한 중점이 서고]"
   ],
   "range": [
    "pointID1: 형식 String [src:mathcore-api/object-factory/packages-base/point-factory.ts:36] [src:mathcore-api/object-factory/object-types.ts:92]",
    "pointID2: 형식 String [src:mathcore-api/object-factory/packages-base/point-factory.ts:37] [src:mathcore-api/object-factory/object-types.ts:92]",
    "name?: 형식 String | Undefined [src:mathcore-api/object-factory/packages-base/point-factory.ts:38] [src:mathcore-api/object-factory/object-types.ts:93]; 생략하면 this.getNewPointName() [src:base2d/base-advanced-api/index.ts:2688]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): traceColor=undefined, shape=PointShape.Circle, imoji=0, position=[0, 0], domain='점', angle=0 [src:object-manager/objects/point.ts:93-99]"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "polygon.polygon",
   "path": [
    "polygon",
    "polygon"
   ],
   "params": [
    {
     "name": "pointIDs",
     "type": "ref[]",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "packages-base/polygon-factory.ts",
   "usage": [
    "용도: pointIDs 에는 꼭짓점을 도형 순서로 한 번씩만 준다(처음 점을 다시 적지 않아도 닫힌다). 점은 새로 서지 않고 변 선분만 서며, 점이 3개 미만이면 만들지 않는다. [src:정합성 polygon-transform: scripts/pipeline/semantic/polygon-transform.mjs 의 시험 '열린 목록 A,B,C,D: ...', '닫힌 목록 A,B,C,D,A 는 끝 점을 빼고 꼭짓점 4개', '점 2개는 개체를 만들지 않는다(undefined)']",
    "호출: factory.polygon.polygon → advanced.createPolygon [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:8-12] [src:base2d/base-advanced-api/index.ts:677-698]",
    "앞에 있어야 하는 것: pointIDs ref[] = point [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:8-12]",
    "만드는 것: polygon(polygon) 1개 (경유 createPolygon2) [src:base2d/base-advanced-api/index.ts:747] — 보임(기본값) [src:object-manager/objects/polygon.ts:85], 색 color [src:base2d/base-advanced-api/index.ts:695], 매인 개체 pointIDs [src:base2d/base-advanced-api/index.ts:690]",
    "함께 생김, 조건부(props && props.vertexPoints && props.vertexPoints…): linear(segment) 여러 개(반복문) (경유 createPolygon2 → createAuxiliarySegment(반복)) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [props.vertexPoints[i], props.vertexPoints[i + 1]] [src:base2d/base-advanced-api/index.ts:3579]",
    "참고: 화면 도구는 점을 하나씩 누르고 처음 점을 다시 눌러 닫지만 이 호출은 점 id 목록만 주면 닫힌다. 화면은 누른 자리에 점을 함께 만들어 주지만 이 호출의 점은 호출 전에 서 있어야 한다. [src:정합성 polygon-transform: /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d-tools/src/tools/math2d-tools/tool-polygon.ts:39-66, /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d-ui/src/tab/tools/configs/base2d-geometry.ts:362, /root/dev/git.cemware.com/mathcore/mathcore-api/src/app/math2d/tool-manager.ts:107 ; 캔버스 재현 scripts/pipeline/semantic/polygon-transform.mjs 의 시험 '캔버스: 처음 점을 다시 누르면 다각형 1개가 서고 vertexPoints 가 누른 점 4개를 순서대로 담는다' 외 3건]"
   ],
   "range": [
    "pointIDs: 형식 [String] [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:9] [src:mathcore-api/object-factory/object-types.ts:96]",
    "name?: 형식 String | Undefined [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:10] [src:mathcore-api/object-factory/object-types.ts:93]; 생략하면 this.getNewObjectName() [src:base2d/base-advanced-api/index.ts:710]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): innerAlpha=0.1, vertices=[], strokeWidth=4.2 [src:object-manager/objects/polygon.ts:87-109]",
    "조용히 끝남(만들지 않음): pointIDs.length < 3 이면 undefined 반환 [src:base2d/base-advanced-api/index.ts:685]",
    "조용히 끝남(만들지 않음): props.color === undefined 이면 undefined 반환 [src:base2d/base-advanced-api/index.ts:707]"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "polygon.regularWithCenterAndVertex",
   "path": [
    "polygon",
    "regularWithCenterAndVertex"
   ],
   "params": [
    {
     "name": "centerPointId",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "vertexPointId",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "numberOfSides",
     "type": "number",
     "optional": false
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "packages-base/polygon-factory.ts",
   "usage": [
    "용도(도구 UI 설명): 정다각형 : 중심과 한 점 — 중심과 한 점을 선택한 후 꼭짓점 수를 입력하세요. [src:base2d-ui/src/tab/tools/configs/base2d-geometry.ts:384]",
    "호출: factory.polygon.regularWithCenterAndVertex → advanced.createCPPolygon [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:14-20] [src:base2d/base-advanced-api/index.ts:1496-1530]",
    "앞에 있어야 하는 것: centerPointId = point [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:14-20]",
    "앞에 있어야 하는 것: vertexPointId = point [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:14-20]",
    "만드는 것: polygon(cpPolygon) 1개 (경유 createCPPolygon2) [src:base2d/base-advanced-api/index.ts:1589] — 보임(기본값) [src:object-manager/objects/polygon.ts:85], 색 color [src:base2d/base-advanced-api/index.ts:1526], 매인 개체 [centerPointId, vertexPointId] [src:base2d/base-advanced-api/index.ts:1513]",
    "함께 생김, 조건부(props && props.numberOfSides && props.vertexPoint…): point(auxiliary) 여러 개(반복문) (경유 createCPPolygon2 → createAuxiliaryPoint(반복)) [src:base2d/base-advanced-api/index.ts:2556] — 보임(기본값) [src:object-manager/objects/point.ts:91], 크기 9(configs.pointSize) [src:base2d/base-advanced-api/configs.ts:85], 색 #6e6868(configs.intersectionPointColor) [src:base2d/base-advanced-api/configs.ts:112]",
    "함께 생김, 조건부(props && props.numberOfSides && props.vertexPoint…): text(nameText) 여러 개(반복문) (경유 createCPPolygon2 → createAuxiliaryPoint(반복) → createNameText) [src:base2d/base-advanced-api/index.ts:3266] — 보임(기본값) [src:object-manager/objects/text.ts:63], 위치 오프셋(화면 px) [16, -16] [src:base2d/base-advanced-api/index.ts:3268], 크기 16(configs.nametextSize) [src:base2d/base-advanced-api/configs.ts:92], 글꼴 'KaTeX'(configs.nametextFont) [src:base2d/base-advanced-api/configs.ts:94], 색 #000(configs.nametextColor) [src:base2d/base-advanced-api/configs.ts:93], 매인 개체 [point.id] [src:base2d/base-advanced-api/index.ts:3269]",
    "함께 생김, 조건부(props && props.numberOfSides && props.vertexPoint…): linear(segment) 여러 개(반복문) (경유 createCPPolygon2 → createAuxiliarySegment(반복)) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [props.vertexPoints[i], props.vertexPoints[i + 1]] [src:base2d/base-advanced-api/index.ts:3579]",
    "참고: centerPointId 는 중심이고 꼭짓점이 아니며 vertexPointId 가 첫 꼭짓점이다. 나머지 꼭짓점 numberOfSides-1개는 첫 꼭짓점에서 중심 둘레로 반시계로 360/numberOfSides 도씩 돈 자리에 새 점으로 선다. [src:정합성 polygon-transform: scripts/pipeline/semantic/polygon-transform.mjs 의 시험 '중심(1,1) 꼭짓점(3,1) 변 N개: vertexPoints 순서대로 좌표가 독립 계산값과 같다'(N=3,4,5,6,8), '변 N개: 중심은 vertexPoints 에 없고 RO 는 중심, 꼭짓점', '중심과 꼭짓점을 바꾸면 중심(3,1) 꼭짓점(1,1) 정사각형이 선다']",
    "참고: 화면 도구는 중심과 꼭짓점을 차례로 누른 뒤 변 개수(최소 3)를 받아 같은 호출(변 수, 중심, 꼭짓점)을 한다. 이 호출의 점 둘은 호출 전에 서 있어야 한다. [src:정합성 polygon-transform: /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d-tools/src/tools/math2d-tools/tool-cp-polygon.ts:39-67, /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d-ui/src/tab/tools/configs/base2d-geometry.ts:381, /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d-ui/src/modal/modals/create-center-point-polygon-modal/index.tsx:3-18 ; 캔버스 재현 scripts/pipeline/semantic/polygon-transform.mjs 의 시험 '캔버스: 둘째 점을 누르는 순간 변 개수 값(5)을 받아 정오각형 1개가 서고 ...', '캔버스: 같은 점으로 팩토리를 부른 결과와 ... 같다']",
    "생성 결과: 다각형 1개와 함께 새 점(보조 점) numberOfSides-1개, 그 이름표 글, 변 선분 numberOfSides개가 선다. [src:정합성 polygon-transform: scripts/pipeline/semantic/polygon-transform.mjs 의 시험 '중심(1,1) 꼭짓점(3,1) 변 N개: 새로 서는 점 N-1개는 보조 점(auxiliary)이고 유효하며 보임', '... 이름표 글 N-1개와 변 선분 N개']"
   ],
   "range": [
    "centerPointId: 형식 String [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:15] [src:mathcore-api/object-factory/object-types.ts:92]",
    "vertexPointId: 형식 String [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:16] [src:mathcore-api/object-factory/object-types.ts:92]",
    "numberOfSides: 형식 Number [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:17] [src:mathcore-api/object-factory/object-types.ts:94]",
    "name?: 형식 String | Undefined [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:18] [src:mathcore-api/object-factory/object-types.ts:93]; 생략하면 this.getNewObjectName() [src:base2d/base-advanced-api/index.ts:1549]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): innerAlpha=0.1, vertices=[], strokeWidth=4.2 [src:object-manager/objects/polygon.ts:87-109]",
    "조용히 끝남(만들지 않음): numberOfSides < 3 이면 undefined 반환 [src:base2d/base-advanced-api/index.ts:1506]",
    "조용히 끝남(만들지 않음): props.color === undefined 이면 undefined 반환 [src:base2d/base-advanced-api/index.ts:1546]",
    "3 이상의 정수만 쓴다. 3 미만이면 개체가 서지 않고, 소수(3.5 등)는 꼭짓점이 어긋난 열린 모양이 선다. [src:정합성 polygon-transform: scripts/pipeline/semantic/polygon-transform.mjs 의 시험 '변 2개는 개체를 만들지 않는다', '변 1개 ...', '변 -5개 ...' 와 기록 '변 3.5: 개체 cpPolygon 유효 true 꼭짓점 4개']"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "polygon.regularWithOneSide",
   "path": [
    "polygon",
    "regularWithOneSide"
   ],
   "params": [
    {
     "name": "vertexPointId1",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "vertexPointId2",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "numberOfSides",
     "type": "number",
     "optional": false
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "packages-base/polygon-factory.ts",
   "usage": [
    "용도(도구 UI 설명): 정다각형 : 한 변 — 한 변이 될 두 점을 선택한 후 꼭짓점 수를 입력하세요. [src:base2d-ui/src/tab/tools/configs/base2d-geometry.ts:390]",
    "호출: factory.polygon.regularWithOneSide → advanced.createLateralPolygon [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:22-28] [src:base2d/base-advanced-api/index.ts:1639-1673]",
    "앞에 있어야 하는 것: vertexPointId1 = point [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:22-28]",
    "앞에 있어야 하는 것: vertexPointId2 = point [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:22-28]",
    "만드는 것: polygon(lateralPolygon) 1개 (경유 createLateralPolygon2) [src:base2d/base-advanced-api/index.ts:1734] — 보임(기본값) [src:object-manager/objects/polygon.ts:85], 색 color [src:base2d/base-advanced-api/index.ts:1669], 매인 개체 [vertexPointId1, vertexPointId2] [src:base2d/base-advanced-api/index.ts:1656]",
    "함께 생김, 조건부(props && props.numberOfSides && props.vertexPoint…): point(auxiliary) 여러 개(반복문) (경유 createLateralPolygon2 → createAuxiliaryPoint(반복)) [src:base2d/base-advanced-api/index.ts:2556] — 보임(기본값) [src:object-manager/objects/point.ts:91], 크기 9(configs.pointSize) [src:base2d/base-advanced-api/configs.ts:85], 색 #6e6868(configs.intersectionPointColor) [src:base2d/base-advanced-api/configs.ts:112]",
    "함께 생김, 조건부(props && props.numberOfSides && props.vertexPoint…): text(nameText) 여러 개(반복문) (경유 createLateralPolygon2 → createAuxiliaryPoint(반복) → createNameText) [src:base2d/base-advanced-api/index.ts:3266] — 보임(기본값) [src:object-manager/objects/text.ts:63], 위치 오프셋(화면 px) [16, -16] [src:base2d/base-advanced-api/index.ts:3268], 크기 16(configs.nametextSize) [src:base2d/base-advanced-api/configs.ts:92], 글꼴 'KaTeX'(configs.nametextFont) [src:base2d/base-advanced-api/configs.ts:94], 색 #000(configs.nametextColor) [src:base2d/base-advanced-api/configs.ts:93], 매인 개체 [point.id] [src:base2d/base-advanced-api/index.ts:3269]",
    "함께 생김, 조건부(props && props.numberOfSides && props.vertexPoint…): linear(segment) 여러 개(반복문) (경유 createLateralPolygon2 → createAuxiliarySegment(반복)) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [props.vertexPoints[i], props.vertexPoints[i + 1]] [src:base2d/base-advanced-api/index.ts:3579]",
    "참고: vertexPointId1 과 vertexPointId2 는 한 변의 두 끝이고 둘 다 꼭짓점이다. 도형은 첫째 점에서 둘째 점으로 가는 방향의 왼쪽(반시계 쪽)에 서므로 점 순서를 바꾸면 반대쪽에 서고, 나머지 꼭짓점 numberOfSides-2개가 새 점으로 선다. [src:정합성 polygon-transform: scripts/pipeline/semantic/polygon-transform.mjs 의 시험 'P(0,0)→Q(4,0) 변 N개 (왼쪽 위로 선다): ...'(N=3,4,5,6), 'Q→P 순서를 바꾸면 반대쪽(아래)에 선다: ...', 'Q→P 의 나머지 꼭짓점 y 좌표가 음수']",
    "참고: 화면 도구는 변의 첫 점과 둘째 점을 차례로 누른 뒤 변 개수(최소 3)를 받아 같은 호출(변 수, 첫 점, 둘째 점)을 한다. 이 호출의 점 둘은 호출 전에 서 있어야 한다. [src:정합성 polygon-transform: /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d-tools/src/tools/math2d-tools/tool-lateral-polygon.ts:39-67, /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d-ui/src/tab/tools/configs/base2d-geometry.ts:387, /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d-ui/src/modal/modals/create-lateral-polygon-modal/index.tsx:3-18 ; 캔버스 재현 scripts/pipeline/semantic/polygon-transform.mjs 의 시험 '캔버스: 둘째 점을 누르는 순간 변 개수 값(5)을 받아 ...'(lateralPolygon)]",
    "생성 결과: 다각형 1개와 함께 새 점(보조 점) numberOfSides-2개, 그 이름표 글, 변 선분 numberOfSides개가 선다. [src:정합성 polygon-transform: scripts/pipeline/semantic/polygon-transform.mjs 의 시험 'P(0,0)→Q(4,0) 변 N개 (왼쪽 위로 선다): 새로 서는 점 N-2개는 보조 점(auxiliary)이고 ...', '... 이름표 글 N-2개와 변 선분 N개']"
   ],
   "range": [
    "vertexPointId1: 형식 String [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:23] [src:mathcore-api/object-factory/object-types.ts:92]",
    "vertexPointId2: 형식 String [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:24] [src:mathcore-api/object-factory/object-types.ts:92]",
    "numberOfSides: 형식 Number [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:25] [src:mathcore-api/object-factory/object-types.ts:94]",
    "name?: 형식 String | Undefined [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:26] [src:mathcore-api/object-factory/object-types.ts:93]; 생략하면 this.getNewObjectName() [src:base2d/base-advanced-api/index.ts:1691]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): innerAlpha=0.1, vertices=[], strokeWidth=4.2 [src:object-manager/objects/polygon.ts:87-109]",
    "조용히 끝남(만들지 않음): numberOfSides < 3 이면 undefined 반환 [src:base2d/base-advanced-api/index.ts:1649]",
    "조용히 끝남(만들지 않음): props.color === undefined 이면 undefined 반환 [src:base2d/base-advanced-api/index.ts:1688]",
    "3 이상의 정수만 쓴다. 3 미만이면 개체가 서지 않고, 소수(3.5 등)는 꼭짓점이 어긋난 열린 모양이 선다. [src:정합성 polygon-transform: scripts/pipeline/semantic/polygon-transform.mjs 의 시험 '변 2개는 개체를 만들지 않는다', '변 0개 ...', '변 -3개 ...' 와 기록 '변 3.5: 개체 lateralPolygon 유효 true 꼭짓점 4개']"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "polygon.isoscelesTriangle",
   "path": [
    "polygon",
    "isoscelesTriangle"
   ],
   "params": [
    {
     "name": "pointID1",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "pointID2",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "pointID3",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "packages-base/polygon-factory.ts",
   "usage": [
    "용도(도구 UI 설명): 이등변삼각형·주어진 크기의 각 — 이등변삼각형이 그려질 세 점을 선택하세요. [src:base2d-ui/src/tab/tools/configs/base2d-geometry.ts:396]",
    "호출: factory.polygon.isoscelesTriangle → advanced.createIsoscelesTriangle [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:30-36] [src:base2d/base-advanced-api/index.ts:750-758]",
    "앞에 있어야 하는 것: pointID1 = point [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:30-36]",
    "앞에 있어야 하는 것: pointID2 = point [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:30-36]",
    "앞에 있어야 하는 것: pointID3 = point [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:30-36]",
    "만드는 것: polygon(isoscelesTriangle) 1개 (경유 createIsoscelesTriangle2) [src:base2d/base-advanced-api/index.ts:863] — 보임(기본값) [src:object-manager/objects/polygon.ts:85], 색 [...this.getNewObjectColor()] [src:base2d/base-advanced-api/index.ts:671], 매인 개체 [pointID1, pointID2, pointID3] [src:base2d/base-advanced-api/index.ts:754]",
    "함께 생김, 조건부(!(props.hasPolygonDependentPoint) 그리고 props && props.relatedObjects && props.relatedObj…): point(auxiliary) 1개 (경유 createIsoscelesTriangle2 → createAuxiliaryPoint) [src:base2d/base-advanced-api/index.ts:2556] — 보임(기본값) [src:object-manager/objects/point.ts:91], 크기 9(configs.pointSize) [src:base2d/base-advanced-api/configs.ts:85], 색 #6e6868(configs.intersectionPointColor) [src:base2d/base-advanced-api/configs.ts:112]",
    "함께 생김, 조건부(!(props.hasPolygonDependentPoint) 그리고 props && props.relatedObjects && props.relatedObj…): text(nameText) 1개 (경유 createIsoscelesTriangle2 → createAuxiliaryPoint → createNameText) [src:base2d/base-advanced-api/index.ts:3266] — 보임(기본값) [src:object-manager/objects/text.ts:63], 위치 오프셋(화면 px) [16, -16] [src:base2d/base-advanced-api/index.ts:3268], 크기 16(configs.nametextSize) [src:base2d/base-advanced-api/configs.ts:92], 글꼴 'KaTeX'(configs.nametextFont) [src:base2d/base-advanced-api/configs.ts:94], 색 #000(configs.nametextColor) [src:base2d/base-advanced-api/configs.ts:93], 매인 개체 [point.id] [src:base2d/base-advanced-api/index.ts:3269]",
    "함께 생김, 조건부(props.hasPolygonDependentPoint 그리고 props && props.relatedObjects && props.relatedObj…): linear(segment) 여러 개(반복문) (경유 createIsoscelesTriangle2 → createAuxiliarySegment) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [props.relatedObjects[0], props.relatedObjects[1]] [src:base2d/base-advanced-api/index.ts:3579]",
    "함께 생김, 조건부(!(props.hasPolygonDependentPoint) 그리고 props && props.relatedObjects && props.relatedObj…): linear(segment) 여러 개(반복문) (경유 createIsoscelesTriangle2 → createAuxiliarySegment) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [props.relatedObjects[0], props.relatedObjects[2]] [src:base2d/base-advanced-api/index.ts:3579]",
    "참고: 입력 점 3개 중 둘째 점은 꼭짓점이 아니라 방향이나 축을 정한다. 계산되는 꼭짓점은 독립된 점으로 새로 선다 [src:docs/palette/polygon-transform.md:74]",
    "참고: pointID1 이 꼭대기 꼭짓점이고 직선 pointID1-pointID2 가 대칭축이며 pointID3 이 밑 꼭짓점 하나이다. 나머지 밑 꼭짓점은 pointID3 을 그 축에 대해 대칭 이동한 자리에 새 점으로 서고, 꼭대기 A 인 이등변삼각형 ABC 는 밑변 BC 의 중점 M 을 먼저 세운 뒤 (A, M, B) 로 부르면 새 점이 C 에 겹쳐 선다. [src:정합성 polygon-transform: scripts/pipeline/semantic/polygon-transform.mjs 의 시험 '(A,B,C) 꼭대기 A, 축 AB, 밑 꼭짓점 C: ...', '(A,B,C): 둘째 점 B 는 꼭짓점이 아니다', '(B,A,C) 첫째 점이 꼭대기 B 가 된다(축은 같은 직선)', '문항 대응: (꼭대기, 밑변 중점, 밑 꼭짓점 B) 이면 새 점이 C(4,0) 에 선다']",
    "참고: 화면 도구의 둘째 점은 꼭짓점이고 셋째 꼭짓점은 마우스 위치로 계산되는데 이 호출은 둘째 점이 축 위 점이라 서로 다르다. 화면의 이등변삼각형(꼭대기 P1, P1P2 = P1P3)과 같은 모양은 이 호출에서 (P1, 밑변 P2P3 의 중점, P2) 로 만든다. [src:정합성 polygon-transform: /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d-tools/src/tools/math2d-tools/tool-isosceles-triangle.ts:39-66, /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d/src/base-advanced-api/index.ts:793-813, /root/dev/git.cemware.com/mathcore/module/mathcore/packages/fundamentals/src/math.ts:2506-2531, /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d-ui/src/tab/tools/configs/base2d-geometry.ts:393 ; 캔버스 재현 scripts/pipeline/semantic/polygon-transform.mjs 의 시험 '캔버스: 꼭짓점 순서와 좌표가 독립 계산값과 같다', '캔버스: 같은 모양을 팩토리로 만든 것과 종류가 같고 꼭짓점 집합이 같다'(isoscelesTriangle)]"
   ],
   "range": [
    "pointID1: 형식 String [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:31] [src:mathcore-api/object-factory/object-types.ts:92]",
    "pointID2: 형식 String [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:32] [src:mathcore-api/object-factory/object-types.ts:92]",
    "pointID3: 형식 String [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:33] [src:mathcore-api/object-factory/object-types.ts:92]",
    "name?: 형식 String | Undefined [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:34] [src:mathcore-api/object-factory/object-types.ts:93]; 생략하면 this.getNewObjectName() [src:base2d/base-advanced-api/index.ts:825]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): innerAlpha=0.1, vertices=[], strokeWidth=4.2 [src:object-manager/objects/polygon.ts:87-109]",
    "조용히 끝남(만들지 않음): props.color === undefined 이면 undefined 반환 [src:base2d/base-advanced-api/index.ts:822]"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "polygon.rightTriangle",
   "path": [
    "polygon",
    "rightTriangle"
   ],
   "params": [
    {
     "name": "pointID1",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "pointID2",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "pointID3",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "packages-base/polygon-factory.ts",
   "usage": [
    "용도(도구 UI 설명): 직각삼각형 — 직각삼각형이 그려질 세 점을 선택하세요. [src:base2d-ui/src/tab/tools/configs/base2d-geometry.ts:402]",
    "호출: factory.polygon.rightTriangle → advanced.createRightTriangle [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:38-44] [src:base2d/base-advanced-api/index.ts:866-879]",
    "앞에 있어야 하는 것: pointID1 = point [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:38-44]",
    "앞에 있어야 하는 것: pointID2 = point [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:38-44]",
    "앞에 있어야 하는 것: pointID3 = point [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:38-44]",
    "만드는 것: polygon(rightTriangle) 1개 (경유 createRightTriangle2) [src:base2d/base-advanced-api/index.ts:984] — 보임(기본값) [src:object-manager/objects/polygon.ts:85], 색 [...this.getNewObjectColor()] [src:base2d/base-advanced-api/index.ts:671], 매인 개체 [pointID1, pointID2, pointID3] [src:base2d/base-advanced-api/index.ts:875]",
    "함께 생김, 조건부(!(props.hasPolygonDependentPoint) 그리고 props && props.relatedObjects && props.relatedObj…): point(auxiliary) 1개 (경유 createRightTriangle2 → createAuxiliaryPoint) [src:base2d/base-advanced-api/index.ts:2556] — 보임(기본값) [src:object-manager/objects/point.ts:91], 크기 9(configs.pointSize) [src:base2d/base-advanced-api/configs.ts:85], 색 #6e6868(configs.intersectionPointColor) [src:base2d/base-advanced-api/configs.ts:112]",
    "함께 생김, 조건부(!(props.hasPolygonDependentPoint) 그리고 props && props.relatedObjects && props.relatedObj…): text(nameText) 1개 (경유 createRightTriangle2 → createAuxiliaryPoint → createNameText) [src:base2d/base-advanced-api/index.ts:3266] — 보임(기본값) [src:object-manager/objects/text.ts:63], 위치 오프셋(화면 px) [16, -16] [src:base2d/base-advanced-api/index.ts:3268], 크기 16(configs.nametextSize) [src:base2d/base-advanced-api/configs.ts:92], 글꼴 'KaTeX'(configs.nametextFont) [src:base2d/base-advanced-api/configs.ts:94], 색 #000(configs.nametextColor) [src:base2d/base-advanced-api/configs.ts:93], 매인 개체 [point.id] [src:base2d/base-advanced-api/index.ts:3269]",
    "함께 생김, 조건부(props.hasPolygonDependentPoint 그리고 props && props.relatedObjects && props.relatedObj…): linear(segment) 여러 개(반복문) (경유 createRightTriangle2 → createAuxiliarySegment) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [props.relatedObjects[0], props.relatedObjects[1]] [src:base2d/base-advanced-api/index.ts:3579]",
    "함께 생김, 조건부(!(props.hasPolygonDependentPoint) 그리고 props && props.relatedObjects && props.relatedObj…): linear(segment) 여러 개(반복문) (경유 createRightTriangle2 → createAuxiliarySegment) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [props.relatedObjects[0], props.relatedObjects[2]] [src:base2d/base-advanced-api/index.ts:3579]",
    "참고: 입력 점 3개 중 둘째 점은 꼭짓점이 아니라 방향이나 축을 정한다. 계산되는 꼭짓점은 독립된 점으로 새로 선다 [src:docs/palette/polygon-transform.md:74]",
    "참고: 직선 pointID1-pointID2 위로 pointID3 에서 수선의 발을 내려 그 발에 새 점이 서고 직각은 그 발에 있다. 꼭짓점은 pointID1, pointID3, 발이므로 직각이 B 인 삼각형 ABC 는 (A, B, C) 로 부르면 발이 B 와 겹쳐 선다. [src:정합성 polygon-transform: scripts/pipeline/semantic/polygon-transform.mjs 의 시험 '(A,B,C) 직선 AB 위로 C 에서 수선의 발 (5,0): ...', '(A,B,C): 직각은 새 점(발)에 있다', '문항 대응: 직각이 B(4,0) 인 삼각형 ABC 는 (A,B,C) 로 세워 ...']",
    "참고: 화면 도구는 직각이 둘째 점 P2 에 있는 삼각형 [P1, P2, 계산점]을 만들고 이 호출은 직각이 계산된 발에 선다. 화면의 삼각형과 같은 모양은 이 호출에서 (P1, P2, P3) 로 부르면 발이 P2 와 겹친다. [src:정합성 polygon-transform: /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d-tools/src/tools/math2d-tools/tool-right-triangle.ts:39-66, /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d/src/base-advanced-api/index.ts:915-934, /root/dev/git.cemware.com/mathcore/module/mathcore/packages/fundamentals/src/math.ts:2539-2561, /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d-ui/src/tab/tools/configs/base2d-geometry.ts:399 ; 캔버스 재현 scripts/pipeline/semantic/polygon-transform.mjs 의 시험 '캔버스: 꼭짓점 순서와 좌표가 독립 계산값과 같다', '... 같은 모양을 팩토리로 만든 것과 ...'(rightTriangle)]"
   ],
   "range": [
    "pointID1: 형식 String [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:39] [src:mathcore-api/object-factory/object-types.ts:92]",
    "pointID2: 형식 String [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:40] [src:mathcore-api/object-factory/object-types.ts:92]",
    "pointID3: 형식 String [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:41] [src:mathcore-api/object-factory/object-types.ts:92]",
    "name?: 형식 String | Undefined [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:42] [src:mathcore-api/object-factory/object-types.ts:93]; 생략하면 this.getNewObjectName() [src:base2d/base-advanced-api/index.ts:946]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): innerAlpha=0.1, vertices=[], strokeWidth=4.2 [src:object-manager/objects/polygon.ts:87-109]",
    "조용히 끝남(만들지 않음): props.color === undefined 이면 undefined 반환 [src:base2d/base-advanced-api/index.ts:943]"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "polygon.rectangle",
   "path": [
    "polygon",
    "rectangle"
   ],
   "params": [
    {
     "name": "pointID1",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "pointID2",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "pointID3",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "packages-base/polygon-factory.ts",
   "usage": [
    "용도(도구 UI 설명): 직사각형 — 직사각형이 그려질 세 점을 선택하세요. [src:base2d-ui/src/tab/tools/configs/base2d-geometry.ts:408]",
    "호출: factory.polygon.rectangle → advanced.createRectangle [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:46-52] [src:base2d/base-advanced-api/index.ts:1095-1103]",
    "앞에 있어야 하는 것: pointID1 = point [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:46-52]",
    "앞에 있어야 하는 것: pointID2 = point [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:46-52]",
    "앞에 있어야 하는 것: pointID3 = point [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:46-52]",
    "만드는 것: polygon(rectangle) 1개 (경유 createRectangle2) [src:base2d/base-advanced-api/index.ts:1217] — 보임(기본값) [src:object-manager/objects/polygon.ts:85], 색 [...this.getNewObjectColor()] [src:base2d/base-advanced-api/index.ts:671], 매인 개체 [pointID1, pointID2, pointID3] [src:base2d/base-advanced-api/index.ts:1099]",
    "함께 생김, 조건부(props && props.relatedObjects && props.relatedObj…): point(auxiliary) 여러 개(반복문) (경유 createRectangle2 → createAuxiliaryPoint(반복)) [src:base2d/base-advanced-api/index.ts:2556] — 보임(기본값) [src:object-manager/objects/point.ts:91], 크기 9(configs.pointSize) [src:base2d/base-advanced-api/configs.ts:85], 색 #6e6868(configs.intersectionPointColor) [src:base2d/base-advanced-api/configs.ts:112]",
    "함께 생김, 조건부(props && props.relatedObjects && props.relatedObj…): text(nameText) 여러 개(반복문) (경유 createRectangle2 → createAuxiliaryPoint(반복) → createNameText) [src:base2d/base-advanced-api/index.ts:3266] — 보임(기본값) [src:object-manager/objects/text.ts:63], 위치 오프셋(화면 px) [16, -16] [src:base2d/base-advanced-api/index.ts:3268], 크기 16(configs.nametextSize) [src:base2d/base-advanced-api/configs.ts:92], 글꼴 'KaTeX'(configs.nametextFont) [src:base2d/base-advanced-api/configs.ts:94], 색 #000(configs.nametextColor) [src:base2d/base-advanced-api/configs.ts:93], 매인 개체 [point.id] [src:base2d/base-advanced-api/index.ts:3269]",
    "함께 생김, 조건부(props.hasPolygonDependentPoint 그리고 props && props.relatedObjects && props.relatedObj…): linear(segment) 여러 개(반복문) (경유 createRectangle2 → createAuxiliarySegment) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [props.relatedObjects[0], props.relatedObjects[1]] [src:base2d/base-advanced-api/index.ts:3579]",
    "함께 생김, 조건부(!(props.hasPolygonDependentPoint) 그리고 props && props.relatedObjects && props.relatedObj…): linear(segment) 여러 개(반복문) (경유 createRectangle2 → createAuxiliarySegment) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [props.relatedObjects[0], props.auxiliaryPoints[0… [src:base2d/base-advanced-api/index.ts:3579]",
    "참고: 입력 점 3개 중 둘째 점은 꼭짓점이 아니라 방향이나 축을 정한다. 계산되는 꼭짓점은 독립된 점으로 새로 선다 [src:docs/palette/polygon-transform.md:74]",
    "참고: pointID1 과 pointID3 이 마주 보는 꼭짓점이고 pointID2 는 변의 방향을 정하는 점이다(변은 직선 pointID1-pointID2 와 그 수직 방향). 나머지 꼭짓점 둘이 새 점으로 서므로 직사각형 ABCD(AB, BC 가 변)는 (A, B, C) 로 부르면 새 점이 D 와 B 에 겹쳐 선다. [src:정합성 polygon-transform: scripts/pipeline/semantic/polygon-transform.mjs 의 시험 '(A,B,E) 직선 AB 방향, A 와 E 가 마주 보는 꼭짓점: ...', '(A,B,E): 둘째 점 B 는 꼭짓점이 아니다', '(A,C,G) 비스듬한 방향 AC: ...', '문항 대응: 직사각형 ABCD 는 (A,B,C) 로 세워 ...']",
    "참고: 화면 도구는 P1P2 가 한 변이고 마우스 위치가 폭을 정하는 직사각형 [P1, P2, 계산점, 계산점]을 만들고 이 호출은 p2 가 방향 점이다. 화면의 직사각형 P1P2P3P4 와 같은 모양은 이 호출에서 (P1, P2, P3) 로 부른다. 화면 도구는 두 점을 누른 뒤 키를 누르면 모은 점이 지워진다. [src:정합성 polygon-transform: /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d-tools/src/tools/math2d-tools/tool-rectangle.ts:39-66, /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d/src/base-advanced-api/index.ts:1139-1160, /root/dev/git.cemware.com/mathcore/module/mathcore/packages/fundamentals/src/math.ts:2569-2589, /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d-tools/src/index.ts:367-376, /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d-ui/src/tab/tools/configs/base2d-geometry.ts:405 ; 캔버스 재현 scripts/pipeline/semantic/polygon-transform.mjs 의 시험 '캔버스: ...'(rectangle) 꼭짓점 좌표와 같은 모양 비교, '두 점을 누른 뒤 아무 키나 누르면 도구 상태(모은 점)가 지워져 ...']"
   ],
   "range": [
    "pointID1: 형식 String [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:47] [src:mathcore-api/object-factory/object-types.ts:92]",
    "pointID2: 형식 String [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:48] [src:mathcore-api/object-factory/object-types.ts:92]",
    "pointID3: 형식 String [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:49] [src:mathcore-api/object-factory/object-types.ts:92]",
    "name?: 형식 String | Undefined [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:50] [src:mathcore-api/object-factory/object-types.ts:93]; 생략하면 this.getNewObjectName() [src:base2d/base-advanced-api/index.ts:1172]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): innerAlpha=0.1, vertices=[], strokeWidth=4.2 [src:object-manager/objects/polygon.ts:87-109]",
    "조용히 끝남(만들지 않음): props.color === undefined 이면 undefined 반환 [src:base2d/base-advanced-api/index.ts:1169]"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "polygon.parallelogram",
   "path": [
    "polygon",
    "parallelogram"
   ],
   "params": [
    {
     "name": "pointID1",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "pointID2",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "pointID3",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "packages-base/polygon-factory.ts",
   "usage": [
    "용도(도구 UI 설명): 평행사변형 — 평행사변형이 그려질 세 점을 선택하세요. [src:base2d-ui/src/tab/tools/configs/base2d-geometry.ts:414]",
    "호출: factory.polygon.parallelogram → advanced.createParallelogram [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:54-60] [src:base2d/base-advanced-api/index.ts:987-995]",
    "앞에 있어야 하는 것: pointID1 = point [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:54-60]",
    "앞에 있어야 하는 것: pointID2 = point [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:54-60]",
    "앞에 있어야 하는 것: pointID3 = point [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:54-60]",
    "만드는 것: polygon(parallelogram) 1개 (경유 createParallelogram2) [src:base2d/base-advanced-api/index.ts:1092] — 보임(기본값) [src:object-manager/objects/polygon.ts:85], 색 [...this.getNewObjectColor()] [src:base2d/base-advanced-api/index.ts:671], 매인 개체 [pointID1, pointID2, pointID3] [src:base2d/base-advanced-api/index.ts:991]",
    "함께 생김, 조건부(props && props.relatedObjects && props.relatedObj…): point(auxiliary) 1개 (경유 createParallelogram2 → createAuxiliaryPoint) [src:base2d/base-advanced-api/index.ts:2556] — 보임(기본값) [src:object-manager/objects/point.ts:91], 크기 9(configs.pointSize) [src:base2d/base-advanced-api/configs.ts:85], 색 #6e6868(configs.intersectionPointColor) [src:base2d/base-advanced-api/configs.ts:112]",
    "함께 생김, 조건부(props && props.relatedObjects && props.relatedObj…): text(nameText) 1개 (경유 createParallelogram2 → createAuxiliaryPoint → createNameText) [src:base2d/base-advanced-api/index.ts:3266] — 보임(기본값) [src:object-manager/objects/text.ts:63], 위치 오프셋(화면 px) [16, -16] [src:base2d/base-advanced-api/index.ts:3268], 크기 16(configs.nametextSize) [src:base2d/base-advanced-api/configs.ts:92], 글꼴 'KaTeX'(configs.nametextFont) [src:base2d/base-advanced-api/configs.ts:94], 색 #000(configs.nametextColor) [src:base2d/base-advanced-api/configs.ts:93], 매인 개체 [point.id] [src:base2d/base-advanced-api/index.ts:3269]",
    "함께 생김, 조건부(i === 0 그리고 props && props.relatedObjects && props.relatedObj…): linear(segment) 여러 개(반복문) (경유 createParallelogram2 → createAuxiliarySegment(반복)) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [props.relatedObjects[0], props.relatedObjects[1]] [src:base2d/base-advanced-api/index.ts:3579]",
    "함께 생김, 조건부(i === 1 그리고 !(i === 0) 그리고 props && props.relatedObjects && props.relatedObj…): linear(segment) 여러 개(반복문) (경유 createParallelogram2 → createAuxiliarySegment(반복)) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [props.relatedObjects[1], props.relatedObjects[2]] [src:base2d/base-advanced-api/index.ts:3579]",
    "함께 생김, 조건부(i === 2 그리고 !(i === 1) 그리고 !(i === 0) 그리고 props && props.relatedObjects && props.relatedObj…): linear(segment) 여러 개(반복문) (경유 createParallelogram2 → createAuxiliarySegment(반복)) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [props.relatedObjects[2], props.auxiliaryPoints[0… [src:base2d/base-advanced-api/index.ts:3579]",
    "함께 생김, 조건부(i === 3 그리고 !(i === 2) 그리고 !(i === 1) 그리고 !(i === 0) 그리고 props && props.relatedObjects && props.relatedObj…): linear(segment) 여러 개(반복문) (경유 createParallelogram2 → createAuxiliarySegment(반복)) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [props.auxiliaryPoints[0], props.relatedObjects[0… [src:base2d/base-advanced-api/index.ts:3579]",
    "참고: 세 점 pointID1, pointID2, pointID3 이 연속한 꼭짓점(pointID2 가 가운데)이고 넷째 꼭짓점은 pointID1 - pointID2 + pointID3 자리에 새 점으로 선다. 평행사변형 ABCD 는 (A, B, C) 로 부르면 새 점이 D 에 겹쳐 선다. [src:정합성 polygon-transform: scripts/pipeline/semantic/polygon-transform.mjs 의 시험 '(A,B,C) 세 점이 연속한 꼭짓점, 넷째는 A-B+C: ...', '(A,C,B) 가운데 점을 바꾸면 넷째 점이 달라진다: A-C+B', '(B,A,H) 둘째 점 A 가 가운데 꼭짓점: ...']",
    "참고: 화면 도구도 점 셋을 모아 같은 호출(P1, P2, P3)을 하며 둘째 점이 가운데 꼭짓점이고 넷째 꼭짓점 P1-P2+P3 이 보조 점으로 선다. 화면과 이 호출의 결과는 같다. [src:정합성 polygon-transform: /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d-tools/src/tools/math2d-tools/tool-parallelogram.ts:39-70, /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d-ui/src/tab/tools/configs/base2d-geometry.ts:411 ; 캔버스 재현 scripts/pipeline/semantic/polygon-transform.mjs 의 시험 '캔버스: 셋째 클릭에서 도형이 서고 꼭짓점이 P1,P2,P3,P1-P2+P3 이다', '캔버스: 같은 점 id 로 팩토리를 부른 결과와 ...']"
   ],
   "range": [
    "pointID1: 형식 String [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:55] [src:mathcore-api/object-factory/object-types.ts:92]",
    "pointID2: 형식 String [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:56] [src:mathcore-api/object-factory/object-types.ts:92]",
    "pointID3: 형식 String [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:57] [src:mathcore-api/object-factory/object-types.ts:92]",
    "name?: 형식 String | Undefined [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:58] [src:mathcore-api/object-factory/object-types.ts:93]; 생략하면 this.getNewObjectName() [src:base2d/base-advanced-api/index.ts:1041]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): innerAlpha=0.1, vertices=[], strokeWidth=4.2 [src:object-manager/objects/polygon.ts:87-109]",
    "조용히 끝남(만들지 않음): props.color === undefined 이면 undefined 반환 [src:base2d/base-advanced-api/index.ts:1038]"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "polygon.rhombus",
   "path": [
    "polygon",
    "rhombus"
   ],
   "params": [
    {
     "name": "pointID1",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "pointID2",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "pointID3",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "packages-base/polygon-factory.ts",
   "usage": [
    "용도(도구 UI 설명): 마름모 — 마름모가 그려질 세 점을 선택하세요. [src:base2d-ui/src/tab/tools/configs/base2d-geometry.ts:420]",
    "호출: factory.polygon.rhombus → advanced.createRhombus [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:62-68] [src:base2d/base-advanced-api/index.ts:1220-1233]",
    "앞에 있어야 하는 것: pointID1 = point [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:62-68]",
    "앞에 있어야 하는 것: pointID2 = point [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:62-68]",
    "앞에 있어야 하는 것: pointID3 = point [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:62-68]",
    "만드는 것: polygon(rhombus) 1개 (경유 createRhombus2) [src:base2d/base-advanced-api/index.ts:1352] — 보임(기본값) [src:object-manager/objects/polygon.ts:85], 색 [...this.getNewObjectColor()] [src:base2d/base-advanced-api/index.ts:671], 매인 개체 [pointID1, pointID2, pointID3] [src:base2d/base-advanced-api/index.ts:1229]",
    "함께 생김, 조건부(props && props.relatedObjects && props.relatedObj…): point(auxiliary) 여러 개(반복문) (경유 createRhombus2 → createAuxiliaryPoint(반복)) [src:base2d/base-advanced-api/index.ts:2556] — 보임(기본값) [src:object-manager/objects/point.ts:91], 크기 9(configs.pointSize) [src:base2d/base-advanced-api/configs.ts:85], 색 #6e6868(configs.intersectionPointColor) [src:base2d/base-advanced-api/configs.ts:112]",
    "함께 생김, 조건부(props && props.relatedObjects && props.relatedObj…): text(nameText) 여러 개(반복문) (경유 createRhombus2 → createAuxiliaryPoint(반복) → createNameText) [src:base2d/base-advanced-api/index.ts:3266] — 보임(기본값) [src:object-manager/objects/text.ts:63], 위치 오프셋(화면 px) [16, -16] [src:base2d/base-advanced-api/index.ts:3268], 크기 16(configs.nametextSize) [src:base2d/base-advanced-api/configs.ts:92], 글꼴 'KaTeX'(configs.nametextFont) [src:base2d/base-advanced-api/configs.ts:94], 색 #000(configs.nametextColor) [src:base2d/base-advanced-api/configs.ts:93], 매인 개체 [point.id] [src:base2d/base-advanced-api/index.ts:3269]",
    "함께 생김, 조건부(props.hasPolygonDependentPoint 그리고 props && props.relatedObjects && props.relatedObj…): linear(segment) 여러 개(반복문) (경유 createRhombus2 → createAuxiliarySegment) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [props.relatedObjects[0], props.relatedObjects[1]] [src:base2d/base-advanced-api/index.ts:3579]",
    "함께 생김, 조건부(!(props.hasPolygonDependentPoint) 그리고 props && props.relatedObjects && props.relatedObj…): linear(segment) 여러 개(반복문) (경유 createRhombus2 → createAuxiliarySegment) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [props.relatedObjects[0], props.relatedObjects[2]] [src:base2d/base-advanced-api/index.ts:3579]",
    "참고: 입력 점 3개 중 둘째 점은 꼭짓점이 아니라 방향이나 축을 정한다. 계산되는 꼭짓점은 독립된 점으로 새로 선다 [src:docs/palette/polygon-transform.md:74]",
    "참고: 직선 pointID1-pointID2 가 한 대각선이 놓이는 직선이고 pointID3 은 다른 대각선의 한 끝이다(pointID2 는 꼭짓점이 아니고, 이 직선은 변이 아니라 대각선 방향이다). 꼭짓점은 pointID1, pointID3 과 새 점 둘이며 마름모 ABCD(대각선 AC, BD)는 (A, C, B) 로 부르면 새 점이 C, D 에 겹쳐 선다. [src:정합성 polygon-transform: scripts/pipeline/semantic/polygon-transform.mjs 의 시험 '(A,B,C) 직선 AB 가 한 대각선 방향, C 가 다른 대각선의 한 끝: ...', '(A,B,C): 네 변 길이가 같고 ...', '문항 대응 (A(0,0), C(4,0), B(2,1)): 꼭짓점 A, B, C ...']",
    "참고: 화면 도구는 P1P2 가 한 변이고 마우스 쪽 방향으로 같은 길이만큼 이어지는 마름모 [P1, P2, 계산점, 계산점]을 만들고 이 호출은 직선 p1p2 가 대각선 방향이다. 화면의 마름모 P1P2P3P4 와 같은 모양은 이 호출에서 (P1, P3, P2) 로 부른다. [src:정합성 polygon-transform: /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d-tools/src/tools/math2d-tools/tool-rhombus.ts:39-68, /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d/src/base-advanced-api/index.ts:1269-1291, /root/dev/git.cemware.com/mathcore/module/mathcore/packages/fundamentals/src/math.ts:2598-2624, /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d-ui/src/tab/tools/configs/base2d-geometry.ts:417 ; 캔버스 재현 scripts/pipeline/semantic/polygon-transform.mjs 의 시험 '캔버스: 꼭짓점 순서와 좌표가 독립 계산값과 같다', '... 같은 모양을 팩토리로 만든 것과 ...'(rhombus)]"
   ],
   "range": [
    "pointID1: 형식 String [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:63] [src:mathcore-api/object-factory/object-types.ts:92]",
    "pointID2: 형식 String [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:64] [src:mathcore-api/object-factory/object-types.ts:92]",
    "pointID3: 형식 String [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:65] [src:mathcore-api/object-factory/object-types.ts:92]",
    "name?: 형식 String | Undefined [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:66] [src:mathcore-api/object-factory/object-types.ts:93]; 생략하면 this.getNewObjectName() [src:base2d/base-advanced-api/index.ts:1303]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): innerAlpha=0.1, vertices=[], strokeWidth=4.2 [src:object-manager/objects/polygon.ts:87-109]",
    "조용히 끝남(만들지 않음): props.color === undefined 이면 undefined 반환 [src:base2d/base-advanced-api/index.ts:1300]"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "polygon.trapezoid",
   "path": [
    "polygon",
    "trapezoid"
   ],
   "params": [
    {
     "name": "pointID1",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "pointID2",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "pointID3",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "pointID4",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "packages-base/polygon-factory.ts",
   "usage": [
    "용도(도구 UI 설명): 사다리꼴 — 사다리꼴이 그려질 네 점을 선택하세요. [src:base2d-ui/src/tab/tools/configs/base2d-geometry.ts:426]",
    "호출: factory.polygon.trapezoid → advanced.createTrapezoid [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:70-77] [src:base2d/base-advanced-api/index.ts:1355-1369]",
    "앞에 있어야 하는 것: pointID1 = point [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:70-77]",
    "앞에 있어야 하는 것: pointID2 = point [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:70-77]",
    "앞에 있어야 하는 것: pointID3 = point [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:70-77]",
    "앞에 있어야 하는 것: pointID4 = point [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:70-77]",
    "만드는 것: polygon(trapezoid) 1개 (경유 createTrapezoid2) [src:base2d/base-advanced-api/index.ts:1493] — 보임(기본값) [src:object-manager/objects/polygon.ts:85], 색 [...this.getNewObjectColor()] [src:base2d/base-advanced-api/index.ts:671], 매인 개체 [pointID1, pointID2, pointID3, pointID4] [src:base2d/base-advanced-api/index.ts:1365]",
    "함께 생김, 조건부(!props.hasPolygonDependentPoint 그리고 props && props.relatedObjects && props.relatedObj…): point(auxiliary) 1개 (경유 createTrapezoid2 → createAuxiliaryPoint) [src:base2d/base-advanced-api/index.ts:2556] — 보임(기본값) [src:object-manager/objects/point.ts:91], 크기 9(configs.pointSize) [src:base2d/base-advanced-api/configs.ts:85], 색 #6e6868(configs.intersectionPointColor) [src:base2d/base-advanced-api/configs.ts:112]",
    "함께 생김, 조건부(!props.hasPolygonDependentPoint 그리고 props && props.relatedObjects && props.relatedObj…): text(nameText) 1개 (경유 createTrapezoid2 → createAuxiliaryPoint → createNameText) [src:base2d/base-advanced-api/index.ts:3266] — 보임(기본값) [src:object-manager/objects/text.ts:63], 위치 오프셋(화면 px) [16, -16] [src:base2d/base-advanced-api/index.ts:3268], 크기 16(configs.nametextSize) [src:base2d/base-advanced-api/configs.ts:92], 글꼴 'KaTeX'(configs.nametextFont) [src:base2d/base-advanced-api/configs.ts:94], 색 #000(configs.nametextColor) [src:base2d/base-advanced-api/configs.ts:93], 매인 개체 [point.id] [src:base2d/base-advanced-api/index.ts:3269]",
    "함께 생김, 조건부(props.hasPolygonDependentPoint 그리고 props && props.relatedObjects && props.relatedObj…): linear(segment) 여러 개(반복문) (경유 createTrapezoid2 → createAuxiliarySegment) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [props.relatedObjects[0], props.relatedObjects[1]] [src:base2d/base-advanced-api/index.ts:3579]",
    "함께 생김, 조건부(!(props.hasPolygonDependentPoint) 그리고 props && props.relatedObjects && props.relatedObj…): linear(segment) 여러 개(반복문) (경유 createTrapezoid2 → createAuxiliarySegment) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [props.relatedObjects[1], props.auxiliaryPoints[0… [src:base2d/base-advanced-api/index.ts:3579]",
    "참고: 넷째 점은 꼭짓점이 아니다. 계산되는 꼭짓점은 독립된 점으로 새로 선다 [src:docs/palette/polygon-transform.md:74]",
    "참고: pointID1-pointID2 가 밑변이고 pointID3 은 윗변의 한 끝(pointID1 쪽 다리의 위 끝)이며, pointID4 는 반대쪽 다리가 지나는 방향을 정하는 점이다. 윗변의 다른 끝은 pointID3 을 지나 밑변에 평행한 직선과 직선 pointID4-pointID2 의 교점에 새 점으로 서므로 사다리꼴 ABCD(AB ∥ DC, 반시계)는 (A, B, D, C) 로 부르면 새 점이 C 에 겹쳐 선다. pointID3 과 pointID4 의 자리를 바꾸면 변이 교차하는 꼬인 사각형이 선다. [src:정합성 polygon-transform: scripts/pipeline/semantic/polygon-transform.mjs 의 시험 '(A,B,D,C) 밑변 AB, D 윗변 한 끝, C 가 다리 방향 점: ...', '(A,B,D,C): 넷째 점 C 는 꼭짓점이 아니라 vertexPoints 에 없다', '(A,B,D,Q) 다리 방향 점 Q(2,5) ...', '(A,B,C,D) 셋째와 넷째를 바꾸면 ...: 변 B-새 점과 변 C-A 가 교차(꼬인 사각형)']",
    "참고: 화면 도구는 P1P2 가 밑변, P2P3 가 다리이고 넷째 꼭짓점이 마우스를 P3 를 지나는 평행선에 사영한 점인 사다리꼴 [P1, P2, P3, 계산점]을 만든다. 같은 모양은 이 호출에서 (P1, P2, 계산된 윗변 끝, P3) 로 부른다. [src:정합성 polygon-transform: /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d-tools/src/tools/math2d-tools/tool-trapezoid.ts:39-66, /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d/src/base-advanced-api/index.ts:1409-1432, /root/dev/git.cemware.com/mathcore/module/mathcore/packages/fundamentals/src/math.ts:2633-2653, /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d-ui/src/tab/tools/configs/base2d-geometry.ts:423 ; 캔버스 재현 scripts/pipeline/semantic/polygon-transform.mjs 의 시험 '캔버스: 꼭짓점 순서와 좌표가 독립 계산값과 같다', '... 같은 모양을 팩토리로 만든 것과 ...'(trapezoid)]"
   ],
   "range": [
    "pointID1: 형식 String [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:71] [src:mathcore-api/object-factory/object-types.ts:92]",
    "pointID2: 형식 String [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:72] [src:mathcore-api/object-factory/object-types.ts:92]",
    "pointID3: 형식 String [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:73] [src:mathcore-api/object-factory/object-types.ts:92]",
    "pointID4: 형식 String [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:74] [src:mathcore-api/object-factory/object-types.ts:92]",
    "name?: 형식 String | Undefined [src:mathcore-api/object-factory/packages-base/polygon-factory.ts:75] [src:mathcore-api/object-factory/object-types.ts:93]; 생략하면 this.getNewObjectName() [src:base2d/base-advanced-api/index.ts:1444]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): innerAlpha=0.1, vertices=[], strokeWidth=4.2 [src:object-manager/objects/polygon.ts:87-109]",
    "조용히 끝남(만들지 않음): props.color === undefined 이면 undefined 반환 [src:base2d/base-advanced-api/index.ts:1441]"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "transform.pointSymmetry",
   "path": [
    "transform",
    "pointSymmetry"
   ],
   "params": [
    {
     "name": "originObjectID",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      },
      {
       "type": "linear"
      },
      {
       "type": "circle"
      },
      {
       "type": "chord"
      },
      {
       "type": "polygon"
      },
      {
       "type": "ellipse"
      },
      {
       "type": "polynomial"
      }
     ]
    },
    {
     "name": "pointID",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "packages-base/transform-factory.ts",
   "usage": [
    "용도(도구 UI 설명): 점대칭 — 대칭시킬 대상을 선택한 후 기준점을 선택하세요. [src:base2d-ui/src/tab/tools/configs/base2d-geometry.ts:507]",
    "호출: factory.transform.pointSymmetry → advanced.createPointSymmetryObject [src:mathcore-api/object-factory/packages-base/transform-factory.ts:8-13] [src:base2d/base-advanced-api/index.ts:6652-6658]",
    "앞에 있어야 하는 것: originObjectID = 아무 개체 [src:mathcore-api/object-factory/packages-base/transform-factory.ts:8-13]",
    "앞에 있어야 하는 것: pointID = point [src:mathcore-api/object-factory/packages-base/transform-factory.ts:8-13]",
    "만드는 것, 조건부(true 그리고 targetObject?.data.type === POINT_TYPE): point(auxiliary) 1개 (경유 createRotationObject → createTransformObject → duplicate → createAuxiliaryPoint) [src:base2d/base-advanced-api/index.ts:2556] — 보임(기본값) [src:object-manager/objects/point.ts:91], 크기 9(configs.pointSize) [src:base2d/base-advanced-api/configs.ts:85], 색 #6e6868(configs.intersectionPointColor) [src:base2d/base-advanced-api/configs.ts:112]",
    "함께 생김, 조건부(true 그리고 targetObject?.data.type === POINT_TYPE): text(nameText) 1개 (경유 createRotationObject → createTransformObject → duplicate → createAuxiliaryPoint → createNameText) [src:base2d/base-advanced-api/index.ts:3266] — 보임(기본값) [src:object-manager/objects/text.ts:63], 위치 오프셋(화면 px) [16, -16] [src:base2d/base-advanced-api/index.ts:3268], 크기 16(configs.nametextSize) [src:base2d/base-advanced-api/configs.ts:92], 글꼴 'KaTeX'(configs.nametextFont) [src:base2d/base-advanced-api/configs.ts:94], 색 #000(configs.nametextColor) [src:base2d/base-advanced-api/configs.ts:93], 매인 개체 [point.id] [src:base2d/base-advanced-api/index.ts:3269]",
    "다른 갈래에서 대신 만드는 것, 조건부(targetObject?.data.type === POINT_TYPE): point(point) 1개 (경유 createRotationObject → createTransformObject → duplicate → createPoint) [src:base2d/base-advanced-api/index.ts:2479] — 보임(기본값) [src:object-manager/objects/point.ts:91], 크기 9(configs.pointSize) [src:base2d/base-advanced-api/configs.ts:85], 색 #fe7701(configs.pointColor) [src:base2d/base-advanced-api/configs.ts:86]",
    "다른 갈래에서 대신 만드는 것, 조건부(targetObject?.data.type === POINT_TYPE): text(nameText) 1개 (경유 createRotationObject → createTransformObject → duplicate → createPoint → createNameText) [src:base2d/base-advanced-api/index.ts:3266] — 보임(기본값) [src:object-manager/objects/text.ts:63], 위치 오프셋(화면 px) [16, -16] [src:base2d/base-advanced-api/index.ts:3268], 크기 16(configs.nametextSize) [src:base2d/base-advanced-api/configs.ts:92], 글꼴 'KaTeX'(configs.nametextFont) [src:base2d/base-advanced-api/configs.ts:94], 색 #000(configs.nametextColor) [src:base2d/base-advanced-api/configs.ts:93], 매인 개체 [point.id] [src:base2d/base-advanced-api/index.ts:3269]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'segment' 그리고 targetObject?.data.type === LINEAR_TYPE): linear(segment) 1개 (경유 createRotationObject → createTransformObject → duplicate → createSegment → createLinear) [src:base2d/base-advanced-api/index.ts:3358] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 null as null | Color(configs.linearColor) [src:base2d/base-advanced-api/configs.ts:127], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [p1.id, p2.id] [src:base2d/base-advanced-api/index.ts:3362]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'line' 그리고 targetObject?.data.type === LINEAR_TYPE): linear(line) 1개 (경유 createRotationObject → createTransformObject → duplicate → createLine → createLinear) [src:base2d/base-advanced-api/index.ts:3358] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 null as null | Color(configs.linearColor) [src:base2d/base-advanced-api/configs.ts:127], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [p1.id, p2.id] [src:base2d/base-advanced-api/index.ts:3362]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'ray' 그리고 targetObject?.data.type === LINEAR_TYPE): linear(ray) 1개 (경유 createRotationObject → createTransformObject → duplicate → createRay → createLinear) [src:base2d/base-advanced-api/index.ts:3358] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 null as null | Color(configs.linearColor) [src:base2d/base-advanced-api/configs.ts:127], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [p1.id, p2.id] [src:base2d/base-advanced-api/index.ts:3362]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'perpendicular' 그리고 targetObject?.data.type === LINEAR_TYPE): linear(perpendicular) 1개 (경유 createRotationObject → createTransformObject → duplicate → createPerpendicular → createLinear) [src:base2d/base-advanced-api/index.ts:3358] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 null as null | Color(configs.linearColor) [src:base2d/base-advanced-api/configs.ts:127], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [l, p.id] [src:base2d/base-advanced-api/index.ts:3362]",
    "다른 갈래에서 대신 만드는 것, 조건부(l?.data.type === LINEAR_TYPE 그리고 case 'perpendicularAtMidpoint' 그리고 targetObject?.data.type === LINEAR_TYPE): linear(perpendicularAtMidpoint) 1개 (경유 createRotationObject → createTransformObject → duplicate → createPerpendicularAtMidpointBySegmentID → createLinear) [src:base2d/base-advanced-api/index.ts:3358] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 null as null | Color(configs.linearColor) [src:base2d/base-advanced-api/configs.ts:127], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [l.data.id] [src:base2d/base-advanced-api/index.ts:3362]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'perpendicularAtMidpoint' 그리고 targetObject?.data.type === LINEAR_TYPE): linear(perpendicularAtMidpoint) 1개 (경유 createRotationObject → createTransformObject → duplicate → createPerpendicularAtMidpointByTwoPointID → createLinear) [src:base2d/base-advanced-api/index.ts:3358] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 null as null | Color(configs.linearColor) [src:base2d/base-advanced-api/configs.ts:127], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [p1.id, p2.id] [src:base2d/base-advanced-api/index.ts:3362]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'bisectorLine' 그리고 targetObject?.data.type === LINEAR_TYPE): linear(bisectorLine) 1개 (경유 createRotationObject → createTransformObject → duplicate → createBisectorLine → createLinear) [src:base2d/base-advanced-api/index.ts:3358] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 null as null | Color(configs.linearColor) [src:base2d/base-advanced-api/configs.ts:127], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [p1.id, p2.id, p3.id] [src:base2d/base-advanced-api/index.ts:3362]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'tangentLine' 그리고 targetObject?.data.type === LINEAR_TYPE): point(point) 여러 개(반복문) (경유 createRotationObject → createTransformObject → duplicate → createPoint) [src:base2d/base-advanced-api/index.ts:2479] — 보임(기본값) [src:object-manager/objects/point.ts:91], 크기 9(configs.pointSize) [src:base2d/base-advanced-api/configs.ts:85], 색 #fe7701(configs.pointColor) [src:base2d/base-advanced-api/configs.ts:86]",
    "다른 갈래에서 대신 만드는 것, 조건부(r1?.data.type === POINT_TYPE && r2?.data.type ===… 그리고 case 'parallel' 그리고 targetObject?.data.type === LINEAR_TYPE): linear(parallel) 1개 (경유 createRotationObject → createTransformObject → duplicate → createParallel → createLinear) [src:base2d/base-advanced-api/index.ts:3358] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 null as null | Color(configs.linearColor) [src:base2d/base-advanced-api/configs.ts:127], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [newPoint.id, r2.data.id] [src:base2d/base-advanced-api/index.ts:3362]",
    "다른 갈래에서 대신 만드는 것, 조건부(r1?.data.type === LINEAR_TYPE && r2?.data.type ==… 그리고 case 'parallel' 그리고 targetObject?.data.type === LINEAR_TYPE): linear(parallel) 1개 (경유 createRotationObject → createTransformObject → duplicate → createParallel → createLinear) [src:base2d/base-advanced-api/index.ts:3358] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 null as null | Color(configs.linearColor) [src:base2d/base-advanced-api/configs.ts:127], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [newPoint.id, r1.data.id] [src:base2d/base-advanced-api/index.ts:3362]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'circleCenterPoint' 그리고 targetObject?.data.type === CIRCLE_TYPE): circle(circleCenterPoint) 1개 (경유 createRotationObject → createTransformObject → duplicate → createCircleCenterPoint) [src:base2d/base-advanced-api/index.ts:3761] — 보임(기본값) [src:object-manager/objects/circle.ts:79], 색 null as null | Color(configs.circleColor) [src:base2d/base-advanced-api/configs.ts:128], 매인 개체 [p1.id, p2.id] [src:base2d/base-advanced-api/index.ts:3768]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'circleCenterRadius' 그리고 targetObject?.data.type === CIRCLE_TYPE): circle(circleCenterRadius) 1개 (경유 createRotationObject → createTransformObject → duplicate → createCircleCenterRadius) [src:base2d/base-advanced-api/index.ts:3738] — 보임(기본값) [src:object-manager/objects/circle.ts:79], 색 null as null | Color(configs.circleColor) [src:base2d/base-advanced-api/configs.ts:128], 매인 개체 [p.id] [src:base2d/base-advanced-api/index.ts:3746]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'triangleCircumCircle' 그리고 targetObject?.data.type === CIRCLE_TYPE): circle(triangleCircumCircle) 1개 (경유 createRotationObject → createTransformObject → duplicate → createCircleTriangleCircumCircle) [src:base2d/base-advanced-api/index.ts:3864] — 보임(기본값) [src:object-manager/objects/circle.ts:79], 색 null as null | Color(configs.circleColor) [src:base2d/base-advanced-api/configs.ts:128], 매인 개체 [p1.id, p2.id, p3.id] [src:base2d/base-advanced-api/index.ts:3871]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'triangleCircumArc' 그리고 targetObject?.data.type === CIRCLE_TYPE): circle(triangleCircumArc) 1개 (경유 createRotationObject → createTransformObject → duplicate → createTriangleCircumArc) [src:base2d/base-advanced-api/index.ts:3925] — 보임(기본값) [src:object-manager/objects/circle.ts:79], 색 null as null | Color(configs.circleColor) [src:base2d/base-advanced-api/configs.ts:128], 매인 개체 [p1.id, p2.id, p3.id] [src:base2d/base-advanced-api/index.ts:3932]",
    "다른 갈래에서 대신 만드는 것, 조건부(o1?.data.type === CIRCLE_TYPE 그리고 case 'compass' 그리고 targetObject?.data.type === CIRCLE_TYPE): circle(compass) 1개 (경유 createRotationObject → createTransformObject → duplicate → createCompassByCircle → createCompassBySegment) [src:base2d/base-advanced-api/index.ts:3988] — 보임(기본값) [src:object-manager/objects/circle.ts:79], 색 null as null | Color(configs.circleColor) [src:base2d/base-advanced-api/configs.ts:128], 매인 개체 [o.relatedObjects[0], p.id] [src:base2d/base-advanced-api/index.ts:3995]",
    "다른 갈래에서 대신 만드는 것, 조건부(o1?.data.type === LINEAR_TYPE 그리고 case 'compass' 그리고 targetObject?.data.type === CIRCLE_TYPE): circle(compass) 1개 (경유 createRotationObject → createTransformObject → duplicate → createCompassBySegment) [src:base2d/base-advanced-api/index.ts:3988] — 보임(기본값) [src:object-manager/objects/circle.ts:79], 색 null as null | Color(configs.circleColor) [src:base2d/base-advanced-api/configs.ts:128], 매인 개체 [o.relatedObjects[0], p.id] [src:base2d/base-advanced-api/index.ts:3995]",
    "다른 갈래에서 대신 만드는 것, 조건부(o1?.data.type === POINT_TYPE 그리고 case 'compass' 그리고 targetObject?.data.type === CIRCLE_TYPE): circle(compass) 1개 (경유 createRotationObject → createTransformObject → duplicate → createCompassByThreePoint) [src:base2d/base-advanced-api/index.ts:3960] — 보임(기본값) [src:object-manager/objects/circle.ts:79], 색 null as null | Color(configs.circleColor) [src:base2d/base-advanced-api/configs.ts:128], 매인 개체 [o.relatedObjects[0], o.relatedObjects[1], p.id] [src:base2d/base-advanced-api/index.ts:3967]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'arc' 그리고 targetObject?.data.type === CIRCLE_TYPE): circle(arc) 1개 (경유 createRotationObject → createTransformObject → duplicate → createArc) [src:base2d/base-advanced-api/index.ts:4023] — 보임(기본값) [src:object-manager/objects/circle.ts:79], 색 null as null | Color(configs.circleColor) [src:base2d/base-advanced-api/configs.ts:128], 매인 개체 [p1.id, p2.id, p3.id, auxiliaryPointID] [src:base2d/base-advanced-api/index.ts:4030]",
    "다른 갈래에서 대신 만드는 것, 조건부(isLineSymmetry 그리고 case 'fan' 그리고 targetObject?.data.type === CIRCLE_TYPE): linear(segment) 여러 개(반복문) (경유 createRotationObject → createTransformObject → duplicate → createFan → createAuxiliarySegment) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [p1.id, auxiliaryPointID] [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(!(isLineSymmetry) 그리고 case 'fan' 그리고 targetObject?.data.type === CIRCLE_TYPE): linear(segment) 1개 (경유 createRotationObject → createTransformObject → duplicate → createFan → createAuxiliarySegment) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [p1.id, p2.id] [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'fan' 그리고 targetObject?.data.type === CIRCLE_TYPE): circle(fan) 1개 (경유 createRotationObject → createTransformObject → duplicate → createFan) [src:base2d/base-advanced-api/index.ts:4133] — 보임(기본값) [src:object-manager/objects/circle.ts:79], 색 color [src:base2d/base-advanced-api/index.ts:4136], 매인 개체 [ p1.id, p2.id, p3.id, auxiliaryPointID, auxiliar… [src:base2d/base-advanced-api/index.ts:4143]",
    "다른 갈래에서 대신 만드는 것, 조건부(isLineSymmetry 그리고 case 'segmentOfACircle' 그리고 targetObject?.data.type === CIRCLE_TYPE): linear(segment) 1개 (경유 createRotationObject → createTransformObject → duplicate → createSegmentOfACircle → createAuxiliarySegment) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [p3.id, auxiliaryPointID] [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(!(isLineSymmetry) 그리고 case 'segmentOfACircle' 그리고 targetObject?.data.type === CIRCLE_TYPE): linear(segment) 1개 (경유 createRotationObject → createTransformObject → duplicate → createSegmentOfACircle → createAuxiliarySegment) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [p2.id, auxiliaryPointID] [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'segmentOfACircle' 그리고 targetObject?.data.type === CIRCLE_TYPE): circle(segmentOfACircle) 1개 (경유 createRotationObject → createTransformObject → duplicate → createSegmentOfACircle) [src:base2d/base-advanced-api/index.ts:4192] — 보임(기본값) [src:object-manager/objects/circle.ts:79], 색 color [src:base2d/base-advanced-api/index.ts:4195], 매인 개체 [ p1.id, p2.id, p3.id, auxiliaryPointID, auxiliar… [src:base2d/base-advanced-api/index.ts:4199]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'polygon' 그리고 targetObject?.data.type === POLYGON_TYPE): polygon(polygon) 1개 (경유 createRotationObject → createTransformObject → duplicate → createPolygon → createPolygon2) [src:base2d/base-advanced-api/index.ts:747] — 보임(기본값) [src:object-manager/objects/polygon.ts:85], 색 color [src:base2d/base-advanced-api/index.ts:695], 매인 개체 [...pointIDs, pointIDs[0]] [src:base2d/base-advanced-api/index.ts:690]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'cpPolygon' 그리고 targetObject?.data.type === POLYGON_TYPE): polygon(cpPolygon) 1개 (경유 createRotationObject → createTransformObject → duplicate → createCPPolygon → createCPPolygon2) [src:base2d/base-advanced-api/index.ts:1589] — 보임(기본값) [src:object-manager/objects/polygon.ts:85], 색 color [src:base2d/base-advanced-api/index.ts:1526], 매인 개체 [p1.id, p2.id] [src:base2d/base-advanced-api/index.ts:1513]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'lateralPolygon' 그리고 targetObject?.data.type === POLYGON_TYPE): polygon(lateralPolygon) 1개 (경유 createRotationObject → createTransformObject → duplicate → createLateralPolygon → createLateralPolygon2) [src:base2d/base-advanced-api/index.ts:1734] — 보임(기본값) [src:object-manager/objects/polygon.ts:85], 색 color [src:base2d/base-advanced-api/index.ts:1669], 매인 개체 [p1.id, p2.id] [src:base2d/base-advanced-api/index.ts:1656]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'rigidPolygon' 그리고 targetObject?.data.type === POLYGON_TYPE): polygon(rigidPolygon) 1개 (경유 createRotationObject → createTransformObject → duplicate → createRigidPolygon → createRigidPolygon2) [src:base2d/base-advanced-api/index.ts:1876] — 보임(기본값) [src:object-manager/objects/polygon.ts:85], 색 color [src:base2d/base-advanced-api/index.ts:1812], 매인 개체 [p1.id, p2.id] [src:base2d/base-advanced-api/index.ts:1799]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'isoscelesTriangle' 그리고 targetObject?.data.type === POLYGON_TYPE): polygon(isoscelesTriangle) 1개 (경유 createRotationObject → createTransformObject → duplicate → createIsoscelesTriangle → createIsoscelesTriangle2) [src:base2d/base-advanced-api/index.ts:863] — 보임(기본값) [src:object-manager/objects/polygon.ts:85], 매인 개체 [p1.id, p2.id, p3.id] [src:base2d/base-advanced-api/index.ts:754]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'rightTriangle' 그리고 targetObject?.data.type === POLYGON_TYPE): polygon(rightTriangle) 1개 (경유 createRotationObject → createTransformObject → duplicate → createRightTriangle → createRightTriangle2) [src:base2d/base-advanced-api/index.ts:984] — 보임(기본값) [src:object-manager/objects/polygon.ts:85], 매인 개체 [p1.id, p2.id, p3.id] [src:base2d/base-advanced-api/index.ts:875]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'rectangle' 그리고 targetObject?.data.type === POLYGON_TYPE): polygon(rectangle) 1개 (경유 createRotationObject → createTransformObject → duplicate → createRectangle → createRectangle2) [src:base2d/base-advanced-api/index.ts:1217] — 보임(기본값) [src:object-manager/objects/polygon.ts:85], 매인 개체 [p1.id, p2.id, p3.id] [src:base2d/base-advanced-api/index.ts:1099]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'parallelogram' 그리고 targetObject?.data.type === POLYGON_TYPE): polygon(parallelogram) 1개 (경유 createRotationObject → createTransformObject → duplicate → createParallelogram → createParallelogram2) [src:base2d/base-advanced-api/index.ts:1092] — 보임(기본값) [src:object-manager/objects/polygon.ts:85], 매인 개체 [p1.id, p2.id, p3.id] [src:base2d/base-advanced-api/index.ts:991]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'rhombus' 그리고 targetObject?.data.type === POLYGON_TYPE): polygon(rhombus) 1개 (경유 createRotationObject → createTransformObject → duplicate → createRhombus → createRhombus2) [src:base2d/base-advanced-api/index.ts:1352] — 보임(기본값) [src:object-manager/objects/polygon.ts:85], 매인 개체 [p1.id, p2.id, p3.id] [src:base2d/base-advanced-api/index.ts:1229]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'trapezoid' 그리고 targetObject?.data.type === POLYGON_TYPE): polygon(trapezoid) 1개 (경유 createRotationObject → createTransformObject → duplicate → createTrapezoid → createTrapezoid2) [src:base2d/base-advanced-api/index.ts:1493] — 보임(기본값) [src:object-manager/objects/polygon.ts:85], 매인 개체 [p1.id, p2.id, p3.id, p4.id] [src:base2d/base-advanced-api/index.ts:1365]",
    "다른 갈래에서 대신 만드는 것, 조건부(targetObject?.data.type === TEXT_TYPE): text 1개 (경유 createRotationObject → createTransformObject → duplicate → createText) [src:base2d/base-advanced-api/index.ts:3203] — 보임(기본값) [src:object-manager/objects/text.ts:63], 크기 o.size [src:base2d/base-advanced-api/index.ts:3207], 글꼴 o.font! [src:base2d/base-advanced-api/index.ts:3208], 색 #000(configs.textColor) [src:base2d/base-advanced-api/configs.ts:90], latex=o.latex [src:base2d/base-advanced-api/index.ts:3206], isScreenCoord=true [src:base2d/base-advanced-api/index.ts:3212]",
    "다른 갈래에서 대신 만드는 것, 조건부(targetObject?.data.type === DRAWING_TYPE): drawing 1개 (경유 createRotationObject → createTransformObject → duplicate → createDrawingObject) [src:base2d/base-advanced-api/index.ts:4233] — 보임(공통 기본값) [src:object-manager/objects/common.ts:38], 색 null as null | Color(configs.drawingColor) [src:base2d/base-advanced-api/configs.ts:130], 선 두께 2(configs.drawingStrokeWidth) [src:base2d/base-advanced-api/configs.ts:135]",
    "다른 갈래에서 대신 만드는 것, 조건부(targetObject?.data.type === IMAGE_TYPE): image 1개 (경유 createRotationObject → createTransformObject → duplicate → createImage) [src:base2d/base-advanced-api/index.ts:4371] — 보임(기본값) [src:object-manager/objects/image.ts:37], isScreenCoord=false [src:base2d/base-advanced-api/index.ts:4378]",
    "다른 갈래에서 대신 만드는 것, 조건부(targetObject?.data.type === ELLIPSE_TYPE): ellipse 1개 (경유 createRotationObject → createTransformObject → duplicate → createEllipse) [src:base2d/base-advanced-api/index.ts:3876] — 보임(기본값) [src:object-manager/objects/ellipse.ts:52], 색 null as null | Color(configs.circleColor) [src:base2d/base-advanced-api/configs.ts:128], 매인 개체 [p1.id, p2.id, p3.id] [src:base2d/base-advanced-api/index.ts:3882]",
    "다른 갈래에서 대신 만드는 것, 조건부(this.typingParser.isValid() 그리고 targetObject?.data.type === POLYNOMIAL_TYPE): polynomial 1개 (경유 createRotationObject → createTransformObject → duplicate → createAlgebraicObject) [src:base2d/base-advanced-api/index.ts:2281] — 보임(기본값) [src:object-manager/objects/polynomial.ts:64], 색 null as null | Color(configs.algebraicColor) [src:base2d/base-advanced-api/configs.ts:131], 선 두께 2(configs.algebraicStrokeWidth) [src:base2d/base-advanced-api/configs.ts:137]",
    "다른 갈래에서 대신 만드는 것, 조건부(this.typingParser.isValid() 그리고 targetObject?.data.type === POLYNOMIAL_TYPE): text(nameText) 1개 (경유 createRotationObject → createTransformObject → duplicate → createAlgebraicObject → createNameTextByPolynomial) [src:base2d/base-advanced-api/index.ts:3339] — 숨김 [src:base2d/base-advanced-api/index.ts:3349], 위치 오프셋(화면 px) [24, -24] || [16, -16] [src:base2d/base-advanced-api/index.ts:3341], 크기 16(configs.nametextSize) [src:base2d/base-advanced-api/configs.ts:92], 색 #000(configs.nametextColor) [src:base2d/base-advanced-api/configs.ts:93], latex=true [src:base2d/base-advanced-api/index.ts:3350], 매인 개체 [object.id] [src:base2d/base-advanced-api/index.ts:3342]",
    "다른 갈래에서 대신 만드는 것, 조건부(this.typingLexer.isEmpty() 그리고 this.typingLexer.process(o.expr) 그리고 targetObject?.data.type === POLYNOMIAL_TYPE): polynomial 1개 (경유 createRotationObject → createTransformObject → duplicate → createAlgebraicObject) [src:base2d/base-advanced-api/index.ts:2299] — 보임(기본값) [src:object-manager/objects/polynomial.ts:64], 색 null as null | Color(configs.algebraicColor) [src:base2d/base-advanced-api/configs.ts:131], 선 두께 2(configs.algebraicStrokeWidth) [src:base2d/base-advanced-api/configs.ts:137]",
    "다른 갈래에서 대신 만드는 것, 조건부(firstToken.type === TokenType.OPENING_PAREN && la… 그리고 this.typingLexer.process(o.expr) 그리고 targetObject?.data.type === POLYNOMIAL_TYPE): point(point) 1개 (경유 createRotationObject → createTransformObject → duplicate → createAlgebraicObject → createPoint) [src:base2d/base-advanced-api/index.ts:2479] — 보임(기본값) [src:object-manager/objects/point.ts:91], 크기 9(configs.pointSize) [src:base2d/base-advanced-api/configs.ts:85], 색 #fe7701(configs.pointColor) [src:base2d/base-advanced-api/configs.ts:86]",
    "다른 갈래에서 대신 만드는 것, 조건부(this.typingLexer.process(o.expr) 그리고 targetObject?.data.type === POLYNOMIAL_TYPE): polynomial 1개 (경유 createRotationObject → createTransformObject → duplicate → createAlgebraicObject) [src:base2d/base-advanced-api/index.ts:2327] — 보임(기본값) [src:object-manager/objects/polynomial.ts:64], 색 null as null | Color(configs.algebraicColor) [src:base2d/base-advanced-api/configs.ts:131], 선 두께 2(configs.algebraicStrokeWidth) [src:base2d/base-advanced-api/configs.ts:137]",
    "다른 갈래에서 대신 만드는 것, 조건부(targetObject?.data.type === POLYNOMIAL_TYPE): polynomial 1개 (경유 createRotationObject → createTransformObject → duplicate → createAlgebraicObject) [src:base2d/base-advanced-api/index.ts:2344] — 보임(기본값) [src:object-manager/objects/polynomial.ts:64], 색 null as null | Color(configs.algebraicColor) [src:base2d/base-advanced-api/configs.ts:131], 선 두께 2(configs.algebraicStrokeWidth) [src:base2d/base-advanced-api/configs.ts:137]",
    "참고: 원본은 그대로 두고 같은 종류의 복사본이 선다 [src:docs/palette/polygon-transform.md:28]",
    "참고: pointID 가 대칭의 중심점이고 결과 좌표는 2×중심 - 원본 좌표이다(각도 π 의 회전과 같다). [src:정합성 polygon-transform: scripts/pipeline/semantic/polygon-transform.mjs 의 시험 '중심 Q(1,-1) / 원본 점·선분·직선·원·삼각형·직사각형·정오각형·호·부채꼴: 복사본 좌표 ...' 와 'transform 이 rotation']",
    "참고: 화면 도구는 원본을 누르고 중심을 누르면(빈 곳이면 새 점) 같은 호출(원본, 중심)을 하며 모달은 없다. 이 호출의 중심은 서 있는 점 id 여야 한다. [src:정합성 polygon-transform: /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d-tools/src/tools/math2d-tools/tool-point-symmetry.ts:54-96, /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d-ui/src/tab/tools/configs/base2d-geometry.ts:504, /root/dev/git.cemware.com/mathcore/mathcore-api/src/app/math2d/tool-manager.ts:124 ; 캔버스 재현 scripts/pipeline/semantic/polygon-transform.mjs 의 시험 '캔버스: 두 번째 클릭(기준점)에서 원본 선분의 복사본이 서고 ...', '캔버스: 팩토리 pointSymmetry(원본, 기준점) 와 ...']",
    "생성 결과: 원본과 같은 종류의 복사본 개체 1개가 서고 반환 id 가 그 복사본이다(점은 보조 점, 선분과 직선은 linear, 원과 호와 부채꼴은 circle, 다각형은 같은 category 의 polygon, 대수 곡선은 polynomial). 다각형 복사본은 꼭짓점 보조 점과 변 선분도 새로 서고 원본은 바뀌지 않는다. [src:정합성 polygon-transform: scripts/pipeline/semantic/polygon-transform.mjs 의 시험 '같은 type(point|linear|circle|polygon|polynomial) 복사본이 유효로 선다', '원본 id 와 다른 새 개체이고 원본은 그대로', '원본의 RO 에 복사본 id 가 더해진다' (원본 점, 선분, 직선, 원, 호, 부채꼴, 삼각형, 직사각형, 정오각형, 곡선 등) 와 기록 '원본 category ... 복사본 category auxiliary']"
   ],
   "range": [
    "originObjectID: 형식 String [src:mathcore-api/object-factory/packages-base/transform-factory.ts:9] [src:mathcore-api/object-factory/object-types.ts:92]",
    "pointID: 형식 String [src:mathcore-api/object-factory/packages-base/transform-factory.ts:10] [src:mathcore-api/object-factory/object-types.ts:92]",
    "name?: 형식 String | Undefined [src:mathcore-api/object-factory/packages-base/transform-factory.ts:11] [src:mathcore-api/object-factory/object-types.ts:93]; 생략하면 this.getNewObjectName()(createLinear) [src:base2d/base-advanced-api/index.ts:3363]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): traceColor=undefined, shape=PointShape.Circle, imoji=0, position=[0, 0], domain='점', angle=0 [src:object-manager/objects/point.ts:93-99]",
    "조용히 끝남(만들지 않음): [...pointIDs, pointIDs[0]].length < 3 이면 undefined 반환 [src:base2d/base-advanced-api/index.ts:685]",
    "조용히 끝남(만들지 않음): props.color === undefined 이면 undefined 반환 [src:base2d/base-advanced-api/index.ts:707]",
    "조용히 끝남(만들지 않음): o.numberOfSides < 3 이면 undefined 반환 [src:base2d/base-advanced-api/index.ts:1506]",
    "조용히 끝남(만들지 않음): props.color === undefined 이면 undefined 반환 [src:base2d/base-advanced-api/index.ts:1546]",
    "조용히 끝남(만들지 않음): o.numberOfSides < 3 이면 undefined 반환 [src:base2d/base-advanced-api/index.ts:1649]",
    "조용히 끝남(만들지 않음): props.color === undefined 이면 undefined 반환 [src:base2d/base-advanced-api/index.ts:1688]",
    "조용히 끝남(만들지 않음): props.color === undefined 이면 undefined 반환 [src:base2d/base-advanced-api/index.ts:1830]",
    "조용히 끝남(만들지 않음): props.color === undefined 이면 undefined 반환 [src:base2d/base-advanced-api/index.ts:822]",
    "조용히 끝나는 조건 외 5곳 (경유 createRightTriangle2, createRectangle2, createParallelogram2, createRhombus2, createTrapezoid2) [src:base2d/base-advanced-api/index.ts:943] [src:base2d/base-advanced-api/index.ts:1169] [src:base2d/base-advanced-api/index.ts:1038] [src:base2d/base-advanced-api/index.ts:1300] [src:base2d/base-advanced-api/index.ts:1441]",
    "원본 id 가 없는 개체이거나 복제할 수 없는 종류(슬라이더, 벡터)이면 개체를 만들지 않고 undefined 를 돌려준다. 중심 점 id 가 없는 개체여도 undefined 이다. [src:정합성 polygon-transform: scripts/pipeline/semantic/polygon-transform.mjs 의 시험 '원본 자리에 슬라이더, 벡터, 없는 id, 이름 문자열을 넣으면 개체를 만들지 않는다(undefined)', '중심 자리에 없는 id 를 넣으면 개체를 만들지 않는다(undefined)']"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "transform.lineSymmetry",
   "path": [
    "transform",
    "lineSymmetry"
   ],
   "params": [
    {
     "name": "originObjectID",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      },
      {
       "type": "linear"
      },
      {
       "type": "circle"
      },
      {
       "type": "chord"
      },
      {
       "type": "polygon"
      },
      {
       "type": "ellipse"
      },
      {
       "type": "polynomial"
      }
     ]
    },
    {
     "name": "linearID",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "linear"
      },
      {
       "type": "axis"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "packages-base/transform-factory.ts",
   "usage": [
    "용도(도구 UI 설명): 선대칭 — 대칭시킬 대상을 선택한 후 기준선을 선택하세요. [src:base2d-ui/src/tab/tools/configs/base2d-geometry.ts:517]",
    "호출: factory.transform.lineSymmetry → advanced.createLineSymmetryObject [src:mathcore-api/object-factory/packages-base/transform-factory.ts:15-20] [src:base2d/base-advanced-api/index.ts:6682-6692]",
    "앞에 있어야 하는 것: originObjectID = 아무 개체 [src:mathcore-api/object-factory/packages-base/transform-factory.ts:15-20]",
    "앞에 있어야 하는 것: linearID = linear [src:mathcore-api/object-factory/packages-base/transform-factory.ts:15-20]",
    "만드는 것, 조건부(true 그리고 targetObject?.data.type === POINT_TYPE): point(auxiliary) 1개 (경유 createTransformObject → duplicate → createAuxiliaryPoint) [src:base2d/base-advanced-api/index.ts:2556] — 보임(기본값) [src:object-manager/objects/point.ts:91], 크기 9(configs.pointSize) [src:base2d/base-advanced-api/configs.ts:85], 색 #6e6868(configs.intersectionPointColor) [src:base2d/base-advanced-api/configs.ts:112]",
    "함께 생김, 조건부(true 그리고 targetObject?.data.type === POINT_TYPE): text(nameText) 1개 (경유 createTransformObject → duplicate → createAuxiliaryPoint → createNameText) [src:base2d/base-advanced-api/index.ts:3266] — 보임(기본값) [src:object-manager/objects/text.ts:63], 위치 오프셋(화면 px) [16, -16] [src:base2d/base-advanced-api/index.ts:3268], 크기 16(configs.nametextSize) [src:base2d/base-advanced-api/configs.ts:92], 글꼴 'KaTeX'(configs.nametextFont) [src:base2d/base-advanced-api/configs.ts:94], 색 #000(configs.nametextColor) [src:base2d/base-advanced-api/configs.ts:93], 매인 개체 [point.id] [src:base2d/base-advanced-api/index.ts:3269]",
    "다른 갈래에서 대신 만드는 것, 조건부(targetObject?.data.type === POINT_TYPE): point(point) 1개 (경유 createTransformObject → duplicate → createPoint) [src:base2d/base-advanced-api/index.ts:2479] — 보임(기본값) [src:object-manager/objects/point.ts:91], 크기 9(configs.pointSize) [src:base2d/base-advanced-api/configs.ts:85], 색 #fe7701(configs.pointColor) [src:base2d/base-advanced-api/configs.ts:86]",
    "다른 갈래에서 대신 만드는 것, 조건부(targetObject?.data.type === POINT_TYPE): text(nameText) 1개 (경유 createTransformObject → duplicate → createPoint → createNameText) [src:base2d/base-advanced-api/index.ts:3266] — 보임(기본값) [src:object-manager/objects/text.ts:63], 위치 오프셋(화면 px) [16, -16] [src:base2d/base-advanced-api/index.ts:3268], 크기 16(configs.nametextSize) [src:base2d/base-advanced-api/configs.ts:92], 글꼴 'KaTeX'(configs.nametextFont) [src:base2d/base-advanced-api/configs.ts:94], 색 #000(configs.nametextColor) [src:base2d/base-advanced-api/configs.ts:93], 매인 개체 [point.id] [src:base2d/base-advanced-api/index.ts:3269]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'segment' 그리고 targetObject?.data.type === LINEAR_TYPE): linear(segment) 1개 (경유 createTransformObject → duplicate → createSegment → createLinear) [src:base2d/base-advanced-api/index.ts:3358] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 null as null | Color(configs.linearColor) [src:base2d/base-advanced-api/configs.ts:127], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [p1.id, p2.id] [src:base2d/base-advanced-api/index.ts:3362]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'line' 그리고 targetObject?.data.type === LINEAR_TYPE): linear(line) 1개 (경유 createTransformObject → duplicate → createLine → createLinear) [src:base2d/base-advanced-api/index.ts:3358] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 null as null | Color(configs.linearColor) [src:base2d/base-advanced-api/configs.ts:127], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [p1.id, p2.id] [src:base2d/base-advanced-api/index.ts:3362]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'ray' 그리고 targetObject?.data.type === LINEAR_TYPE): linear(ray) 1개 (경유 createTransformObject → duplicate → createRay → createLinear) [src:base2d/base-advanced-api/index.ts:3358] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 null as null | Color(configs.linearColor) [src:base2d/base-advanced-api/configs.ts:127], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [p1.id, p2.id] [src:base2d/base-advanced-api/index.ts:3362]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'perpendicular' 그리고 targetObject?.data.type === LINEAR_TYPE): linear(perpendicular) 1개 (경유 createTransformObject → duplicate → createPerpendicular → createLinear) [src:base2d/base-advanced-api/index.ts:3358] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 null as null | Color(configs.linearColor) [src:base2d/base-advanced-api/configs.ts:127], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [l, p.id] [src:base2d/base-advanced-api/index.ts:3362]",
    "다른 갈래에서 대신 만드는 것, 조건부(l?.data.type === LINEAR_TYPE 그리고 case 'perpendicularAtMidpoint' 그리고 targetObject?.data.type === LINEAR_TYPE): linear(perpendicularAtMidpoint) 1개 (경유 createTransformObject → duplicate → createPerpendicularAtMidpointBySegmentID → createLinear) [src:base2d/base-advanced-api/index.ts:3358] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 null as null | Color(configs.linearColor) [src:base2d/base-advanced-api/configs.ts:127], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [l.data.id] [src:base2d/base-advanced-api/index.ts:3362]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'perpendicularAtMidpoint' 그리고 targetObject?.data.type === LINEAR_TYPE): linear(perpendicularAtMidpoint) 1개 (경유 createTransformObject → duplicate → createPerpendicularAtMidpointByTwoPointID → createLinear) [src:base2d/base-advanced-api/index.ts:3358] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 null as null | Color(configs.linearColor) [src:base2d/base-advanced-api/configs.ts:127], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [p1.id, p2.id] [src:base2d/base-advanced-api/index.ts:3362]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'bisectorLine' 그리고 targetObject?.data.type === LINEAR_TYPE): linear(bisectorLine) 1개 (경유 createTransformObject → duplicate → createBisectorLine → createLinear) [src:base2d/base-advanced-api/index.ts:3358] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 null as null | Color(configs.linearColor) [src:base2d/base-advanced-api/configs.ts:127], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [p1.id, p2.id, p3.id] [src:base2d/base-advanced-api/index.ts:3362]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'tangentLine' 그리고 targetObject?.data.type === LINEAR_TYPE): point(point) 여러 개(반복문) (경유 createTransformObject → duplicate → createPoint) [src:base2d/base-advanced-api/index.ts:2479] — 보임(기본값) [src:object-manager/objects/point.ts:91], 크기 9(configs.pointSize) [src:base2d/base-advanced-api/configs.ts:85], 색 #fe7701(configs.pointColor) [src:base2d/base-advanced-api/configs.ts:86]",
    "다른 갈래에서 대신 만드는 것, 조건부(r1?.data.type === POINT_TYPE && r2?.data.type ===… 그리고 case 'parallel' 그리고 targetObject?.data.type === LINEAR_TYPE): linear(parallel) 1개 (경유 createTransformObject → duplicate → createParallel → createLinear) [src:base2d/base-advanced-api/index.ts:3358] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 null as null | Color(configs.linearColor) [src:base2d/base-advanced-api/configs.ts:127], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [newPoint.id, r2.data.id] [src:base2d/base-advanced-api/index.ts:3362]",
    "다른 갈래에서 대신 만드는 것, 조건부(r1?.data.type === LINEAR_TYPE && r2?.data.type ==… 그리고 case 'parallel' 그리고 targetObject?.data.type === LINEAR_TYPE): linear(parallel) 1개 (경유 createTransformObject → duplicate → createParallel → createLinear) [src:base2d/base-advanced-api/index.ts:3358] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 null as null | Color(configs.linearColor) [src:base2d/base-advanced-api/configs.ts:127], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [newPoint.id, r1.data.id] [src:base2d/base-advanced-api/index.ts:3362]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'circleCenterPoint' 그리고 targetObject?.data.type === CIRCLE_TYPE): circle(circleCenterPoint) 1개 (경유 createTransformObject → duplicate → createCircleCenterPoint) [src:base2d/base-advanced-api/index.ts:3761] — 보임(기본값) [src:object-manager/objects/circle.ts:79], 색 null as null | Color(configs.circleColor) [src:base2d/base-advanced-api/configs.ts:128], 매인 개체 [p1.id, p2.id] [src:base2d/base-advanced-api/index.ts:3768]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'circleCenterRadius' 그리고 targetObject?.data.type === CIRCLE_TYPE): circle(circleCenterRadius) 1개 (경유 createTransformObject → duplicate → createCircleCenterRadius) [src:base2d/base-advanced-api/index.ts:3738] — 보임(기본값) [src:object-manager/objects/circle.ts:79], 색 null as null | Color(configs.circleColor) [src:base2d/base-advanced-api/configs.ts:128], 매인 개체 [p.id] [src:base2d/base-advanced-api/index.ts:3746]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'triangleCircumCircle' 그리고 targetObject?.data.type === CIRCLE_TYPE): circle(triangleCircumCircle) 1개 (경유 createTransformObject → duplicate → createCircleTriangleCircumCircle) [src:base2d/base-advanced-api/index.ts:3864] — 보임(기본값) [src:object-manager/objects/circle.ts:79], 색 null as null | Color(configs.circleColor) [src:base2d/base-advanced-api/configs.ts:128], 매인 개체 [p1.id, p2.id, p3.id] [src:base2d/base-advanced-api/index.ts:3871]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'triangleCircumArc' 그리고 targetObject?.data.type === CIRCLE_TYPE): circle(triangleCircumArc) 1개 (경유 createTransformObject → duplicate → createTriangleCircumArc) [src:base2d/base-advanced-api/index.ts:3925] — 보임(기본값) [src:object-manager/objects/circle.ts:79], 색 null as null | Color(configs.circleColor) [src:base2d/base-advanced-api/configs.ts:128], 매인 개체 [p1.id, p2.id, p3.id] [src:base2d/base-advanced-api/index.ts:3932]",
    "다른 갈래에서 대신 만드는 것, 조건부(o1?.data.type === CIRCLE_TYPE 그리고 case 'compass' 그리고 targetObject?.data.type === CIRCLE_TYPE): circle(compass) 1개 (경유 createTransformObject → duplicate → createCompassByCircle → createCompassBySegment) [src:base2d/base-advanced-api/index.ts:3988] — 보임(기본값) [src:object-manager/objects/circle.ts:79], 색 null as null | Color(configs.circleColor) [src:base2d/base-advanced-api/configs.ts:128], 매인 개체 [o.relatedObjects[0], p.id] [src:base2d/base-advanced-api/index.ts:3995]",
    "다른 갈래에서 대신 만드는 것, 조건부(o1?.data.type === LINEAR_TYPE 그리고 case 'compass' 그리고 targetObject?.data.type === CIRCLE_TYPE): circle(compass) 1개 (경유 createTransformObject → duplicate → createCompassBySegment) [src:base2d/base-advanced-api/index.ts:3988] — 보임(기본값) [src:object-manager/objects/circle.ts:79], 색 null as null | Color(configs.circleColor) [src:base2d/base-advanced-api/configs.ts:128], 매인 개체 [o.relatedObjects[0], p.id] [src:base2d/base-advanced-api/index.ts:3995]",
    "다른 갈래에서 대신 만드는 것, 조건부(o1?.data.type === POINT_TYPE 그리고 case 'compass' 그리고 targetObject?.data.type === CIRCLE_TYPE): circle(compass) 1개 (경유 createTransformObject → duplicate → createCompassByThreePoint) [src:base2d/base-advanced-api/index.ts:3960] — 보임(기본값) [src:object-manager/objects/circle.ts:79], 색 null as null | Color(configs.circleColor) [src:base2d/base-advanced-api/configs.ts:128], 매인 개체 [o.relatedObjects[0], o.relatedObjects[1], p.id] [src:base2d/base-advanced-api/index.ts:3967]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'arc' 그리고 targetObject?.data.type === CIRCLE_TYPE): circle(arc) 1개 (경유 createTransformObject → duplicate → createArc) [src:base2d/base-advanced-api/index.ts:4023] — 보임(기본값) [src:object-manager/objects/circle.ts:79], 색 null as null | Color(configs.circleColor) [src:base2d/base-advanced-api/configs.ts:128], 매인 개체 [p1.id, p2.id, p3.id, auxiliaryPointID] [src:base2d/base-advanced-api/index.ts:4030]",
    "다른 갈래에서 대신 만드는 것, 조건부(isLineSymmetry 그리고 case 'fan' 그리고 targetObject?.data.type === CIRCLE_TYPE): linear(segment) 여러 개(반복문) (경유 createTransformObject → duplicate → createFan → createAuxiliarySegment) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [p1.id, auxiliaryPointID] [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(!(isLineSymmetry) 그리고 case 'fan' 그리고 targetObject?.data.type === CIRCLE_TYPE): linear(segment) 1개 (경유 createTransformObject → duplicate → createFan → createAuxiliarySegment) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [p1.id, p2.id] [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'fan' 그리고 targetObject?.data.type === CIRCLE_TYPE): circle(fan) 1개 (경유 createTransformObject → duplicate → createFan) [src:base2d/base-advanced-api/index.ts:4133] — 보임(기본값) [src:object-manager/objects/circle.ts:79], 색 color [src:base2d/base-advanced-api/index.ts:4136], 매인 개체 [ p1.id, p2.id, p3.id, auxiliaryPointID, auxiliar… [src:base2d/base-advanced-api/index.ts:4143]",
    "다른 갈래에서 대신 만드는 것, 조건부(isLineSymmetry 그리고 case 'segmentOfACircle' 그리고 targetObject?.data.type === CIRCLE_TYPE): linear(segment) 1개 (경유 createTransformObject → duplicate → createSegmentOfACircle → createAuxiliarySegment) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [p3.id, auxiliaryPointID] [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(!(isLineSymmetry) 그리고 case 'segmentOfACircle' 그리고 targetObject?.data.type === CIRCLE_TYPE): linear(segment) 1개 (경유 createTransformObject → duplicate → createSegmentOfACircle → createAuxiliarySegment) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [p2.id, auxiliaryPointID] [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'segmentOfACircle' 그리고 targetObject?.data.type === CIRCLE_TYPE): circle(segmentOfACircle) 1개 (경유 createTransformObject → duplicate → createSegmentOfACircle) [src:base2d/base-advanced-api/index.ts:4192] — 보임(기본값) [src:object-manager/objects/circle.ts:79], 색 color [src:base2d/base-advanced-api/index.ts:4195], 매인 개체 [ p1.id, p2.id, p3.id, auxiliaryPointID, auxiliar… [src:base2d/base-advanced-api/index.ts:4199]",
    "다른 갈래에서 대신 만드는 것, 조건부(props && props.vertexPoints && props.vertexPoints… 그리고 case 'polygon' 그리고 targetObject?.data.type === POLYGON_TYPE): linear(segment) 여러 개(반복문) (경유 createTransformObject → duplicate → createPolygon → createPolygon2 → createAuxiliarySegment(반복)) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [props.vertexPoints[i], props.vertexPoints[i + 1]] [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'polygon' 그리고 targetObject?.data.type === POLYGON_TYPE): polygon(polygon) 1개 (경유 createTransformObject → duplicate → createPolygon → createPolygon2) [src:base2d/base-advanced-api/index.ts:747] — 보임(기본값) [src:object-manager/objects/polygon.ts:85], 색 color [src:base2d/base-advanced-api/index.ts:695], 매인 개체 [...pointIDs, pointIDs[0]] [src:base2d/base-advanced-api/index.ts:690]",
    "다른 갈래에서 대신 만드는 것, 조건부(props && props.numberOfSides && props.vertexPoint… 그리고 case 'cpPolygon' 그리고 targetObject?.data.type === POLYGON_TYPE): linear(segment) 1개 (경유 createTransformObject → duplicate → createCPPolygon → createCPPolygon2 → createAuxiliarySegment) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [props.auxiliaryPoints[props.auxiliaryPoints.leng… [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'cpPolygon' 그리고 targetObject?.data.type === POLYGON_TYPE): polygon(cpPolygon) 1개 (경유 createTransformObject → duplicate → createCPPolygon → createCPPolygon2) [src:base2d/base-advanced-api/index.ts:1589] — 보임(기본값) [src:object-manager/objects/polygon.ts:85], 색 color [src:base2d/base-advanced-api/index.ts:1526], 매인 개체 [p1.id, p2.id] [src:base2d/base-advanced-api/index.ts:1513]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'lateralPolygon' 그리고 targetObject?.data.type === POLYGON_TYPE): polygon(lateralPolygon) 1개 (경유 createTransformObject → duplicate → createLateralPolygon → createLateralPolygon2) [src:base2d/base-advanced-api/index.ts:1734] — 보임(기본값) [src:object-manager/objects/polygon.ts:85], 색 color [src:base2d/base-advanced-api/index.ts:1669], 매인 개체 [p1.id, p2.id] [src:base2d/base-advanced-api/index.ts:1656]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'rigidPolygon' 그리고 targetObject?.data.type === POLYGON_TYPE): polygon(rigidPolygon) 1개 (경유 createTransformObject → duplicate → createRigidPolygon → createRigidPolygon2) [src:base2d/base-advanced-api/index.ts:1876] — 보임(기본값) [src:object-manager/objects/polygon.ts:85], 색 color [src:base2d/base-advanced-api/index.ts:1812], 매인 개체 [p1.id, p2.id] [src:base2d/base-advanced-api/index.ts:1799]",
    "다른 갈래에서 대신 만드는 것, 조건부(props.hasPolygonDependentPoint 그리고 props && props.relatedObjects && props.relatedObj… 그리고 case 'isoscelesTriangle' 그리고 targetObject?.data.type === POLYGON_TYPE): linear(segment) 여러 개(반복문) (경유 createTransformObject → duplicate → createIsoscelesTriangle → createIsoscelesTriangle2 → createAuxiliarySegment) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [props.relatedObjects[0], props.relatedObjects[1]] [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(!(props.hasPolygonDependentPoint) 그리고 props && props.relatedObjects && props.relatedObj… 그리고 case 'isoscelesTriangle' 그리고 targetObject?.data.type === POLYGON_TYPE): linear(segment) 여러 개(반복문) (경유 createTransformObject → duplicate → createIsoscelesTriangle → createIsoscelesTriangle2 → createAuxiliarySegment) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [props.relatedObjects[0], props.relatedObjects[2]] [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'isoscelesTriangle' 그리고 targetObject?.data.type === POLYGON_TYPE): polygon(isoscelesTriangle) 1개 (경유 createTransformObject → duplicate → createIsoscelesTriangle → createIsoscelesTriangle2) [src:base2d/base-advanced-api/index.ts:863] — 보임(기본값) [src:object-manager/objects/polygon.ts:85], 매인 개체 [p1.id, p2.id, p3.id] [src:base2d/base-advanced-api/index.ts:754]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'rightTriangle' 그리고 targetObject?.data.type === POLYGON_TYPE): polygon(rightTriangle) 1개 (경유 createTransformObject → duplicate → createRightTriangle → createRightTriangle2) [src:base2d/base-advanced-api/index.ts:984] — 보임(기본값) [src:object-manager/objects/polygon.ts:85], 매인 개체 [p1.id, p2.id, p3.id] [src:base2d/base-advanced-api/index.ts:875]",
    "다른 갈래에서 대신 만드는 것, 조건부(!(props.hasPolygonDependentPoint) 그리고 props && props.relatedObjects && props.relatedObj… 그리고 case 'rectangle' 그리고 targetObject?.data.type === POLYGON_TYPE): linear(segment) 여러 개(반복문) (경유 createTransformObject → duplicate → createRectangle → createRectangle2 → createAuxiliarySegment) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [props.relatedObjects[0], props.auxiliaryPoints[0… [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'rectangle' 그리고 targetObject?.data.type === POLYGON_TYPE): polygon(rectangle) 1개 (경유 createTransformObject → duplicate → createRectangle → createRectangle2) [src:base2d/base-advanced-api/index.ts:1217] — 보임(기본값) [src:object-manager/objects/polygon.ts:85], 매인 개체 [p1.id, p2.id, p3.id] [src:base2d/base-advanced-api/index.ts:1099]",
    "다른 갈래에서 대신 만드는 것, 조건부(i === 0 그리고 props && props.relatedObjects && props.relatedObj… 그리고 case 'parallelogram' 그리고 targetObject?.data.type === POLYGON_TYPE): linear(segment) 여러 개(반복문) (경유 createTransformObject → duplicate → createParallelogram → createParallelogram2 → createAuxiliarySegment(반복)) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [props.relatedObjects[0], props.relatedObjects[1]] [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(i === 1 그리고 !(i === 0) 그리고 props && props.relatedObjects && props.relatedObj… 그리고 case 'parallelogram' 그리고 targetObject?.data.type === POLYGON_TYPE): linear(segment) 여러 개(반복문) (경유 createTransformObject → duplicate → createParallelogram → createParallelogram2 → createAuxiliarySegment(반복)) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [props.relatedObjects[1], props.relatedObjects[2]] [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(i === 2 그리고 !(i === 1) 그리고 !(i === 0) 그리고 props && props.relatedObjects && props.relatedObj… 그리고 case 'parallelogram' 그리고 targetObject?.data.type === POLYGON_TYPE): linear(segment) 여러 개(반복문) (경유 createTransformObject → duplicate → createParallelogram → createParallelogram2 → createAuxiliarySegment(반복)) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [props.relatedObjects[2], props.auxiliaryPoints[0… [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(i === 3 그리고 !(i === 2) 그리고 !(i === 1) 그리고 !(i === 0) 그리고 props && props.relatedObjects && props.relatedObj… 그리고 case 'parallelogram' 그리고 targetObject?.data.type === POLYGON_TYPE): linear(segment) 여러 개(반복문) (경유 createTransformObject → duplicate → createParallelogram → createParallelogram2 → createAuxiliarySegment(반복)) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [props.auxiliaryPoints[0], props.relatedObjects[0… [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'parallelogram' 그리고 targetObject?.data.type === POLYGON_TYPE): polygon(parallelogram) 1개 (경유 createTransformObject → duplicate → createParallelogram → createParallelogram2) [src:base2d/base-advanced-api/index.ts:1092] — 보임(기본값) [src:object-manager/objects/polygon.ts:85], 매인 개체 [p1.id, p2.id, p3.id] [src:base2d/base-advanced-api/index.ts:991]",
    "다른 갈래에서 대신 만드는 것, 조건부(!(props.hasPolygonDependentPoint) 그리고 props && props.relatedObjects && props.relatedObj… 그리고 case 'rhombus' 그리고 targetObject?.data.type === POLYGON_TYPE): linear(segment) 1개 (경유 createTransformObject → duplicate → createRhombus → createRhombus2 → createAuxiliarySegment) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [props.auxiliaryPoints[0], props.auxiliaryPoints[… [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'rhombus' 그리고 targetObject?.data.type === POLYGON_TYPE): polygon(rhombus) 1개 (경유 createTransformObject → duplicate → createRhombus → createRhombus2) [src:base2d/base-advanced-api/index.ts:1352] — 보임(기본값) [src:object-manager/objects/polygon.ts:85], 매인 개체 [p1.id, p2.id, p3.id] [src:base2d/base-advanced-api/index.ts:1229]",
    "다른 갈래에서 대신 만드는 것, 조건부(props.hasPolygonDependentPoint 그리고 props && props.relatedObjects && props.relatedObj… 그리고 case 'trapezoid' 그리고 targetObject?.data.type === POLYGON_TYPE): linear(segment) 여러 개(반복문) (경유 createTransformObject → duplicate → createTrapezoid → createTrapezoid2 → createAuxiliarySegment) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [props.relatedObjects[2], props.relatedObjects[3]] [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(!(props.hasPolygonDependentPoint) 그리고 props && props.relatedObjects && props.relatedObj… 그리고 case 'trapezoid' 그리고 targetObject?.data.type === POLYGON_TYPE): linear(segment) 1개 (경유 createTransformObject → duplicate → createTrapezoid → createTrapezoid2 → createAuxiliarySegment) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [props.relatedObjects[1], props.auxiliaryPoints[0… [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'trapezoid' 그리고 targetObject?.data.type === POLYGON_TYPE): polygon(trapezoid) 1개 (경유 createTransformObject → duplicate → createTrapezoid → createTrapezoid2) [src:base2d/base-advanced-api/index.ts:1493] — 보임(기본값) [src:object-manager/objects/polygon.ts:85], 매인 개체 [p1.id, p2.id, p3.id, p4.id] [src:base2d/base-advanced-api/index.ts:1365]",
    "다른 갈래에서 대신 만드는 것, 조건부(targetObject?.data.type === TEXT_TYPE): text 1개 (경유 createTransformObject → duplicate → createText) [src:base2d/base-advanced-api/index.ts:3203] — 보임(기본값) [src:object-manager/objects/text.ts:63], 크기 o.size [src:base2d/base-advanced-api/index.ts:3207], 글꼴 o.font! [src:base2d/base-advanced-api/index.ts:3208], 색 #000(configs.textColor) [src:base2d/base-advanced-api/configs.ts:90], latex=o.latex [src:base2d/base-advanced-api/index.ts:3206], isScreenCoord=true [src:base2d/base-advanced-api/index.ts:3212]",
    "다른 갈래에서 대신 만드는 것, 조건부(targetObject?.data.type === DRAWING_TYPE): drawing 1개 (경유 createTransformObject → duplicate → createDrawingObject) [src:base2d/base-advanced-api/index.ts:4233] — 보임(공통 기본값) [src:object-manager/objects/common.ts:38], 색 null as null | Color(configs.drawingColor) [src:base2d/base-advanced-api/configs.ts:130], 선 두께 2(configs.drawingStrokeWidth) [src:base2d/base-advanced-api/configs.ts:135]",
    "다른 갈래에서 대신 만드는 것, 조건부(targetObject?.data.type === IMAGE_TYPE): image 1개 (경유 createTransformObject → duplicate → createImage) [src:base2d/base-advanced-api/index.ts:4371] — 보임(기본값) [src:object-manager/objects/image.ts:37], isScreenCoord=false [src:base2d/base-advanced-api/index.ts:4378]",
    "다른 갈래에서 대신 만드는 것, 조건부(targetObject?.data.type === ELLIPSE_TYPE): ellipse 1개 (경유 createTransformObject → duplicate → createEllipse) [src:base2d/base-advanced-api/index.ts:3876] — 보임(기본값) [src:object-manager/objects/ellipse.ts:52], 색 null as null | Color(configs.circleColor) [src:base2d/base-advanced-api/configs.ts:128], 매인 개체 [p1.id, p2.id, p3.id] [src:base2d/base-advanced-api/index.ts:3882]",
    "다른 갈래에서 대신 만드는 것, 조건부(this.typingParser.isValid() 그리고 targetObject?.data.type === POLYNOMIAL_TYPE): polynomial 1개 (경유 createTransformObject → duplicate → createAlgebraicObject) [src:base2d/base-advanced-api/index.ts:2281] — 보임(기본값) [src:object-manager/objects/polynomial.ts:64], 색 null as null | Color(configs.algebraicColor) [src:base2d/base-advanced-api/configs.ts:131], 선 두께 2(configs.algebraicStrokeWidth) [src:base2d/base-advanced-api/configs.ts:137]",
    "다른 갈래에서 대신 만드는 것, 조건부(this.typingParser.isValid() 그리고 targetObject?.data.type === POLYNOMIAL_TYPE): text(nameText) 1개 (경유 createTransformObject → duplicate → createAlgebraicObject → createNameTextByPolynomial) [src:base2d/base-advanced-api/index.ts:3339] — 숨김 [src:base2d/base-advanced-api/index.ts:3349], 위치 오프셋(화면 px) [24, -24] || [16, -16] [src:base2d/base-advanced-api/index.ts:3341], 크기 16(configs.nametextSize) [src:base2d/base-advanced-api/configs.ts:92], 색 #000(configs.nametextColor) [src:base2d/base-advanced-api/configs.ts:93], latex=true [src:base2d/base-advanced-api/index.ts:3350], 매인 개체 [object.id] [src:base2d/base-advanced-api/index.ts:3342]",
    "다른 갈래에서 대신 만드는 것, 조건부(this.typingLexer.isEmpty() 그리고 this.typingLexer.process(o.expr) 그리고 targetObject?.data.type === POLYNOMIAL_TYPE): polynomial 1개 (경유 createTransformObject → duplicate → createAlgebraicObject) [src:base2d/base-advanced-api/index.ts:2299] — 보임(기본값) [src:object-manager/objects/polynomial.ts:64], 색 null as null | Color(configs.algebraicColor) [src:base2d/base-advanced-api/configs.ts:131], 선 두께 2(configs.algebraicStrokeWidth) [src:base2d/base-advanced-api/configs.ts:137]",
    "다른 갈래에서 대신 만드는 것, 조건부(firstToken.type === TokenType.OPENING_PAREN && la… 그리고 this.typingLexer.process(o.expr) 그리고 targetObject?.data.type === POLYNOMIAL_TYPE): point(point) 1개 (경유 createTransformObject → duplicate → createAlgebraicObject → createPoint) [src:base2d/base-advanced-api/index.ts:2479] — 보임(기본값) [src:object-manager/objects/point.ts:91], 크기 9(configs.pointSize) [src:base2d/base-advanced-api/configs.ts:85], 색 #fe7701(configs.pointColor) [src:base2d/base-advanced-api/configs.ts:86]",
    "다른 갈래에서 대신 만드는 것, 조건부(this.typingLexer.process(o.expr) 그리고 targetObject?.data.type === POLYNOMIAL_TYPE): polynomial 1개 (경유 createTransformObject → duplicate → createAlgebraicObject) [src:base2d/base-advanced-api/index.ts:2327] — 보임(기본값) [src:object-manager/objects/polynomial.ts:64], 색 null as null | Color(configs.algebraicColor) [src:base2d/base-advanced-api/configs.ts:131], 선 두께 2(configs.algebraicStrokeWidth) [src:base2d/base-advanced-api/configs.ts:137]",
    "다른 갈래에서 대신 만드는 것, 조건부(targetObject?.data.type === POLYNOMIAL_TYPE): polynomial 1개 (경유 createTransformObject → duplicate → createAlgebraicObject) [src:base2d/base-advanced-api/index.ts:2344] — 보임(기본값) [src:object-manager/objects/polynomial.ts:64], 색 null as null | Color(configs.algebraicColor) [src:base2d/base-advanced-api/configs.ts:131], 선 두께 2(configs.algebraicStrokeWidth) [src:base2d/base-advanced-api/configs.ts:137]",
    "참고: 원본은 그대로 두고 같은 종류의 복사본이 선다 [src:docs/palette/polygon-transform.md:28]",
    "참고: linearID 가 선분이면 선분이 놓인 직선 전체가 축이고 축 위의 점은 제자리에 선다. 좌표축은 문자열 0:xAxis, 0:yAxis 로 가리킨다. [src:정합성 polygon-transform: scripts/pipeline/semantic/polygon-transform.mjs 의 시험 '축이 선분이면 선분이 놓인 직선을 축으로 한다(점 P 의 상)', '축 위의 점은 제자리', '좌표축 문자열 \"0:xAxis\" / 원본 ...', '파이프라인: 좌표축 id \"0:xAxis\" 를 축으로 받아 ...']",
    "참고: 화면 도구는 원본을 누르고 선(또는 x축, y축)을 누르면 같은 호출(원본, 선)을 하며 점 등 선이 아닌 것을 누르면 무시하고 기다린다. 모달은 없다. [src:정합성 polygon-transform: /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d-tools/src/tools/math2d-tools/tool-line-symmetry.ts:54-90, /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d-ui/src/tab/tools/configs/base2d-geometry.ts:514, /root/dev/git.cemware.com/mathcore/mathcore-api/src/app/math2d/tool-manager.ts:125 ; 캔버스 재현 scripts/pipeline/semantic/polygon-transform.mjs 의 시험 '캔버스: 두 번째 클릭이 x축 위이면 x축이 선이 되어 ...', '캔버스: 선 자리에 점을 누르면 선택되지 않고 아무것도 서지 않는다']",
    "생성 결과: 원본과 같은 종류의 복사본 개체 1개가 서고 반환 id 가 그 복사본이다(점은 보조 점, 선분과 직선은 linear, 원과 호와 부채꼴은 circle, 다각형은 같은 category 의 polygon, 대수 곡선은 polynomial). 다각형 복사본은 꼭짓점 보조 점과 변 선분도 새로 서고 원본은 바뀌지 않는다. [src:정합성 polygon-transform: scripts/pipeline/semantic/polygon-transform.mjs 의 시험 '같은 type(point|linear|circle|polygon|polynomial) 복사본이 유효로 선다', '원본 id 와 다른 새 개체이고 원본은 그대로', '원본의 RO 에 복사본 id 가 더해진다' (원본 점, 선분, 직선, 원, 호, 부채꼴, 삼각형, 직사각형, 정오각형, 곡선 등) 와 기록 '원본 category ... 복사본 category auxiliary']"
   ],
   "range": [
    "originObjectID: 형식 String [src:mathcore-api/object-factory/packages-base/transform-factory.ts:16] [src:mathcore-api/object-factory/object-types.ts:92]",
    "linearID: 형식 String [src:mathcore-api/object-factory/packages-base/transform-factory.ts:17] [src:mathcore-api/object-factory/object-types.ts:92]",
    "name?: 형식 String | Undefined [src:mathcore-api/object-factory/packages-base/transform-factory.ts:18] [src:mathcore-api/object-factory/object-types.ts:93]; 생략하면 this.getNewObjectName()(createLinear) [src:base2d/base-advanced-api/index.ts:3363]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): traceColor=undefined, shape=PointShape.Circle, imoji=0, position=[0, 0], domain='점', angle=0 [src:object-manager/objects/point.ts:93-99]",
    "조용히 끝남(만들지 않음): [...pointIDs, pointIDs[0]].length < 3 이면 undefined 반환 [src:base2d/base-advanced-api/index.ts:685]",
    "조용히 끝남(만들지 않음): props.color === undefined 이면 undefined 반환 [src:base2d/base-advanced-api/index.ts:707]",
    "조용히 끝남(만들지 않음): o.numberOfSides < 3 이면 undefined 반환 [src:base2d/base-advanced-api/index.ts:1506]",
    "조용히 끝남(만들지 않음): props.color === undefined 이면 undefined 반환 [src:base2d/base-advanced-api/index.ts:1546]",
    "조용히 끝남(만들지 않음): o.numberOfSides < 3 이면 undefined 반환 [src:base2d/base-advanced-api/index.ts:1649]",
    "조용히 끝남(만들지 않음): props.color === undefined 이면 undefined 반환 [src:base2d/base-advanced-api/index.ts:1688]",
    "조용히 끝남(만들지 않음): props.color === undefined 이면 undefined 반환 [src:base2d/base-advanced-api/index.ts:1830]",
    "조용히 끝남(만들지 않음): props.color === undefined 이면 undefined 반환 [src:base2d/base-advanced-api/index.ts:822]",
    "조용히 끝나는 조건 외 5곳 (경유 createRightTriangle2, createRectangle2, createParallelogram2, createRhombus2, createTrapezoid2) [src:base2d/base-advanced-api/index.ts:943] [src:base2d/base-advanced-api/index.ts:1169] [src:base2d/base-advanced-api/index.ts:1038] [src:base2d/base-advanced-api/index.ts:1300] [src:base2d/base-advanced-api/index.ts:1441]",
    "원본 id 가 없는 개체이거나 복제할 수 없는 종류(슬라이더, 벡터)이면 개체를 만들지 않고 undefined 를 돌려준다. 축 id 가 없는 개체이거나 0:xAxis, 0:yAxis 가 아닌 임의 문자열이어도 undefined 이다. [src:정합성 polygon-transform: scripts/pipeline/semantic/polygon-transform.mjs 의 시험 '원본 자리에 슬라이더, 벡터, 없는 id, 이름 문자열을 넣으면 개체를 만들지 않는다(undefined)', '축 자리에 없는 id 를 넣으면 ...', '임의 문자열 축은 개체를 만들지 않는다(undefined)']"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "transform.rotation",
   "path": [
    "transform",
    "rotation"
   ],
   "params": [
    {
     "name": "originObjectID",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      },
      {
       "type": "linear"
      },
      {
       "type": "circle"
      },
      {
       "type": "chord"
      },
      {
       "type": "polygon"
      },
      {
       "type": "ellipse"
      },
      {
       "type": "polynomial"
      }
     ]
    },
    {
     "name": "pointID",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "angle",
     "type": "number|string",
     "optional": false
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "packages-base/transform-factory.ts",
   "usage": [
    "용도(도구 UI 설명): 회전이동 — 회전시킬 대상을 선택한 후 기준점을 선택하여 회전할 각도를 입력하세요. [src:base2d-ui/src/tab/tools/configs/base2d-geometry.ts:487]",
    "호출: factory.transform.rotation → advanced.createRotationObject [src:mathcore-api/object-factory/packages-base/transform-factory.ts:22-28] [src:base2d/base-advanced-api/index.ts:6608-6621]",
    "앞에 있어야 하는 것: originObjectID = 아무 개체 [src:mathcore-api/object-factory/packages-base/transform-factory.ts:22-28]",
    "앞에 있어야 하는 것: pointID = point [src:mathcore-api/object-factory/packages-base/transform-factory.ts:22-28]",
    "만드는 것, 조건부(true 그리고 targetObject?.data.type === POINT_TYPE): point(auxiliary) 1개 (경유 createTransformObject → duplicate → createAuxiliaryPoint) [src:base2d/base-advanced-api/index.ts:2556] — 보임(기본값) [src:object-manager/objects/point.ts:91], 크기 9(configs.pointSize) [src:base2d/base-advanced-api/configs.ts:85], 색 #6e6868(configs.intersectionPointColor) [src:base2d/base-advanced-api/configs.ts:112]",
    "함께 생김, 조건부(true 그리고 targetObject?.data.type === POINT_TYPE): text(nameText) 1개 (경유 createTransformObject → duplicate → createAuxiliaryPoint → createNameText) [src:base2d/base-advanced-api/index.ts:3266] — 보임(기본값) [src:object-manager/objects/text.ts:63], 위치 오프셋(화면 px) [16, -16] [src:base2d/base-advanced-api/index.ts:3268], 크기 16(configs.nametextSize) [src:base2d/base-advanced-api/configs.ts:92], 글꼴 'KaTeX'(configs.nametextFont) [src:base2d/base-advanced-api/configs.ts:94], 색 #000(configs.nametextColor) [src:base2d/base-advanced-api/configs.ts:93], 매인 개체 [point.id] [src:base2d/base-advanced-api/index.ts:3269]",
    "다른 갈래에서 대신 만드는 것, 조건부(targetObject?.data.type === POINT_TYPE): point(point) 1개 (경유 createTransformObject → duplicate → createPoint) [src:base2d/base-advanced-api/index.ts:2479] — 보임(기본값) [src:object-manager/objects/point.ts:91], 크기 9(configs.pointSize) [src:base2d/base-advanced-api/configs.ts:85], 색 #fe7701(configs.pointColor) [src:base2d/base-advanced-api/configs.ts:86]",
    "다른 갈래에서 대신 만드는 것, 조건부(targetObject?.data.type === POINT_TYPE): text(nameText) 1개 (경유 createTransformObject → duplicate → createPoint → createNameText) [src:base2d/base-advanced-api/index.ts:3266] — 보임(기본값) [src:object-manager/objects/text.ts:63], 위치 오프셋(화면 px) [16, -16] [src:base2d/base-advanced-api/index.ts:3268], 크기 16(configs.nametextSize) [src:base2d/base-advanced-api/configs.ts:92], 글꼴 'KaTeX'(configs.nametextFont) [src:base2d/base-advanced-api/configs.ts:94], 색 #000(configs.nametextColor) [src:base2d/base-advanced-api/configs.ts:93], 매인 개체 [point.id] [src:base2d/base-advanced-api/index.ts:3269]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'segment' 그리고 targetObject?.data.type === LINEAR_TYPE): linear(segment) 1개 (경유 createTransformObject → duplicate → createSegment → createLinear) [src:base2d/base-advanced-api/index.ts:3358] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 null as null | Color(configs.linearColor) [src:base2d/base-advanced-api/configs.ts:127], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [p1.id, p2.id] [src:base2d/base-advanced-api/index.ts:3362]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'line' 그리고 targetObject?.data.type === LINEAR_TYPE): linear(line) 1개 (경유 createTransformObject → duplicate → createLine → createLinear) [src:base2d/base-advanced-api/index.ts:3358] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 null as null | Color(configs.linearColor) [src:base2d/base-advanced-api/configs.ts:127], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [p1.id, p2.id] [src:base2d/base-advanced-api/index.ts:3362]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'ray' 그리고 targetObject?.data.type === LINEAR_TYPE): linear(ray) 1개 (경유 createTransformObject → duplicate → createRay → createLinear) [src:base2d/base-advanced-api/index.ts:3358] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 null as null | Color(configs.linearColor) [src:base2d/base-advanced-api/configs.ts:127], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [p1.id, p2.id] [src:base2d/base-advanced-api/index.ts:3362]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'perpendicular' 그리고 targetObject?.data.type === LINEAR_TYPE): linear(perpendicular) 1개 (경유 createTransformObject → duplicate → createPerpendicular → createLinear) [src:base2d/base-advanced-api/index.ts:3358] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 null as null | Color(configs.linearColor) [src:base2d/base-advanced-api/configs.ts:127], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [l, p.id] [src:base2d/base-advanced-api/index.ts:3362]",
    "다른 갈래에서 대신 만드는 것, 조건부(l?.data.type === LINEAR_TYPE 그리고 case 'perpendicularAtMidpoint' 그리고 targetObject?.data.type === LINEAR_TYPE): linear(perpendicularAtMidpoint) 1개 (경유 createTransformObject → duplicate → createPerpendicularAtMidpointBySegmentID → createLinear) [src:base2d/base-advanced-api/index.ts:3358] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 null as null | Color(configs.linearColor) [src:base2d/base-advanced-api/configs.ts:127], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [l.data.id] [src:base2d/base-advanced-api/index.ts:3362]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'perpendicularAtMidpoint' 그리고 targetObject?.data.type === LINEAR_TYPE): linear(perpendicularAtMidpoint) 1개 (경유 createTransformObject → duplicate → createPerpendicularAtMidpointByTwoPointID → createLinear) [src:base2d/base-advanced-api/index.ts:3358] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 null as null | Color(configs.linearColor) [src:base2d/base-advanced-api/configs.ts:127], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [p1.id, p2.id] [src:base2d/base-advanced-api/index.ts:3362]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'bisectorLine' 그리고 targetObject?.data.type === LINEAR_TYPE): linear(bisectorLine) 1개 (경유 createTransformObject → duplicate → createBisectorLine → createLinear) [src:base2d/base-advanced-api/index.ts:3358] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 null as null | Color(configs.linearColor) [src:base2d/base-advanced-api/configs.ts:127], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [p1.id, p2.id, p3.id] [src:base2d/base-advanced-api/index.ts:3362]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'tangentLine' 그리고 targetObject?.data.type === LINEAR_TYPE): point(point) 여러 개(반복문) (경유 createTransformObject → duplicate → createPoint) [src:base2d/base-advanced-api/index.ts:2479] — 보임(기본값) [src:object-manager/objects/point.ts:91], 크기 9(configs.pointSize) [src:base2d/base-advanced-api/configs.ts:85], 색 #fe7701(configs.pointColor) [src:base2d/base-advanced-api/configs.ts:86]",
    "다른 갈래에서 대신 만드는 것, 조건부(r1?.data.type === POINT_TYPE && r2?.data.type ===… 그리고 case 'parallel' 그리고 targetObject?.data.type === LINEAR_TYPE): linear(parallel) 1개 (경유 createTransformObject → duplicate → createParallel → createLinear) [src:base2d/base-advanced-api/index.ts:3358] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 null as null | Color(configs.linearColor) [src:base2d/base-advanced-api/configs.ts:127], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [newPoint.id, r2.data.id] [src:base2d/base-advanced-api/index.ts:3362]",
    "다른 갈래에서 대신 만드는 것, 조건부(r1?.data.type === LINEAR_TYPE && r2?.data.type ==… 그리고 case 'parallel' 그리고 targetObject?.data.type === LINEAR_TYPE): linear(parallel) 1개 (경유 createTransformObject → duplicate → createParallel → createLinear) [src:base2d/base-advanced-api/index.ts:3358] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 null as null | Color(configs.linearColor) [src:base2d/base-advanced-api/configs.ts:127], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [newPoint.id, r1.data.id] [src:base2d/base-advanced-api/index.ts:3362]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'circleCenterPoint' 그리고 targetObject?.data.type === CIRCLE_TYPE): circle(circleCenterPoint) 1개 (경유 createTransformObject → duplicate → createCircleCenterPoint) [src:base2d/base-advanced-api/index.ts:3761] — 보임(기본값) [src:object-manager/objects/circle.ts:79], 색 null as null | Color(configs.circleColor) [src:base2d/base-advanced-api/configs.ts:128], 매인 개체 [p1.id, p2.id] [src:base2d/base-advanced-api/index.ts:3768]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'circleCenterRadius' 그리고 targetObject?.data.type === CIRCLE_TYPE): circle(circleCenterRadius) 1개 (경유 createTransformObject → duplicate → createCircleCenterRadius) [src:base2d/base-advanced-api/index.ts:3738] — 보임(기본값) [src:object-manager/objects/circle.ts:79], 색 null as null | Color(configs.circleColor) [src:base2d/base-advanced-api/configs.ts:128], 매인 개체 [p.id] [src:base2d/base-advanced-api/index.ts:3746]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'triangleCircumCircle' 그리고 targetObject?.data.type === CIRCLE_TYPE): circle(triangleCircumCircle) 1개 (경유 createTransformObject → duplicate → createCircleTriangleCircumCircle) [src:base2d/base-advanced-api/index.ts:3864] — 보임(기본값) [src:object-manager/objects/circle.ts:79], 색 null as null | Color(configs.circleColor) [src:base2d/base-advanced-api/configs.ts:128], 매인 개체 [p1.id, p2.id, p3.id] [src:base2d/base-advanced-api/index.ts:3871]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'triangleCircumArc' 그리고 targetObject?.data.type === CIRCLE_TYPE): circle(triangleCircumArc) 1개 (경유 createTransformObject → duplicate → createTriangleCircumArc) [src:base2d/base-advanced-api/index.ts:3925] — 보임(기본값) [src:object-manager/objects/circle.ts:79], 색 null as null | Color(configs.circleColor) [src:base2d/base-advanced-api/configs.ts:128], 매인 개체 [p1.id, p2.id, p3.id] [src:base2d/base-advanced-api/index.ts:3932]",
    "다른 갈래에서 대신 만드는 것, 조건부(o1?.data.type === CIRCLE_TYPE 그리고 case 'compass' 그리고 targetObject?.data.type === CIRCLE_TYPE): circle(compass) 1개 (경유 createTransformObject → duplicate → createCompassByCircle → createCompassBySegment) [src:base2d/base-advanced-api/index.ts:3988] — 보임(기본값) [src:object-manager/objects/circle.ts:79], 색 null as null | Color(configs.circleColor) [src:base2d/base-advanced-api/configs.ts:128], 매인 개체 [o.relatedObjects[0], p.id] [src:base2d/base-advanced-api/index.ts:3995]",
    "다른 갈래에서 대신 만드는 것, 조건부(o1?.data.type === LINEAR_TYPE 그리고 case 'compass' 그리고 targetObject?.data.type === CIRCLE_TYPE): circle(compass) 1개 (경유 createTransformObject → duplicate → createCompassBySegment) [src:base2d/base-advanced-api/index.ts:3988] — 보임(기본값) [src:object-manager/objects/circle.ts:79], 색 null as null | Color(configs.circleColor) [src:base2d/base-advanced-api/configs.ts:128], 매인 개체 [o.relatedObjects[0], p.id] [src:base2d/base-advanced-api/index.ts:3995]",
    "다른 갈래에서 대신 만드는 것, 조건부(o1?.data.type === POINT_TYPE 그리고 case 'compass' 그리고 targetObject?.data.type === CIRCLE_TYPE): circle(compass) 1개 (경유 createTransformObject → duplicate → createCompassByThreePoint) [src:base2d/base-advanced-api/index.ts:3960] — 보임(기본값) [src:object-manager/objects/circle.ts:79], 색 null as null | Color(configs.circleColor) [src:base2d/base-advanced-api/configs.ts:128], 매인 개체 [o.relatedObjects[0], o.relatedObjects[1], p.id] [src:base2d/base-advanced-api/index.ts:3967]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'arc' 그리고 targetObject?.data.type === CIRCLE_TYPE): circle(arc) 1개 (경유 createTransformObject → duplicate → createArc) [src:base2d/base-advanced-api/index.ts:4023] — 보임(기본값) [src:object-manager/objects/circle.ts:79], 색 null as null | Color(configs.circleColor) [src:base2d/base-advanced-api/configs.ts:128], 매인 개체 [p1.id, p2.id, p3.id, auxiliaryPointID] [src:base2d/base-advanced-api/index.ts:4030]",
    "다른 갈래에서 대신 만드는 것, 조건부(isLineSymmetry 그리고 case 'fan' 그리고 targetObject?.data.type === CIRCLE_TYPE): linear(segment) 여러 개(반복문) (경유 createTransformObject → duplicate → createFan → createAuxiliarySegment) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [p1.id, auxiliaryPointID] [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(!(isLineSymmetry) 그리고 case 'fan' 그리고 targetObject?.data.type === CIRCLE_TYPE): linear(segment) 1개 (경유 createTransformObject → duplicate → createFan → createAuxiliarySegment) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [p1.id, p2.id] [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'fan' 그리고 targetObject?.data.type === CIRCLE_TYPE): circle(fan) 1개 (경유 createTransformObject → duplicate → createFan) [src:base2d/base-advanced-api/index.ts:4133] — 보임(기본값) [src:object-manager/objects/circle.ts:79], 색 color [src:base2d/base-advanced-api/index.ts:4136], 매인 개체 [ p1.id, p2.id, p3.id, auxiliaryPointID, auxiliar… [src:base2d/base-advanced-api/index.ts:4143]",
    "다른 갈래에서 대신 만드는 것, 조건부(isLineSymmetry 그리고 case 'segmentOfACircle' 그리고 targetObject?.data.type === CIRCLE_TYPE): linear(segment) 1개 (경유 createTransformObject → duplicate → createSegmentOfACircle → createAuxiliarySegment) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [p3.id, auxiliaryPointID] [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(!(isLineSymmetry) 그리고 case 'segmentOfACircle' 그리고 targetObject?.data.type === CIRCLE_TYPE): linear(segment) 1개 (경유 createTransformObject → duplicate → createSegmentOfACircle → createAuxiliarySegment) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [p2.id, auxiliaryPointID] [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'segmentOfACircle' 그리고 targetObject?.data.type === CIRCLE_TYPE): circle(segmentOfACircle) 1개 (경유 createTransformObject → duplicate → createSegmentOfACircle) [src:base2d/base-advanced-api/index.ts:4192] — 보임(기본값) [src:object-manager/objects/circle.ts:79], 색 color [src:base2d/base-advanced-api/index.ts:4195], 매인 개체 [ p1.id, p2.id, p3.id, auxiliaryPointID, auxiliar… [src:base2d/base-advanced-api/index.ts:4199]",
    "다른 갈래에서 대신 만드는 것, 조건부(props && props.vertexPoints && props.vertexPoints… 그리고 case 'polygon' 그리고 targetObject?.data.type === POLYGON_TYPE): linear(segment) 여러 개(반복문) (경유 createTransformObject → duplicate → createPolygon → createPolygon2 → createAuxiliarySegment(반복)) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [props.vertexPoints[i], props.vertexPoints[i + 1]] [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'polygon' 그리고 targetObject?.data.type === POLYGON_TYPE): polygon(polygon) 1개 (경유 createTransformObject → duplicate → createPolygon → createPolygon2) [src:base2d/base-advanced-api/index.ts:747] — 보임(기본값) [src:object-manager/objects/polygon.ts:85], 색 color [src:base2d/base-advanced-api/index.ts:695], 매인 개체 [...pointIDs, pointIDs[0]] [src:base2d/base-advanced-api/index.ts:690]",
    "다른 갈래에서 대신 만드는 것, 조건부(props && props.numberOfSides && props.vertexPoint… 그리고 case 'cpPolygon' 그리고 targetObject?.data.type === POLYGON_TYPE): linear(segment) 1개 (경유 createTransformObject → duplicate → createCPPolygon → createCPPolygon2 → createAuxiliarySegment) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [props.auxiliaryPoints[props.auxiliaryPoints.leng… [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'cpPolygon' 그리고 targetObject?.data.type === POLYGON_TYPE): polygon(cpPolygon) 1개 (경유 createTransformObject → duplicate → createCPPolygon → createCPPolygon2) [src:base2d/base-advanced-api/index.ts:1589] — 보임(기본값) [src:object-manager/objects/polygon.ts:85], 색 color [src:base2d/base-advanced-api/index.ts:1526], 매인 개체 [p1.id, p2.id] [src:base2d/base-advanced-api/index.ts:1513]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'lateralPolygon' 그리고 targetObject?.data.type === POLYGON_TYPE): polygon(lateralPolygon) 1개 (경유 createTransformObject → duplicate → createLateralPolygon → createLateralPolygon2) [src:base2d/base-advanced-api/index.ts:1734] — 보임(기본값) [src:object-manager/objects/polygon.ts:85], 색 color [src:base2d/base-advanced-api/index.ts:1669], 매인 개체 [p1.id, p2.id] [src:base2d/base-advanced-api/index.ts:1656]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'rigidPolygon' 그리고 targetObject?.data.type === POLYGON_TYPE): polygon(rigidPolygon) 1개 (경유 createTransformObject → duplicate → createRigidPolygon → createRigidPolygon2) [src:base2d/base-advanced-api/index.ts:1876] — 보임(기본값) [src:object-manager/objects/polygon.ts:85], 색 color [src:base2d/base-advanced-api/index.ts:1812], 매인 개체 [p1.id, p2.id] [src:base2d/base-advanced-api/index.ts:1799]",
    "다른 갈래에서 대신 만드는 것, 조건부(props.hasPolygonDependentPoint 그리고 props && props.relatedObjects && props.relatedObj… 그리고 case 'isoscelesTriangle' 그리고 targetObject?.data.type === POLYGON_TYPE): linear(segment) 여러 개(반복문) (경유 createTransformObject → duplicate → createIsoscelesTriangle → createIsoscelesTriangle2 → createAuxiliarySegment) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [props.relatedObjects[0], props.relatedObjects[1]] [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(!(props.hasPolygonDependentPoint) 그리고 props && props.relatedObjects && props.relatedObj… 그리고 case 'isoscelesTriangle' 그리고 targetObject?.data.type === POLYGON_TYPE): linear(segment) 여러 개(반복문) (경유 createTransformObject → duplicate → createIsoscelesTriangle → createIsoscelesTriangle2 → createAuxiliarySegment) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [props.relatedObjects[0], props.relatedObjects[2]] [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'isoscelesTriangle' 그리고 targetObject?.data.type === POLYGON_TYPE): polygon(isoscelesTriangle) 1개 (경유 createTransformObject → duplicate → createIsoscelesTriangle → createIsoscelesTriangle2) [src:base2d/base-advanced-api/index.ts:863] — 보임(기본값) [src:object-manager/objects/polygon.ts:85], 매인 개체 [p1.id, p2.id, p3.id] [src:base2d/base-advanced-api/index.ts:754]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'rightTriangle' 그리고 targetObject?.data.type === POLYGON_TYPE): polygon(rightTriangle) 1개 (경유 createTransformObject → duplicate → createRightTriangle → createRightTriangle2) [src:base2d/base-advanced-api/index.ts:984] — 보임(기본값) [src:object-manager/objects/polygon.ts:85], 매인 개체 [p1.id, p2.id, p3.id] [src:base2d/base-advanced-api/index.ts:875]",
    "다른 갈래에서 대신 만드는 것, 조건부(!(props.hasPolygonDependentPoint) 그리고 props && props.relatedObjects && props.relatedObj… 그리고 case 'rectangle' 그리고 targetObject?.data.type === POLYGON_TYPE): linear(segment) 여러 개(반복문) (경유 createTransformObject → duplicate → createRectangle → createRectangle2 → createAuxiliarySegment) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [props.relatedObjects[0], props.auxiliaryPoints[0… [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'rectangle' 그리고 targetObject?.data.type === POLYGON_TYPE): polygon(rectangle) 1개 (경유 createTransformObject → duplicate → createRectangle → createRectangle2) [src:base2d/base-advanced-api/index.ts:1217] — 보임(기본값) [src:object-manager/objects/polygon.ts:85], 매인 개체 [p1.id, p2.id, p3.id] [src:base2d/base-advanced-api/index.ts:1099]",
    "다른 갈래에서 대신 만드는 것, 조건부(i === 0 그리고 props && props.relatedObjects && props.relatedObj… 그리고 case 'parallelogram' 그리고 targetObject?.data.type === POLYGON_TYPE): linear(segment) 여러 개(반복문) (경유 createTransformObject → duplicate → createParallelogram → createParallelogram2 → createAuxiliarySegment(반복)) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [props.relatedObjects[0], props.relatedObjects[1]] [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(i === 1 그리고 !(i === 0) 그리고 props && props.relatedObjects && props.relatedObj… 그리고 case 'parallelogram' 그리고 targetObject?.data.type === POLYGON_TYPE): linear(segment) 여러 개(반복문) (경유 createTransformObject → duplicate → createParallelogram → createParallelogram2 → createAuxiliarySegment(반복)) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [props.relatedObjects[1], props.relatedObjects[2]] [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(i === 2 그리고 !(i === 1) 그리고 !(i === 0) 그리고 props && props.relatedObjects && props.relatedObj… 그리고 case 'parallelogram' 그리고 targetObject?.data.type === POLYGON_TYPE): linear(segment) 여러 개(반복문) (경유 createTransformObject → duplicate → createParallelogram → createParallelogram2 → createAuxiliarySegment(반복)) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [props.relatedObjects[2], props.auxiliaryPoints[0… [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(i === 3 그리고 !(i === 2) 그리고 !(i === 1) 그리고 !(i === 0) 그리고 props && props.relatedObjects && props.relatedObj… 그리고 case 'parallelogram' 그리고 targetObject?.data.type === POLYGON_TYPE): linear(segment) 여러 개(반복문) (경유 createTransformObject → duplicate → createParallelogram → createParallelogram2 → createAuxiliarySegment(반복)) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [props.auxiliaryPoints[0], props.relatedObjects[0… [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'parallelogram' 그리고 targetObject?.data.type === POLYGON_TYPE): polygon(parallelogram) 1개 (경유 createTransformObject → duplicate → createParallelogram → createParallelogram2) [src:base2d/base-advanced-api/index.ts:1092] — 보임(기본값) [src:object-manager/objects/polygon.ts:85], 매인 개체 [p1.id, p2.id, p3.id] [src:base2d/base-advanced-api/index.ts:991]",
    "다른 갈래에서 대신 만드는 것, 조건부(!(props.hasPolygonDependentPoint) 그리고 props && props.relatedObjects && props.relatedObj… 그리고 case 'rhombus' 그리고 targetObject?.data.type === POLYGON_TYPE): linear(segment) 1개 (경유 createTransformObject → duplicate → createRhombus → createRhombus2 → createAuxiliarySegment) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [props.auxiliaryPoints[0], props.auxiliaryPoints[… [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'rhombus' 그리고 targetObject?.data.type === POLYGON_TYPE): polygon(rhombus) 1개 (경유 createTransformObject → duplicate → createRhombus → createRhombus2) [src:base2d/base-advanced-api/index.ts:1352] — 보임(기본값) [src:object-manager/objects/polygon.ts:85], 매인 개체 [p1.id, p2.id, p3.id] [src:base2d/base-advanced-api/index.ts:1229]",
    "다른 갈래에서 대신 만드는 것, 조건부(props.hasPolygonDependentPoint 그리고 props && props.relatedObjects && props.relatedObj… 그리고 case 'trapezoid' 그리고 targetObject?.data.type === POLYGON_TYPE): linear(segment) 여러 개(반복문) (경유 createTransformObject → duplicate → createTrapezoid → createTrapezoid2 → createAuxiliarySegment) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [props.relatedObjects[2], props.relatedObjects[3]] [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(!(props.hasPolygonDependentPoint) 그리고 props && props.relatedObjects && props.relatedObj… 그리고 case 'trapezoid' 그리고 targetObject?.data.type === POLYGON_TYPE): linear(segment) 1개 (경유 createTransformObject → duplicate → createTrapezoid → createTrapezoid2 → createAuxiliarySegment) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [props.relatedObjects[1], props.auxiliaryPoints[0… [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'trapezoid' 그리고 targetObject?.data.type === POLYGON_TYPE): polygon(trapezoid) 1개 (경유 createTransformObject → duplicate → createTrapezoid → createTrapezoid2) [src:base2d/base-advanced-api/index.ts:1493] — 보임(기본값) [src:object-manager/objects/polygon.ts:85], 매인 개체 [p1.id, p2.id, p3.id, p4.id] [src:base2d/base-advanced-api/index.ts:1365]",
    "다른 갈래에서 대신 만드는 것, 조건부(targetObject?.data.type === TEXT_TYPE): text 1개 (경유 createTransformObject → duplicate → createText) [src:base2d/base-advanced-api/index.ts:3203] — 보임(기본값) [src:object-manager/objects/text.ts:63], 크기 o.size [src:base2d/base-advanced-api/index.ts:3207], 글꼴 o.font! [src:base2d/base-advanced-api/index.ts:3208], 색 #000(configs.textColor) [src:base2d/base-advanced-api/configs.ts:90], latex=o.latex [src:base2d/base-advanced-api/index.ts:3206], isScreenCoord=true [src:base2d/base-advanced-api/index.ts:3212]",
    "다른 갈래에서 대신 만드는 것, 조건부(targetObject?.data.type === DRAWING_TYPE): drawing 1개 (경유 createTransformObject → duplicate → createDrawingObject) [src:base2d/base-advanced-api/index.ts:4233] — 보임(공통 기본값) [src:object-manager/objects/common.ts:38], 색 null as null | Color(configs.drawingColor) [src:base2d/base-advanced-api/configs.ts:130], 선 두께 2(configs.drawingStrokeWidth) [src:base2d/base-advanced-api/configs.ts:135]",
    "다른 갈래에서 대신 만드는 것, 조건부(targetObject?.data.type === IMAGE_TYPE): image 1개 (경유 createTransformObject → duplicate → createImage) [src:base2d/base-advanced-api/index.ts:4371] — 보임(기본값) [src:object-manager/objects/image.ts:37], isScreenCoord=false [src:base2d/base-advanced-api/index.ts:4378]",
    "다른 갈래에서 대신 만드는 것, 조건부(targetObject?.data.type === ELLIPSE_TYPE): ellipse 1개 (경유 createTransformObject → duplicate → createEllipse) [src:base2d/base-advanced-api/index.ts:3876] — 보임(기본값) [src:object-manager/objects/ellipse.ts:52], 색 null as null | Color(configs.circleColor) [src:base2d/base-advanced-api/configs.ts:128], 매인 개체 [p1.id, p2.id, p3.id] [src:base2d/base-advanced-api/index.ts:3882]",
    "다른 갈래에서 대신 만드는 것, 조건부(this.typingParser.isValid() 그리고 targetObject?.data.type === POLYNOMIAL_TYPE): polynomial 1개 (경유 createTransformObject → duplicate → createAlgebraicObject) [src:base2d/base-advanced-api/index.ts:2281] — 보임(기본값) [src:object-manager/objects/polynomial.ts:64], 색 null as null | Color(configs.algebraicColor) [src:base2d/base-advanced-api/configs.ts:131], 선 두께 2(configs.algebraicStrokeWidth) [src:base2d/base-advanced-api/configs.ts:137]",
    "다른 갈래에서 대신 만드는 것, 조건부(this.typingParser.isValid() 그리고 targetObject?.data.type === POLYNOMIAL_TYPE): text(nameText) 1개 (경유 createTransformObject → duplicate → createAlgebraicObject → createNameTextByPolynomial) [src:base2d/base-advanced-api/index.ts:3339] — 숨김 [src:base2d/base-advanced-api/index.ts:3349], 위치 오프셋(화면 px) [24, -24] || [16, -16] [src:base2d/base-advanced-api/index.ts:3341], 크기 16(configs.nametextSize) [src:base2d/base-advanced-api/configs.ts:92], 색 #000(configs.nametextColor) [src:base2d/base-advanced-api/configs.ts:93], latex=true [src:base2d/base-advanced-api/index.ts:3350], 매인 개체 [object.id] [src:base2d/base-advanced-api/index.ts:3342]",
    "다른 갈래에서 대신 만드는 것, 조건부(this.typingLexer.isEmpty() 그리고 this.typingLexer.process(o.expr) 그리고 targetObject?.data.type === POLYNOMIAL_TYPE): polynomial 1개 (경유 createTransformObject → duplicate → createAlgebraicObject) [src:base2d/base-advanced-api/index.ts:2299] — 보임(기본값) [src:object-manager/objects/polynomial.ts:64], 색 null as null | Color(configs.algebraicColor) [src:base2d/base-advanced-api/configs.ts:131], 선 두께 2(configs.algebraicStrokeWidth) [src:base2d/base-advanced-api/configs.ts:137]",
    "다른 갈래에서 대신 만드는 것, 조건부(firstToken.type === TokenType.OPENING_PAREN && la… 그리고 this.typingLexer.process(o.expr) 그리고 targetObject?.data.type === POLYNOMIAL_TYPE): point(point) 1개 (경유 createTransformObject → duplicate → createAlgebraicObject → createPoint) [src:base2d/base-advanced-api/index.ts:2479] — 보임(기본값) [src:object-manager/objects/point.ts:91], 크기 9(configs.pointSize) [src:base2d/base-advanced-api/configs.ts:85], 색 #fe7701(configs.pointColor) [src:base2d/base-advanced-api/configs.ts:86]",
    "다른 갈래에서 대신 만드는 것, 조건부(this.typingLexer.process(o.expr) 그리고 targetObject?.data.type === POLYNOMIAL_TYPE): polynomial 1개 (경유 createTransformObject → duplicate → createAlgebraicObject) [src:base2d/base-advanced-api/index.ts:2327] — 보임(기본값) [src:object-manager/objects/polynomial.ts:64], 색 null as null | Color(configs.algebraicColor) [src:base2d/base-advanced-api/configs.ts:131], 선 두께 2(configs.algebraicStrokeWidth) [src:base2d/base-advanced-api/configs.ts:137]",
    "다른 갈래에서 대신 만드는 것, 조건부(targetObject?.data.type === POLYNOMIAL_TYPE): polynomial 1개 (경유 createTransformObject → duplicate → createAlgebraicObject) [src:base2d/base-advanced-api/index.ts:2344] — 보임(기본값) [src:object-manager/objects/polynomial.ts:64], 색 null as null | Color(configs.algebraicColor) [src:base2d/base-advanced-api/configs.ts:131], 선 두께 2(configs.algebraicStrokeWidth) [src:base2d/base-advanced-api/configs.ts:137]",
    "참고: 각도는 라디안이고 양수는 반시계다. 원본은 그대로 두고 같은 종류의 복사본이 선다 [src:docs/palette/polygon-transform.md:28]",
    "참고: 대수 곡선(algebraric 로 세운 곡선)은 점, 선, 원, 다각형과 반대로 돈다. angle 이 양수여도 곡선은 시계 방향으로 angle 만큼 돌아 같은 호출의 다른 개체와 어긋난다. [src:정합성 polygon-transform: scripts/pipeline/semantic/polygon-transform.mjs 의 시험 '대수 곡선 y=x^2 를 중심 원점 둘레로 +π/6 호출하면 시계 방향(-π/6)으로 돈다', '... 중심 (1,-1) ...' (통과)와 '중심 Q(1,-1), +π/6 ... / 원본 대수 곡선 y=x^2: 복사본 곡선의 점을 역변환하면 ...' (실패)]",
    "참고: 화면 도구는 원본과 중심을 누른 뒤 도 단위 각도 모달(기본 45)을 받아 `<값>*(\\pi / 180)` 으로 같은 호출을 한다. 이 호출의 angle 은 라디안이라 화면의 90도는 1.5707963267948966(π/2)이다. [src:정합성 polygon-transform: /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d-tools/src/tools/math2d-tools/tool-rotation.ts:54-92, /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d-ui/src/modal/modals/create-rotation-modal/index.tsx:3-18, /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d-ui/src/tab/tools/configs/base2d-geometry.ts:484 ; 캔버스 재현 scripts/pipeline/semantic/polygon-transform.mjs 의 시험 '캔버스: 두 번째 클릭(중심)에서 모달 값 90 을 도로 받아 반시계 90도 회전한 복사본이 선다', '... payload 가 π/2 라디안이다 ...']",
    "생성 결과: 원본과 같은 종류의 복사본 개체 1개가 서고 반환 id 가 그 복사본이다(점은 보조 점, 선분과 직선은 linear, 원과 호와 부채꼴은 circle, 다각형은 같은 category 의 polygon, 대수 곡선은 polynomial). 다각형 복사본은 꼭짓점 보조 점과 변 선분도 새로 서고 원본은 바뀌지 않는다. [src:정합성 polygon-transform: scripts/pipeline/semantic/polygon-transform.mjs 의 시험 '같은 type(point|linear|circle|polygon|polynomial) 복사본이 유효로 선다', '원본 id 와 다른 새 개체이고 원본은 그대로', '원본의 RO 에 복사본 id 가 더해진다' (원본 점, 선분, 직선, 원, 호, 부채꼴, 삼각형, 직사각형, 정오각형, 곡선 등) 와 기록 '원본 category ... 복사본 category auxiliary']"
   ],
   "range": [
    "originObjectID: 형식 String [src:mathcore-api/object-factory/packages-base/transform-factory.ts:23] [src:mathcore-api/object-factory/object-types.ts:92]",
    "pointID: 형식 String [src:mathcore-api/object-factory/packages-base/transform-factory.ts:24] [src:mathcore-api/object-factory/object-types.ts:92]",
    "angle: 형식 Number | String [src:mathcore-api/object-factory/packages-base/transform-factory.ts:25] [src:mathcore-api/object-factory/object-types.ts:105]; 숫자가 아닌 문자열이면 슬라이더 연결식으로 들어가 그 값을 따라 움직인다 [src:base2d/base-advanced-api/index.ts:644-654]",
    "name?: 형식 String | Undefined [src:mathcore-api/object-factory/packages-base/transform-factory.ts:26] [src:mathcore-api/object-factory/object-types.ts:93]; 생략하면 this.getNewObjectName()(createLinear) [src:base2d/base-advanced-api/index.ts:3363]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): traceColor=undefined, shape=PointShape.Circle, imoji=0, position=[0, 0], domain='점', angle=0 [src:object-manager/objects/point.ts:93-99]",
    "조용히 끝남(만들지 않음): [...pointIDs, pointIDs[0]].length < 3 이면 undefined 반환 [src:base2d/base-advanced-api/index.ts:685]",
    "조용히 끝남(만들지 않음): props.color === undefined 이면 undefined 반환 [src:base2d/base-advanced-api/index.ts:707]",
    "조용히 끝남(만들지 않음): o.numberOfSides < 3 이면 undefined 반환 [src:base2d/base-advanced-api/index.ts:1506]",
    "조용히 끝남(만들지 않음): props.color === undefined 이면 undefined 반환 [src:base2d/base-advanced-api/index.ts:1546]",
    "조용히 끝남(만들지 않음): o.numberOfSides < 3 이면 undefined 반환 [src:base2d/base-advanced-api/index.ts:1649]",
    "조용히 끝남(만들지 않음): props.color === undefined 이면 undefined 반환 [src:base2d/base-advanced-api/index.ts:1688]",
    "조용히 끝남(만들지 않음): props.color === undefined 이면 undefined 반환 [src:base2d/base-advanced-api/index.ts:1830]",
    "조용히 끝남(만들지 않음): props.color === undefined 이면 undefined 반환 [src:base2d/base-advanced-api/index.ts:822]",
    "조용히 끝나는 조건 외 5곳 (경유 createRightTriangle2, createRectangle2, createParallelogram2, createRhombus2, createTrapezoid2) [src:base2d/base-advanced-api/index.ts:943] [src:base2d/base-advanced-api/index.ts:1169] [src:base2d/base-advanced-api/index.ts:1038] [src:base2d/base-advanced-api/index.ts:1300] [src:base2d/base-advanced-api/index.ts:1441]",
    "원본 id 가 없는 개체이거나 복제할 수 없는 종류(슬라이더, 벡터)이면 개체를 만들지 않고 undefined 를 돌려준다. 중심 점 id 가 없는 개체여도 undefined 이다. [src:정합성 polygon-transform: scripts/pipeline/semantic/polygon-transform.mjs 의 시험 '원본 자리에 슬라이더, 벡터, 없는 id, 이름 문자열을 넣으면 개체를 만들지 않는다(undefined)', '중심 자리에 없는 id 를 넣으면 ...']"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "transform.translation",
   "path": [
    "transform",
    "translation"
   ],
   "params": [
    {
     "name": "originObjectID",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      },
      {
       "type": "linear"
      },
      {
       "type": "circle"
      },
      {
       "type": "chord"
      },
      {
       "type": "polygon"
      },
      {
       "type": "ellipse"
      },
      {
       "type": "polynomial"
      }
     ]
    },
    {
     "name": "dx",
     "type": "number|string",
     "optional": false
    },
    {
     "name": "dy",
     "type": "number|string",
     "optional": false
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "packages-base/transform-factory.ts",
   "usage": [
    "용도(도구 UI 설명): 평행이동 — 평행이동시킬 대상을 선택한 후 평행이동할 좌표를 입력하세요. [src:base2d-ui/src/tab/tools/configs/base2d-geometry.ts:497]",
    "호출: factory.transform.translation → advanced.createTranslationObject [src:mathcore-api/object-factory/packages-base/transform-factory.ts:30-36] [src:base2d/base-advanced-api/index.ts:6732-6747]",
    "앞에 있어야 하는 것: originObjectID = 아무 개체 [src:mathcore-api/object-factory/packages-base/transform-factory.ts:30-36]",
    "만드는 것, 조건부(true 그리고 targetObject?.data.type === POINT_TYPE): point(auxiliary) 1개 (경유 createTransformObject → duplicate → createAuxiliaryPoint) [src:base2d/base-advanced-api/index.ts:2556] — 보임(기본값) [src:object-manager/objects/point.ts:91], 크기 9(configs.pointSize) [src:base2d/base-advanced-api/configs.ts:85], 색 #6e6868(configs.intersectionPointColor) [src:base2d/base-advanced-api/configs.ts:112]",
    "함께 생김, 조건부(true 그리고 targetObject?.data.type === POINT_TYPE): text(nameText) 1개 (경유 createTransformObject → duplicate → createAuxiliaryPoint → createNameText) [src:base2d/base-advanced-api/index.ts:3266] — 보임(기본값) [src:object-manager/objects/text.ts:63], 위치 오프셋(화면 px) [16, -16] [src:base2d/base-advanced-api/index.ts:3268], 크기 16(configs.nametextSize) [src:base2d/base-advanced-api/configs.ts:92], 글꼴 'KaTeX'(configs.nametextFont) [src:base2d/base-advanced-api/configs.ts:94], 색 #000(configs.nametextColor) [src:base2d/base-advanced-api/configs.ts:93], 매인 개체 [point.id] [src:base2d/base-advanced-api/index.ts:3269]",
    "다른 갈래에서 대신 만드는 것, 조건부(targetObject?.data.type === POINT_TYPE): point(point) 1개 (경유 createTransformObject → duplicate → createPoint) [src:base2d/base-advanced-api/index.ts:2479] — 보임(기본값) [src:object-manager/objects/point.ts:91], 크기 9(configs.pointSize) [src:base2d/base-advanced-api/configs.ts:85], 색 #fe7701(configs.pointColor) [src:base2d/base-advanced-api/configs.ts:86]",
    "다른 갈래에서 대신 만드는 것, 조건부(targetObject?.data.type === POINT_TYPE): text(nameText) 1개 (경유 createTransformObject → duplicate → createPoint → createNameText) [src:base2d/base-advanced-api/index.ts:3266] — 보임(기본값) [src:object-manager/objects/text.ts:63], 위치 오프셋(화면 px) [16, -16] [src:base2d/base-advanced-api/index.ts:3268], 크기 16(configs.nametextSize) [src:base2d/base-advanced-api/configs.ts:92], 글꼴 'KaTeX'(configs.nametextFont) [src:base2d/base-advanced-api/configs.ts:94], 색 #000(configs.nametextColor) [src:base2d/base-advanced-api/configs.ts:93], 매인 개체 [point.id] [src:base2d/base-advanced-api/index.ts:3269]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'segment' 그리고 targetObject?.data.type === LINEAR_TYPE): linear(segment) 1개 (경유 createTransformObject → duplicate → createSegment → createLinear) [src:base2d/base-advanced-api/index.ts:3358] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 null as null | Color(configs.linearColor) [src:base2d/base-advanced-api/configs.ts:127], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [p1.id, p2.id] [src:base2d/base-advanced-api/index.ts:3362]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'line' 그리고 targetObject?.data.type === LINEAR_TYPE): linear(line) 1개 (경유 createTransformObject → duplicate → createLine → createLinear) [src:base2d/base-advanced-api/index.ts:3358] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 null as null | Color(configs.linearColor) [src:base2d/base-advanced-api/configs.ts:127], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [p1.id, p2.id] [src:base2d/base-advanced-api/index.ts:3362]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'ray' 그리고 targetObject?.data.type === LINEAR_TYPE): linear(ray) 1개 (경유 createTransformObject → duplicate → createRay → createLinear) [src:base2d/base-advanced-api/index.ts:3358] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 null as null | Color(configs.linearColor) [src:base2d/base-advanced-api/configs.ts:127], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [p1.id, p2.id] [src:base2d/base-advanced-api/index.ts:3362]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'perpendicular' 그리고 targetObject?.data.type === LINEAR_TYPE): linear(perpendicular) 1개 (경유 createTransformObject → duplicate → createPerpendicular → createLinear) [src:base2d/base-advanced-api/index.ts:3358] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 null as null | Color(configs.linearColor) [src:base2d/base-advanced-api/configs.ts:127], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [l, p.id] [src:base2d/base-advanced-api/index.ts:3362]",
    "다른 갈래에서 대신 만드는 것, 조건부(l?.data.type === LINEAR_TYPE 그리고 case 'perpendicularAtMidpoint' 그리고 targetObject?.data.type === LINEAR_TYPE): linear(perpendicularAtMidpoint) 1개 (경유 createTransformObject → duplicate → createPerpendicularAtMidpointBySegmentID → createLinear) [src:base2d/base-advanced-api/index.ts:3358] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 null as null | Color(configs.linearColor) [src:base2d/base-advanced-api/configs.ts:127], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [l.data.id] [src:base2d/base-advanced-api/index.ts:3362]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'perpendicularAtMidpoint' 그리고 targetObject?.data.type === LINEAR_TYPE): linear(perpendicularAtMidpoint) 1개 (경유 createTransformObject → duplicate → createPerpendicularAtMidpointByTwoPointID → createLinear) [src:base2d/base-advanced-api/index.ts:3358] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 null as null | Color(configs.linearColor) [src:base2d/base-advanced-api/configs.ts:127], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [p1.id, p2.id] [src:base2d/base-advanced-api/index.ts:3362]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'bisectorLine' 그리고 targetObject?.data.type === LINEAR_TYPE): linear(bisectorLine) 1개 (경유 createTransformObject → duplicate → createBisectorLine → createLinear) [src:base2d/base-advanced-api/index.ts:3358] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 null as null | Color(configs.linearColor) [src:base2d/base-advanced-api/configs.ts:127], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [p1.id, p2.id, p3.id] [src:base2d/base-advanced-api/index.ts:3362]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'tangentLine' 그리고 targetObject?.data.type === LINEAR_TYPE): point(point) 여러 개(반복문) (경유 createTransformObject → duplicate → createPoint) [src:base2d/base-advanced-api/index.ts:2479] — 보임(기본값) [src:object-manager/objects/point.ts:91], 크기 9(configs.pointSize) [src:base2d/base-advanced-api/configs.ts:85], 색 #fe7701(configs.pointColor) [src:base2d/base-advanced-api/configs.ts:86]",
    "다른 갈래에서 대신 만드는 것, 조건부(r1?.data.type === POINT_TYPE && r2?.data.type ===… 그리고 case 'parallel' 그리고 targetObject?.data.type === LINEAR_TYPE): linear(parallel) 1개 (경유 createTransformObject → duplicate → createParallel → createLinear) [src:base2d/base-advanced-api/index.ts:3358] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 null as null | Color(configs.linearColor) [src:base2d/base-advanced-api/configs.ts:127], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [newPoint.id, r2.data.id] [src:base2d/base-advanced-api/index.ts:3362]",
    "다른 갈래에서 대신 만드는 것, 조건부(r1?.data.type === LINEAR_TYPE && r2?.data.type ==… 그리고 case 'parallel' 그리고 targetObject?.data.type === LINEAR_TYPE): linear(parallel) 1개 (경유 createTransformObject → duplicate → createParallel → createLinear) [src:base2d/base-advanced-api/index.ts:3358] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 null as null | Color(configs.linearColor) [src:base2d/base-advanced-api/configs.ts:127], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [newPoint.id, r1.data.id] [src:base2d/base-advanced-api/index.ts:3362]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'circleCenterPoint' 그리고 targetObject?.data.type === CIRCLE_TYPE): circle(circleCenterPoint) 1개 (경유 createTransformObject → duplicate → createCircleCenterPoint) [src:base2d/base-advanced-api/index.ts:3761] — 보임(기본값) [src:object-manager/objects/circle.ts:79], 색 null as null | Color(configs.circleColor) [src:base2d/base-advanced-api/configs.ts:128], 매인 개체 [p1.id, p2.id] [src:base2d/base-advanced-api/index.ts:3768]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'circleCenterRadius' 그리고 targetObject?.data.type === CIRCLE_TYPE): circle(circleCenterRadius) 1개 (경유 createTransformObject → duplicate → createCircleCenterRadius) [src:base2d/base-advanced-api/index.ts:3738] — 보임(기본값) [src:object-manager/objects/circle.ts:79], 색 null as null | Color(configs.circleColor) [src:base2d/base-advanced-api/configs.ts:128], 매인 개체 [p.id] [src:base2d/base-advanced-api/index.ts:3746]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'triangleCircumCircle' 그리고 targetObject?.data.type === CIRCLE_TYPE): circle(triangleCircumCircle) 1개 (경유 createTransformObject → duplicate → createCircleTriangleCircumCircle) [src:base2d/base-advanced-api/index.ts:3864] — 보임(기본값) [src:object-manager/objects/circle.ts:79], 색 null as null | Color(configs.circleColor) [src:base2d/base-advanced-api/configs.ts:128], 매인 개체 [p1.id, p2.id, p3.id] [src:base2d/base-advanced-api/index.ts:3871]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'triangleCircumArc' 그리고 targetObject?.data.type === CIRCLE_TYPE): circle(triangleCircumArc) 1개 (경유 createTransformObject → duplicate → createTriangleCircumArc) [src:base2d/base-advanced-api/index.ts:3925] — 보임(기본값) [src:object-manager/objects/circle.ts:79], 색 null as null | Color(configs.circleColor) [src:base2d/base-advanced-api/configs.ts:128], 매인 개체 [p1.id, p2.id, p3.id] [src:base2d/base-advanced-api/index.ts:3932]",
    "다른 갈래에서 대신 만드는 것, 조건부(o1?.data.type === CIRCLE_TYPE 그리고 case 'compass' 그리고 targetObject?.data.type === CIRCLE_TYPE): circle(compass) 1개 (경유 createTransformObject → duplicate → createCompassByCircle → createCompassBySegment) [src:base2d/base-advanced-api/index.ts:3988] — 보임(기본값) [src:object-manager/objects/circle.ts:79], 색 null as null | Color(configs.circleColor) [src:base2d/base-advanced-api/configs.ts:128], 매인 개체 [o.relatedObjects[0], p.id] [src:base2d/base-advanced-api/index.ts:3995]",
    "다른 갈래에서 대신 만드는 것, 조건부(o1?.data.type === LINEAR_TYPE 그리고 case 'compass' 그리고 targetObject?.data.type === CIRCLE_TYPE): circle(compass) 1개 (경유 createTransformObject → duplicate → createCompassBySegment) [src:base2d/base-advanced-api/index.ts:3988] — 보임(기본값) [src:object-manager/objects/circle.ts:79], 색 null as null | Color(configs.circleColor) [src:base2d/base-advanced-api/configs.ts:128], 매인 개체 [o.relatedObjects[0], p.id] [src:base2d/base-advanced-api/index.ts:3995]",
    "다른 갈래에서 대신 만드는 것, 조건부(o1?.data.type === POINT_TYPE 그리고 case 'compass' 그리고 targetObject?.data.type === CIRCLE_TYPE): circle(compass) 1개 (경유 createTransformObject → duplicate → createCompassByThreePoint) [src:base2d/base-advanced-api/index.ts:3960] — 보임(기본값) [src:object-manager/objects/circle.ts:79], 색 null as null | Color(configs.circleColor) [src:base2d/base-advanced-api/configs.ts:128], 매인 개체 [o.relatedObjects[0], o.relatedObjects[1], p.id] [src:base2d/base-advanced-api/index.ts:3967]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'arc' 그리고 targetObject?.data.type === CIRCLE_TYPE): circle(arc) 1개 (경유 createTransformObject → duplicate → createArc) [src:base2d/base-advanced-api/index.ts:4023] — 보임(기본값) [src:object-manager/objects/circle.ts:79], 색 null as null | Color(configs.circleColor) [src:base2d/base-advanced-api/configs.ts:128], 매인 개체 [p1.id, p2.id, p3.id, auxiliaryPointID] [src:base2d/base-advanced-api/index.ts:4030]",
    "다른 갈래에서 대신 만드는 것, 조건부(isLineSymmetry 그리고 case 'fan' 그리고 targetObject?.data.type === CIRCLE_TYPE): linear(segment) 여러 개(반복문) (경유 createTransformObject → duplicate → createFan → createAuxiliarySegment) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [p1.id, auxiliaryPointID] [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(!(isLineSymmetry) 그리고 case 'fan' 그리고 targetObject?.data.type === CIRCLE_TYPE): linear(segment) 1개 (경유 createTransformObject → duplicate → createFan → createAuxiliarySegment) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [p1.id, p2.id] [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'fan' 그리고 targetObject?.data.type === CIRCLE_TYPE): circle(fan) 1개 (경유 createTransformObject → duplicate → createFan) [src:base2d/base-advanced-api/index.ts:4133] — 보임(기본값) [src:object-manager/objects/circle.ts:79], 색 color [src:base2d/base-advanced-api/index.ts:4136], 매인 개체 [ p1.id, p2.id, p3.id, auxiliaryPointID, auxiliar… [src:base2d/base-advanced-api/index.ts:4143]",
    "다른 갈래에서 대신 만드는 것, 조건부(isLineSymmetry 그리고 case 'segmentOfACircle' 그리고 targetObject?.data.type === CIRCLE_TYPE): linear(segment) 1개 (경유 createTransformObject → duplicate → createSegmentOfACircle → createAuxiliarySegment) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [p3.id, auxiliaryPointID] [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(!(isLineSymmetry) 그리고 case 'segmentOfACircle' 그리고 targetObject?.data.type === CIRCLE_TYPE): linear(segment) 1개 (경유 createTransformObject → duplicate → createSegmentOfACircle → createAuxiliarySegment) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [p2.id, auxiliaryPointID] [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'segmentOfACircle' 그리고 targetObject?.data.type === CIRCLE_TYPE): circle(segmentOfACircle) 1개 (경유 createTransformObject → duplicate → createSegmentOfACircle) [src:base2d/base-advanced-api/index.ts:4192] — 보임(기본값) [src:object-manager/objects/circle.ts:79], 색 color [src:base2d/base-advanced-api/index.ts:4195], 매인 개체 [ p1.id, p2.id, p3.id, auxiliaryPointID, auxiliar… [src:base2d/base-advanced-api/index.ts:4199]",
    "다른 갈래에서 대신 만드는 것, 조건부(props && props.vertexPoints && props.vertexPoints… 그리고 case 'polygon' 그리고 targetObject?.data.type === POLYGON_TYPE): linear(segment) 여러 개(반복문) (경유 createTransformObject → duplicate → createPolygon → createPolygon2 → createAuxiliarySegment(반복)) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [props.vertexPoints[i], props.vertexPoints[i + 1]] [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'polygon' 그리고 targetObject?.data.type === POLYGON_TYPE): polygon(polygon) 1개 (경유 createTransformObject → duplicate → createPolygon → createPolygon2) [src:base2d/base-advanced-api/index.ts:747] — 보임(기본값) [src:object-manager/objects/polygon.ts:85], 색 color [src:base2d/base-advanced-api/index.ts:695], 매인 개체 [...pointIDs, pointIDs[0]] [src:base2d/base-advanced-api/index.ts:690]",
    "다른 갈래에서 대신 만드는 것, 조건부(props && props.numberOfSides && props.vertexPoint… 그리고 case 'cpPolygon' 그리고 targetObject?.data.type === POLYGON_TYPE): linear(segment) 1개 (경유 createTransformObject → duplicate → createCPPolygon → createCPPolygon2 → createAuxiliarySegment) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [props.auxiliaryPoints[props.auxiliaryPoints.leng… [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'cpPolygon' 그리고 targetObject?.data.type === POLYGON_TYPE): polygon(cpPolygon) 1개 (경유 createTransformObject → duplicate → createCPPolygon → createCPPolygon2) [src:base2d/base-advanced-api/index.ts:1589] — 보임(기본값) [src:object-manager/objects/polygon.ts:85], 색 color [src:base2d/base-advanced-api/index.ts:1526], 매인 개체 [p1.id, p2.id] [src:base2d/base-advanced-api/index.ts:1513]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'lateralPolygon' 그리고 targetObject?.data.type === POLYGON_TYPE): polygon(lateralPolygon) 1개 (경유 createTransformObject → duplicate → createLateralPolygon → createLateralPolygon2) [src:base2d/base-advanced-api/index.ts:1734] — 보임(기본값) [src:object-manager/objects/polygon.ts:85], 색 color [src:base2d/base-advanced-api/index.ts:1669], 매인 개체 [p1.id, p2.id] [src:base2d/base-advanced-api/index.ts:1656]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'rigidPolygon' 그리고 targetObject?.data.type === POLYGON_TYPE): polygon(rigidPolygon) 1개 (경유 createTransformObject → duplicate → createRigidPolygon → createRigidPolygon2) [src:base2d/base-advanced-api/index.ts:1876] — 보임(기본값) [src:object-manager/objects/polygon.ts:85], 색 color [src:base2d/base-advanced-api/index.ts:1812], 매인 개체 [p1.id, p2.id] [src:base2d/base-advanced-api/index.ts:1799]",
    "다른 갈래에서 대신 만드는 것, 조건부(props.hasPolygonDependentPoint 그리고 props && props.relatedObjects && props.relatedObj… 그리고 case 'isoscelesTriangle' 그리고 targetObject?.data.type === POLYGON_TYPE): linear(segment) 여러 개(반복문) (경유 createTransformObject → duplicate → createIsoscelesTriangle → createIsoscelesTriangle2 → createAuxiliarySegment) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [props.relatedObjects[0], props.relatedObjects[1]] [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(!(props.hasPolygonDependentPoint) 그리고 props && props.relatedObjects && props.relatedObj… 그리고 case 'isoscelesTriangle' 그리고 targetObject?.data.type === POLYGON_TYPE): linear(segment) 여러 개(반복문) (경유 createTransformObject → duplicate → createIsoscelesTriangle → createIsoscelesTriangle2 → createAuxiliarySegment) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [props.relatedObjects[0], props.relatedObjects[2]] [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'isoscelesTriangle' 그리고 targetObject?.data.type === POLYGON_TYPE): polygon(isoscelesTriangle) 1개 (경유 createTransformObject → duplicate → createIsoscelesTriangle → createIsoscelesTriangle2) [src:base2d/base-advanced-api/index.ts:863] — 보임(기본값) [src:object-manager/objects/polygon.ts:85], 매인 개체 [p1.id, p2.id, p3.id] [src:base2d/base-advanced-api/index.ts:754]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'rightTriangle' 그리고 targetObject?.data.type === POLYGON_TYPE): polygon(rightTriangle) 1개 (경유 createTransformObject → duplicate → createRightTriangle → createRightTriangle2) [src:base2d/base-advanced-api/index.ts:984] — 보임(기본값) [src:object-manager/objects/polygon.ts:85], 매인 개체 [p1.id, p2.id, p3.id] [src:base2d/base-advanced-api/index.ts:875]",
    "다른 갈래에서 대신 만드는 것, 조건부(!(props.hasPolygonDependentPoint) 그리고 props && props.relatedObjects && props.relatedObj… 그리고 case 'rectangle' 그리고 targetObject?.data.type === POLYGON_TYPE): linear(segment) 여러 개(반복문) (경유 createTransformObject → duplicate → createRectangle → createRectangle2 → createAuxiliarySegment) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [props.relatedObjects[0], props.auxiliaryPoints[0… [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'rectangle' 그리고 targetObject?.data.type === POLYGON_TYPE): polygon(rectangle) 1개 (경유 createTransformObject → duplicate → createRectangle → createRectangle2) [src:base2d/base-advanced-api/index.ts:1217] — 보임(기본값) [src:object-manager/objects/polygon.ts:85], 매인 개체 [p1.id, p2.id, p3.id] [src:base2d/base-advanced-api/index.ts:1099]",
    "다른 갈래에서 대신 만드는 것, 조건부(i === 0 그리고 props && props.relatedObjects && props.relatedObj… 그리고 case 'parallelogram' 그리고 targetObject?.data.type === POLYGON_TYPE): linear(segment) 여러 개(반복문) (경유 createTransformObject → duplicate → createParallelogram → createParallelogram2 → createAuxiliarySegment(반복)) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [props.relatedObjects[0], props.relatedObjects[1]] [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(i === 1 그리고 !(i === 0) 그리고 props && props.relatedObjects && props.relatedObj… 그리고 case 'parallelogram' 그리고 targetObject?.data.type === POLYGON_TYPE): linear(segment) 여러 개(반복문) (경유 createTransformObject → duplicate → createParallelogram → createParallelogram2 → createAuxiliarySegment(반복)) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [props.relatedObjects[1], props.relatedObjects[2]] [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(i === 2 그리고 !(i === 1) 그리고 !(i === 0) 그리고 props && props.relatedObjects && props.relatedObj… 그리고 case 'parallelogram' 그리고 targetObject?.data.type === POLYGON_TYPE): linear(segment) 여러 개(반복문) (경유 createTransformObject → duplicate → createParallelogram → createParallelogram2 → createAuxiliarySegment(반복)) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [props.relatedObjects[2], props.auxiliaryPoints[0… [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(i === 3 그리고 !(i === 2) 그리고 !(i === 1) 그리고 !(i === 0) 그리고 props && props.relatedObjects && props.relatedObj… 그리고 case 'parallelogram' 그리고 targetObject?.data.type === POLYGON_TYPE): linear(segment) 여러 개(반복문) (경유 createTransformObject → duplicate → createParallelogram → createParallelogram2 → createAuxiliarySegment(반복)) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [props.auxiliaryPoints[0], props.relatedObjects[0… [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'parallelogram' 그리고 targetObject?.data.type === POLYGON_TYPE): polygon(parallelogram) 1개 (경유 createTransformObject → duplicate → createParallelogram → createParallelogram2) [src:base2d/base-advanced-api/index.ts:1092] — 보임(기본값) [src:object-manager/objects/polygon.ts:85], 매인 개체 [p1.id, p2.id, p3.id] [src:base2d/base-advanced-api/index.ts:991]",
    "다른 갈래에서 대신 만드는 것, 조건부(!(props.hasPolygonDependentPoint) 그리고 props && props.relatedObjects && props.relatedObj… 그리고 case 'rhombus' 그리고 targetObject?.data.type === POLYGON_TYPE): linear(segment) 1개 (경유 createTransformObject → duplicate → createRhombus → createRhombus2 → createAuxiliarySegment) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [props.auxiliaryPoints[0], props.auxiliaryPoints[… [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'rhombus' 그리고 targetObject?.data.type === POLYGON_TYPE): polygon(rhombus) 1개 (경유 createTransformObject → duplicate → createRhombus → createRhombus2) [src:base2d/base-advanced-api/index.ts:1352] — 보임(기본값) [src:object-manager/objects/polygon.ts:85], 매인 개체 [p1.id, p2.id, p3.id] [src:base2d/base-advanced-api/index.ts:1229]",
    "다른 갈래에서 대신 만드는 것, 조건부(props.hasPolygonDependentPoint 그리고 props && props.relatedObjects && props.relatedObj… 그리고 case 'trapezoid' 그리고 targetObject?.data.type === POLYGON_TYPE): linear(segment) 여러 개(반복문) (경유 createTransformObject → duplicate → createTrapezoid → createTrapezoid2 → createAuxiliarySegment) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [props.relatedObjects[2], props.relatedObjects[3]] [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(!(props.hasPolygonDependentPoint) 그리고 props && props.relatedObjects && props.relatedObj… 그리고 case 'trapezoid' 그리고 targetObject?.data.type === POLYGON_TYPE): linear(segment) 1개 (경유 createTransformObject → duplicate → createTrapezoid → createTrapezoid2 → createAuxiliarySegment) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [props.relatedObjects[1], props.auxiliaryPoints[0… [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'trapezoid' 그리고 targetObject?.data.type === POLYGON_TYPE): polygon(trapezoid) 1개 (경유 createTransformObject → duplicate → createTrapezoid → createTrapezoid2) [src:base2d/base-advanced-api/index.ts:1493] — 보임(기본값) [src:object-manager/objects/polygon.ts:85], 매인 개체 [p1.id, p2.id, p3.id, p4.id] [src:base2d/base-advanced-api/index.ts:1365]",
    "다른 갈래에서 대신 만드는 것, 조건부(targetObject?.data.type === TEXT_TYPE): text 1개 (경유 createTransformObject → duplicate → createText) [src:base2d/base-advanced-api/index.ts:3203] — 보임(기본값) [src:object-manager/objects/text.ts:63], 크기 o.size [src:base2d/base-advanced-api/index.ts:3207], 글꼴 o.font! [src:base2d/base-advanced-api/index.ts:3208], 색 #000(configs.textColor) [src:base2d/base-advanced-api/configs.ts:90], latex=o.latex [src:base2d/base-advanced-api/index.ts:3206], isScreenCoord=true [src:base2d/base-advanced-api/index.ts:3212]",
    "다른 갈래에서 대신 만드는 것, 조건부(targetObject?.data.type === DRAWING_TYPE): drawing 1개 (경유 createTransformObject → duplicate → createDrawingObject) [src:base2d/base-advanced-api/index.ts:4233] — 보임(공통 기본값) [src:object-manager/objects/common.ts:38], 색 null as null | Color(configs.drawingColor) [src:base2d/base-advanced-api/configs.ts:130], 선 두께 2(configs.drawingStrokeWidth) [src:base2d/base-advanced-api/configs.ts:135]",
    "다른 갈래에서 대신 만드는 것, 조건부(targetObject?.data.type === IMAGE_TYPE): image 1개 (경유 createTransformObject → duplicate → createImage) [src:base2d/base-advanced-api/index.ts:4371] — 보임(기본값) [src:object-manager/objects/image.ts:37], isScreenCoord=false [src:base2d/base-advanced-api/index.ts:4378]",
    "다른 갈래에서 대신 만드는 것, 조건부(targetObject?.data.type === ELLIPSE_TYPE): ellipse 1개 (경유 createTransformObject → duplicate → createEllipse) [src:base2d/base-advanced-api/index.ts:3876] — 보임(기본값) [src:object-manager/objects/ellipse.ts:52], 색 null as null | Color(configs.circleColor) [src:base2d/base-advanced-api/configs.ts:128], 매인 개체 [p1.id, p2.id, p3.id] [src:base2d/base-advanced-api/index.ts:3882]",
    "다른 갈래에서 대신 만드는 것, 조건부(this.typingParser.isValid() 그리고 targetObject?.data.type === POLYNOMIAL_TYPE): polynomial 1개 (경유 createTransformObject → duplicate → createAlgebraicObject) [src:base2d/base-advanced-api/index.ts:2281] — 보임(기본값) [src:object-manager/objects/polynomial.ts:64], 색 null as null | Color(configs.algebraicColor) [src:base2d/base-advanced-api/configs.ts:131], 선 두께 2(configs.algebraicStrokeWidth) [src:base2d/base-advanced-api/configs.ts:137]",
    "다른 갈래에서 대신 만드는 것, 조건부(this.typingParser.isValid() 그리고 targetObject?.data.type === POLYNOMIAL_TYPE): text(nameText) 1개 (경유 createTransformObject → duplicate → createAlgebraicObject → createNameTextByPolynomial) [src:base2d/base-advanced-api/index.ts:3339] — 숨김 [src:base2d/base-advanced-api/index.ts:3349], 위치 오프셋(화면 px) [24, -24] || [16, -16] [src:base2d/base-advanced-api/index.ts:3341], 크기 16(configs.nametextSize) [src:base2d/base-advanced-api/configs.ts:92], 색 #000(configs.nametextColor) [src:base2d/base-advanced-api/configs.ts:93], latex=true [src:base2d/base-advanced-api/index.ts:3350], 매인 개체 [object.id] [src:base2d/base-advanced-api/index.ts:3342]",
    "다른 갈래에서 대신 만드는 것, 조건부(this.typingLexer.isEmpty() 그리고 this.typingLexer.process(o.expr) 그리고 targetObject?.data.type === POLYNOMIAL_TYPE): polynomial 1개 (경유 createTransformObject → duplicate → createAlgebraicObject) [src:base2d/base-advanced-api/index.ts:2299] — 보임(기본값) [src:object-manager/objects/polynomial.ts:64], 색 null as null | Color(configs.algebraicColor) [src:base2d/base-advanced-api/configs.ts:131], 선 두께 2(configs.algebraicStrokeWidth) [src:base2d/base-advanced-api/configs.ts:137]",
    "다른 갈래에서 대신 만드는 것, 조건부(firstToken.type === TokenType.OPENING_PAREN && la… 그리고 this.typingLexer.process(o.expr) 그리고 targetObject?.data.type === POLYNOMIAL_TYPE): point(point) 1개 (경유 createTransformObject → duplicate → createAlgebraicObject → createPoint) [src:base2d/base-advanced-api/index.ts:2479] — 보임(기본값) [src:object-manager/objects/point.ts:91], 크기 9(configs.pointSize) [src:base2d/base-advanced-api/configs.ts:85], 색 #fe7701(configs.pointColor) [src:base2d/base-advanced-api/configs.ts:86]",
    "다른 갈래에서 대신 만드는 것, 조건부(this.typingLexer.process(o.expr) 그리고 targetObject?.data.type === POLYNOMIAL_TYPE): polynomial 1개 (경유 createTransformObject → duplicate → createAlgebraicObject) [src:base2d/base-advanced-api/index.ts:2327] — 보임(기본값) [src:object-manager/objects/polynomial.ts:64], 색 null as null | Color(configs.algebraicColor) [src:base2d/base-advanced-api/configs.ts:131], 선 두께 2(configs.algebraicStrokeWidth) [src:base2d/base-advanced-api/configs.ts:137]",
    "다른 갈래에서 대신 만드는 것, 조건부(targetObject?.data.type === POLYNOMIAL_TYPE): polynomial 1개 (경유 createTransformObject → duplicate → createAlgebraicObject) [src:base2d/base-advanced-api/index.ts:2344] — 보임(기본값) [src:object-manager/objects/polynomial.ts:64], 색 null as null | Color(configs.algebraicColor) [src:base2d/base-advanced-api/configs.ts:131], 선 두께 2(configs.algebraicStrokeWidth) [src:base2d/base-advanced-api/configs.ts:137]",
    "참고: 원본은 그대로 두고 같은 종류의 복사본이 선다 [src:docs/palette/polygon-transform.md:28]",
    "참고: dx 는 x 방향(오른쪽이 양수), dy 는 y 방향(위쪽이 양수)으로 옮기는 좌표 단위 이동량이고 기준 점은 받지 않는다. [src:정합성 polygon-transform: scripts/pipeline/semantic/polygon-transform.mjs 의 시험 '(dx,dy)=(3,-1) / 원본 ...' 의 점, 선분, 직선, 원, 다각형, 곡선 복사본 좌표와 '점 P(1,2) 를 (...) 만큼 → ...']",
    "참고: 화면 도구는 이동량 모달을 열지 않고 원본과 벡터(기존 벡터 또는 점 둘로 만든 새 벡터)를 모아 벡터만큼 옮긴다. 이 호출은 벡터 대신 dx, dy(= 벡터의 끝 - 시작)를 직접 받는다. [src:정합성 polygon-transform: /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d-tools/src/tools/math2d-tools/tool-translation.ts:63-138, /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d/src/base-advanced-api/index.ts:6720, /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d-ui/src/tab/tools/configs/base2d-geometry.ts:494 ; 캔버스 재현 scripts/pipeline/semantic/polygon-transform.mjs 의 시험 '캔버스: 셋째 클릭(벡터 끝점)에서 두 점을 잇는 벡터 개체가 서고 ...', '... 복사본 transform 이 translationByVector 이고 팩토리에는 같은 호출이 없다 ...']",
    "생성 결과: 원본과 같은 종류의 복사본 개체 1개가 서고 반환 id 가 그 복사본이다(점은 보조 점, 선분과 직선은 linear, 원과 호와 부채꼴은 circle, 다각형은 같은 category 의 polygon, 대수 곡선은 polynomial). 다각형 복사본은 꼭짓점 보조 점과 변 선분도 새로 서고 원본은 바뀌지 않는다. [src:정합성 polygon-transform: scripts/pipeline/semantic/polygon-transform.mjs 의 시험 '같은 type(point|linear|circle|polygon|polynomial) 복사본이 유효로 선다', '원본 id 와 다른 새 개체이고 원본은 그대로', '원본의 RO 에 복사본 id 가 더해진다' (원본 점, 선분, 직선, 원, 호, 부채꼴, 삼각형, 직사각형, 정오각형, 곡선 등) 와 기록 '원본 category ... 복사본 category auxiliary']"
   ],
   "range": [
    "originObjectID: 형식 String [src:mathcore-api/object-factory/packages-base/transform-factory.ts:31] [src:mathcore-api/object-factory/object-types.ts:92]",
    "dx: 형식 Number | String [src:mathcore-api/object-factory/packages-base/transform-factory.ts:32] [src:mathcore-api/object-factory/object-types.ts:105]; 숫자가 아닌 문자열이면 슬라이더 연결식으로 들어가 그 값을 따라 움직인다 [src:base2d/base-advanced-api/index.ts:644-654]",
    "dy: 형식 Number | String [src:mathcore-api/object-factory/packages-base/transform-factory.ts:33] [src:mathcore-api/object-factory/object-types.ts:105]; 숫자가 아닌 문자열이면 슬라이더 연결식으로 들어가 그 값을 따라 움직인다 [src:base2d/base-advanced-api/index.ts:644-654]",
    "name?: 형식 String | Undefined [src:mathcore-api/object-factory/packages-base/transform-factory.ts:34] [src:mathcore-api/object-factory/object-types.ts:93]; 생략하면 this.getNewObjectName()(createLinear) [src:base2d/base-advanced-api/index.ts:3363]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): traceColor=undefined, shape=PointShape.Circle, imoji=0, position=[0, 0], domain='점', angle=0 [src:object-manager/objects/point.ts:93-99]",
    "조용히 끝남(만들지 않음): [...pointIDs, pointIDs[0]].length < 3 이면 undefined 반환 [src:base2d/base-advanced-api/index.ts:685]",
    "조용히 끝남(만들지 않음): props.color === undefined 이면 undefined 반환 [src:base2d/base-advanced-api/index.ts:707]",
    "조용히 끝남(만들지 않음): o.numberOfSides < 3 이면 undefined 반환 [src:base2d/base-advanced-api/index.ts:1506]",
    "조용히 끝남(만들지 않음): props.color === undefined 이면 undefined 반환 [src:base2d/base-advanced-api/index.ts:1546]",
    "조용히 끝남(만들지 않음): o.numberOfSides < 3 이면 undefined 반환 [src:base2d/base-advanced-api/index.ts:1649]",
    "조용히 끝남(만들지 않음): props.color === undefined 이면 undefined 반환 [src:base2d/base-advanced-api/index.ts:1688]",
    "조용히 끝남(만들지 않음): props.color === undefined 이면 undefined 반환 [src:base2d/base-advanced-api/index.ts:1830]",
    "조용히 끝남(만들지 않음): props.color === undefined 이면 undefined 반환 [src:base2d/base-advanced-api/index.ts:822]",
    "조용히 끝나는 조건 외 5곳 (경유 createRightTriangle2, createRectangle2, createParallelogram2, createRhombus2, createTrapezoid2) [src:base2d/base-advanced-api/index.ts:943] [src:base2d/base-advanced-api/index.ts:1169] [src:base2d/base-advanced-api/index.ts:1038] [src:base2d/base-advanced-api/index.ts:1300] [src:base2d/base-advanced-api/index.ts:1441]",
    "원본 id 가 없는 개체이거나 복제할 수 없는 종류(슬라이더, 벡터)이면 개체를 만들지 않고 undefined 를 돌려준다. dx, dy 에 null 이나 배열을 주면 예외가 난다. [src:정합성 polygon-transform: scripts/pipeline/semantic/polygon-transform.mjs 의 시험 '원본 자리에 슬라이더, 벡터, 없는 id, 이름 문자열을 넣으면 개체를 만들지 않는다(undefined)', 'dx 가 null 이면 예외', 'dx 에 배열을 주면 예외']"
   ]
  },
  {
   "tool": "math2d",
   "backend": "factory",
   "name": "transform.scale",
   "path": [
    "transform",
    "scale"
   ],
   "params": [
    {
     "name": "originObjectID",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      },
      {
       "type": "linear"
      },
      {
       "type": "circle"
      },
      {
       "type": "chord"
      },
      {
       "type": "polygon"
      },
      {
       "type": "ellipse"
      },
      {
       "type": "polynomial"
      }
     ]
    },
    {
     "name": "pointID",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "scope",
     "type": "number|string",
     "optional": false
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "packages-base/transform-factory.ts",
   "usage": [
    "용도(도구 UI 설명): 점을 중심으로 확대 — 확대시킬 대상을 선택한 후 점을 선택하여 확대시킬 배율을 입력하세요. [src:base2d-ui/src/tab/tools/configs/base2d-geometry.ts:527]",
    "호출: factory.transform.scale → advanced.createEnlargeFromPointObject [src:mathcore-api/object-factory/packages-base/transform-factory.ts:38-44] [src:base2d/base-advanced-api/index.ts:6776-6789]",
    "앞에 있어야 하는 것: originObjectID = 아무 개체 [src:mathcore-api/object-factory/packages-base/transform-factory.ts:38-44]",
    "앞에 있어야 하는 것: pointID = point [src:mathcore-api/object-factory/packages-base/transform-factory.ts:38-44]",
    "만드는 것, 조건부(true 그리고 targetObject?.data.type === POINT_TYPE): point(auxiliary) 1개 (경유 createTransformObject → duplicate → createAuxiliaryPoint) [src:base2d/base-advanced-api/index.ts:2556] — 보임(기본값) [src:object-manager/objects/point.ts:91], 크기 9(configs.pointSize) [src:base2d/base-advanced-api/configs.ts:85], 색 #6e6868(configs.intersectionPointColor) [src:base2d/base-advanced-api/configs.ts:112]",
    "함께 생김, 조건부(true 그리고 targetObject?.data.type === POINT_TYPE): text(nameText) 1개 (경유 createTransformObject → duplicate → createAuxiliaryPoint → createNameText) [src:base2d/base-advanced-api/index.ts:3266] — 보임(기본값) [src:object-manager/objects/text.ts:63], 위치 오프셋(화면 px) [16, -16] [src:base2d/base-advanced-api/index.ts:3268], 크기 16(configs.nametextSize) [src:base2d/base-advanced-api/configs.ts:92], 글꼴 'KaTeX'(configs.nametextFont) [src:base2d/base-advanced-api/configs.ts:94], 색 #000(configs.nametextColor) [src:base2d/base-advanced-api/configs.ts:93], 매인 개체 [point.id] [src:base2d/base-advanced-api/index.ts:3269]",
    "다른 갈래에서 대신 만드는 것, 조건부(targetObject?.data.type === POINT_TYPE): point(point) 1개 (경유 createTransformObject → duplicate → createPoint) [src:base2d/base-advanced-api/index.ts:2479] — 보임(기본값) [src:object-manager/objects/point.ts:91], 크기 9(configs.pointSize) [src:base2d/base-advanced-api/configs.ts:85], 색 #fe7701(configs.pointColor) [src:base2d/base-advanced-api/configs.ts:86]",
    "다른 갈래에서 대신 만드는 것, 조건부(targetObject?.data.type === POINT_TYPE): text(nameText) 1개 (경유 createTransformObject → duplicate → createPoint → createNameText) [src:base2d/base-advanced-api/index.ts:3266] — 보임(기본값) [src:object-manager/objects/text.ts:63], 위치 오프셋(화면 px) [16, -16] [src:base2d/base-advanced-api/index.ts:3268], 크기 16(configs.nametextSize) [src:base2d/base-advanced-api/configs.ts:92], 글꼴 'KaTeX'(configs.nametextFont) [src:base2d/base-advanced-api/configs.ts:94], 색 #000(configs.nametextColor) [src:base2d/base-advanced-api/configs.ts:93], 매인 개체 [point.id] [src:base2d/base-advanced-api/index.ts:3269]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'segment' 그리고 targetObject?.data.type === LINEAR_TYPE): linear(segment) 1개 (경유 createTransformObject → duplicate → createSegment → createLinear) [src:base2d/base-advanced-api/index.ts:3358] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 null as null | Color(configs.linearColor) [src:base2d/base-advanced-api/configs.ts:127], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [p1.id, p2.id] [src:base2d/base-advanced-api/index.ts:3362]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'line' 그리고 targetObject?.data.type === LINEAR_TYPE): linear(line) 1개 (경유 createTransformObject → duplicate → createLine → createLinear) [src:base2d/base-advanced-api/index.ts:3358] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 null as null | Color(configs.linearColor) [src:base2d/base-advanced-api/configs.ts:127], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [p1.id, p2.id] [src:base2d/base-advanced-api/index.ts:3362]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'ray' 그리고 targetObject?.data.type === LINEAR_TYPE): linear(ray) 1개 (경유 createTransformObject → duplicate → createRay → createLinear) [src:base2d/base-advanced-api/index.ts:3358] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 null as null | Color(configs.linearColor) [src:base2d/base-advanced-api/configs.ts:127], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [p1.id, p2.id] [src:base2d/base-advanced-api/index.ts:3362]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'perpendicular' 그리고 targetObject?.data.type === LINEAR_TYPE): linear(perpendicular) 1개 (경유 createTransformObject → duplicate → createPerpendicular → createLinear) [src:base2d/base-advanced-api/index.ts:3358] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 null as null | Color(configs.linearColor) [src:base2d/base-advanced-api/configs.ts:127], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [l, p.id] [src:base2d/base-advanced-api/index.ts:3362]",
    "다른 갈래에서 대신 만드는 것, 조건부(l?.data.type === LINEAR_TYPE 그리고 case 'perpendicularAtMidpoint' 그리고 targetObject?.data.type === LINEAR_TYPE): linear(perpendicularAtMidpoint) 1개 (경유 createTransformObject → duplicate → createPerpendicularAtMidpointBySegmentID → createLinear) [src:base2d/base-advanced-api/index.ts:3358] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 null as null | Color(configs.linearColor) [src:base2d/base-advanced-api/configs.ts:127], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [l.data.id] [src:base2d/base-advanced-api/index.ts:3362]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'perpendicularAtMidpoint' 그리고 targetObject?.data.type === LINEAR_TYPE): linear(perpendicularAtMidpoint) 1개 (경유 createTransformObject → duplicate → createPerpendicularAtMidpointByTwoPointID → createLinear) [src:base2d/base-advanced-api/index.ts:3358] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 null as null | Color(configs.linearColor) [src:base2d/base-advanced-api/configs.ts:127], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [p1.id, p2.id] [src:base2d/base-advanced-api/index.ts:3362]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'bisectorLine' 그리고 targetObject?.data.type === LINEAR_TYPE): linear(bisectorLine) 1개 (경유 createTransformObject → duplicate → createBisectorLine → createLinear) [src:base2d/base-advanced-api/index.ts:3358] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 null as null | Color(configs.linearColor) [src:base2d/base-advanced-api/configs.ts:127], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [p1.id, p2.id, p3.id] [src:base2d/base-advanced-api/index.ts:3362]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'tangentLine' 그리고 targetObject?.data.type === LINEAR_TYPE): point(point) 여러 개(반복문) (경유 createTransformObject → duplicate → createPoint) [src:base2d/base-advanced-api/index.ts:2479] — 보임(기본값) [src:object-manager/objects/point.ts:91], 크기 9(configs.pointSize) [src:base2d/base-advanced-api/configs.ts:85], 색 #fe7701(configs.pointColor) [src:base2d/base-advanced-api/configs.ts:86]",
    "다른 갈래에서 대신 만드는 것, 조건부(r1?.data.type === POINT_TYPE && r2?.data.type ===… 그리고 case 'parallel' 그리고 targetObject?.data.type === LINEAR_TYPE): linear(parallel) 1개 (경유 createTransformObject → duplicate → createParallel → createLinear) [src:base2d/base-advanced-api/index.ts:3358] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 null as null | Color(configs.linearColor) [src:base2d/base-advanced-api/configs.ts:127], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [newPoint.id, r2.data.id] [src:base2d/base-advanced-api/index.ts:3362]",
    "다른 갈래에서 대신 만드는 것, 조건부(r1?.data.type === LINEAR_TYPE && r2?.data.type ==… 그리고 case 'parallel' 그리고 targetObject?.data.type === LINEAR_TYPE): linear(parallel) 1개 (경유 createTransformObject → duplicate → createParallel → createLinear) [src:base2d/base-advanced-api/index.ts:3358] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 null as null | Color(configs.linearColor) [src:base2d/base-advanced-api/configs.ts:127], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [newPoint.id, r1.data.id] [src:base2d/base-advanced-api/index.ts:3362]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'circleCenterPoint' 그리고 targetObject?.data.type === CIRCLE_TYPE): circle(circleCenterPoint) 1개 (경유 createTransformObject → duplicate → createCircleCenterPoint) [src:base2d/base-advanced-api/index.ts:3761] — 보임(기본값) [src:object-manager/objects/circle.ts:79], 색 null as null | Color(configs.circleColor) [src:base2d/base-advanced-api/configs.ts:128], 매인 개체 [p1.id, p2.id] [src:base2d/base-advanced-api/index.ts:3768]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'circleCenterRadius' 그리고 targetObject?.data.type === CIRCLE_TYPE): circle(circleCenterRadius) 1개 (경유 createTransformObject → duplicate → createCircleCenterRadius) [src:base2d/base-advanced-api/index.ts:3738] — 보임(기본값) [src:object-manager/objects/circle.ts:79], 색 null as null | Color(configs.circleColor) [src:base2d/base-advanced-api/configs.ts:128], 매인 개체 [p.id] [src:base2d/base-advanced-api/index.ts:3746]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'triangleCircumCircle' 그리고 targetObject?.data.type === CIRCLE_TYPE): circle(triangleCircumCircle) 1개 (경유 createTransformObject → duplicate → createCircleTriangleCircumCircle) [src:base2d/base-advanced-api/index.ts:3864] — 보임(기본값) [src:object-manager/objects/circle.ts:79], 색 null as null | Color(configs.circleColor) [src:base2d/base-advanced-api/configs.ts:128], 매인 개체 [p1.id, p2.id, p3.id] [src:base2d/base-advanced-api/index.ts:3871]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'triangleCircumArc' 그리고 targetObject?.data.type === CIRCLE_TYPE): circle(triangleCircumArc) 1개 (경유 createTransformObject → duplicate → createTriangleCircumArc) [src:base2d/base-advanced-api/index.ts:3925] — 보임(기본값) [src:object-manager/objects/circle.ts:79], 색 null as null | Color(configs.circleColor) [src:base2d/base-advanced-api/configs.ts:128], 매인 개체 [p1.id, p2.id, p3.id] [src:base2d/base-advanced-api/index.ts:3932]",
    "다른 갈래에서 대신 만드는 것, 조건부(o1?.data.type === CIRCLE_TYPE 그리고 case 'compass' 그리고 targetObject?.data.type === CIRCLE_TYPE): circle(compass) 1개 (경유 createTransformObject → duplicate → createCompassByCircle → createCompassBySegment) [src:base2d/base-advanced-api/index.ts:3988] — 보임(기본값) [src:object-manager/objects/circle.ts:79], 색 null as null | Color(configs.circleColor) [src:base2d/base-advanced-api/configs.ts:128], 매인 개체 [o.relatedObjects[0], p.id] [src:base2d/base-advanced-api/index.ts:3995]",
    "다른 갈래에서 대신 만드는 것, 조건부(o1?.data.type === LINEAR_TYPE 그리고 case 'compass' 그리고 targetObject?.data.type === CIRCLE_TYPE): circle(compass) 1개 (경유 createTransformObject → duplicate → createCompassBySegment) [src:base2d/base-advanced-api/index.ts:3988] — 보임(기본값) [src:object-manager/objects/circle.ts:79], 색 null as null | Color(configs.circleColor) [src:base2d/base-advanced-api/configs.ts:128], 매인 개체 [o.relatedObjects[0], p.id] [src:base2d/base-advanced-api/index.ts:3995]",
    "다른 갈래에서 대신 만드는 것, 조건부(o1?.data.type === POINT_TYPE 그리고 case 'compass' 그리고 targetObject?.data.type === CIRCLE_TYPE): circle(compass) 1개 (경유 createTransformObject → duplicate → createCompassByThreePoint) [src:base2d/base-advanced-api/index.ts:3960] — 보임(기본값) [src:object-manager/objects/circle.ts:79], 색 null as null | Color(configs.circleColor) [src:base2d/base-advanced-api/configs.ts:128], 매인 개체 [o.relatedObjects[0], o.relatedObjects[1], p.id] [src:base2d/base-advanced-api/index.ts:3967]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'arc' 그리고 targetObject?.data.type === CIRCLE_TYPE): circle(arc) 1개 (경유 createTransformObject → duplicate → createArc) [src:base2d/base-advanced-api/index.ts:4023] — 보임(기본값) [src:object-manager/objects/circle.ts:79], 색 null as null | Color(configs.circleColor) [src:base2d/base-advanced-api/configs.ts:128], 매인 개체 [p1.id, p2.id, p3.id, auxiliaryPointID] [src:base2d/base-advanced-api/index.ts:4030]",
    "다른 갈래에서 대신 만드는 것, 조건부(isLineSymmetry 그리고 case 'fan' 그리고 targetObject?.data.type === CIRCLE_TYPE): linear(segment) 여러 개(반복문) (경유 createTransformObject → duplicate → createFan → createAuxiliarySegment) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [p1.id, auxiliaryPointID] [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(!(isLineSymmetry) 그리고 case 'fan' 그리고 targetObject?.data.type === CIRCLE_TYPE): linear(segment) 1개 (경유 createTransformObject → duplicate → createFan → createAuxiliarySegment) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [p1.id, p2.id] [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'fan' 그리고 targetObject?.data.type === CIRCLE_TYPE): circle(fan) 1개 (경유 createTransformObject → duplicate → createFan) [src:base2d/base-advanced-api/index.ts:4133] — 보임(기본값) [src:object-manager/objects/circle.ts:79], 색 color [src:base2d/base-advanced-api/index.ts:4136], 매인 개체 [ p1.id, p2.id, p3.id, auxiliaryPointID, auxiliar… [src:base2d/base-advanced-api/index.ts:4143]",
    "다른 갈래에서 대신 만드는 것, 조건부(isLineSymmetry 그리고 case 'segmentOfACircle' 그리고 targetObject?.data.type === CIRCLE_TYPE): linear(segment) 1개 (경유 createTransformObject → duplicate → createSegmentOfACircle → createAuxiliarySegment) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [p3.id, auxiliaryPointID] [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(!(isLineSymmetry) 그리고 case 'segmentOfACircle' 그리고 targetObject?.data.type === CIRCLE_TYPE): linear(segment) 1개 (경유 createTransformObject → duplicate → createSegmentOfACircle → createAuxiliarySegment) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [p2.id, auxiliaryPointID] [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'segmentOfACircle' 그리고 targetObject?.data.type === CIRCLE_TYPE): circle(segmentOfACircle) 1개 (경유 createTransformObject → duplicate → createSegmentOfACircle) [src:base2d/base-advanced-api/index.ts:4192] — 보임(기본값) [src:object-manager/objects/circle.ts:79], 색 color [src:base2d/base-advanced-api/index.ts:4195], 매인 개체 [ p1.id, p2.id, p3.id, auxiliaryPointID, auxiliar… [src:base2d/base-advanced-api/index.ts:4199]",
    "다른 갈래에서 대신 만드는 것, 조건부(props && props.vertexPoints && props.vertexPoints… 그리고 case 'polygon' 그리고 targetObject?.data.type === POLYGON_TYPE): linear(segment) 여러 개(반복문) (경유 createTransformObject → duplicate → createPolygon → createPolygon2 → createAuxiliarySegment(반복)) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [props.vertexPoints[i], props.vertexPoints[i + 1]] [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'polygon' 그리고 targetObject?.data.type === POLYGON_TYPE): polygon(polygon) 1개 (경유 createTransformObject → duplicate → createPolygon → createPolygon2) [src:base2d/base-advanced-api/index.ts:747] — 보임(기본값) [src:object-manager/objects/polygon.ts:85], 색 color [src:base2d/base-advanced-api/index.ts:695], 매인 개체 [...pointIDs, pointIDs[0]] [src:base2d/base-advanced-api/index.ts:690]",
    "다른 갈래에서 대신 만드는 것, 조건부(props && props.numberOfSides && props.vertexPoint… 그리고 case 'cpPolygon' 그리고 targetObject?.data.type === POLYGON_TYPE): linear(segment) 1개 (경유 createTransformObject → duplicate → createCPPolygon → createCPPolygon2 → createAuxiliarySegment) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [props.auxiliaryPoints[props.auxiliaryPoints.leng… [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'cpPolygon' 그리고 targetObject?.data.type === POLYGON_TYPE): polygon(cpPolygon) 1개 (경유 createTransformObject → duplicate → createCPPolygon → createCPPolygon2) [src:base2d/base-advanced-api/index.ts:1589] — 보임(기본값) [src:object-manager/objects/polygon.ts:85], 색 color [src:base2d/base-advanced-api/index.ts:1526], 매인 개체 [p1.id, p2.id] [src:base2d/base-advanced-api/index.ts:1513]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'lateralPolygon' 그리고 targetObject?.data.type === POLYGON_TYPE): polygon(lateralPolygon) 1개 (경유 createTransformObject → duplicate → createLateralPolygon → createLateralPolygon2) [src:base2d/base-advanced-api/index.ts:1734] — 보임(기본값) [src:object-manager/objects/polygon.ts:85], 색 color [src:base2d/base-advanced-api/index.ts:1669], 매인 개체 [p1.id, p2.id] [src:base2d/base-advanced-api/index.ts:1656]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'rigidPolygon' 그리고 targetObject?.data.type === POLYGON_TYPE): polygon(rigidPolygon) 1개 (경유 createTransformObject → duplicate → createRigidPolygon → createRigidPolygon2) [src:base2d/base-advanced-api/index.ts:1876] — 보임(기본값) [src:object-manager/objects/polygon.ts:85], 색 color [src:base2d/base-advanced-api/index.ts:1812], 매인 개체 [p1.id, p2.id] [src:base2d/base-advanced-api/index.ts:1799]",
    "다른 갈래에서 대신 만드는 것, 조건부(props.hasPolygonDependentPoint 그리고 props && props.relatedObjects && props.relatedObj… 그리고 case 'isoscelesTriangle' 그리고 targetObject?.data.type === POLYGON_TYPE): linear(segment) 여러 개(반복문) (경유 createTransformObject → duplicate → createIsoscelesTriangle → createIsoscelesTriangle2 → createAuxiliarySegment) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [props.relatedObjects[0], props.relatedObjects[1]] [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(!(props.hasPolygonDependentPoint) 그리고 props && props.relatedObjects && props.relatedObj… 그리고 case 'isoscelesTriangle' 그리고 targetObject?.data.type === POLYGON_TYPE): linear(segment) 여러 개(반복문) (경유 createTransformObject → duplicate → createIsoscelesTriangle → createIsoscelesTriangle2 → createAuxiliarySegment) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [props.relatedObjects[0], props.relatedObjects[2]] [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'isoscelesTriangle' 그리고 targetObject?.data.type === POLYGON_TYPE): polygon(isoscelesTriangle) 1개 (경유 createTransformObject → duplicate → createIsoscelesTriangle → createIsoscelesTriangle2) [src:base2d/base-advanced-api/index.ts:863] — 보임(기본값) [src:object-manager/objects/polygon.ts:85], 매인 개체 [p1.id, p2.id, p3.id] [src:base2d/base-advanced-api/index.ts:754]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'rightTriangle' 그리고 targetObject?.data.type === POLYGON_TYPE): polygon(rightTriangle) 1개 (경유 createTransformObject → duplicate → createRightTriangle → createRightTriangle2) [src:base2d/base-advanced-api/index.ts:984] — 보임(기본값) [src:object-manager/objects/polygon.ts:85], 매인 개체 [p1.id, p2.id, p3.id] [src:base2d/base-advanced-api/index.ts:875]",
    "다른 갈래에서 대신 만드는 것, 조건부(!(props.hasPolygonDependentPoint) 그리고 props && props.relatedObjects && props.relatedObj… 그리고 case 'rectangle' 그리고 targetObject?.data.type === POLYGON_TYPE): linear(segment) 여러 개(반복문) (경유 createTransformObject → duplicate → createRectangle → createRectangle2 → createAuxiliarySegment) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [props.relatedObjects[0], props.auxiliaryPoints[0… [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'rectangle' 그리고 targetObject?.data.type === POLYGON_TYPE): polygon(rectangle) 1개 (경유 createTransformObject → duplicate → createRectangle → createRectangle2) [src:base2d/base-advanced-api/index.ts:1217] — 보임(기본값) [src:object-manager/objects/polygon.ts:85], 매인 개체 [p1.id, p2.id, p3.id] [src:base2d/base-advanced-api/index.ts:1099]",
    "다른 갈래에서 대신 만드는 것, 조건부(i === 0 그리고 props && props.relatedObjects && props.relatedObj… 그리고 case 'parallelogram' 그리고 targetObject?.data.type === POLYGON_TYPE): linear(segment) 여러 개(반복문) (경유 createTransformObject → duplicate → createParallelogram → createParallelogram2 → createAuxiliarySegment(반복)) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [props.relatedObjects[0], props.relatedObjects[1]] [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(i === 1 그리고 !(i === 0) 그리고 props && props.relatedObjects && props.relatedObj… 그리고 case 'parallelogram' 그리고 targetObject?.data.type === POLYGON_TYPE): linear(segment) 여러 개(반복문) (경유 createTransformObject → duplicate → createParallelogram → createParallelogram2 → createAuxiliarySegment(반복)) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [props.relatedObjects[1], props.relatedObjects[2]] [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(i === 2 그리고 !(i === 1) 그리고 !(i === 0) 그리고 props && props.relatedObjects && props.relatedObj… 그리고 case 'parallelogram' 그리고 targetObject?.data.type === POLYGON_TYPE): linear(segment) 여러 개(반복문) (경유 createTransformObject → duplicate → createParallelogram → createParallelogram2 → createAuxiliarySegment(반복)) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [props.relatedObjects[2], props.auxiliaryPoints[0… [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(i === 3 그리고 !(i === 2) 그리고 !(i === 1) 그리고 !(i === 0) 그리고 props && props.relatedObjects && props.relatedObj… 그리고 case 'parallelogram' 그리고 targetObject?.data.type === POLYGON_TYPE): linear(segment) 여러 개(반복문) (경유 createTransformObject → duplicate → createParallelogram → createParallelogram2 → createAuxiliarySegment(반복)) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [props.auxiliaryPoints[0], props.relatedObjects[0… [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'parallelogram' 그리고 targetObject?.data.type === POLYGON_TYPE): polygon(parallelogram) 1개 (경유 createTransformObject → duplicate → createParallelogram → createParallelogram2) [src:base2d/base-advanced-api/index.ts:1092] — 보임(기본값) [src:object-manager/objects/polygon.ts:85], 매인 개체 [p1.id, p2.id, p3.id] [src:base2d/base-advanced-api/index.ts:991]",
    "다른 갈래에서 대신 만드는 것, 조건부(!(props.hasPolygonDependentPoint) 그리고 props && props.relatedObjects && props.relatedObj… 그리고 case 'rhombus' 그리고 targetObject?.data.type === POLYGON_TYPE): linear(segment) 1개 (경유 createTransformObject → duplicate → createRhombus → createRhombus2 → createAuxiliarySegment) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [props.auxiliaryPoints[0], props.auxiliaryPoints[… [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'rhombus' 그리고 targetObject?.data.type === POLYGON_TYPE): polygon(rhombus) 1개 (경유 createTransformObject → duplicate → createRhombus → createRhombus2) [src:base2d/base-advanced-api/index.ts:1352] — 보임(기본값) [src:object-manager/objects/polygon.ts:85], 매인 개체 [p1.id, p2.id, p3.id] [src:base2d/base-advanced-api/index.ts:1229]",
    "다른 갈래에서 대신 만드는 것, 조건부(props.hasPolygonDependentPoint 그리고 props && props.relatedObjects && props.relatedObj… 그리고 case 'trapezoid' 그리고 targetObject?.data.type === POLYGON_TYPE): linear(segment) 여러 개(반복문) (경유 createTransformObject → duplicate → createTrapezoid → createTrapezoid2 → createAuxiliarySegment) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [props.relatedObjects[2], props.relatedObjects[3]] [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(!(props.hasPolygonDependentPoint) 그리고 props && props.relatedObjects && props.relatedObj… 그리고 case 'trapezoid' 그리고 targetObject?.data.type === POLYGON_TYPE): linear(segment) 1개 (경유 createTransformObject → duplicate → createTrapezoid → createTrapezoid2 → createAuxiliarySegment) [src:base2d/base-advanced-api/index.ts:3575] — 보임(기본값) [src:object-manager/objects/linear.ts:76], 색 #7b7b7b(configs.auxiliaryObjectColor) [src:base2d/base-advanced-api/configs.ts:109], 선 두께 1(configs.linearStrokeWidth) [src:base2d/base-advanced-api/configs.ts:133], 매인 개체 [props.relatedObjects[1], props.auxiliaryPoints[0… [src:base2d/base-advanced-api/index.ts:3579]",
    "다른 갈래에서 대신 만드는 것, 조건부(case 'trapezoid' 그리고 targetObject?.data.type === POLYGON_TYPE): polygon(trapezoid) 1개 (경유 createTransformObject → duplicate → createTrapezoid → createTrapezoid2) [src:base2d/base-advanced-api/index.ts:1493] — 보임(기본값) [src:object-manager/objects/polygon.ts:85], 매인 개체 [p1.id, p2.id, p3.id, p4.id] [src:base2d/base-advanced-api/index.ts:1365]",
    "다른 갈래에서 대신 만드는 것, 조건부(targetObject?.data.type === TEXT_TYPE): text 1개 (경유 createTransformObject → duplicate → createText) [src:base2d/base-advanced-api/index.ts:3203] — 보임(기본값) [src:object-manager/objects/text.ts:63], 크기 o.size [src:base2d/base-advanced-api/index.ts:3207], 글꼴 o.font! [src:base2d/base-advanced-api/index.ts:3208], 색 #000(configs.textColor) [src:base2d/base-advanced-api/configs.ts:90], latex=o.latex [src:base2d/base-advanced-api/index.ts:3206], isScreenCoord=true [src:base2d/base-advanced-api/index.ts:3212]",
    "다른 갈래에서 대신 만드는 것, 조건부(targetObject?.data.type === DRAWING_TYPE): drawing 1개 (경유 createTransformObject → duplicate → createDrawingObject) [src:base2d/base-advanced-api/index.ts:4233] — 보임(공통 기본값) [src:object-manager/objects/common.ts:38], 색 null as null | Color(configs.drawingColor) [src:base2d/base-advanced-api/configs.ts:130], 선 두께 2(configs.drawingStrokeWidth) [src:base2d/base-advanced-api/configs.ts:135]",
    "다른 갈래에서 대신 만드는 것, 조건부(targetObject?.data.type === IMAGE_TYPE): image 1개 (경유 createTransformObject → duplicate → createImage) [src:base2d/base-advanced-api/index.ts:4371] — 보임(기본값) [src:object-manager/objects/image.ts:37], isScreenCoord=false [src:base2d/base-advanced-api/index.ts:4378]",
    "다른 갈래에서 대신 만드는 것, 조건부(targetObject?.data.type === ELLIPSE_TYPE): ellipse 1개 (경유 createTransformObject → duplicate → createEllipse) [src:base2d/base-advanced-api/index.ts:3876] — 보임(기본값) [src:object-manager/objects/ellipse.ts:52], 색 null as null | Color(configs.circleColor) [src:base2d/base-advanced-api/configs.ts:128], 매인 개체 [p1.id, p2.id, p3.id] [src:base2d/base-advanced-api/index.ts:3882]",
    "다른 갈래에서 대신 만드는 것, 조건부(this.typingParser.isValid() 그리고 targetObject?.data.type === POLYNOMIAL_TYPE): polynomial 1개 (경유 createTransformObject → duplicate → createAlgebraicObject) [src:base2d/base-advanced-api/index.ts:2281] — 보임(기본값) [src:object-manager/objects/polynomial.ts:64], 색 null as null | Color(configs.algebraicColor) [src:base2d/base-advanced-api/configs.ts:131], 선 두께 2(configs.algebraicStrokeWidth) [src:base2d/base-advanced-api/configs.ts:137]",
    "다른 갈래에서 대신 만드는 것, 조건부(this.typingParser.isValid() 그리고 targetObject?.data.type === POLYNOMIAL_TYPE): text(nameText) 1개 (경유 createTransformObject → duplicate → createAlgebraicObject → createNameTextByPolynomial) [src:base2d/base-advanced-api/index.ts:3339] — 숨김 [src:base2d/base-advanced-api/index.ts:3349], 위치 오프셋(화면 px) [24, -24] || [16, -16] [src:base2d/base-advanced-api/index.ts:3341], 크기 16(configs.nametextSize) [src:base2d/base-advanced-api/configs.ts:92], 색 #000(configs.nametextColor) [src:base2d/base-advanced-api/configs.ts:93], latex=true [src:base2d/base-advanced-api/index.ts:3350], 매인 개체 [object.id] [src:base2d/base-advanced-api/index.ts:3342]",
    "다른 갈래에서 대신 만드는 것, 조건부(this.typingLexer.isEmpty() 그리고 this.typingLexer.process(o.expr) 그리고 targetObject?.data.type === POLYNOMIAL_TYPE): polynomial 1개 (경유 createTransformObject → duplicate → createAlgebraicObject) [src:base2d/base-advanced-api/index.ts:2299] — 보임(기본값) [src:object-manager/objects/polynomial.ts:64], 색 null as null | Color(configs.algebraicColor) [src:base2d/base-advanced-api/configs.ts:131], 선 두께 2(configs.algebraicStrokeWidth) [src:base2d/base-advanced-api/configs.ts:137]",
    "다른 갈래에서 대신 만드는 것, 조건부(firstToken.type === TokenType.OPENING_PAREN && la… 그리고 this.typingLexer.process(o.expr) 그리고 targetObject?.data.type === POLYNOMIAL_TYPE): point(point) 1개 (경유 createTransformObject → duplicate → createAlgebraicObject → createPoint) [src:base2d/base-advanced-api/index.ts:2479] — 보임(기본값) [src:object-manager/objects/point.ts:91], 크기 9(configs.pointSize) [src:base2d/base-advanced-api/configs.ts:85], 색 #fe7701(configs.pointColor) [src:base2d/base-advanced-api/configs.ts:86]",
    "다른 갈래에서 대신 만드는 것, 조건부(this.typingLexer.process(o.expr) 그리고 targetObject?.data.type === POLYNOMIAL_TYPE): polynomial 1개 (경유 createTransformObject → duplicate → createAlgebraicObject) [src:base2d/base-advanced-api/index.ts:2327] — 보임(기본값) [src:object-manager/objects/polynomial.ts:64], 색 null as null | Color(configs.algebraicColor) [src:base2d/base-advanced-api/configs.ts:131], 선 두께 2(configs.algebraicStrokeWidth) [src:base2d/base-advanced-api/configs.ts:137]",
    "다른 갈래에서 대신 만드는 것, 조건부(targetObject?.data.type === POLYNOMIAL_TYPE): polynomial 1개 (경유 createTransformObject → duplicate → createAlgebraicObject) [src:base2d/base-advanced-api/index.ts:2344] — 보임(기본값) [src:object-manager/objects/polynomial.ts:64], 색 null as null | Color(configs.algebraicColor) [src:base2d/base-advanced-api/configs.ts:131], 선 두께 2(configs.algebraicStrokeWidth) [src:base2d/base-advanced-api/configs.ts:137]",
    "참고: 원본은 그대로 두고 같은 종류의 복사본이 선다 [src:docs/palette/polygon-transform.md:28]",
    "참고: pointID 가 확대 중심이고 scope 가 배율이며 새 좌표는 중심 + (원본 좌표 - 중심) × scope 이다(음수는 중심 반대쪽, 0 은 모두 중심에 겹친다). 호, 부채꼴, 활꼴, 세 점을 지나는 원은 중심과 꼭짓점 점만 옮겨지고 반지름이 원본 그대로여서 확대되지 않으므로 이들에는 쓰지 않는다(중심과 반지름으로 세운 원과 중심과 한 점으로 세운 원은 반지름도 |scope| 배가 된다). [src:정합성 polygon-transform: scripts/pipeline/semantic/polygon-transform.mjs 의 시험 '배율은 scope 이고 pointID 는 확대의 중심이다', '중심 Q(1,-1), 배율 2 / 원본 호·부채꼴·세 점을 지나는 원·활꼴(semiCircle): 복사본 반지름 ...' 8건 실패, '... 원본 원: 복사본 반지름 ...' 와 '... 원본 원(중심과 한 점): ...' 통과, 소스 packages/object-manager/src/objects/circle.ts:731, 387]",
    "참고: 화면 도구는 원본과 확대 중심을 누른 뒤 배율 모달(기본 1.2, 단위 없음)을 받아 같은 호출(원본, 중심, 배율)을 한다. 화면 도구는 배율 0 을 거르지만 이 호출은 배율 0 이면 모든 점이 중심에 겹치는 복사본을 만든다. [src:정합성 polygon-transform: /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d-tools/src/tools/math2d-tools/tool-enlarge-from-point.ts:54-92 (87-92 if (angle) 거름), /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d-ui/src/modal/modals/create-enlarge-from-point-modal/index.tsx:3-18, /root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d-ui/src/tab/tools/configs/base2d-geometry.ts:524 ; 캔버스 재현 scripts/pipeline/semantic/polygon-transform.mjs 의 시험 '캔버스: 두 번째 클릭(중심)에서 모달 값 2 를 받아 배율 2 로 확대한 복사본이 선다', 일반 시험 '점 P(1,2) 를 원점 중심 배율 0 (=0)']",
    "생성 결과: 원본과 같은 종류의 복사본 개체 1개가 서고 반환 id 가 그 복사본이다(점은 보조 점, 선분과 직선은 linear, 원과 호와 부채꼴은 circle, 다각형은 같은 category 의 polygon, 대수 곡선은 polynomial). 다각형 복사본은 꼭짓점 보조 점과 변 선분도 새로 서고 원본은 바뀌지 않는다. [src:정합성 polygon-transform: scripts/pipeline/semantic/polygon-transform.mjs 의 시험 '같은 type(point|linear|circle|polygon|polynomial) 복사본이 유효로 선다', '원본 id 와 다른 새 개체이고 원본은 그대로', '원본의 RO 에 복사본 id 가 더해진다' (원본 점, 선분, 직선, 원, 호, 부채꼴, 삼각형, 직사각형, 정오각형, 곡선 등) 와 기록 '원본 category ... 복사본 category auxiliary']"
   ],
   "range": [
    "originObjectID: 형식 String [src:mathcore-api/object-factory/packages-base/transform-factory.ts:39] [src:mathcore-api/object-factory/object-types.ts:92]",
    "pointID: 형식 String [src:mathcore-api/object-factory/packages-base/transform-factory.ts:40] [src:mathcore-api/object-factory/object-types.ts:92]",
    "scope: 형식 Number | String [src:mathcore-api/object-factory/packages-base/transform-factory.ts:41] [src:mathcore-api/object-factory/object-types.ts:105]; 숫자가 아닌 문자열이면 슬라이더 연결식으로 들어가 그 값을 따라 움직인다 [src:base2d/base-advanced-api/index.ts:644-654]",
    "name?: 형식 String | Undefined [src:mathcore-api/object-factory/packages-base/transform-factory.ts:42] [src:mathcore-api/object-factory/object-types.ts:93]; 생략하면 this.getNewObjectName()(createLinear) [src:base2d/base-advanced-api/index.ts:3363]",
    "형식 검사를 어기면 예외: \"<값> is not assignable to type …\" [src:mathcore-api/object-factory/object-types.ts:657]",
    "인자로 못 정하는 속성(생성 기본값): traceColor=undefined, shape=PointShape.Circle, imoji=0, position=[0, 0], domain='점', angle=0 [src:object-manager/objects/point.ts:93-99]",
    "조용히 끝남(만들지 않음): [...pointIDs, pointIDs[0]].length < 3 이면 undefined 반환 [src:base2d/base-advanced-api/index.ts:685]",
    "조용히 끝남(만들지 않음): props.color === undefined 이면 undefined 반환 [src:base2d/base-advanced-api/index.ts:707]",
    "조용히 끝남(만들지 않음): o.numberOfSides < 3 이면 undefined 반환 [src:base2d/base-advanced-api/index.ts:1506]",
    "조용히 끝남(만들지 않음): props.color === undefined 이면 undefined 반환 [src:base2d/base-advanced-api/index.ts:1546]",
    "조용히 끝남(만들지 않음): o.numberOfSides < 3 이면 undefined 반환 [src:base2d/base-advanced-api/index.ts:1649]",
    "조용히 끝남(만들지 않음): props.color === undefined 이면 undefined 반환 [src:base2d/base-advanced-api/index.ts:1688]",
    "조용히 끝남(만들지 않음): props.color === undefined 이면 undefined 반환 [src:base2d/base-advanced-api/index.ts:1830]",
    "조용히 끝남(만들지 않음): props.color === undefined 이면 undefined 반환 [src:base2d/base-advanced-api/index.ts:822]",
    "조용히 끝나는 조건 외 5곳 (경유 createRightTriangle2, createRectangle2, createParallelogram2, createRhombus2, createTrapezoid2) [src:base2d/base-advanced-api/index.ts:943] [src:base2d/base-advanced-api/index.ts:1169] [src:base2d/base-advanced-api/index.ts:1038] [src:base2d/base-advanced-api/index.ts:1300] [src:base2d/base-advanced-api/index.ts:1441]",
    "원본 id 가 없는 개체이거나 복제할 수 없는 종류(슬라이더, 벡터)이면 개체를 만들지 않고 undefined 를 돌려준다. 확대 중심 점 id 가 없는 개체여도 undefined 이다. [src:정합성 polygon-transform: scripts/pipeline/semantic/polygon-transform.mjs 의 시험 '원본 자리에 슬라이더, 벡터, 없는 id, 이름 문자열을 넣으면 개체를 만들지 않는다(undefined)', '중심 자리에 없는 id 를 넣으면 ...']"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.setGeneratePosition",
   "command": "object.setGeneratePosition",
   "params": [
    {
     "name": "position",
     "type": "point3",
     "optional": false
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.setGeneratePosition\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1503-1505]",
    "바꾸는 것: state.__generatePosition [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1504]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "position: 형식 point3(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1503]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.makeGroup",
   "command": "object.makeGroup",
   "params": [
    {
     "name": "objectIDs",
     "type": "ref[]",
     "optional": false,
     "accepts": "any"
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.makeGroup\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1507-1509]",
    "앞에 있어야 하는 것: objectIDs ref[] = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1507-1509]",
    "바꾸는 것: object.groupIdList 에 추가 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:346]",
    "바꾸는 것: state.groupMap[groupID] [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:349]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "objectIDs: 형식 ref[](TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1507]",
    "조용히 끝남(아무것도 안 함): !object || object.groupIdList.includes(groupID) 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:338]",
    "조용히 끝남(아무것도 안 함): objects.length === 0 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:342]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.destroyGroup",
   "command": "object.destroyGroup",
   "params": [
    {
     "name": "groupID",
     "type": "ref",
     "optional": false,
     "accepts": "any"
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.destroyGroup\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1511-1513]",
    "앞에 있어야 하는 것: groupID = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1511-1513]",
    "바꾸는 것: object.groupIdList [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:363]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "groupID: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1511]",
    "조용히 끝남(아무것도 안 함): !objectIDs 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:358]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.addPoint",
   "command": "object.addPoint",
   "params": [
    {
     "name": "position",
     "type": "point3",
     "optional": false
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    },
    {
     "name": "shape",
     "type": "'sphere'|'tetrahedron'|'cube'|'octahedron'|'dodecahedron'|'icosahedron'",
     "optional": true
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도(도구 UI 설명): 점 — 점을 만들 위치를 선택하세요. [src:base2d-ui/src/tab/tools/configs/base2d-geometry.ts:58]",
    "호출: commandManager.execute(\"object.addPoint\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1515-1537]",
    "만드는 것: point(generalPoint) 1개 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1517] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 #005cff(_defaultProperties.normalPointColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:32], 크기 0.4(_defaultProperties.normalPointSize) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:33], 모양 기본 \"sphere\" [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1520], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible true [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:37], relatedPosition [12, -10] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:38], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79], 끌어서 움직일 수 있음(generalPoint) [src:math3d/src/app/math3d/state-manager/object-types/math3d-point.ts:17] [src:math3d/src/app/math3d/state-manager/object-types/index.ts:46-51]",
    "바꾸는 것: state.__returnValue [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1536]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "position: 형식 point3(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1515]; 문자열이면 슬라이더 변수식으로 계산된다 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1515]",
    "name?: 형식 string(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1515]; 생략하면 objectCommandUtils.getNextPointName(state) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1523]",
    "shape?: 형식 'sphere'|'tetrahedron'|'cube'|'octahedron'|'dodecahedron'|'icosahedron'(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1515]; 생략하면 \"sphere\" [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1520]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.addPointOnObject",
   "command": "object.addPointOnObject",
   "params": [
    {
     "name": "position",
     "type": "point3",
     "optional": false
    },
    {
     "name": "referenceID1",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "linear"
      },
      {
       "type": "plane"
      },
      {
       "type": "circular"
      },
      {
       "type": "sphere"
      },
      {
       "type": "cylindroconical"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도(도구 UI 설명): 대상 위의 점 — 선 또는 다각형을 선택하세요. [src:base2d-ui/src/tab/tools/configs/base2d-geometry.ts:78]",
    "호출: commandManager.execute(\"object.addPointOnObject\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1539-1565]",
    "앞에 있어야 하는 것: referenceID1 = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1539-1565]",
    "만드는 것: point(pointOnObject) 1개 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1544] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 #7b7b7b(_defaultProperties.dependentPointColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:34], 크기 0.4(_defaultProperties.normalPointSize) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:33], 모양 'cube'(_defaultProperties.constraintPointShape) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:36], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible true [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:37], relatedPosition [12, -10] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:38], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79], 끌어서 움직일 수 있음(pointOnObject) [src:math3d/src/app/math3d/state-manager/object-types/math3d-point.ts:17] [src:math3d/src/app/math3d/state-manager/object-types/index.ts:46-51]",
    "바꾸는 것: state.__returnValue [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1564]",
    "참고: 선, 평면(다각형 포함), 원, 구, 원뿔, 원기둥 위에 점을 세운다. 각뿔과 다면체, 식의 곡면을 주면 무효 개체가 선다. [src:정합성 math3d-kinds: scripts/pipeline/kind-matrix3d.mjs 의 시험 object.addPointOnObject 에 장면 개체 종류 조합 22건을 넣어 유효 14건(증거 evidence/runs/2026-10-22/math3d/kind-matrix3d-3.json)]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "position: 형식 point3(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1539]; 문자열이면 슬라이더 변수식으로 계산된다 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1539]",
    "referenceID1: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1539]",
    "name?: 형식 string(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1539]; 생략하면 objectCommandUtils.getNextPointName(state) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1549]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.addMiddlePointFromTwoPoint",
   "command": "object.addMiddlePointFromTwoPoint",
   "params": [
    {
     "name": "pointID1",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "pointID2",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.addMiddlePointFromTwoPoint\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1567-1584]",
    "앞에 있어야 하는 것: pointID1 = point [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1567-1584]",
    "앞에 있어야 하는 것: pointID2 = point [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1567-1584]",
    "만드는 것: point(middlePointFromTwoPoint) 1개 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1568] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 #7b7b7b(_defaultProperties.dependentPointColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:34], 크기 0.4(_defaultProperties.normalPointSize) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:33], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible true [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:37], relatedPosition [12, -10] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:38], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79], 끌어서 움직일 수 없음(middlePointFromTwoPoint, 이동 가능 분류 generalPoint, pointOnObject, rotateHandlePoint) [src:math3d/src/app/math3d/state-manager/object-types/math3d-point.ts:17] [src:math3d/src/app/math3d/state-manager/object-types/index.ts:46-51]",
    "바꾸는 것: state.__returnValue [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1583]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "pointID1: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1567]",
    "pointID2: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1567]",
    "name?: 형식 string(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1567]; 생략하면 objectCommandUtils.getNextPointName(state) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1573]",
    "인자로 못 정하는 속성(생성 기본값): position=[0, 0, 0], shape='sphere' [src:math3d/src/app/math3d/state-manager/object-types/math3d-point.ts:61]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.addMiddlePointFromSegment",
   "command": "object.addMiddlePointFromSegment",
   "params": [
    {
     "name": "segmentID",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "linear",
       "category": "segment"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도(도구 UI 설명): 중점 — 선분 또는 두 점을 선택하세요. [src:base2d-ui/src/tab/tools/configs/base2d-geometry.ts:67]",
    "호출: commandManager.execute(\"object.addMiddlePointFromSegment\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1586-1603]",
    "앞에 있어야 하는 것: segmentID = linear(segment) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1586-1603]",
    "만드는 것: point(middlePointFromSegment) 1개 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1587] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 #7b7b7b(_defaultProperties.dependentPointColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:34], 크기 0.4(_defaultProperties.normalPointSize) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:33], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible true [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:37], relatedPosition [12, -10] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:38], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79], 끌어서 움직일 수 없음(middlePointFromSegment, 이동 가능 분류 generalPoint, pointOnObject, rotateHandlePoint) [src:math3d/src/app/math3d/state-manager/object-types/math3d-point.ts:17] [src:math3d/src/app/math3d/state-manager/object-types/index.ts:46-51]",
    "바꾸는 것: state.__returnValue [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1602]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "segmentID: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1586]",
    "name?: 형식 string(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1586]; 생략하면 objectCommandUtils.getNextPointName(state) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1592]",
    "인자로 못 정하는 속성(생성 기본값): position=[0, 0, 0], shape='sphere' [src:math3d/src/app/math3d/state-manager/object-types/math3d-point.ts:61]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.addSegment",
   "command": "object.addSegment",
   "params": [
    {
     "name": "pointID1",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "pointID2",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도(도구 UI 설명): 선분 — 두 점을 선택하세요. [src:base2d-ui/src/tab/tools/configs/base2d-geometry.ts:126]",
    "호출: commandManager.execute(\"object.addSegment\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1605-1622]",
    "앞에 있어야 하는 것: pointID1 = point [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1605-1622]",
    "앞에 있어야 하는 것: pointID2 = point [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1605-1622]",
    "만드는 것: linear(generalSegment) 1개 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1606] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 null(_defaultProperties.linearColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:40], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible false [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:42], relatedPosition [0, 0] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:43], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79]",
    "바꾸는 것: state.__returnValue [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1621]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "pointID1: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1605]",
    "pointID2: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1605]",
    "name?: 형식 string(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1605]; 생략하면 objectCommandUtils.getNextObjectName(state, \"lowercase\") [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1611]",
    "인자로 못 정하는 속성(생성 기본값): dashed=false, coordinates=[[0, 0, 0], [0, 0, 0]] [src:math3d/src/app/math3d/state-manager/object-types/math3d-linear.ts:57]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.addLine",
   "command": "object.addLine",
   "params": [
    {
     "name": "pointID1",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "pointID2",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도(도구 UI 설명): 직선 — 두 점을 선택하세요. [src:base2d-ui/src/tab/tools/configs/base2d-geometry.ts:126]",
    "호출: commandManager.execute(\"object.addLine\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1624-1641]",
    "앞에 있어야 하는 것: pointID1 = point [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1624-1641]",
    "앞에 있어야 하는 것: pointID2 = point [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1624-1641]",
    "만드는 것: linear(generalLine) 1개 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1625] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 null(_defaultProperties.linearColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:40], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible false [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:42], relatedPosition [0, 0] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:43], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79]",
    "바꾸는 것: state.__returnValue [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1640]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "pointID1: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1624]",
    "pointID2: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1624]",
    "name?: 형식 string(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1624]; 생략하면 objectCommandUtils.getNextObjectName(state, \"lowercase\") [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1630]",
    "인자로 못 정하는 속성(생성 기본값): dashed=false, coordinates=[[0, 0, 0], [0, 0, 0]] [src:math3d/src/app/math3d/state-manager/object-types/math3d-linear.ts:57]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.addDefaultLine",
   "command": "object.addDefaultLine",
   "params": [
    {
     "name": "coordinates",
     "type": "point3[2]",
     "optional": false
    },
    {
     "name": "id",
     "type": "number",
     "optional": false
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.addDefaultLine\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1643-1653]",
    "만드는 것: linear(defaultLine) 1개 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1644] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120]",
    "바꾸는 것: state.__returnValue [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1652]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "coordinates: 형식 point3[2](TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1643]",
    "id: 형식 number(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1643]",
    "name?: 형식 string(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1643]; 생략하면 '' [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1649]",
    "인자로 못 정하는 속성(생성 기본값): lineWidth=0.3, dashed=false [src:math3d/src/app/math3d/state-manager/object-types/math3d-linear.ts:56]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.addRay",
   "command": "object.addRay",
   "params": [
    {
     "name": "pointID1",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "pointID2",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도(도구 UI 설명): 반직선 — 두 점을 선택하세요. [src:base2d-ui/src/tab/tools/configs/base2d-geometry.ts:126]",
    "호출: commandManager.execute(\"object.addRay\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1655-1672]",
    "앞에 있어야 하는 것: pointID1 = point [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1655-1672]",
    "앞에 있어야 하는 것: pointID2 = point [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1655-1672]",
    "만드는 것: linear(generalRay) 1개 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1656] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 null(_defaultProperties.linearColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:40], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible false [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:42], relatedPosition [0, 0] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:43], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79]",
    "바꾸는 것: state.__returnValue [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1671]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "pointID1: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1655]",
    "pointID2: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1655]",
    "name?: 형식 string(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1655]; 생략하면 objectCommandUtils.getNextObjectName(state, \"lowercase\") [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1661]",
    "인자로 못 정하는 속성(생성 기본값): dashed=false, coordinates=[[0, 0, 0], [0, 0, 0]] [src:math3d/src/app/math3d/state-manager/object-types/math3d-linear.ts:57]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.addParallelLine",
   "command": "object.addParallelLine",
   "params": [
    {
     "name": "pointID1",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "referenceID1",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "linear"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도(도구 UI 설명): 평행선 — 평행이 될 선을 선택하고 만들 위치를 선택하거나, 만들 위치를 선택하고 평행이 될 선을 선택하세요. [src:base2d-ui/src/tab/tools/configs/base2d-geometry.ts:163]",
    "호출: commandManager.execute(\"object.addParallelLine\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1674-1691]",
    "앞에 있어야 하는 것: pointID1 = point [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1674-1691]",
    "앞에 있어야 하는 것: referenceID1 = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1674-1691]",
    "만드는 것: linear(parallelLine) 1개 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1675] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 null(_defaultProperties.linearColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:40], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible false [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:42], relatedPosition [0, 0] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:43], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79]",
    "바꾸는 것: state.__returnValue [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1690]",
    "참고: 평행할 기준은 선분, 직선, 반직선, 벡터만 받는다. 점 pointID1 을 지나는 평행선이 선다. [src:정합성 math3d-kinds: scripts/pipeline/kind-matrix3d.mjs 의 시험 object.addParallelLine 에 장면 개체 종류 조합 22건을 넣어 유효 8건(증거 evidence/runs/2026-10-22/math3d/kind-matrix3d-3.json)]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "pointID1: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1674]",
    "referenceID1: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1674]",
    "name?: 형식 string(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1674]; 생략하면 objectCommandUtils.getNextObjectName(state, \"lowercase\") [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1680]",
    "인자로 못 정하는 속성(생성 기본값): dashed=false, coordinates=[[0, 0, 0], [0, 0, 0]] [src:math3d/src/app/math3d/state-manager/object-types/math3d-linear.ts:57]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.addPerpendicularLine",
   "command": "object.addPerpendicularLine",
   "params": [
    {
     "name": "pointID1",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "referenceID1",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "linear"
      },
      {
       "type": "plane"
      },
      {
       "type": "circular"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도(도구 UI 설명): 수직선 — 수직이 될 선을 선택하고 만들 위치를 선택하거나, 만들 위치를 선택하고 수직이 될 선을 선택하세요. [src:base2d-ui/src/tab/tools/configs/base2d-geometry.ts:172]",
    "호출: commandManager.execute(\"object.addPerpendicularLine\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1693-1710]",
    "앞에 있어야 하는 것: pointID1 = point [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1693-1710]",
    "앞에 있어야 하는 것: referenceID1 = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1693-1710]",
    "만드는 것: linear(perpendicularLine) 1개 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1694] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 null(_defaultProperties.linearColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:40], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible false [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:42], relatedPosition [0, 0] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:43], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79]",
    "바꾸는 것: state.__returnValue [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1709]",
    "참고: 수직의 기준으로 선(선분, 직선, 반직선, 벡터), 평면(다각형 포함), 원을 받는다. 점 pointID1 을 지나는 수선이 선다. 구, 다면체, 원뿔, 원기둥은 무효 개체가 선다. [src:정합성 math3d-kinds: scripts/pipeline/kind-matrix3d.mjs 의 시험 object.addPerpendicularLine 에 장면 개체 종류 조합 22건을 넣어 유효 8건(증거 evidence/runs/2026-10-22/math3d/kind-matrix3d-3.json)]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "pointID1: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1693]",
    "referenceID1: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1693]",
    "name?: 형식 string(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1693]; 생략하면 objectCommandUtils.getNextObjectName(state, \"lowercase\") [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1699]",
    "인자로 못 정하는 속성(생성 기본값): dashed=false, coordinates=[[0, 0, 0], [0, 0, 0]] [src:math3d/src/app/math3d/state-manager/object-types/math3d-linear.ts:57]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.addTangentLine",
   "command": "object.addTangentLine",
   "params": [
    {
     "name": "curveID",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "unknown": "curve"
      }
     ]
    },
    {
     "name": "referenceID",
     "type": "ref",
     "optional": false,
     "accepts": "any"
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도(도구 UI 설명): 접선 — 접선을 생성할 원을 선택하고 접선이 지나는 점 또는 접선의 기울기가 될 선을 선택하세요. [src:math3d-ui/src/app/components/tabs/geometry/config.ts:235]",
    "호출: commandManager.execute(\"object.addTangentLine\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1712-1748]",
    "앞에 있어야 하는 것: curveID = 미확인(curve) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1712-1748]",
    "앞에 있어야 하는 것: referenceID = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1712-1748]",
    "만드는 것: linear(tangentLine) 1개 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1713] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 null(_defaultProperties.linearColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:40], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible false [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:42], relatedPosition [0, 0] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:43], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79]",
    "함께 생김: linear(tangentLine) 1개 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1729] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 null(_defaultProperties.linearColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:40], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible false [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:42], relatedPosition [0, 0] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:43], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79]",
    "바꾸는 것: state.__returnValue [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1747]",
    "참고: 개체를 번호 두 개의 배열로 돌려준다(접선 2개). 이 시험은 무효 여부만 가렸고 접선의 기하는 확인하지 않았다. [src:정합성 math3d-kinds: scripts/pipeline/kind-matrix3d.mjs 의 시험 object.addTangentLine 에 장면 개체 종류 조합 22건을 넣어 유효 11건(증거 evidence/runs/2026-10-22/math3d/kind-matrix3d-3.json)]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "curveID: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1712]",
    "referenceID: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1712]",
    "name?: 형식 string(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1712]; 생략하면 objectCommandUtils.getNextObjectName(state, \"lowercase\") [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1718]",
    "인자로 못 정하는 속성(생성 기본값): dashed=false, coordinates=[[0, 0, 0], [0, 0, 0]] [src:math3d/src/app/math3d/state-manager/object-types/math3d-linear.ts:57]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.addAngleBisectorLine",
   "command": "object.addAngleBisectorLine",
   "params": [
    {
     "name": "pointID1",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "pointID2",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "pointID3",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도(도구 UI 설명): 각의 이등분선 — 세 점을 선택하세요. [src:base2d-ui/src/tab/tools/configs/base2d-geometry.ts:190]",
    "호출: commandManager.execute(\"object.addAngleBisectorLine\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1750-1767]",
    "앞에 있어야 하는 것: pointID1 = point [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1750-1767]",
    "앞에 있어야 하는 것: pointID2 = point [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1750-1767]",
    "앞에 있어야 하는 것: pointID3 = point [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1750-1767]",
    "만드는 것: linear(angleBisectorLine) 1개 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1751] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 null(_defaultProperties.linearColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:40], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible false [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:42], relatedPosition [0, 0] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:43], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79]",
    "바꾸는 것: state.__returnValue [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1766]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "pointID1: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1750]",
    "pointID2: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1750]",
    "pointID3: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1750]",
    "name?: 형식 string(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1750]; 생략하면 objectCommandUtils.getNextObjectName(state, \"lowercase\") [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1756]",
    "인자로 못 정하는 속성(생성 기본값): dashed=false, coordinates=[[0, 0, 0], [0, 0, 0]] [src:math3d/src/app/math3d/state-manager/object-types/math3d-linear.ts:57]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.addVector",
   "command": "object.addVector",
   "params": [
    {
     "name": "pointID1",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "pointID2",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도(도구 UI 설명): 벡터 — 시작점을 선택한 후 끝점을 선택하세요. [src:base2d-ui/src/tab/tools/configs/base2d-geometry.ts:215]",
    "호출: commandManager.execute(\"object.addVector\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1769-1786]",
    "앞에 있어야 하는 것: pointID1 = point [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1769-1786]",
    "앞에 있어야 하는 것: pointID2 = point [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1769-1786]",
    "만드는 것: linear(generalVector) 1개 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1770] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 null(_defaultProperties.linearColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:40], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible false [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:42], relatedPosition [0, 0] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:43], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79]",
    "바꾸는 것: state.__returnValue [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1785]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "pointID1: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1769]",
    "pointID2: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1769]",
    "name?: 형식 string(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1769]; 생략하면 objectCommandUtils.getNextObjectName(state, \"lowercase\") [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1775]",
    "인자로 못 정하는 속성(생성 기본값): dashed=false, coordinates=[[0, 0, 0], [0, 0, 0]] [src:math3d/src/app/math3d/state-manager/object-types/math3d-linear.ts:57]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.addCircleFromThreePoints",
   "command": "object.addCircleFromThreePoints",
   "params": [
    {
     "name": "pointID1",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "pointID2",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "pointID3",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도(도구 UI 설명): 원: 세 점 — 세 점을 선택하세요. [src:base2d-ui/src/tab/tools/configs/base2d-geometry.ts:190]",
    "호출: commandManager.execute(\"object.addCircleFromThreePoints\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1788-1805]",
    "앞에 있어야 하는 것: pointID1 = point [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1788-1805]",
    "앞에 있어야 하는 것: pointID2 = point [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1788-1805]",
    "앞에 있어야 하는 것: pointID3 = point [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1788-1805]",
    "만드는 것: circular(generalCircleFromThreePoints) 1개 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1789] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 null(_defaultProperties.linearColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:40], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible false [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:42], relatedPosition [0, 0] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:43], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79]",
    "바꾸는 것: state.__returnValue [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1804]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "pointID1: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1788]",
    "pointID2: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1788]",
    "pointID3: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1788]",
    "name?: 형식 string(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1788]; 생략하면 objectCommandUtils.getNextObjectName(state, \"lowercase\") [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1794]",
    "인자로 못 정하는 속성(생성 기본값): dashed=false, isFilled=false, centerPointPosition=[0, 0, 0], normal=[0, 0, 0], radius=0 [src:math3d/src/app/math3d/state-manager/object-types/math3d-circular.ts:45]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.addCircleFromPointAndAxis",
   "command": "object.addCircleFromPointAndAxis",
   "params": [
    {
     "name": "pointID1",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "referenceID1",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "linear"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도(도구 UI 설명): 원: 점과 축 — 점과 축을 선택하세요. [src:math3d-ui/src/app/components/tabs/geometry/config.ts:314]",
    "호출: commandManager.execute(\"object.addCircleFromPointAndAxis\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1807-1827]",
    "앞에 있어야 하는 것: pointID1 = point [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1807-1827]",
    "앞에 있어야 하는 것: referenceID1 = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1807-1827]",
    "만드는 것: circular(generalCircleFromPointAndAxis) 1개 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1808] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 null(_defaultProperties.linearColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:40], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible false [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:42], relatedPosition [0, 0] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:43], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79]",
    "바꾸는 것: state.__returnValue [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1826]",
    "참고: 회전축은 선분, 직선, 반직선, 벡터만 받는다. 평면이나 구를 주면 무효 개체가 선다. [src:정합성 math3d-kinds: scripts/pipeline/kind-matrix3d.mjs 의 시험 object.addCircleFromPointAndAxis 에 장면 개체 종류 조합 22건을 넣어 유효 8건(증거 evidence/runs/2026-10-22/math3d/kind-matrix3d-3.json)]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "pointID1: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1807]",
    "referenceID1: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1807]",
    "name?: 형식 string(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1807]; 생략하면 objectCommandUtils.getNextObjectName(state, \"lowercase\") [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1813]",
    "인자로 못 정하는 속성(생성 기본값): dashed=false, isFilled=false, centerPointPosition=[0, 0, 0], normal=[0, 0, 0], radius=0 [src:math3d/src/app/math3d/state-manager/object-types/math3d-circular.ts:45]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.addCone",
   "command": "object.addCone",
   "params": [
    {
     "name": "pointID1",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "pointID2",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "radius",
     "type": "number|string",
     "optional": false
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도(도구 UI 설명): 원뿔 — 밑면의 중심점을 선택하고 원뿔이 그려질 위치를 선택하세요. [src:math3d-ui/src/app/components/tabs/geometry/config.ts:354]",
    "호출: commandManager.execute(\"object.addCone\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1829-1883]",
    "앞에 있어야 하는 것: pointID1 = point [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1829-1883]",
    "앞에 있어야 하는 것: pointID2 = point [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1829-1883]",
    "만드는 것: circular(cylindroconicalCircle) 1개 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1837] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 null(_defaultProperties.linearColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:40], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible false [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:42], relatedPosition [0, 0] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:43], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79]",
    "함께 생김: cylindroconical(cone) 1개 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1859] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 null(_defaultProperties.planeColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:45], 불투명도 0.4(_defaultProperties.polygonOpacity) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:50], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible false [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:47], relatedPosition [0, 0] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:48], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79]",
    "바꾸는 것: object.groupIdList 에 추가 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:346]",
    "바꾸는 것: state.groupMap[groupID] [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:349]",
    "바꾸는 것: state.__returnValue [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1882]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "pointID1: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1829]",
    "pointID2: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1829]",
    "radius: 형식 number|string(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1829]; 문자열이면 슬라이더 변수식으로 계산된다 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1829]",
    "name?: 형식 string(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1829]; 생략하면 objectCommandUtils.getNextObjectName(state, \"lowercase\") [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1864]",
    "인자로 못 정하는 속성(생성 기본값): dashed=false [src:math3d/src/app/math3d/state-manager/object-types/math3d-circular.ts:45]",
    "조용히 끝남(아무것도 안 함): !point1 || !point2 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1835]",
    "조용히 끝남(아무것도 안 함): !object || object.groupIdList.includes(groupID) 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:338]",
    "조용히 끝남(아무것도 안 함): objects.length === 0 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:342]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.addCylinder",
   "command": "object.addCylinder",
   "params": [
    {
     "name": "pointID1",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "pointID2",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "radius",
     "type": "number|string",
     "optional": false
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도(도구 UI 설명): 원기둥 — 밑면의 중심점을 선택하고 원기둥이 그려질 위치를 선택하세요. [src:math3d-ui/src/app/components/tabs/geometry/config.ts:361]",
    "호출: commandManager.execute(\"object.addCylinder\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1885-1963]",
    "앞에 있어야 하는 것: pointID1 = point [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1885-1963]",
    "앞에 있어야 하는 것: pointID2 = point [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1885-1963]",
    "만드는 것: circular(cylindroconicalCircle) 1개 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1894] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 null(_defaultProperties.linearColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:40], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible false [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:42], relatedPosition [0, 0] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:43], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79]",
    "함께 생김: circular(cylindroconicalCircle) 1개 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1916] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 null(_defaultProperties.linearColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:40], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible false [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:42], relatedPosition [0, 0] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:43], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79]",
    "함께 생김: cylindroconical(cylinder) 1개 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1938] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 null(_defaultProperties.planeColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:45], 불투명도 0.4(_defaultProperties.polygonOpacity) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:50], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible false [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:47], relatedPosition [0, 0] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:48], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79]",
    "바꾸는 것: object.groupIdList 에 추가 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:346]",
    "바꾸는 것: state.groupMap[groupID] [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:349]",
    "바꾸는 것: state.__returnValue [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1962]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "pointID1: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1885]",
    "pointID2: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1885]",
    "radius: 형식 number|string(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1885]; 문자열이면 슬라이더 변수식으로 계산된다 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1885]",
    "name?: 형식 string(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1885]; 생략하면 objectCommandUtils.getNextObjectName(state, \"lowercase\") [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1943]",
    "인자로 못 정하는 속성(생성 기본값): dashed=false [src:math3d/src/app/math3d/state-manager/object-types/math3d-circular.ts:45]",
    "조용히 끝남(아무것도 안 함): !point1 || point1.type !== 'point' 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1891]",
    "조용히 끝남(아무것도 안 함): !point2 || point2.type !== 'point' 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1892]",
    "조용히 끝남(아무것도 안 함): !object || object.groupIdList.includes(groupID) 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:338]",
    "조용히 끝남(아무것도 안 함): objects.length === 0 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:342]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.addPlaneFromThreePoints",
   "command": "object.addPlaneFromThreePoints",
   "params": [
    {
     "name": "pointID1",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "pointID2",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "pointID3",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도(도구 UI 설명): 평면: 세 점 — 세 점을 선택하세요. [src:base2d-ui/src/tab/tools/configs/base2d-geometry.ts:190]",
    "호출: commandManager.execute(\"object.addPlaneFromThreePoints\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1965-1982]",
    "앞에 있어야 하는 것: pointID1 = point [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1965-1982]",
    "앞에 있어야 하는 것: pointID2 = point [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1965-1982]",
    "앞에 있어야 하는 것: pointID3 = point [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1965-1982]",
    "만드는 것: plane(generalPlaneFromThreePoints) 1개 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1966] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 null(_defaultProperties.planeColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:45], 불투명도 0.1(_defaultProperties.planeOpacity) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:46], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible false [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:47], relatedPosition [0, 0] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:48], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79]",
    "바꾸는 것: state.__returnValue [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1981]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "pointID1: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1965]",
    "pointID2: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1965]",
    "pointID3: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1965]",
    "name?: 형식 string(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1965]; 생략하면 objectCommandUtils.getNextObjectName(state, \"lowercase\") [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1971]",
    "인자로 못 정하는 속성(생성 기본값): coplanarPoints=[[0, 0, 0], [0, 0, 0], … [src:math3d/src/app/math3d/state-manager/object-types/math3d-plane.ts:70]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.addDefaultPlane",
   "command": "object.addDefaultPlane",
   "params": [
    {
     "name": "coplanarPoints",
     "type": "point3[]",
     "optional": false
    },
    {
     "name": "id",
     "type": "number",
     "optional": false
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.addDefaultPlane\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1984-1994]",
    "만드는 것: plane(defaultPlane) 1개 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1985] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120]",
    "바꾸는 것: state.__returnValue [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1993]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "coplanarPoints: 형식 point3[](TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1984]",
    "id: 형식 number(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1984]",
    "name?: 형식 string(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1984]; 생략하면 '' [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1990]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.addPlaneFromPointAndLinear",
   "command": "object.addPlaneFromPointAndLinear",
   "params": [
    {
     "name": "referenceID1",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      },
      {
       "type": "linear"
      }
     ]
    },
    {
     "name": "referenceID2",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      },
      {
       "type": "linear"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.addPlaneFromPointAndLinear\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1996-2013]",
    "앞에 있어야 하는 것: referenceID1 = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1996-2013]",
    "앞에 있어야 하는 것: referenceID2 = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1996-2013]",
    "만드는 것: plane(generalPlaneFromPointAndLinear) 1개 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1997] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 null(_defaultProperties.planeColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:45], 불투명도 0.1(_defaultProperties.planeOpacity) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:46], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible false [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:47], relatedPosition [0, 0] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:48], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79]",
    "바꾸는 것: state.__returnValue [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2012]",
    "참고: 한 인자는 점이고 다른 인자는 선(선분, 직선, 반직선, 벡터)이다. 순서는 어느 쪽이든 된다. 점이 선 위에 있으면 무효 개체가 선다. [src:정합성 math3d-kinds: scripts/pipeline/kind-matrix3d.mjs 의 시험 object.addPlaneFromPointAndLinear 에 장면 개체 종류 조합 462건을 넣어 유효 64건(증거 evidence/runs/2026-10-22/math3d/kind-matrix3d-3.json)]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "referenceID1: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1996]",
    "referenceID2: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1996]",
    "name?: 형식 string(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1996]; 생략하면 objectCommandUtils.getNextObjectName(state, \"lowercase\") [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2002]",
    "인자로 못 정하는 속성(생성 기본값): coplanarPoints=[[0, 0, 0], [0, 0, 0], … [src:math3d/src/app/math3d/state-manager/object-types/math3d-plane.ts:70]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.addPlaneFromTwoLinears",
   "command": "object.addPlaneFromTwoLinears",
   "params": [
    {
     "name": "referenceID1",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "linear"
      }
     ]
    },
    {
     "name": "referenceID2",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "linear"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.addPlaneFromTwoLinears\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2015-2032]",
    "앞에 있어야 하는 것: referenceID1 = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2015-2032]",
    "앞에 있어야 하는 것: referenceID2 = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2015-2032]",
    "만드는 것: plane(generalPlaneFromTwoLinears) 1개 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2016] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 null(_defaultProperties.planeColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:45], 불투명도 0.1(_defaultProperties.planeOpacity) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:46], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible false [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:47], relatedPosition [0, 0] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:48], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79]",
    "바꾸는 것: state.__returnValue [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2031]",
    "참고: 두 선(선분, 직선, 반직선, 벡터)이 한 평면 위에 있어야 한다. 꼬인 위치의 두 선은 무효 개체가 선다. [src:정합성 math3d-kinds: scripts/pipeline/kind-matrix3d.mjs 의 시험 object.addPlaneFromTwoLinears 에 장면 개체 종류 조합 462건을 넣어 유효 18건(증거 evidence/runs/2026-10-22/math3d/kind-matrix3d-3.json)]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "referenceID1: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2015]",
    "referenceID2: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2015]",
    "name?: 형식 string(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2015]; 생략하면 objectCommandUtils.getNextObjectName(state, \"lowercase\") [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2021]",
    "인자로 못 정하는 속성(생성 기본값): coplanarPoints=[[0, 0, 0], [0, 0, 0], … [src:math3d/src/app/math3d/state-manager/object-types/math3d-plane.ts:70]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.addPlaneFromPolygon",
   "command": "object.addPlaneFromPolygon",
   "params": [
    {
     "name": "polygonID1",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "plane",
       "category": "generalPolygon"
      },
      {
       "type": "plane",
       "category": "regularPolygon"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.addPlaneFromPolygon\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2034-2051]",
    "앞에 있어야 하는 것: polygonID1 = plane(generalPolygon) 또는 plane(regularPolygon) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2034-2051]",
    "만드는 것: plane(generalPlaneFromPolygon) 1개 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2035] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 null(_defaultProperties.planeColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:45], 불투명도 0.1(_defaultProperties.planeOpacity) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:46], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible false [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:47], relatedPosition [0, 0] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:48], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79]",
    "바꾸는 것: state.__returnValue [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2050]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "polygonID1: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2034]",
    "name?: 형식 string(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2034]; 생략하면 objectCommandUtils.getNextObjectName(state, \"lowercase\") [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2040]",
    "인자로 못 정하는 속성(생성 기본값): coplanarPoints=[[0, 0, 0], [0, 0, 0], … [src:math3d/src/app/math3d/state-manager/object-types/math3d-plane.ts:70]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.addParallelPlane",
   "command": "object.addParallelPlane",
   "params": [
    {
     "name": "pointID1",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "planeID1",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "plane"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도(도구 UI 설명): 평행한 평면 — 평면을 선택하고 평행한 평면이 그려질 한 점을 선택하세요. [src:math3d-ui/src/app/components/tabs/geometry/config.ts:289]",
    "호출: commandManager.execute(\"object.addParallelPlane\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2053-2070]",
    "앞에 있어야 하는 것: pointID1 = point [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2053-2070]",
    "앞에 있어야 하는 것: planeID1 = plane [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2053-2070]",
    "만드는 것: plane(parallelPlane) 1개 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2054] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 null(_defaultProperties.planeColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:45], 불투명도 0.1(_defaultProperties.planeOpacity) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:46], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible false [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:47], relatedPosition [0, 0] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:48], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79]",
    "바꾸는 것: state.__returnValue [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2069]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "pointID1: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2053]",
    "planeID1: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2053]",
    "name?: 형식 string(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2053]; 생략하면 objectCommandUtils.getNextObjectName(state, \"lowercase\") [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2059]",
    "인자로 못 정하는 속성(생성 기본값): coplanarPoints=[[0, 0, 0], [0, 0, 0], … [src:math3d/src/app/math3d/state-manager/object-types/math3d-plane.ts:70]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.addPerpendicularPlane",
   "command": "object.addPerpendicularPlane",
   "params": [
    {
     "name": "pointID1",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "linearID1",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "linear"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도(도구 UI 설명): 수직평면 — 수직이 될 선을 선택하고 만들 위치를 선택하거나, 만들 위치를 선택하고 수직이 될 선을 선택하세요. [src:base2d-ui/src/tab/tools/configs/base2d-geometry.ts:172]",
    "호출: commandManager.execute(\"object.addPerpendicularPlane\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2072-2089]",
    "앞에 있어야 하는 것: pointID1 = point [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2072-2089]",
    "앞에 있어야 하는 것: linearID1 = linear [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2072-2089]",
    "만드는 것: plane(perpendicularPlane) 1개 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2073] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 null(_defaultProperties.planeColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:45], 불투명도 0.1(_defaultProperties.planeOpacity) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:46], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible false [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:47], relatedPosition [0, 0] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:48], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79]",
    "바꾸는 것: state.__returnValue [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2088]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "pointID1: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2072]",
    "linearID1: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2072]",
    "name?: 형식 string(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2072]; 생략하면 objectCommandUtils.getNextObjectName(state, \"lowercase\") [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2078]",
    "인자로 못 정하는 속성(생성 기본값): coplanarPoints=[[0, 0, 0], [0, 0, 0], … [src:math3d/src/app/math3d/state-manager/object-types/math3d-plane.ts:70]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.addPolygon",
   "command": "object.addPolygon",
   "params": [
    {
     "name": "pointIDs",
     "type": "ref[]",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도(도구 UI 설명): 다각형 — 모든 꼭짓점을 선택하고 처음 꼭짓점을 다시 선택하세요. [src:base2d-ui/src/tab/tools/configs/base2d-geometry.ts:365]",
    "호출: commandManager.execute(\"object.addPolygon\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2091-2134]",
    "앞에 있어야 하는 것: pointIDs ref[] = point [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2091-2134]",
    "만드는 것: plane(generalPolygon) 1개 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2115] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 null(_defaultProperties.planeColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:45], 불투명도 0.4(_defaultProperties.polygonOpacity) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:50], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible false [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:47], relatedPosition [0, 0] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:48], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79]",
    "함께 생김: linear(generalSegment) 여러 개(반복문) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2097] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 null(_defaultProperties.linearColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:40], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible false [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:42], relatedPosition [0, 0] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:43], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79]",
    "바꾸는 것: state.__returnValue [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2133]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "pointIDs: 형식 ref[](TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2091]",
    "name?: 형식 string(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2091]; 생략하면 objectCommandUtils.getNextObjectName(state, \"lowercase\") [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2120]",
    "인자로 못 정하는 속성(생성 기본값): coplanarPoints=[[0, 0, 0], [0, 0, 0], … [src:math3d/src/app/math3d/state-manager/object-types/math3d-plane.ts:70]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.addRegularPolygon",
   "command": "object.addRegularPolygon",
   "params": [
    {
     "name": "pointID1",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "pointID2",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "numberOfSides",
     "type": "number",
     "optional": false
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도(도구 UI 설명): 정다각형 — 평면을 선택하고 정다각형이 그려질 위치를 선택하세요. [src:math3d-ui/src/app/components/tabs/geometry/config.ts:267]",
    "호출: commandManager.execute(\"object.addRegularPolygon\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2136-2139]",
    "앞에 있어야 하는 것: pointID1 = point [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2136-2139]",
    "앞에 있어야 하는 것: pointID2 = point [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2136-2139]",
    "만드는 것: plane(regularPolygon) 1개 (경유 objectCommandUtils.polygon.createRegularPolygon) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:756] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 null(_defaultProperties.planeColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:45], 불투명도 0.4(_defaultProperties.polygonOpacity) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:50], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible false [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:47], relatedPosition [0, 0] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:48], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79]",
    "함께 생김: point(rotateHandlePoint) 1개 (경유 objectCommandUtils.polygon.createRegularPolygon) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:688] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 #2f6dbe(_defaultProperties.handlePointColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:35], 크기 0.4(_defaultProperties.normalPointSize) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:33], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible true [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:37], relatedPosition [12, -10] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:38], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79], 끌어서 움직일 수 있음(rotateHandlePoint) [src:math3d/src/app/math3d/state-manager/object-types/math3d-point.ts:17] [src:math3d/src/app/math3d/state-manager/object-types/index.ts:46-51]",
    "함께 생김: point(auxiliaryPoint) 여러 개(반복문) (경유 objectCommandUtils.polygon.createRegularPolygon) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:712] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 #7b7b7b(_defaultProperties.dependentPointColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:34], 크기 0.4(_defaultProperties.normalPointSize) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:33], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible true [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:37], relatedPosition [12, -10] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:38], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79], 끌어서 움직일 수 없음(auxiliaryPoint, 이동 가능 분류 generalPoint, pointOnObject, rotateHandlePoint) [src:math3d/src/app/math3d/state-manager/object-types/math3d-point.ts:17] [src:math3d/src/app/math3d/state-manager/object-types/index.ts:46-51]",
    "함께 생김: linear(generalSegment) 여러 개(반복문) (경유 objectCommandUtils.polygon.createRegularPolygon) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:738] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 null(_defaultProperties.linearColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:40], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible false [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:42], relatedPosition [0, 0] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:43], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79]",
    "바꾸는 속성: relativeObject [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:777]",
    "바꾸는 것: state.__returnValue [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2138]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "pointID1: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2136]",
    "pointID2: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2136]",
    "numberOfSides: 형식 number(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2136]",
    "name?: 형식 string(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2136]; 생략하면 objectCommandUtils.getNextObjectName(state, 'lowercase')(objectCommandUtils.polygon.createRegularPolygon) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:761]",
    "인자로 못 정하는 속성(생성 기본값): coplanarPoints=[[0, 0, 0], [0, 0, 0], … [src:math3d/src/app/math3d/state-manager/object-types/math3d-plane.ts:70]",
    "조용히 끝남(아무것도 안 함): numberOfSides < 3 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:676]",
    "조용히 끝남(아무것도 안 함): point1?.type !== 'point' || point2?.type !== 'point' 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:682]",
    "조용히 끝남(아무것도 안 함): !pointPositions 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:685]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.addSphereFromCenterAndPoint",
   "command": "object.addSphereFromCenterAndPoint",
   "params": [
    {
     "name": "centerPointID",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "pointID1",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도(도구 UI 설명): 구: 중심과 한 점 — 중심을 선택한 후 구가 그려질 한 점을 선택하세요. [src:math3d-ui/src/app/components/tabs/geometry/config.ts:373]",
    "호출: commandManager.execute(\"object.addSphereFromCenterAndPoint\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2141-2159]",
    "앞에 있어야 하는 것: centerPointID = point [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2141-2159]",
    "앞에 있어야 하는 것: pointID1 = point [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2141-2159]",
    "만드는 것: sphere(sphereFromCenterAndPoint) 1개 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2142] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 null(_defaultProperties.planeColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:45], 불투명도 0.4(_defaultProperties.polygonOpacity) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:50], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible false [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:47], relatedPosition [0, 0] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:48], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79]",
    "바꾸는 것: state.__returnValue [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2158]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "centerPointID: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2141]",
    "pointID1: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2141]",
    "name?: 형식 string(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2141]; 생략하면 objectCommandUtils.getNextObjectName(state, \"lowercase\") [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2147]",
    "인자로 못 정하는 속성(생성 기본값): centerPointPosition=[0, 0, 0], radius=0 [src:math3d/src/app/math3d/state-manager/object-types/math3d-sphere.ts:44]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.addSphereFromCenterAndRadius",
   "command": "object.addSphereFromCenterAndRadius",
   "params": [
    {
     "name": "centerPointID",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "radius",
     "type": "number|string",
     "optional": false
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도(도구 UI 설명): 구: 중심과 반지름 — 중심을 선택한 후 반지름을 입력하세요. [src:base2d-ui/src/tab/tools/configs/base2d-geometry.ts:249]",
    "호출: commandManager.execute(\"object.addSphereFromCenterAndRadius\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2161-2181]",
    "앞에 있어야 하는 것: centerPointID = point [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2161-2181]",
    "만드는 것: sphere(sphereFromCenterAndRadius) 1개 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2163] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 null(_defaultProperties.planeColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:45], 불투명도 0.4(_defaultProperties.polygonOpacity) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:50], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible false [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:47], relatedPosition [0, 0] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:48], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79]",
    "바꾸는 것: state.__returnValue [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2180]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "centerPointID: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2161]",
    "radius: 형식 number|string(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2161]; 문자열이면 슬라이더 변수식으로 계산된다 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2161]",
    "name?: 형식 string(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2161]; 생략하면 objectCommandUtils.getNextObjectName(state, \"lowercase\") [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2168]",
    "인자로 못 정하는 속성(생성 기본값): centerPointPosition=[0, 0, 0] [src:math3d/src/app/math3d/state-manager/object-types/math3d-sphere.ts:44]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.addPyramidFromPolygon",
   "command": "object.addPyramidFromPolygon",
   "params": [
    {
     "name": "polygonID",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "plane",
       "category": "generalPolygon"
      },
      {
       "type": "plane",
       "category": "regularPolygon"
      }
     ]
    },
    {
     "name": "topVertexPointID",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.addPyramidFromPolygon\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2183-2187]",
    "앞에 있어야 하는 것: polygonID = plane(generalPolygon) 또는 plane(regularPolygon) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2183-2187]",
    "앞에 있어야 하는 것: topVertexPointID = point [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2183-2187]",
    "만드는 것: polyhedron(pyramid) 1개 (경유 objectCommandUtils.polyhedron.createPyramidFromPolygon) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:857] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120]",
    "함께 생김: linear(generalSegment) 여러 개(반복문) (경유 objectCommandUtils.polyhedron.createPyramidFromPolygon) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:809] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 null(_defaultProperties.linearColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:40], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible false [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:42], relatedPosition [0, 0] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:43], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79]",
    "함께 생김: plane(generalPolygon) 여러 개(반복문) (경유 objectCommandUtils.polyhedron.createPyramidFromPolygon) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:832] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 null(_defaultProperties.linearColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:40], 불투명도 0.4(_defaultProperties.polygonOpacity) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:50], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible false [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:47], relatedPosition [0, 0] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:48], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79]",
    "바꾸는 것: object.groupIdList 에 추가 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:346]",
    "바꾸는 것: state.groupMap[groupID] [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:349]",
    "바꾸는 것: state.__returnValue [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2186]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "polygonID: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2183]",
    "topVertexPointID: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2183]",
    "name?: 형식 string(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2183]; 생략하면 objectCommandUtils.getNextObjectName(state, \"lowercase\")(objectCommandUtils.polyhedron.createPyramidFromPolygon) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:860]",
    "조용히 끝남(아무것도 안 함): !pyramidID 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2185]",
    "조용히 끝남(아무것도 안 함): !bottomPolygon || !isObjectType(bottomPolygon, 'plane') || PLANE_CATEGORY_CLASSIFICATION[… 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:795]",
    "조용히 끝남(아무것도 안 함): !bottomPolygon.relativePointAndSegmentArray 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:796]",
    "조용히 끝남(아무것도 안 함): !object || object.groupIdList.includes(groupID) 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:338]",
    "조용히 끝남(아무것도 안 함): objects.length === 0 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:342]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.addPyramidFromPoints",
   "command": "object.addPyramidFromPoints",
   "params": [
    {
     "name": "pointIDs",
     "type": "ref[]",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "topVertexPointID",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도(도구 UI 설명): 각뿔 — 밑면의 다각형을 선택하거나, 점을 선택하여 밑면을 만든 후, 꼭짓점을 선택하세요. [src:math3d-ui/src/app/components/tabs/geometry/config.ts:326]",
    "호출: commandManager.execute(\"object.addPyramidFromPoints\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2189-2238]",
    "앞에 있어야 하는 것: pointIDs ref[] = point [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2189-2238]",
    "앞에 있어야 하는 것: topVertexPointID = point [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2189-2238]",
    "만드는 것: polyhedron(pyramid) 1개 (경유 objectCommandUtils.polyhedron.createPyramidFromPolygon) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:857] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120]",
    "함께 생김: linear(generalSegment) 여러 개(반복문) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2196] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 null(_defaultProperties.linearColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:40], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible false [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:42], relatedPosition [0, 0] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:43], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79]",
    "함께 생김: plane(generalPolygon) 1개 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2215] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 null(_defaultProperties.linearColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:40], 불투명도 0.4(_defaultProperties.polygonOpacity) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:50], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible false [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:47], relatedPosition [0, 0] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:48], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79]",
    "함께 생김: linear(generalSegment) 여러 개(반복문) (경유 objectCommandUtils.polyhedron.createPyramidFromPolygon) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:809] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 null(_defaultProperties.linearColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:40], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible false [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:42], relatedPosition [0, 0] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:43], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79]",
    "함께 생김: plane(generalPolygon) 여러 개(반복문) (경유 objectCommandUtils.polyhedron.createPyramidFromPolygon) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:832] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 null(_defaultProperties.linearColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:40], 불투명도 0.4(_defaultProperties.polygonOpacity) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:50], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible false [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:47], relatedPosition [0, 0] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:48], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79]",
    "바꾸는 것: object.groupIdList 에 추가 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:346]",
    "바꾸는 것: state.groupMap[groupID] [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:349]",
    "바꾸는 것: state.__returnValue [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2237]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "pointIDs: 형식 ref[](TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2189]",
    "topVertexPointID: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2189]",
    "name?: 형식 string(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2189]; 생략하면 objectCommandUtils.getNextObjectName(state, \"lowercase\")(objectCommandUtils.polyhedron.createPyramidFromPolygon) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:860]",
    "조용히 끝남(아무것도 안 함): !pyramidID 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2236]",
    "조용히 끝남(아무것도 안 함): !bottomPolygon || !isObjectType(bottomPolygon, 'plane') || PLANE_CATEGORY_CLASSIFICATION[… 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:795]",
    "조용히 끝남(아무것도 안 함): !bottomPolygon.relativePointAndSegmentArray 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:796]",
    "조용히 끝남(아무것도 안 함): !object || object.groupIdList.includes(groupID) 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:338]",
    "조용히 끝남(아무것도 안 함): objects.length === 0 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:342]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.addPrismFromPolygon",
   "command": "object.addPrismFromPolygon",
   "params": [
    {
     "name": "polygonID",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "plane",
       "category": "generalPolygon"
      },
      {
       "type": "plane",
       "category": "regularPolygon"
      }
     ]
    },
    {
     "name": "topVertexPointID",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.addPrismFromPolygon\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2240-2244]",
    "앞에 있어야 하는 것: polygonID = plane(generalPolygon) 또는 plane(regularPolygon) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2240-2244]",
    "앞에 있어야 하는 것: topVertexPointID = point [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2240-2244]",
    "만드는 것: polyhedron(prism) 1개 (경유 objectCommandUtils.polyhedron.createPrismFromPolygon) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1030] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120]",
    "함께 생김: point(auxiliaryPoint) 여러 개(반복문) (경유 objectCommandUtils.polyhedron.createPrismFromPolygon) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:908] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 #7b7b7b(_defaultProperties.dependentPointColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:34], 크기 0.4(_defaultProperties.normalPointSize) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:33], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible true [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:37], relatedPosition [12, -10] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:38], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79], 끌어서 움직일 수 없음(auxiliaryPoint, 이동 가능 분류 generalPoint, pointOnObject, rotateHandlePoint) [src:math3d/src/app/math3d/state-manager/object-types/math3d-point.ts:17] [src:math3d/src/app/math3d/state-manager/object-types/index.ts:46-51]",
    "함께 생김: linear(generalSegment) 여러 개(반복문) (경유 objectCommandUtils.polyhedron.createPrismFromPolygon) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:936] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 null(_defaultProperties.linearColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:40], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible false [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:42], relatedPosition [0, 0] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:43], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79]",
    "함께 생김: plane(generalPolygon) 1개 (경유 objectCommandUtils.polyhedron.createPrismFromPolygon) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:956] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 null(_defaultProperties.linearColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:40], 불투명도 0.4(_defaultProperties.polygonOpacity) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:50], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible false [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:47], relatedPosition [0, 0] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:48], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79]",
    "함께 생김: linear(generalSegment) 여러 개(반복문) (경유 objectCommandUtils.polyhedron.createPrismFromPolygon) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:981] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 null(_defaultProperties.linearColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:40], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible false [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:42], relatedPosition [0, 0] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:43], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79]",
    "함께 생김: plane(generalPolygon) 여러 개(반복문) (경유 objectCommandUtils.polyhedron.createPrismFromPolygon) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1005] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 null(_defaultProperties.linearColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:40], 불투명도 0.4(_defaultProperties.polygonOpacity) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:50], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible false [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:47], relatedPosition [0, 0] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:48], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79]",
    "바꾸는 것: object.groupIdList 에 추가 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:346]",
    "바꾸는 것: state.groupMap[groupID] [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:349]",
    "바꾸는 것: state.__returnValue [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2243]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "polygonID: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2240]",
    "topVertexPointID: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2240]",
    "name?: 형식 string(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2240]; 생략하면 objectCommandUtils.getNextObjectName(state, \"lowercase\")(objectCommandUtils.polyhedron.createPrismFromPolygon) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1033]",
    "조용히 끝남(아무것도 안 함): !prismID 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2242]",
    "조용히 끝남(아무것도 안 함): !bottomPolygon || !isObjectType(bottomPolygon, 'plane') || PLANE_CATEGORY_CLASSIFICATION[… 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:880]",
    "조용히 끝남(아무것도 안 함): !bottomPolygon.relativePointAndSegmentArray 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:881]",
    "조용히 끝남(아무것도 안 함): !topVertexPoint || !isObjectType(topVertexPoint, \"point\") 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:897]",
    "조용히 끝남(아무것도 안 함): bottomPolygonPointIDs.length === 0 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:898]",
    "조용히 끝남(아무것도 안 함): !firstBottomPoint || !isObjectType(firstBottomPoint, \"point\") 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:900]",
    "조용히 끝남(아무것도 안 함): !object || object.groupIdList.includes(groupID) 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:338]",
    "조용히 끝남(아무것도 안 함): objects.length === 0 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:342]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.addPrismFromPoints",
   "command": "object.addPrismFromPoints",
   "params": [
    {
     "name": "pointIDs",
     "type": "ref[]",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "topVertexPointID",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도(도구 UI 설명): 각기둥 — 밑면의 다각형을 선택하거나, 점을 선택하여 밑면을 만든 후, 윗면의 점을 선택하세요. [src:math3d-ui/src/app/components/tabs/geometry/config.ts:333]",
    "호출: commandManager.execute(\"object.addPrismFromPoints\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2246-2295]",
    "앞에 있어야 하는 것: pointIDs ref[] = point [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2246-2295]",
    "앞에 있어야 하는 것: topVertexPointID = point [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2246-2295]",
    "만드는 것: polyhedron(prism) 1개 (경유 objectCommandUtils.polyhedron.createPrismFromPolygon) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1030] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120]",
    "함께 생김: linear(generalSegment) 여러 개(반복문) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2253] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 null(_defaultProperties.linearColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:40], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible false [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:42], relatedPosition [0, 0] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:43], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79]",
    "함께 생김: plane(generalPolygon) 1개 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2272] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 null(_defaultProperties.linearColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:40], 불투명도 0.4(_defaultProperties.polygonOpacity) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:50], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible false [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:47], relatedPosition [0, 0] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:48], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79]",
    "함께 생김: point(auxiliaryPoint) 여러 개(반복문) (경유 objectCommandUtils.polyhedron.createPrismFromPolygon) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:908] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 #7b7b7b(_defaultProperties.dependentPointColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:34], 크기 0.4(_defaultProperties.normalPointSize) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:33], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible true [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:37], relatedPosition [12, -10] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:38], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79], 끌어서 움직일 수 없음(auxiliaryPoint, 이동 가능 분류 generalPoint, pointOnObject, rotateHandlePoint) [src:math3d/src/app/math3d/state-manager/object-types/math3d-point.ts:17] [src:math3d/src/app/math3d/state-manager/object-types/index.ts:46-51]",
    "함께 생김: linear(generalSegment) 여러 개(반복문) (경유 objectCommandUtils.polyhedron.createPrismFromPolygon) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:936] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 null(_defaultProperties.linearColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:40], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible false [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:42], relatedPosition [0, 0] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:43], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79]",
    "함께 생김: plane(generalPolygon) 1개 (경유 objectCommandUtils.polyhedron.createPrismFromPolygon) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:956] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 null(_defaultProperties.linearColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:40], 불투명도 0.4(_defaultProperties.polygonOpacity) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:50], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible false [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:47], relatedPosition [0, 0] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:48], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79]",
    "함께 생김: linear(generalSegment) 여러 개(반복문) (경유 objectCommandUtils.polyhedron.createPrismFromPolygon) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:981] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 null(_defaultProperties.linearColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:40], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible false [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:42], relatedPosition [0, 0] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:43], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79]",
    "함께 생김: plane(generalPolygon) 여러 개(반복문) (경유 objectCommandUtils.polyhedron.createPrismFromPolygon) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1005] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 null(_defaultProperties.linearColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:40], 불투명도 0.4(_defaultProperties.polygonOpacity) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:50], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible false [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:47], relatedPosition [0, 0] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:48], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79]",
    "바꾸는 것: object.groupIdList 에 추가 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:346]",
    "바꾸는 것: state.groupMap[groupID] [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:349]",
    "바꾸는 것: state.__returnValue [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2294]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "pointIDs: 형식 ref[](TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2246]",
    "topVertexPointID: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2246]",
    "name?: 형식 string(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2246]; 생략하면 objectCommandUtils.getNextObjectName(state, \"lowercase\")(objectCommandUtils.polyhedron.createPrismFromPolygon) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1033]",
    "조용히 끝남(아무것도 안 함): !prismID 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2293]",
    "조용히 끝남(아무것도 안 함): !bottomPolygon || !isObjectType(bottomPolygon, 'plane') || PLANE_CATEGORY_CLASSIFICATION[… 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:880]",
    "조용히 끝남(아무것도 안 함): !bottomPolygon.relativePointAndSegmentArray 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:881]",
    "조용히 끝남(아무것도 안 함): !topVertexPoint || !isObjectType(topVertexPoint, \"point\") 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:897]",
    "조용히 끝남(아무것도 안 함): bottomPolygonPointIDs.length === 0 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:898]",
    "조용히 끝남(아무것도 안 함): !firstBottomPoint || !isObjectType(firstBottomPoint, \"point\") 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:900]",
    "조용히 끝남(아무것도 안 함): !object || object.groupIdList.includes(groupID) 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:338]",
    "조용히 끝남(아무것도 안 함): objects.length === 0 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:342]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.addRegularTetrahedronFromPolygon",
   "command": "object.addRegularTetrahedronFromPolygon",
   "params": [
    {
     "name": "polygonID",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "plane",
       "category": "generalPolygon"
      },
      {
       "type": "plane",
       "category": "regularPolygon"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.addRegularTetrahedronFromPolygon\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2297-2301]",
    "앞에 있어야 하는 것: polygonID = plane(generalPolygon) 또는 plane(regularPolygon) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2297-2301]",
    "만드는 것: polyhedron(regularTetrahedron) 1개 (경유 objectCommandUtils.polyhedron.createRegularTetrahedronFromPolygon) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1145] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120]",
    "함께 생김: point(auxiliaryPoint) 1개 (경유 objectCommandUtils.polyhedron.createRegularTetrahedronFromPolygon) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1077] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 #7b7b7b(_defaultProperties.dependentPointColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:34], 크기 0.4(_defaultProperties.normalPointSize) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:33], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible true [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:37], relatedPosition [12, -10] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:38], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79], 끌어서 움직일 수 없음(auxiliaryPoint, 이동 가능 분류 generalPoint, pointOnObject, rotateHandlePoint) [src:math3d/src/app/math3d/state-manager/object-types/math3d-point.ts:17] [src:math3d/src/app/math3d/state-manager/object-types/index.ts:46-51]",
    "함께 생김: linear(generalSegment) 여러 개(반복문) (경유 objectCommandUtils.polyhedron.createRegularTetrahedronFromPolygon) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1097] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 null(_defaultProperties.linearColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:40], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible false [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:42], relatedPosition [0, 0] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:43], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79]",
    "함께 생김: plane(regularPolygon) 여러 개(반복문) (경유 objectCommandUtils.polyhedron.createRegularTetrahedronFromPolygon) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1120] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 null(_defaultProperties.linearColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:40], 불투명도 0.4(_defaultProperties.polygonOpacity) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:50], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible false [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:47], relatedPosition [0, 0] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:48], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79]",
    "바꾸는 속성: relativeObject [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1158]",
    "바꾸는 것: object.groupIdList 에 추가 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:346]",
    "바꾸는 것: state.groupMap[groupID] [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:349]",
    "바꾸는 것: state.__returnValue [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2300]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "polygonID: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2297]",
    "name?: 형식 string(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2297]; 생략하면 objectCommandUtils.getNextObjectName(state, 'lowercase')(objectCommandUtils.polyhedron.createRegularTetrahedronFromPolygon) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1148]",
    "조용히 끝남(아무것도 안 함): !regularTetrahedronID 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2299]",
    "조용히 끝남(아무것도 안 함): !regularTriangle || regularTriangle.type !== 'plane' || regularTriangle.category !== 'reg… 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1053]",
    "조용히 끝남(아무것도 안 함): !bottomPoint || bottomPoint.type !== 'point' 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1067]",
    "조용히 끝남(아무것도 안 함): !object || object.groupIdList.includes(groupID) 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:338]",
    "조용히 끝남(아무것도 안 함): objects.length === 0 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:342]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.addRegularTetrahedronFromPoints",
   "command": "object.addRegularTetrahedronFromPoints",
   "params": [
    {
     "name": "pointID1",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "pointID2",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도(도구 UI 설명): 정사면체 — 평면을 선택하고 정사면체가 그려질 위치를 선택하세요. [src:math3d-ui/src/app/components/tabs/geometry/config.ts:340]",
    "호출: commandManager.execute(\"object.addRegularTetrahedronFromPoints\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2303-2311]",
    "앞에 있어야 하는 것: pointID1 = point [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2303-2311]",
    "앞에 있어야 하는 것: pointID2 = point [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2303-2311]",
    "만드는 것: plane(regularPolygon) 1개 (경유 objectCommandUtils.polygon.createRegularPolygon) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:756] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 null(_defaultProperties.planeColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:45], 불투명도 0.4(_defaultProperties.polygonOpacity) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:50], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible false [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:47], relatedPosition [0, 0] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:48], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79]",
    "함께 생김: point(rotateHandlePoint) 1개 (경유 objectCommandUtils.polygon.createRegularPolygon) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:688] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 #2f6dbe(_defaultProperties.handlePointColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:35], 크기 0.4(_defaultProperties.normalPointSize) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:33], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible true [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:37], relatedPosition [12, -10] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:38], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79], 끌어서 움직일 수 있음(rotateHandlePoint) [src:math3d/src/app/math3d/state-manager/object-types/math3d-point.ts:17] [src:math3d/src/app/math3d/state-manager/object-types/index.ts:46-51]",
    "함께 생김: point(auxiliaryPoint) 여러 개(반복문) (경유 objectCommandUtils.polygon.createRegularPolygon) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:712] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 #7b7b7b(_defaultProperties.dependentPointColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:34], 크기 0.4(_defaultProperties.normalPointSize) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:33], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible true [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:37], relatedPosition [12, -10] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:38], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79], 끌어서 움직일 수 없음(auxiliaryPoint, 이동 가능 분류 generalPoint, pointOnObject, rotateHandlePoint) [src:math3d/src/app/math3d/state-manager/object-types/math3d-point.ts:17] [src:math3d/src/app/math3d/state-manager/object-types/index.ts:46-51]",
    "함께 생김: linear(generalSegment) 여러 개(반복문) (경유 objectCommandUtils.polygon.createRegularPolygon) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:738] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 null(_defaultProperties.linearColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:40], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible false [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:42], relatedPosition [0, 0] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:43], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79]",
    "함께 생김: point(auxiliaryPoint) 1개 (경유 objectCommandUtils.polyhedron.createRegularTetrahedronFromPolygon) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1077] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 #7b7b7b(_defaultProperties.dependentPointColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:34], 크기 0.4(_defaultProperties.normalPointSize) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:33], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible true [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:37], relatedPosition [12, -10] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:38], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79], 끌어서 움직일 수 없음(auxiliaryPoint, 이동 가능 분류 generalPoint, pointOnObject, rotateHandlePoint) [src:math3d/src/app/math3d/state-manager/object-types/math3d-point.ts:17] [src:math3d/src/app/math3d/state-manager/object-types/index.ts:46-51]",
    "함께 생김: linear(generalSegment) 여러 개(반복문) (경유 objectCommandUtils.polyhedron.createRegularTetrahedronFromPolygon) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1097] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 null(_defaultProperties.linearColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:40], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible false [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:42], relatedPosition [0, 0] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:43], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79]",
    "함께 생김: plane(regularPolygon) 여러 개(반복문) (경유 objectCommandUtils.polyhedron.createRegularTetrahedronFromPolygon) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1120] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 null(_defaultProperties.linearColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:40], 불투명도 0.4(_defaultProperties.polygonOpacity) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:50], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible false [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:47], relatedPosition [0, 0] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:48], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79]",
    "함께 생김: polyhedron(regularTetrahedron) 1개 (경유 objectCommandUtils.polyhedron.createRegularTetrahedronFromPolygon) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1145] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120]",
    "바꾸는 속성: relativeObject [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:777]",
    "바꾸는 속성: relativeObject [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1158]",
    "바꾸는 것: object.groupIdList 에 추가 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:346]",
    "바꾸는 것: state.groupMap[groupID] [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:349]",
    "바꾸는 것: state.__returnValue [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2310]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "pointID1: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2303]",
    "pointID2: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2303]",
    "name?: 형식 string(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2303]; 생략하면 objectCommandUtils.getNextObjectName(state, 'lowercase')(objectCommandUtils.polygon.createRegularPolygon) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:761]",
    "인자로 못 정하는 속성(생성 기본값): coplanarPoints=[[0, 0, 0], [0, 0, 0], … [src:math3d/src/app/math3d/state-manager/object-types/math3d-plane.ts:70]",
    "조용히 끝남(아무것도 안 함): !regularPolygonID 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2306]",
    "조용히 끝남(아무것도 안 함): !regularTetrahedronID 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2309]",
    "조용히 끝남(아무것도 안 함): numberOfSides < 3 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:676]",
    "조용히 끝남(아무것도 안 함): point1?.type !== 'point' || point2?.type !== 'point' 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:682]",
    "조용히 끝남(아무것도 안 함): !pointPositions 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:685]",
    "조용히 끝남(아무것도 안 함): !regularTriangle || regularTriangle.type !== 'plane' || regularTriangle.category !== 'reg… 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1053]",
    "조용히 끝남(아무것도 안 함): !bottomPoint || bottomPoint.type !== 'point' 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1067]",
    "조용히 끝남(아무것도 안 함): !object || object.groupIdList.includes(groupID) 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:338]",
    "조용히 끝나는 조건 외 1곳 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:342]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.addRegularCubeFromPolygon",
   "command": "object.addRegularCubeFromPolygon",
   "params": [
    {
     "name": "polygonID",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "plane",
       "category": "generalPolygon"
      },
      {
       "type": "plane",
       "category": "regularPolygon"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.addRegularCubeFromPolygon\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2313-2317]",
    "앞에 있어야 하는 것: polygonID = plane(generalPolygon) 또는 plane(regularPolygon) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2313-2317]",
    "만드는 것: polyhedron(regularCube) 1개 (경유 objectCommandUtils.polyhedron.createRegularCubeFromPolygon) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1309] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120]",
    "함께 생김: point(auxiliaryPoint) 여러 개(반복문) (경유 objectCommandUtils.polyhedron.createRegularCubeFromPolygon) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1197] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 #7b7b7b(_defaultProperties.dependentPointColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:34], 크기 0.4(_defaultProperties.normalPointSize) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:33], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible true [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:37], relatedPosition [12, -10] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:38], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79], 끌어서 움직일 수 없음(auxiliaryPoint, 이동 가능 분류 generalPoint, pointOnObject, rotateHandlePoint) [src:math3d/src/app/math3d/state-manager/object-types/math3d-point.ts:17] [src:math3d/src/app/math3d/state-manager/object-types/index.ts:46-51]",
    "함께 생김: linear(generalSegment) 여러 개(반복문) (경유 objectCommandUtils.polyhedron.createRegularCubeFromPolygon) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1219] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 null(_defaultProperties.linearColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:40], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible false [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:42], relatedPosition [0, 0] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:43], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79]",
    "함께 생김: linear(generalSegment) 여러 개(반복문) (경유 objectCommandUtils.polyhedron.createRegularCubeFromPolygon) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1240] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 null(_defaultProperties.linearColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:40], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible false [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:42], relatedPosition [0, 0] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:43], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79]",
    "함께 생김: plane(regularPolygon) 1개 (경유 objectCommandUtils.polyhedron.createRegularCubeFromPolygon) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1260] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 null(_defaultProperties.linearColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:40], 불투명도 0.4(_defaultProperties.polygonOpacity) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:50], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible false [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:47], relatedPosition [0, 0] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:48], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79]",
    "함께 생김: plane(regularPolygon) 여러 개(반복문) (경유 objectCommandUtils.polyhedron.createRegularCubeFromPolygon) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1284] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 null(_defaultProperties.linearColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:40], 불투명도 0.4(_defaultProperties.polygonOpacity) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:50], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible false [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:47], relatedPosition [0, 0] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:48], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79]",
    "바꾸는 속성: relativeObject [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1192]",
    "바꾸는 속성: relativeObject [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1323]",
    "바꾸는 것: object.groupIdList 에 추가 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:346]",
    "바꾸는 것: state.groupMap[groupID] [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:349]",
    "바꾸는 것: state.__returnValue [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2316]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "polygonID: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2313]",
    "name?: 형식 string(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2313]; 생략하면 objectCommandUtils.getNextObjectName(state, 'lowercase')(objectCommandUtils.polyhedron.createRegularCubeFromPolygon) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1312]",
    "조용히 끝남(아무것도 안 함): !regularTetrahedronID 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2315]",
    "조용히 끝남(아무것도 안 함): !regularTriangle || regularTriangle.type !== 'plane' || regularTriangle.category !== 'reg… 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1169]",
    "조용히 끝남(아무것도 안 함): !bottomPoint || bottomPoint.type !== 'point' 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1183]",
    "조용히 끝남(아무것도 안 함): !object || object.groupIdList.includes(groupID) 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:338]",
    "조용히 끝남(아무것도 안 함): objects.length === 0 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:342]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.addRegularCubeFromPoints",
   "command": "object.addRegularCubeFromPoints",
   "params": [
    {
     "name": "pointID1",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "pointID2",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도(도구 UI 설명): 정육면체 — 평면을 선택하고 정육면체가 그려질 위치를 선택하세요. [src:math3d-ui/src/app/components/tabs/geometry/config.ts:347]",
    "호출: commandManager.execute(\"object.addRegularCubeFromPoints\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2319-2327]",
    "앞에 있어야 하는 것: pointID1 = point [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2319-2327]",
    "앞에 있어야 하는 것: pointID2 = point [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2319-2327]",
    "만드는 것: plane(regularPolygon) 1개 (경유 objectCommandUtils.polygon.createRegularPolygon) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:756] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 null(_defaultProperties.planeColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:45], 불투명도 0.4(_defaultProperties.polygonOpacity) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:50], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible false [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:47], relatedPosition [0, 0] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:48], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79]",
    "함께 생김: point(rotateHandlePoint) 1개 (경유 objectCommandUtils.polygon.createRegularPolygon) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:688] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 #2f6dbe(_defaultProperties.handlePointColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:35], 크기 0.4(_defaultProperties.normalPointSize) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:33], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible true [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:37], relatedPosition [12, -10] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:38], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79], 끌어서 움직일 수 있음(rotateHandlePoint) [src:math3d/src/app/math3d/state-manager/object-types/math3d-point.ts:17] [src:math3d/src/app/math3d/state-manager/object-types/index.ts:46-51]",
    "함께 생김: point(auxiliaryPoint) 여러 개(반복문) (경유 objectCommandUtils.polygon.createRegularPolygon) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:712] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 #7b7b7b(_defaultProperties.dependentPointColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:34], 크기 0.4(_defaultProperties.normalPointSize) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:33], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible true [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:37], relatedPosition [12, -10] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:38], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79], 끌어서 움직일 수 없음(auxiliaryPoint, 이동 가능 분류 generalPoint, pointOnObject, rotateHandlePoint) [src:math3d/src/app/math3d/state-manager/object-types/math3d-point.ts:17] [src:math3d/src/app/math3d/state-manager/object-types/index.ts:46-51]",
    "함께 생김: linear(generalSegment) 여러 개(반복문) (경유 objectCommandUtils.polygon.createRegularPolygon) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:738] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 null(_defaultProperties.linearColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:40], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible false [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:42], relatedPosition [0, 0] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:43], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79]",
    "함께 생김: point(auxiliaryPoint) 여러 개(반복문) (경유 objectCommandUtils.polyhedron.createRegularCubeFromPolygon) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1197] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 #7b7b7b(_defaultProperties.dependentPointColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:34], 크기 0.4(_defaultProperties.normalPointSize) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:33], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible true [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:37], relatedPosition [12, -10] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:38], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79], 끌어서 움직일 수 없음(auxiliaryPoint, 이동 가능 분류 generalPoint, pointOnObject, rotateHandlePoint) [src:math3d/src/app/math3d/state-manager/object-types/math3d-point.ts:17] [src:math3d/src/app/math3d/state-manager/object-types/index.ts:46-51]",
    "함께 생김: linear(generalSegment) 여러 개(반복문) (경유 objectCommandUtils.polyhedron.createRegularCubeFromPolygon) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1219] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 null(_defaultProperties.linearColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:40], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible false [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:42], relatedPosition [0, 0] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:43], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79]",
    "함께 생김: linear(generalSegment) 여러 개(반복문) (경유 objectCommandUtils.polyhedron.createRegularCubeFromPolygon) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1240] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 null(_defaultProperties.linearColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:40], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible false [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:42], relatedPosition [0, 0] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:43], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79]",
    "함께 생김: plane(regularPolygon) 1개 (경유 objectCommandUtils.polyhedron.createRegularCubeFromPolygon) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1260] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 null(_defaultProperties.linearColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:40], 불투명도 0.4(_defaultProperties.polygonOpacity) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:50], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible false [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:47], relatedPosition [0, 0] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:48], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79]",
    "함께 생김: plane(regularPolygon) 여러 개(반복문) (경유 objectCommandUtils.polyhedron.createRegularCubeFromPolygon) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1284] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 null(_defaultProperties.linearColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:40], 불투명도 0.4(_defaultProperties.polygonOpacity) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:50], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible false [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:47], relatedPosition [0, 0] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:48], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79]",
    "함께 생김: polyhedron(regularCube) 1개 (경유 objectCommandUtils.polyhedron.createRegularCubeFromPolygon) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1309] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120]",
    "바꾸는 속성: relativeObject [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:777]",
    "바꾸는 속성: relativeObject [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1192]",
    "바꾸는 속성: relativeObject [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1323]",
    "바꾸는 것: object.groupIdList 에 추가 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:346]",
    "바꾸는 것: state.groupMap[groupID] [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:349]",
    "바꾸는 것: state.__returnValue [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2326]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "pointID1: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2319]",
    "pointID2: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2319]",
    "name?: 형식 string(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2319]; 생략하면 objectCommandUtils.getNextObjectName(state, 'lowercase')(objectCommandUtils.polygon.createRegularPolygon) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:761]",
    "인자로 못 정하는 속성(생성 기본값): coplanarPoints=[[0, 0, 0], [0, 0, 0], … [src:math3d/src/app/math3d/state-manager/object-types/math3d-plane.ts:70]",
    "조용히 끝남(아무것도 안 함): !regularPolygonID 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2322]",
    "조용히 끝남(아무것도 안 함): !regularTetrahedronID 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2325]",
    "조용히 끝남(아무것도 안 함): numberOfSides < 3 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:676]",
    "조용히 끝남(아무것도 안 함): point1?.type !== 'point' || point2?.type !== 'point' 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:682]",
    "조용히 끝남(아무것도 안 함): !pointPositions 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:685]",
    "조용히 끝남(아무것도 안 함): !regularTriangle || regularTriangle.type !== 'plane' || regularTriangle.category !== 'reg… 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1169]",
    "조용히 끝남(아무것도 안 함): !bottomPoint || bottomPoint.type !== 'point' 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:1183]",
    "조용히 끝남(아무것도 안 함): !object || object.groupIdList.includes(groupID) 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:338]",
    "조용히 끝나는 조건 외 1곳 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:342]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.addPointIntersection",
   "command": "object.addPointIntersection",
   "params": [
    {
     "name": "referenceID1",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "linear"
      },
      {
       "type": "plane"
      },
      {
       "type": "sphere"
      }
     ]
    },
    {
     "name": "referenceID2",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "linear"
      },
      {
       "type": "plane"
      },
      {
       "type": "sphere"
      }
     ]
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도(도구 UI 설명): 교점 — 교차하는 선의 교차점을 선택하거나, 두 선을 연속적으로 선택하세요. [src:base2d-ui/src/tab/tools/configs/base2d-geometry.ts:88]",
    "호출: commandManager.execute(\"object.addPointIntersection\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2329-2371]",
    "앞에 있어야 하는 것: referenceID1 = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2329-2371]",
    "앞에 있어야 하는 것: referenceID2 = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2329-2371]",
    "만드는 것: intersection(pointIntersection) 1개 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2361] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120]",
    "함께 생김: point(auxiliaryPoint) 여러 개(반복문) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2341] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 #7b7b7b(_defaultProperties.dependentPointColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:34], 크기 0.4(_defaultProperties.normalPointSize) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:33], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible true [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:37], relatedPosition [12, -10] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:38], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79], 끌어서 움직일 수 없음(auxiliaryPoint, 이동 가능 분류 generalPoint, pointOnObject, rotateHandlePoint) [src:math3d/src/app/math3d/state-manager/object-types/math3d-point.ts:17] [src:math3d/src/app/math3d/state-manager/object-types/index.ts:46-51]",
    "바꾸는 것: state.__returnValue [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2370]",
    "참고: 선과 선, 선과 평면(다각형 포함), 선과 구의 교점을 세운다. 두 선은 서로 만나야 하고 꼬인 위치이면 무효이다. 평면에 포함된 선도 무효이다. 평면과 평면, 평면과 구는 개체가 서지 않는다. 교점은 그릇 개체(intersection)와 보조점으로 서므로 이후 호출은 보조점을 가리킨다. [src:정합성 math3d-kinds: scripts/pipeline/kind-matrix3d.mjs 의 시험 object.addPointIntersection 에 장면 개체 종류 조합 462건을 넣어 유효 46건(증거 evidence/runs/2026-10-22/math3d/kind-matrix3d-3.json)]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "referenceID1: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2329]",
    "referenceID2: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2329]",
    "name?: 형식 string(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2329]; 생략하면 objectCommandUtils.getNextPointName(state) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2346]",
    "조용히 끝남(아무것도 안 함): !reference1 || !POINT_INTERSECTABLE_OBJECT_TYPE_NAMES.includes(reference1.type as ObjectT… 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2332]",
    "조용히 끝남(아무것도 안 함): !reference2 || !POINT_INTERSECTABLE_OBJECT_TYPE_NAMES.includes(reference2.type as ObjectT… 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2333]",
    "조용히 끝남(아무것도 안 함): !count 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2336]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.addAlgebraic",
   "command": "object.addAlgebraic",
   "params": [
    {
     "name": "expression",
     "type": "expr",
     "optional": false
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.addAlgebraic\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2373-2394]",
    "만드는 것: algebraic 1개 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2374] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 objectCommandUtils.getNextObjectColor(state) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2376], 불투명도 0.7(_defaultProperties.algebraicOpacity) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:52], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible true [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:37], relatedPosition [12, -10] [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:38], size 14 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:80], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79]",
    "바꾸는 것: state.__returnValue [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2393]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "expression: 형식 expr(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2373]",
    "name?: 형식 string(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2373]; 생략하면 objectCommandUtils.getNextObjectName(state, \"lowercase\") [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2377]",
    "인자로 못 정하는 속성(생성 기본값): exprEval='' [src:math3d/src/app/math3d/state-manager/object-types/math3d-algebraic.ts:37]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.addText3D",
   "command": "object.addText3D",
   "params": [
    {
     "name": "text",
     "type": "string",
     "optional": false
    },
    {
     "name": "size",
     "type": "number",
     "optional": true
    },
    {
     "name": "position",
     "type": "point3",
     "optional": true
    },
    {
     "name": "rotation",
     "type": "point3",
     "optional": true
    },
    {
     "name": "latex",
     "type": "boolean",
     "optional": true
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    },
    {
     "name": "relativeObjects",
     "type": "ref[]",
     "optional": true,
     "accepts": [
      {
       "type": "point"
      },
      {
       "type": "plane"
      },
      {
       "type": "sphere"
      },
      {
       "type": "polyhedron"
      },
      {
       "type": "cylindroconical"
      }
     ]
    },
    {
     "name": "category",
     "type": "'text'|'textCallout'|'textAngle'|'textLength'|'textArea'|'textVolume'",
     "optional": true
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도(도구 UI 설명): 텍스트 — 텍스트를 만들 위치를 선택하세요. [src:math3d-ui/src/app/components/tabs/geometry/config.ts:94]",
    "호출: commandManager.execute(\"object.addText3D\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2396-2428]",
    "앞에 있어야 하는 것: relativeObjects ref[] = 아무 개체 (생략 가능) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2396-2428]",
    "만드는 것: text(payload.category ?? \"text) 1개 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2412] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 #000000(_defaultProperties.textColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:61], 크기 3(_defaultProperties.textSize) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:62], 불투명도 1(_defaultProperties.textOpacity) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:64]",
    "바꾸는 것: state.__returnValue [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2427]",
    "참고: 이 시험에서 유효가 나온 category 는 text 뿐이다. textLength, textArea, textVolume, textCallout, textAngle 은 이 인자 조합으로는 유효가 나오지 않았다. [src:정합성 math3d-kinds: scripts/pipeline/kind-matrix3d.mjs 의 시험 object.addText3D 에 장면 개체 종류 조합 3054건을 넣어 유효 509건(증거 evidence/runs/2026-10-22/math3d/kind-matrix3d-3.json)]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "text: 형식 string(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2396]",
    "size?: 형식 number(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2396]; 생략하면 3(_defaultProperties.textSize) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:62] [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2421]",
    "position?: 형식 point3(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2396]; 생략하면 state.__generatePosition [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2416]",
    "rotation?: 형식 point3(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2396]; 생략하면 [0, 0, 0](_defaultProperties.textRotation) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:60] [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2418]",
    "latex?: 형식 boolean(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2396]; 생략하면 false [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2417]",
    "name?: 형식 string(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2396]; 생략하면 objectCommandUtils.getNextObjectName(state, \"lowercase\") [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2423]",
    "relativeObjects?: 형식 ref[](TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2396]; 생략하면 [] [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2424]",
    "category?: 형식 'text'|'textCallout'|'textAngle'|'textLength'|'textArea'|'textVolume'(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2396]; 생략하면 \"text\" [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2414]",
    "인자로 못 정하는 속성(생성 기본값): anchor='left', autoRotate=false, scaleLock=true, isLoaded=false [src:math3d/src/app/math3d/state-manager/object-types/math3d-text.ts:45]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.addImage",
   "command": "object.addImage",
   "params": [
    {
     "name": "url",
     "type": "string",
     "optional": false
    },
    {
     "name": "size",
     "type": "point2",
     "optional": true
    },
    {
     "name": "name",
     "type": "string",
     "optional": true
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도(도구 UI 설명): 이미지 — 이미지를 만들 위치를 선택하세요. [src:math3d-ui/src/app/components/tabs/geometry/config.ts:104]",
    "호출: commandManager.execute(\"object.addImage\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2430-2442]",
    "만드는 것: image 1개 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2432] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 크기 size [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2437]",
    "바꾸는 것: state.__returnValue [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2441]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "url: 형식 string(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2430]",
    "size?: 형식 point2(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2430]; 생략하면 [10, 10] [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2431]",
    "name?: 형식 string(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2430]; 본문에서 읽지 않는다, 넣어도 무시된다 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2430-2442]",
    "인자로 못 정하는 속성(생성 기본값): rotation=[0, 0, 0], scaleLock=false, ratioLock=true, flipX=false, flipY=false, isLoaded=false [src:math3d/src/app/math3d/state-manager/object-types/math3d-image.ts:33]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.addSlider",
   "command": "object.addSlider",
   "params": [
    {
     "name": "category",
     "type": "'horizon-bar'|'vertical-bar'|'circle'",
     "optional": false
    },
    {
     "name": "normalizedPosition",
     "type": "point2",
     "optional": true
    },
    {
     "name": "defaultValue",
     "type": "number",
     "optional": true
    },
    {
     "name": "symbol",
     "type": "string",
     "optional": true
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도(도구 UI 설명): 슬라이더 — 슬라이더를 만들 위치를 선택하세요. [src:math3d-ui/src/app/components/tabs/geometry/config.ts:74]",
    "호출: commandManager.execute(\"object.addSlider\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2444-2489]",
    "만드는 것: slider(payload.category) 1개 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2465] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 objectCommandUtils.getNextObjectColor(state) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2477], 불투명도 1 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2478], 이름표(label 하위 객체, 따로 생기는 개체 아님): visible true [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:66], relatedPosition [0, 0] [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2482], size 16 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:67], color #333333 [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:79]",
    "바꾸는 것: state.__returnValue [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2488]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "category: 형식 'horizon-bar'|'vertical-bar'|'circle'(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2444]",
    "normalizedPosition?: 형식 point2(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2444]; 생략하면 [nx, ny] [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2469]",
    "defaultValue?: 형식 number(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2444]; 생략하면 1 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2473]",
    "symbol?: 형식 string(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2444]; 생략하면 objectCommandUtils.getNextSliderSymbol(state) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2460]",
    "값 자르기: o.value < o.min → o.value = o.min [src:math3d/src/app/math3d/state-manager/object-types/math3d-slider.ts:50]",
    "값 자르기: o.value > o.max → o.value = o.max [src:math3d/src/app/math3d/state-manager/object-types/math3d-slider.ts:51]",
    "명령이 고정하는 값: min=-10, max=10, step=0.1 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2470]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.addCheckbox",
   "command": "object.addCheckbox",
   "params": [
    {
     "name": "title",
     "type": "string",
     "optional": true
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도(도구 UI 설명): 체크박스 — 체크박스를 만들 위치를 선택하세요. [src:math3d-ui/src/app/components/tabs/geometry/config.ts:84]",
    "호출: commandManager.execute(\"object.addCheckbox\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2491-2501]",
    "만드는 것: checkbox 1개 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2492] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120], 색 #005cff(_defaultProperties.normalPointColor) [src:math3d/src/app/math3d/state-manager/slices/object/slice.ts:32]",
    "바꾸는 것: state.__returnValue [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2500]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "title?: 형식 string(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2491]; 생략하면 '' [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2497]",
    "인자로 못 정하는 속성(생성 기본값): objectList={} [src:math3d/src/app/math3d/state-manager/object-types/math3d-checkbox.ts:29]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.addDecoCallout",
   "command": "object.addDecoCallout",
   "params": [
    {
     "name": "relativePoints",
     "type": "ref[2]",
     "optional": false,
     "accepts": [
      {
       "type": "point",
       "category": "points"
      }
     ]
    },
    {
     "name": "controlPoint",
     "type": "point3",
     "optional": false
    },
    {
     "name": "direction",
     "type": "'x'|'z'",
     "optional": false
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도(도구 UI 설명): 설명선 — 설명선을 만들 선분 또는 두 점을 선택한 후 만들 위치를 선택하세요. [src:math3d-ui/src/app/components/tabs/geometry/config.ts:495]",
    "호출: commandManager.execute(\"object.addDecoCallout\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2503-2522]",
    "앞에 있어야 하는 것: relativePoints ref[2] = point(points) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2503-2522]",
    "만드는 것: decoration 1개 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2511] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120]",
    "바꾸는 것: state.__returnValue [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2521]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "relativePoints: 형식 ref[2](TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2503]",
    "controlPoint: 형식 point3(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2503]",
    "direction: 형식 'x'|'z'(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2503]",
    "조용히 끝남(아무것도 안 함): !p1 || !p2 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2509]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.addDecoLength",
   "command": "object.addDecoLength",
   "params": [
    {
     "name": "linearID",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "linear"
      }
     ]
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도(도구 UI 설명): 길이 — 길이를 만들 선분을 선택하세요. [src:math3d-ui/src/app/components/tabs/geometry/config.ts:517]",
    "호출: commandManager.execute(\"object.addDecoLength\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2524-2537]",
    "앞에 있어야 하는 것: linearID = linear [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2524-2537]",
    "만드는 것: decoration(decoLength) 1개 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2528] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120]",
    "바꾸는 것: state.__returnValue [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2536]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "linearID: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2524]",
    "조용히 끝남(아무것도 안 함): !linear || linear.category !== \"generalSegment\" 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2526]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.addDecoParallel",
   "command": "object.addDecoParallel",
   "params": [
    {
     "name": "linearID",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "linear"
      }
     ]
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도(도구 UI 설명): 평행 — 평행선을 만들 선분을 선택하세요. [src:math3d-ui/src/app/components/tabs/geometry/config.ts:506]",
    "호출: commandManager.execute(\"object.addDecoParallel\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2539-2552]",
    "앞에 있어야 하는 것: linearID = linear [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2539-2552]",
    "만드는 것: decoration(decoParallel) 1개 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2543] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120]",
    "바꾸는 것: state.__returnValue [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2551]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "linearID: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2539]",
    "조용히 끝남(아무것도 안 함): !linear || !isObjectType(linear, 'linear') 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2541]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.addDecoAngle",
   "command": "object.addDecoAngle",
   "params": [
    {
     "name": "relativePoints",
     "type": "ref[3]",
     "optional": false,
     "accepts": [
      {
       "type": "point",
       "category": "points"
      }
     ]
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도(도구 UI 설명): 각도 — 각도를 만들 세 점을 선택하세요. [src:base2d-ui/src/tab/tools/configs/base2d-geometry.ts:573]",
    "호출: commandManager.execute(\"object.addDecoAngle\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2554-2564]",
    "앞에 있어야 하는 것: relativePoints ref[3] = point(points) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2554-2564]",
    "만드는 것: decoration(decoAngle) 1개 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2555] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120]",
    "바꾸는 것: state.__returnValue [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2563]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "relativePoints: 형식 ref[3](TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2554]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.addMeasurement",
   "command": "object.addMeasurement",
   "params": [
    {
     "name": "category",
     "type": "'measureLength'|'measureAngle'|'measureArea'|'measureVolume'",
     "optional": false
    },
    {
     "name": "relativeObjects",
     "type": "ref[]",
     "optional": true,
     "accepts": [
      {
       "type": "point"
      },
      {
       "type": "plane"
      },
      {
       "type": "sphere"
      },
      {
       "type": "polyhedron"
      },
      {
       "type": "cylindroconical"
      }
     ]
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도(도구 UI 설명): 길이·각도·넓이·부피 — 길이를 측정할 두 점 또는 선분을 선택하세요. [src:base2d-ui/src/tab/tools/configs/base2d-geometry.ts:447]",
    "호출: commandManager.execute(\"object.addMeasurement\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2566-2581]",
    "앞에 있어야 하는 것: relativeObjects ref[] = 아무 개체 (생략 가능) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2566-2581]",
    "만드는 것: measurement(payload.category) 1개 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2572] — 보임=true(공통 기본값) [src:math3d/src/app/math3d/state-manager/object-types/common.ts:120]",
    "바꾸는 것: state.__returnValue [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2580]",
    "참고: category 별로 받는 개체가 다르다. measureLength 는 점 2개의 거리이다(선분 하나를 주면 무효이다). measureAngle 은 점 3개이고 가운데가 꼭짓점이며 값은 도 단위이다. measureArea 는 다각형이면 넓이이고 구, 각뿔, 원뿔, 원기둥이면 밑면을 포함한 겉넓이이다. 세 점으로 만든 평면에 measureArea 를 주면 값이 0 이다. measureVolume 은 구, 각뿔, 원뿔, 원기둥 중 하나를 주면 그 부피이다. [src:정합성 math3d-kinds: scripts/pipeline/kind-matrix3d.mjs 의 시험 object.addMeasurement 에 장면 개체 종류 조합 2036건을 넣어 유효 298건(증거 evidence/runs/2026-10-22/math3d/kind-matrix3d-3.json)]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "category: 형식 'measureLength'|'measureAngle'|'measureArea'|'measureVolume'(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2566]",
    "relativeObjects?: 형식 ref[](TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2566]; 생략하면 [] [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2576]",
    "인자로 못 정하는 속성(생성 기본값): value=0 [src:math3d/src/app/math3d/state-manager/object-types/math3d-measurement.ts:34]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.addTransformObject",
   "command": "object.addTransformObject",
   "params": [
    {
     "name": "transformType",
     "type": "'none'|'planeSymmetry'|'linearSymmetry'|'pointSymmetry'|'translation'|'scale'|'rotation'",
     "optional": false
    },
    {
     "name": "targetId",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      },
      {
       "type": "linear"
      },
      {
       "type": "plane"
      },
      {
       "type": "circular"
      },
      {
       "type": "sphere"
      },
      {
       "type": "polyhedron"
      },
      {
       "type": "cylindroconical"
      }
     ]
    },
    {
     "name": "pivotId",
     "type": "ref",
     "optional": false,
     "accepts": [
      {
       "type": "point"
      },
      {
       "type": "linear"
      },
      {
       "type": "plane"
      }
     ]
    },
    {
     "name": "angle",
     "type": "number|string",
     "optional": true
    },
    {
     "name": "scale",
     "type": "number|string",
     "optional": true
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.addTransformObject\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2583-2706]",
    "앞에 있어야 하는 것: targetId = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2583-2706]",
    "앞에 있어야 하는 것: pivotId = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2583-2706]",
    "바꾸는 속성: relativeObject [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2696]",
    "바꾸는 것: object.groupIdList 에 추가 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:346]",
    "바꾸는 것: state.groupMap[groupID] [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:349]",
    "바꾸는 것: state.__returnValue [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2705]",
    "참고: 변환 종류마다 기준(pivotId) 종류가 다르다. planeSymmetry 는 평면, linearSymmetry 와 translation 과 rotation 은 선, pointSymmetry 는 점이다. rotation 은 angle 을 함께 준다. scale 과 none 은 이 시험에서 유효가 나오지 않았다. [src:정합성 math3d-kinds: scripts/pipeline/kind-matrix3d.mjs 의 시험 object.addTransformObject 에 장면 개체 종류 조합 3234건을 넣어 유효 640건(증거 evidence/runs/2026-10-22/math3d/kind-matrix3d-3.json)]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "transformType: 형식 'none'|'planeSymmetry'|'linearSymmetry'|'pointSymmetry'|'translation'|'scale'|'rotation'(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2583]",
    "targetId: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2583]",
    "pivotId: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2583]",
    "angle?: 형식 number|string(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2583]; 생략하면 그 속성은 바꾸지 않는다 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2591]; 문자열이면 슬라이더 변수식으로 계산된다 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2583]",
    "scale?: 형식 number|string(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2583]; 생략하면 그 속성은 바꾸지 않는다 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2595]; 문자열이면 슬라이더 변수식으로 계산된다 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2583]",
    "조용히 끝남(아무것도 안 함): !originalTargetObject 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2586]",
    "조용히 끝남(아무것도 안 함): !object || object.groupIdList.includes(groupID) 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:338]",
    "조용히 끝남(아무것도 안 함): objects.length === 0 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:342]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.updateTransformObject",
   "command": "object.updateTransformObject",
   "params": [
    {
     "name": "id",
     "type": "ref",
     "optional": false,
     "accepts": "any"
    },
    {
     "name": "transformType",
     "type": "'none'|'planeSymmetry'|'linearSymmetry'|'pointSymmetry'|'translation'|'scale'|'rotation'",
     "optional": false
    },
    {
     "name": "angle",
     "type": "number|string",
     "optional": true
    },
    {
     "name": "scale",
     "type": "number|string",
     "optional": true
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.updateTransformObject\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2708-2832]",
    "앞에 있어야 하는 것: id = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2708-2832]",
    "바꾸는 것: state.__returnValue [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2831]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "id: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2708]",
    "transformType: 형식 'none'|'planeSymmetry'|'linearSymmetry'|'pointSymmetry'|'translation'|'scale'|'rotation'(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2708]; 본문에서 읽지 않는다, 넣어도 무시된다 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2708-2832]",
    "angle?: 형식 number|string(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2708]; 생략하면 그 속성은 바꾸지 않는다 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2716]; 문자열이면 슬라이더 변수식으로 계산된다 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2708]",
    "scale?: 형식 number|string(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2708]; 생략하면 그 속성은 바꾸지 않는다 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2722]; 문자열이면 슬라이더 변수식으로 계산된다 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2708]",
    "조용히 끝남(아무것도 안 함): !object || !object.transform 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2710]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.setDecoControlPoint",
   "command": "object.setDecoControlPoint",
   "params": [
    {
     "name": "id",
     "type": "ref",
     "optional": false,
     "accepts": "any"
    },
    {
     "name": "controlPoint",
     "type": "point3",
     "optional": false
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.setDecoControlPoint\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2834-2839]",
    "앞에 있어야 하는 것: id = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2834-2839]",
    "바꾸는 속성: controlPoints [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2838]",
    "바꾸는 것: deco.controlPoints[1] [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2837]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "id: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2834]",
    "controlPoint: 형식 point3(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2834]",
    "조용히 끝남(아무것도 안 함): !deco || !deco.controlPoints 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2836]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.setDecoShapeType",
   "command": "object.setDecoShapeType",
   "params": [
    {
     "name": "id",
     "type": "ref",
     "optional": false,
     "accepts": "any"
    },
    {
     "name": "shapeType",
     "type": "number",
     "optional": false
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.setDecoShapeType\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2841-2846]",
    "앞에 있어야 하는 것: id = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2841-2846]",
    "바꾸는 속성: shapeType [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2845]",
    "바꾸는 것: deco.shapeType [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2844]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "id: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2841]",
    "shapeType: 형식 number(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2841]",
    "조용히 끝남(아무것도 안 함): !deco 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2843]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.setDecoParallelDirection",
   "command": "object.setDecoParallelDirection",
   "params": [
    {
     "name": "id",
     "type": "ref",
     "optional": false,
     "accepts": "any"
    },
    {
     "name": "parallelDirection",
     "type": "boolean",
     "optional": false
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.setDecoParallelDirection\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2848-2853]",
    "앞에 있어야 하는 것: id = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2848-2853]",
    "바꾸는 속성: parallelDirection [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2852]",
    "바꾸는 것: deco.parallelDirection [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2851]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "id: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2848]",
    "parallelDirection: 형식 boolean(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2848]",
    "조용히 끝남(아무것도 안 함): !deco 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2850]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.setCheckboxTitle",
   "command": "object.setCheckboxTitle",
   "params": [
    {
     "name": "id",
     "type": "ref",
     "optional": false,
     "accepts": "any"
    },
    {
     "name": "title",
     "type": "string",
     "optional": false
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.setCheckboxTitle\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2855-2859]",
    "앞에 있어야 하는 것: id = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2855-2859]",
    "바꾸는 속성: title [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2858]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "id: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2855]",
    "title: 형식 string(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2855]",
    "조용히 끝남(아무것도 안 함): !checkbox 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2857]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.setCheckboxObjectList",
   "command": "object.setCheckboxObjectList",
   "params": [
    {
     "name": "id",
     "type": "ref",
     "optional": false,
     "accepts": "any"
    },
    {
     "name": "objectList",
     "type": "record:ref:'visible'|'invisible'|'toggle'",
     "optional": false
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.setCheckboxObjectList\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2861-2865]",
    "앞에 있어야 하는 것: id = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2861-2865]",
    "바꾸는 속성: objectList [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2864]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "id: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2861]",
    "objectList: 형식 record:ref:'visible'|'invisible'|'toggle'(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2861]",
    "조용히 끝남(아무것도 안 함): !checkbox 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2863]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.getSliderIdBySymbol",
   "command": "object.getSliderIdBySymbol",
   "params": [
    {
     "name": "symbol",
     "type": "string",
     "optional": false
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.getSliderIdBySymbol\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2867-2876]",
    "본문이 확인하는 종류: slider [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2867-2876]",
    "바꾸는 것: state.__returnValue [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2875]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "symbol: 형식 string(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2867]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.setLayer2DNormalizedPosition",
   "command": "object.setLayer2DNormalizedPosition",
   "params": [
    {
     "name": "id",
     "type": "ref",
     "optional": false,
     "accepts": "any"
    },
    {
     "name": "normalizedPosition",
     "type": "point2",
     "optional": false
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.setLayer2DNormalizedPosition\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2878-2882]",
    "앞에 있어야 하는 것: id = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2878-2882]",
    "본문이 확인하는 종류: slider, checkbox [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2878-2882]",
    "바꾸는 속성: normalizedPosition [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2881]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "id: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2878]",
    "normalizedPosition: 형식 point2(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2878]",
    "조용히 끝남(아무것도 안 함): !object2d || !(isObjectType(object2d, \"slider\") || isObjectType(object2d, \"checkbox\")) 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2880]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.setSliderValue",
   "command": "object.setSliderValue",
   "params": [
    {
     "name": "id",
     "type": "ref",
     "optional": false,
     "accepts": "any"
    },
    {
     "name": "value",
     "type": "number",
     "optional": false
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.setSliderValue\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2884-2889]",
    "앞에 있어야 하는 것: id = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2884-2889]",
    "본문이 확인하는 종류: slider [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2884-2889]",
    "바꾸는 속성: value [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2888]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "id: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2884]",
    "value: 형식 number(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2884]",
    "조용히 끝남(아무것도 안 함): !slider || !isObjectType(slider, \"slider\") 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2886]",
    "조용히 끝남(아무것도 안 함): slider.value === payload.value 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2887]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.setSliderAnimationPlayingState",
   "command": "object.setSliderAnimationPlayingState",
   "params": [
    {
     "name": "id",
     "type": "ref",
     "optional": false,
     "accepts": "any"
    },
    {
     "name": "animationPlayingState",
     "type": "boolean",
     "optional": false
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.setSliderAnimationPlayingState\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2891-2895]",
    "앞에 있어야 하는 것: id = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2891-2895]",
    "본문이 확인하는 종류: slider [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2891-2895]",
    "바꾸는 속성: animationPlayingState [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2894]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "id: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2891]",
    "animationPlayingState: 형식 boolean(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2891]",
    "조용히 끝남(아무것도 안 함): !slider || !isObjectType(slider, \"slider\") 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2893]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.setSliderMinValue",
   "command": "object.setSliderMinValue",
   "params": [
    {
     "name": "id",
     "type": "ref",
     "optional": false,
     "accepts": "any"
    },
    {
     "name": "value",
     "type": "number",
     "optional": false
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.setSliderMinValue\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2897-2901]",
    "앞에 있어야 하는 것: id = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2897-2901]",
    "본문이 확인하는 종류: slider [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2897-2901]",
    "바꾸는 속성: min [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2900]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "id: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2897]",
    "value: 형식 number(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2897]",
    "조용히 끝남(아무것도 안 함): !slider || !isObjectType(slider, \"slider\") 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2899]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.setSliderMaxValue",
   "command": "object.setSliderMaxValue",
   "params": [
    {
     "name": "id",
     "type": "ref",
     "optional": false,
     "accepts": "any"
    },
    {
     "name": "value",
     "type": "number",
     "optional": false
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.setSliderMaxValue\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2903-2907]",
    "앞에 있어야 하는 것: id = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2903-2907]",
    "본문이 확인하는 종류: slider [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2903-2907]",
    "바꾸는 속성: max [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2906]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "id: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2903]",
    "value: 형식 number(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2903]",
    "조용히 끝남(아무것도 안 함): !slider || !isObjectType(slider, \"slider\") 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2905]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.setSliderStepValue",
   "command": "object.setSliderStepValue",
   "params": [
    {
     "name": "id",
     "type": "ref",
     "optional": false,
     "accepts": "any"
    },
    {
     "name": "value",
     "type": "number",
     "optional": false
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.setSliderStepValue\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2909-2913]",
    "앞에 있어야 하는 것: id = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2909-2913]",
    "본문이 확인하는 종류: slider [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2909-2913]",
    "바꾸는 속성: step [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2912]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "id: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2909]",
    "value: 형식 number(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2909]",
    "조용히 끝남(아무것도 안 함): !slider || !isObjectType(slider, \"slider\") 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2911]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.setSliderAnimationSpeed",
   "command": "object.setSliderAnimationSpeed",
   "params": [
    {
     "name": "id",
     "type": "ref",
     "optional": false,
     "accepts": "any"
    },
    {
     "name": "value",
     "type": "number",
     "optional": false
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.setSliderAnimationSpeed\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2915-2919]",
    "앞에 있어야 하는 것: id = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2915-2919]",
    "본문이 확인하는 종류: slider [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2915-2919]",
    "바꾸는 속성: animationSpeed [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2918]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "id: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2915]",
    "value: 형식 number(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2915]",
    "조용히 끝남(아무것도 안 함): !slider || !isObjectType(slider, \"slider\") 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2917]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.setSliderAnimationDirection",
   "command": "object.setSliderAnimationDirection",
   "params": [
    {
     "name": "id",
     "type": "ref",
     "optional": false,
     "accepts": "any"
    },
    {
     "name": "value",
     "type": "'increasing'|'decreasing'|'oscillating'",
     "optional": false
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.setSliderAnimationDirection\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2921-2925]",
    "앞에 있어야 하는 것: id = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2921-2925]",
    "본문이 확인하는 종류: slider [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2921-2925]",
    "바꾸는 속성: animationDirection [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2924]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "id: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2921]",
    "value: 형식 'increasing'|'decreasing'|'oscillating'(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2921]",
    "조용히 끝남(아무것도 안 함): !slider || !isObjectType(slider, \"slider\") 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2923]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.setSliderCategory",
   "command": "object.setSliderCategory",
   "params": [
    {
     "name": "id",
     "type": "ref",
     "optional": false,
     "accepts": "any"
    },
    {
     "name": "value",
     "type": "'horizon-bar'|'vertical-bar'|'circle'",
     "optional": false
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.setSliderCategory\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2927-2931]",
    "앞에 있어야 하는 것: id = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2927-2931]",
    "본문이 확인하는 종류: slider [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2927-2931]",
    "바꾸는 속성: category [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2930]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "id: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2927]",
    "value: 형식 'horizon-bar'|'vertical-bar'|'circle'(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2927]",
    "조용히 끝남(아무것도 안 함): !slider || !isObjectType(slider, \"slider\") 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2929]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.setSliderSymbol",
   "command": "object.setSliderSymbol",
   "params": [
    {
     "name": "id",
     "type": "ref",
     "optional": false,
     "accepts": "any"
    },
    {
     "name": "value",
     "type": "string",
     "optional": false
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.setSliderSymbol\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2933-2937]",
    "앞에 있어야 하는 것: id = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2933-2937]",
    "본문이 확인하는 종류: slider [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2933-2937]",
    "바꾸는 속성: symbol [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2936]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "id: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2933]",
    "value: 형식 string(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2933]",
    "조용히 끝남(아무것도 안 함): !slider || !isObjectType(slider, \"slider\") 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2935]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.setCheckboxValue",
   "command": "object.setCheckboxValue",
   "params": [
    {
     "name": "id",
     "type": "ref",
     "optional": false,
     "accepts": "any"
    },
    {
     "name": "value",
     "type": "boolean",
     "optional": false
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.setCheckboxValue\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2939-2944]",
    "앞에 있어야 하는 것: id = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2939-2944]",
    "본문이 확인하는 종류: checkbox [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2939-2944]",
    "바꾸는 속성: value [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2943]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "id: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2939]",
    "value: 형식 boolean(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2939]",
    "조용히 끝남(아무것도 안 함): !checkbox || !isObjectType(checkbox, \"checkbox\") 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2941]",
    "조용히 끝남(아무것도 안 함): checkbox.value === payload.value 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2942]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.setAlgebraicExpression",
   "command": "object.setAlgebraicExpression",
   "params": [
    {
     "name": "id",
     "type": "ref",
     "optional": false,
     "accepts": "any"
    },
    {
     "name": "expression",
     "type": "expr",
     "optional": false
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.setAlgebraicExpression\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2946-2950]",
    "앞에 있어야 하는 것: id = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2946-2950]",
    "본문이 확인하는 종류: algebraic [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2946-2950]",
    "바꾸는 속성: exprInputLatex [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2949]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "id: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2946]",
    "expression: 형식 expr(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2946]",
    "조용히 끝남(아무것도 안 함): !algebraic || !isObjectType(algebraic, \"algebraic\") 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2948]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.setPointPosition",
   "command": "object.setPointPosition",
   "params": [
    {
     "name": "id",
     "type": "ref",
     "optional": false,
     "accepts": "any"
    },
    {
     "name": "position",
     "type": "point3",
     "optional": false
    },
    {
     "name": "animate",
     "type": "enum:AnimationOptions",
     "optional": true
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.setPointPosition\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2952-2962]",
    "앞에 있어야 하는 것: id = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2952-2962]",
    "본문이 확인하는 종류: point [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2952-2962]",
    "바꾸는 속성: position, expressionProperty [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2957]",
    "바꾸는 속성: expressionProperty [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2959]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "id: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2952]",
    "position: 형식 point3(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2952]; 문자열이면 슬라이더 변수식으로 계산된다 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2952]",
    "animate?: 형식 enum:AnimationOptions(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2952]; 주면 명령 본문은 아무것도 안 하고 끝난다, 대신 $animate 미들웨어가 애니메이션으로 바꾼다 [src:math3d/src/app/math3d/command-manager/command-manager.ts:101-141]; 생략하면 본문이 바로 바꾼다 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2954]",
    "조용히 끝남(아무것도 안 함): !point || !isObjectType(point, \"point\") || payload.animate 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2954]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.setObjectPositions",
   "command": "object.setObjectPositions",
   "params": [
    {
     "name": "data",
     "type": "{id:ref;position:point3}[]",
     "optional": false
    },
    {
     "name": "animate",
     "type": "enum:AnimationOptions",
     "optional": true
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.setObjectPositions\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2964-2977]",
    "본문이 확인하는 종류: point, text, image [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2964-2977]",
    "만드는 개체 없음, 속성 갱신 리터럴도 못 찾음 — 본문 직접 확인 필요(미확인) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2964-2977]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "data: 형식 {id:ref;position:point3}[](TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2964]; 문자열이면 슬라이더 변수식으로 계산된다 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2964]",
    "animate?: 형식 enum:AnimationOptions(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2964]; 주면 명령 본문은 아무것도 안 하고 끝난다, 대신 $animate 미들웨어가 애니메이션으로 바꾼다 [src:math3d/src/app/math3d/command-manager/command-manager.ts:101-141]; 생략하면 본문이 바로 바꾼다 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2968]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.deleteAllTrails",
   "command": "object.deleteAllTrails",
   "params": [],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.deleteAllTrails\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2979-2992]",
    "바꾸는 속성: isTrail [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2989]",
    "바꾸는 것: object.trails [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2983]",
    "바꾸는 것: state.objectTrailGraph.all.length [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2986]",
    "바꾸는 것: state.objectTrailGraph.on.length [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2991]"
   ],
   "range": []
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.clearAllTrails",
   "command": "object.clearAllTrails",
   "params": [],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.clearAllTrails\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2994-3001]",
    "바꾸는 것: object.trails [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:2998]"
   ],
   "range": []
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.setTextPosition",
   "command": "object.setTextPosition",
   "params": [
    {
     "name": "id",
     "type": "ref",
     "optional": false,
     "accepts": "any"
    },
    {
     "name": "position",
     "type": "point3",
     "optional": false
    },
    {
     "name": "animate",
     "type": "enum:AnimationOptions",
     "optional": true
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.setTextPosition\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3003-3007]",
    "앞에 있어야 하는 것: id = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3003-3007]",
    "본문이 확인하는 종류: text [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3003-3007]",
    "바꾸는 속성: position [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3006]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "id: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3003]",
    "position: 형식 point3(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3003]",
    "animate?: 형식 enum:AnimationOptions(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3003]; 주면 명령 본문은 아무것도 안 하고 끝난다, 대신 $animate 미들웨어가 애니메이션으로 바꾼다 [src:math3d/src/app/math3d/command-manager/command-manager.ts:101-141]; 생략하면 본문이 바로 바꾼다 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3005]",
    "조용히 끝남(아무것도 안 함): !text || !isObjectType(text, \"text\") || payload.animate 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3005]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.setTextRotation",
   "command": "object.setTextRotation",
   "params": [
    {
     "name": "id",
     "type": "ref",
     "optional": false,
     "accepts": "any"
    },
    {
     "name": "rotation",
     "type": "point3",
     "optional": false
    },
    {
     "name": "animate",
     "type": "enum:AnimationOptions",
     "optional": true
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.setTextRotation\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3009-3014]",
    "앞에 있어야 하는 것: id = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3009-3014]",
    "본문이 확인하는 종류: text [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3009-3014]",
    "바꾸는 속성: rotation [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3013]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "id: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3009]",
    "rotation: 형식 point3(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3009]",
    "animate?: 형식 enum:AnimationOptions(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3009]; 주면 명령 본문은 아무것도 안 하고 끝난다, 대신 $animate 미들웨어가 애니메이션으로 바꾼다 [src:math3d/src/app/math3d/command-manager/command-manager.ts:101-141]; 생략하면 본문이 바로 바꾼다 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3012]",
    "조용히 끝남(아무것도 안 함): !text || !isObjectType(text, \"text\") || payload.animate 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3012]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.setTextProperty",
   "command": "object.setTextProperty",
   "params": [
    {
     "name": "id",
     "type": "ref",
     "optional": false,
     "accepts": "any"
    },
    {
     "name": "latex",
     "type": "boolean",
     "optional": true
    },
    {
     "name": "text",
     "type": "string",
     "optional": true
    },
    {
     "name": "size",
     "type": "number",
     "optional": true
    },
    {
     "name": "scaleLock",
     "type": "boolean",
     "optional": true
    },
    {
     "name": "animate",
     "type": "enum:AnimationOptions",
     "optional": true
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.setTextProperty\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3016-3026]",
    "앞에 있어야 하는 것: id = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3016-3026]",
    "본문이 확인하는 종류: text [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3016-3026]",
    "바꾸는 속성: latex [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3021]",
    "바꾸는 속성: text [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3022]",
    "바꾸는 속성: size [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3023]",
    "바꾸는 속성: scaleLock [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3024]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "id: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3016]",
    "latex?: 형식 boolean(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3016]; 생략하면 그 속성은 바꾸지 않는다 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3021]",
    "text?: 형식 string(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3016]; 생략하면 그 속성은 바꾸지 않는다 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3022]",
    "size?: 형식 number(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3016]; 생략하면 그 속성은 바꾸지 않는다 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3023]",
    "scaleLock?: 형식 boolean(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3016]; 생략하면 그 속성은 바꾸지 않는다 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3024]",
    "animate?: 형식 enum:AnimationOptions(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3016]; 주면 명령 본문은 아무것도 안 하고 끝난다, 대신 $animate 미들웨어가 애니메이션으로 바꾼다 [src:math3d/src/app/math3d/command-manager/command-manager.ts:101-141]; 생략하면 본문이 바로 바꾼다 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3018]",
    "조용히 끝남(아무것도 안 함): !text || !isObjectType(text, \"text\") || (payload.size && payload.animate) 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3018]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.setImagePosition",
   "command": "object.setImagePosition",
   "params": [
    {
     "name": "id",
     "type": "ref",
     "optional": false,
     "accepts": "any"
    },
    {
     "name": "position",
     "type": "point3",
     "optional": false
    },
    {
     "name": "animate",
     "type": "enum:AnimationOptions",
     "optional": true
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.setImagePosition\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3028-3032]",
    "앞에 있어야 하는 것: id = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3028-3032]",
    "본문이 확인하는 종류: image [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3028-3032]",
    "바꾸는 속성: position [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3031]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "id: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3028]",
    "position: 형식 point3(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3028]",
    "animate?: 형식 enum:AnimationOptions(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3028]; 주면 명령 본문은 아무것도 안 하고 끝난다, 대신 $animate 미들웨어가 애니메이션으로 바꾼다 [src:math3d/src/app/math3d/command-manager/command-manager.ts:101-141]; 생략하면 본문이 바로 바꾼다 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3030]",
    "조용히 끝남(아무것도 안 함): !image || !isObjectType(image, \"image\") || payload.animate 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3030]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.setImageSize",
   "command": "object.setImageSize",
   "params": [
    {
     "name": "id",
     "type": "ref",
     "optional": false,
     "accepts": "any"
    },
    {
     "name": "size",
     "type": "point2",
     "optional": false
    },
    {
     "name": "animate",
     "type": "enum:AnimationOptions",
     "optional": true
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.setImageSize\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3034-3042]",
    "앞에 있어야 하는 것: id = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3034-3042]",
    "바꾸는 속성: size, ratio [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3038]",
    "바꾸는 속성: size [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3040]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "id: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3034]",
    "size: 형식 point2(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3034]",
    "animate?: 형식 enum:AnimationOptions(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3034]; 주면 명령 본문은 아무것도 안 하고 끝난다, 대신 $animate 미들웨어가 애니메이션으로 바꾼다 [src:math3d/src/app/math3d/command-manager/command-manager.ts:101-141]; 생략하면 본문이 바로 바꾼다 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3036]",
    "조용히 끝남(아무것도 안 함): !image || payload.animate 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3036]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.setImageRotation",
   "command": "object.setImageRotation",
   "params": [
    {
     "name": "id",
     "type": "ref",
     "optional": false,
     "accepts": "any"
    },
    {
     "name": "rotation",
     "type": "point3",
     "optional": false
    },
    {
     "name": "animate",
     "type": "enum:AnimationOptions",
     "optional": true
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.setImageRotation\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3044-3048]",
    "앞에 있어야 하는 것: id = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3044-3048]",
    "바꾸는 속성: rotation [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3047]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "id: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3044]",
    "rotation: 형식 point3(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3044]",
    "animate?: 형식 enum:AnimationOptions(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3044]; 주면 명령 본문은 아무것도 안 하고 끝난다, 대신 $animate 미들웨어가 애니메이션으로 바꾼다 [src:math3d/src/app/math3d/command-manager/command-manager.ts:101-141]; 생략하면 본문이 바로 바꾼다 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3046]",
    "조용히 끝남(아무것도 안 함): !image || payload.animate 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3046]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.setImageFlipX",
   "command": "object.setImageFlipX",
   "params": [
    {
     "name": "id",
     "type": "ref",
     "optional": false,
     "accepts": "any"
    },
    {
     "name": "flipX",
     "type": "boolean",
     "optional": false
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.setImageFlipX\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3050-3054]",
    "앞에 있어야 하는 것: id = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3050-3054]",
    "바꾸는 속성: flipX [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3053]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "id: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3050]",
    "flipX: 형식 boolean(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3050]",
    "조용히 끝남(아무것도 안 함): !image 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3052]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.setImageFlipY",
   "command": "object.setImageFlipY",
   "params": [
    {
     "name": "id",
     "type": "ref",
     "optional": false,
     "accepts": "any"
    },
    {
     "name": "flipY",
     "type": "boolean",
     "optional": false
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.setImageFlipY\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3056-3060]",
    "앞에 있어야 하는 것: id = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3056-3060]",
    "바꾸는 속성: flipY [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3059]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "id: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3056]",
    "flipY: 형식 boolean(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3056]",
    "조용히 끝남(아무것도 안 함): !image 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3058]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.setImageProperty",
   "command": "object.setImageProperty",
   "params": [
    {
     "name": "id",
     "type": "ref",
     "optional": false,
     "accepts": "any"
    },
    {
     "name": "size",
     "type": "point2",
     "optional": true
    },
    {
     "name": "scaleLock",
     "type": "boolean",
     "optional": true
    },
    {
     "name": "ratioLock",
     "type": "boolean",
     "optional": true
    },
    {
     "name": "opacity",
     "type": "number",
     "optional": true
    },
    {
     "name": "animate",
     "type": "enum:AnimationOptions",
     "optional": true
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.setImageProperty\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3062-3077]",
    "앞에 있어야 하는 것: id = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3062-3077]",
    "바꾸는 속성: scaleLock [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3072]",
    "바꾸는 속성: ratioLock [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3073]",
    "바꾸는 속성: opacity [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3074]",
    "바꾸는 속성: size [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3075]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "id: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3062]",
    "size?: 형식 point2(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3062]; 생략하면 그 속성은 바꾸지 않는다 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3075]",
    "scaleLock?: 형식 boolean(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3062]; 생략하면 그 속성은 바꾸지 않는다 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3072]",
    "ratioLock?: 형식 boolean(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3062]; 생략하면 그 속성은 바꾸지 않는다 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3073]",
    "opacity?: 형식 number(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3062]; 생략하면 그 속성은 바꾸지 않는다 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3074]",
    "animate?: 형식 enum:AnimationOptions(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3062]; 주면 명령 본문은 아무것도 안 하고 끝난다, 대신 $animate 미들웨어가 애니메이션으로 바꾼다 [src:math3d/src/app/math3d/command-manager/command-manager.ts:101-141]; 생략하면 본문이 바로 바꾼다 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3069]",
    "조용히 끝남(아무것도 안 함): !image || (payload.opacity && payload.animate) 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3069]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.setHoverState",
   "command": "object.setHoverState",
   "params": [
    {
     "name": "id",
     "type": "ref",
     "optional": false,
     "accepts": "any"
    },
    {
     "name": "isHovered",
     "type": "boolean",
     "optional": false
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.setHoverState\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3079-3092]",
    "앞에 있어야 하는 것: id = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3079-3092]",
    "바꾸는 것: polygonObject.isHovered [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3087]",
    "바꾸는 것: object.isHovered [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3091]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "id: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3079]",
    "isHovered: 형식 boolean(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3079]",
    "조용히 끝남(아무것도 안 함): !object 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3081]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.selectObject",
   "command": "object.selectObject",
   "params": [
    {
     "name": "id",
     "type": "ref",
     "optional": false,
     "accepts": "any"
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.selectObject\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3094-3096]",
    "앞에 있어야 하는 것: id = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3094-3096]",
    "바꾸는 것: selectedObject.isSelected [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:640]",
    "바꾸는 것: state.selectedObjects 에 추가 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:642]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "id: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3094]",
    "조용히 끝남(아무것도 안 함): !selectedObject 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:639]",
    "조용히 끝남(아무것도 안 함): state.selectedObjects.includes(id) 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:641]",
    "조용히 끝남(아무것도 안 함): !object 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:628]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.selectObjects",
   "command": "object.selectObjects",
   "params": [
    {
     "name": "ids",
     "type": "ref[]",
     "optional": false,
     "accepts": "any"
    },
    {
     "name": "isSelected",
     "type": "boolean",
     "optional": true
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.selectObjects\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3098-3102]",
    "앞에 있어야 하는 것: ids ref[] = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3098-3102]",
    "바꾸는 것: selectedObject.isSelected [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:640]",
    "바꾸는 것: state.selectedObjects 에 추가 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:642]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "ids: 형식 ref[](TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3098]",
    "isSelected?: 형식 boolean(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3098]; 본문에서 읽지 않는다, 넣어도 무시된다 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3098-3102]",
    "조용히 끝남(아무것도 안 함): !selectedObject 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:639]",
    "조용히 끝남(아무것도 안 함): state.selectedObjects.includes(id) 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:641]",
    "조용히 끝남(아무것도 안 함): !object 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:628]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.unselectObject",
   "command": "object.unselectObject",
   "params": [
    {
     "name": "id",
     "type": "ref",
     "optional": false,
     "accepts": "any"
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.unselectObject\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3104-3106]",
    "앞에 있어야 하는 것: id = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3104-3106]",
    "바꾸는 것: selectedObject.isSelected [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:653]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "id: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3104]",
    "조용히 끝남(아무것도 안 함): !selectedObject 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:652]",
    "조용히 끝남(아무것도 안 함): !state.selectedObjects.includes(id) 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:654]",
    "조용히 끝남(아무것도 안 함): !object 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:628]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.unselectObjects",
   "command": "object.unselectObjects",
   "params": [
    {
     "name": "ids",
     "type": "ref[]",
     "optional": false,
     "accepts": "any"
    },
    {
     "name": "isSelected",
     "type": "boolean",
     "optional": true
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.unselectObjects\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3108-3112]",
    "앞에 있어야 하는 것: ids ref[] = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3108-3112]",
    "바꾸는 것: selectedObject.isSelected [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:653]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "ids: 형식 ref[](TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3108]",
    "isSelected?: 형식 boolean(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3108]; 본문에서 읽지 않는다, 넣어도 무시된다 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3108-3112]",
    "조용히 끝남(아무것도 안 함): !selectedObject 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:652]",
    "조용히 끝남(아무것도 안 함): !state.selectedObjects.includes(id) 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:654]",
    "조용히 끝남(아무것도 안 함): !object 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:628]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.unselectAllObjects",
   "command": "object.unselectAllObjects",
   "params": [],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.unselectAllObjects\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3114-3116]",
    "바꾸는 것: selectedObject.isSelected [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:667]",
    "바꾸는 것: state.selectedObjects [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:670]"
   ],
   "range": []
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.hideObject",
   "command": "object.hideObject",
   "params": [
    {
     "name": "id",
     "type": "ref",
     "optional": false,
     "accepts": "any"
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.hideObject\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3118-3122]",
    "앞에 있어야 하는 것: id = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3118-3122]",
    "바꾸는 속성: isVisible [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3121]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "id: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3118]",
    "조용히 끝남(아무것도 안 함): !target 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3120]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.showObject",
   "command": "object.showObject",
   "params": [
    {
     "name": "id",
     "type": "ref",
     "optional": false,
     "accepts": "any"
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.showObject\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3124-3128]",
    "앞에 있어야 하는 것: id = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3124-3128]",
    "바꾸는 속성: isVisible [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3127]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "id: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3124]",
    "조용히 끝남(아무것도 안 함): !target 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3126]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.deleteObject",
   "command": "object.deleteObject",
   "params": [
    {
     "name": "id",
     "type": "ref|ref[]",
     "optional": false,
     "accepts": "any"
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도(도구 UI 설명): 삭제 — 삭제할 대상을 선택하세요. [src:math3d-ui/src/app/components/tabs/geometry/config.ts:64]",
    "호출: commandManager.execute(\"object.deleteObject\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3130-3138]",
    "앞에 있어야 하는 것: id ref|ref[] = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3130-3138]",
    "바꾸는 것: target.exprEval [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:314]",
    "바꾸는 것: target.isValid [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:315]",
    "바꾸는 것: target.category [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:316]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "id: 형식 ref|ref[](TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3130]",
    "조용히 끝남(아무것도 안 함): !targetObject 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:441]",
    "조용히 끝남(아무것도 안 함): !slider || !isObjectType(slider, \"slider\") && !isObjectType(slider, \"measurement\") 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:323]",
    "조용히 끝남(아무것도 안 함): !object 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:628]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.setTrailState",
   "command": "object.setTrailState",
   "params": [
    {
     "name": "id",
     "type": "ref",
     "optional": false,
     "accepts": "any"
    },
    {
     "name": "isTrail",
     "type": "boolean",
     "optional": false
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.setTrailState\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3140-3144]",
    "앞에 있어야 하는 것: id = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3140-3144]",
    "바꾸는 속성: isTrail [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3143]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "id: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3140]",
    "isTrail: 형식 boolean(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3140]",
    "조용히 끝남(아무것도 안 함): !target 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3142]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "variable.getVariables",
   "command": "variable.getVariables",
   "params": [],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"variable.getVariables\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3146-3148]",
    "바꾸는 것: state.__returnValue [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3147]"
   ],
   "range": []
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "variable.getVariable",
   "command": "variable.getVariable",
   "params": [
    {
     "name": "symbol",
     "type": "string",
     "optional": false
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"variable.getVariable\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3150-3152]",
    "바꾸는 것: state.__returnValue [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3151]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "symbol: 형식 string(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3150]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.setObjectDefaultProperty",
   "command": "object.setObjectDefaultProperty",
   "params": [],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.setObjectDefaultProperty\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3154-3161]",
    "바꾸는 것: (state._defaultProperties as any)[key] [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3158]"
   ],
   "range": []
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.setPointSize",
   "command": "object.setPointSize",
   "params": [
    {
     "name": "id",
     "type": "ref",
     "optional": false,
     "accepts": "any"
    },
    {
     "name": "size",
     "type": "number",
     "optional": false
    },
    {
     "name": "animate",
     "type": "enum:AnimationOptions",
     "optional": true
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.setPointSize\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3163-3167]",
    "앞에 있어야 하는 것: id = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3163-3167]",
    "본문이 확인하는 종류: point [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3163-3167]",
    "바꾸는 속성: size [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3166]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "id: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3163]",
    "size: 형식 number(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3163]",
    "animate?: 형식 enum:AnimationOptions(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3163]; 주면 명령 본문은 아무것도 안 하고 끝난다, 대신 $animate 미들웨어가 애니메이션으로 바꾼다 [src:math3d/src/app/math3d/command-manager/command-manager.ts:101-141]; 생략하면 본문이 바로 바꾼다 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3165]",
    "조용히 끝남(아무것도 안 함): !isObjectType(point, \"point\") || payload.animate 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3165]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.setPointShape",
   "command": "object.setPointShape",
   "params": [
    {
     "name": "id",
     "type": "ref",
     "optional": false,
     "accepts": "any"
    },
    {
     "name": "shape",
     "type": "'sphere'|'tetrahedron'|'cube'|'octahedron'|'dodecahedron'|'icosahedron'",
     "optional": false
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.setPointShape\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3169-3173]",
    "앞에 있어야 하는 것: id = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3169-3173]",
    "바꾸는 속성: shape [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3172]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "id: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3169]",
    "shape: 형식 'sphere'|'tetrahedron'|'cube'|'octahedron'|'dodecahedron'|'icosahedron'(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3169]",
    "조용히 끝남(아무것도 안 함): !point 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3171]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.setColor",
   "command": "object.setColor",
   "params": [
    {
     "name": "id",
     "type": "ref",
     "optional": false,
     "accepts": "any"
    },
    {
     "name": "color",
     "type": "color",
     "optional": false
    },
    {
     "name": "animate",
     "type": "enum:AnimationOptions",
     "optional": true
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.setColor\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3175-3180]",
    "앞에 있어야 하는 것: id = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3175-3180]",
    "바꾸는 속성: color [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3179]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "id: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3175]",
    "color: 형식 color(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3175]",
    "animate?: 형식 enum:AnimationOptions(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3175]; 주면 명령 본문은 아무것도 안 하고 끝난다, 대신 $animate 미들웨어가 애니메이션으로 바꾼다 [src:math3d/src/app/math3d/command-manager/command-manager.ts:101-141]; 생략하면 본문이 바로 바꾼다 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3177]",
    "조용히 끝남(아무것도 안 함): !object || payload.animate 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3177]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.setMovable",
   "command": "object.setMovable",
   "params": [
    {
     "name": "id",
     "type": "ref",
     "optional": false,
     "accepts": "any"
    },
    {
     "name": "isMovable",
     "type": "boolean",
     "optional": false
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.setMovable\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3182-3187]",
    "앞에 있어야 하는 것: id = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3182-3187]",
    "바꾸는 속성: isMovable [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3186]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "id: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3182]",
    "isMovable: 형식 boolean(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3182]",
    "조용히 끝남(아무것도 안 함): !object 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3184]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.setLinearWidth",
   "command": "object.setLinearWidth",
   "params": [
    {
     "name": "id",
     "type": "ref",
     "optional": false,
     "accepts": "any"
    },
    {
     "name": "lineWidth",
     "type": "number",
     "optional": false
    },
    {
     "name": "animate",
     "type": "enum:AnimationOptions",
     "optional": true
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.setLinearWidth\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3189-3193]",
    "앞에 있어야 하는 것: id = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3189-3193]",
    "본문이 확인하는 종류: linear, decoration, circular [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3189-3193]",
    "바꾸는 속성: lineWidth [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3192]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "id: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3189]",
    "lineWidth: 형식 number(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3189]",
    "animate?: 형식 enum:AnimationOptions(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3189]; 주면 명령 본문은 아무것도 안 하고 끝난다, 대신 $animate 미들웨어가 애니메이션으로 바꾼다 [src:math3d/src/app/math3d/command-manager/command-manager.ts:101-141]; 생략하면 본문이 바로 바꾼다 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3191]",
    "조용히 끝남(아무것도 안 함): (!isObjectType(linear, \"linear\") && !isObjectType(linear, \"decoration\") && !isObjectType(… 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3191]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.setLinearDashed",
   "command": "object.setLinearDashed",
   "params": [
    {
     "name": "id",
     "type": "ref",
     "optional": false,
     "accepts": "any"
    },
    {
     "name": "dashed",
     "type": "boolean",
     "optional": false
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.setLinearDashed\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3195-3199]",
    "앞에 있어야 하는 것: id = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3195-3199]",
    "본문이 확인하는 종류: linear, decoration, circular [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3195-3199]",
    "바꾸는 속성: dashed [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3198]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "id: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3195]",
    "dashed: 형식 boolean(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3195]",
    "조용히 끝남(아무것도 안 함): !isObjectType(linear, \"linear\") && !isObjectType(linear, \"decoration\") && !isObjectType(l… 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3197]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.setOpacity",
   "command": "object.setOpacity",
   "params": [
    {
     "name": "id",
     "type": "ref",
     "optional": false,
     "accepts": "any"
    },
    {
     "name": "opacity",
     "type": "number",
     "optional": false
    },
    {
     "name": "animate",
     "type": "enum:AnimationOptions",
     "optional": true
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.setOpacity\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3201-3206]",
    "앞에 있어야 하는 것: id = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3201-3206]",
    "바꾸는 속성: opacity [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3205]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "id: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3201]",
    "opacity: 형식 number(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3201]",
    "animate?: 형식 enum:AnimationOptions(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3201]; 주면 명령 본문은 아무것도 안 하고 끝난다, 대신 $animate 미들웨어가 애니메이션으로 바꾼다 [src:math3d/src/app/math3d/command-manager/command-manager.ts:101-141]; 생략하면 본문이 바로 바꾼다 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3203]",
    "조용히 끝남(아무것도 안 함): !object || payload.animate 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3203]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.setName",
   "command": "object.setName",
   "params": [
    {
     "name": "id",
     "type": "ref",
     "optional": false,
     "accepts": "any"
    },
    {
     "name": "name",
     "type": "string",
     "optional": false
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.setName\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3208-3213]",
    "앞에 있어야 하는 것: id = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3208-3213]",
    "바꾸는 속성: name [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3212]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "id: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3208]",
    "name: 형식 string(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3208]",
    "조용히 끝남(아무것도 안 함): !object 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3210]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.setGridXVisible",
   "command": "object.setGridXVisible",
   "params": [
    {
     "name": "id",
     "type": "ref",
     "optional": false,
     "accepts": "any"
    },
    {
     "name": "visible",
     "type": "boolean",
     "optional": false
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.setGridXVisible\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3215-3219]",
    "앞에 있어야 하는 것: id = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3215-3219]",
    "본문이 확인하는 종류: algebraic [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3215-3219]",
    "바꾸는 속성: gridXVisible [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3218]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "id: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3215]",
    "visible: 형식 boolean(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3215]",
    "조용히 끝남(아무것도 안 함): !isObjectType(algebraic, \"algebraic\") 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3217]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.setGridXColor",
   "command": "object.setGridXColor",
   "params": [
    {
     "name": "id",
     "type": "ref",
     "optional": false,
     "accepts": "any"
    },
    {
     "name": "color",
     "type": "color",
     "optional": false
    },
    {
     "name": "animate",
     "type": "enum:AnimationOptions",
     "optional": true
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.setGridXColor\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3221-3225]",
    "앞에 있어야 하는 것: id = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3221-3225]",
    "본문이 확인하는 종류: algebraic [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3221-3225]",
    "바꾸는 속성: gridXColor [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3224]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "id: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3221]",
    "color: 형식 color(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3221]",
    "animate?: 형식 enum:AnimationOptions(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3221]; 주면 명령 본문은 아무것도 안 하고 끝난다, 대신 $animate 미들웨어가 애니메이션으로 바꾼다 [src:math3d/src/app/math3d/command-manager/command-manager.ts:101-141]; 생략하면 본문이 바로 바꾼다 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3223]",
    "조용히 끝남(아무것도 안 함): !isObjectType(algebraic, \"algebraic\") || payload.animate 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3223]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.setGridYVisible",
   "command": "object.setGridYVisible",
   "params": [
    {
     "name": "id",
     "type": "ref",
     "optional": false,
     "accepts": "any"
    },
    {
     "name": "visible",
     "type": "boolean",
     "optional": false
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.setGridYVisible\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3227-3231]",
    "앞에 있어야 하는 것: id = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3227-3231]",
    "본문이 확인하는 종류: algebraic [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3227-3231]",
    "바꾸는 속성: gridYVisible [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3230]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "id: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3227]",
    "visible: 형식 boolean(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3227]",
    "조용히 끝남(아무것도 안 함): !isObjectType(algebraic, \"algebraic\") 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3229]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.setGridYColor",
   "command": "object.setGridYColor",
   "params": [
    {
     "name": "id",
     "type": "ref",
     "optional": false,
     "accepts": "any"
    },
    {
     "name": "color",
     "type": "color",
     "optional": false
    },
    {
     "name": "animate",
     "type": "enum:AnimationOptions",
     "optional": true
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.setGridYColor\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3233-3237]",
    "앞에 있어야 하는 것: id = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3233-3237]",
    "본문이 확인하는 종류: algebraic [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3233-3237]",
    "바꾸는 속성: gridYColor [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3236]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "id: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3233]",
    "color: 형식 color(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3233]",
    "animate?: 형식 enum:AnimationOptions(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3233]; 주면 명령 본문은 아무것도 안 하고 끝난다, 대신 $animate 미들웨어가 애니메이션으로 바꾼다 [src:math3d/src/app/math3d/command-manager/command-manager.ts:101-141]; 생략하면 본문이 바로 바꾼다 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3235]",
    "조용히 끝남(아무것도 안 함): !isObjectType(algebraic, \"algebraic\") || payload.animate 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3235]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.setLabelCaption",
   "command": "object.setLabelCaption",
   "params": [
    {
     "name": "id",
     "type": "ref",
     "optional": false,
     "accepts": "any"
    },
    {
     "name": "caption",
     "type": "string",
     "optional": false
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.setLabelCaption\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3239-3243]",
    "앞에 있어야 하는 것: id = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3239-3243]",
    "바꾸는 속성: label [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3242]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "id: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3239]",
    "caption: 형식 string(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3239]",
    "조용히 끝남(아무것도 안 함): !object 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3241]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.setLabelSize",
   "command": "object.setLabelSize",
   "params": [
    {
     "name": "id",
     "type": "ref",
     "optional": false,
     "accepts": "any"
    },
    {
     "name": "size",
     "type": "number",
     "optional": false
    },
    {
     "name": "animate",
     "type": "enum:AnimationOptions",
     "optional": true
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.setLabelSize\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3245-3249]",
    "앞에 있어야 하는 것: id = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3245-3249]",
    "바꾸는 속성: label [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3248]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "id: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3245]",
    "size: 형식 number(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3245]",
    "animate?: 형식 enum:AnimationOptions(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3245]; 주면 명령 본문은 아무것도 안 하고 끝난다, 대신 $animate 미들웨어가 애니메이션으로 바꾼다 [src:math3d/src/app/math3d/command-manager/command-manager.ts:101-141]; 생략하면 본문이 바로 바꾼다 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3247]",
    "조용히 끝남(아무것도 안 함): !object || payload.animate 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3247]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.setLabelVisible",
   "command": "object.setLabelVisible",
   "params": [
    {
     "name": "id",
     "type": "ref",
     "optional": false,
     "accepts": "any"
    },
    {
     "name": "visible",
     "type": "boolean",
     "optional": false
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도(도구 UI 설명): 라벨 숨기기/보이기 — 라벨을 숨길 대상을 선택하세요. [src:math3d-ui/src/app/components/tabs/geometry/config.ts:111]",
    "호출: commandManager.execute(\"object.setLabelVisible\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3251-3255]",
    "앞에 있어야 하는 것: id = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3251-3255]",
    "바꾸는 속성: label [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3254]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "id: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3251]",
    "visible: 형식 boolean(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3251]",
    "조용히 끝남(아무것도 안 함): !object 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3253]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.setLabelVisibleType",
   "command": "object.setLabelVisibleType",
   "params": [
    {
     "name": "id",
     "type": "ref",
     "optional": false,
     "accepts": "any"
    },
    {
     "name": "visibleType",
     "type": "'name'|'name-value'|'value'|'caption'|'caption-value'",
     "optional": false
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.setLabelVisibleType\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3257-3261]",
    "앞에 있어야 하는 것: id = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3257-3261]",
    "바꾸는 속성: label [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3260]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "id: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3257]",
    "visibleType: 형식 'name'|'name-value'|'value'|'caption'|'caption-value'(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3257]",
    "조용히 끝남(아무것도 안 함): !object 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3259]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.setLabelColor",
   "command": "object.setLabelColor",
   "params": [
    {
     "name": "id",
     "type": "ref",
     "optional": false,
     "accepts": "any"
    },
    {
     "name": "color",
     "type": "color",
     "optional": false
    },
    {
     "name": "animate",
     "type": "enum:AnimationOptions",
     "optional": true
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.setLabelColor\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3263-3267]",
    "앞에 있어야 하는 것: id = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3263-3267]",
    "바꾸는 속성: label [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3266]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "id: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3263]",
    "color: 형식 color(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3263]",
    "animate?: 형식 enum:AnimationOptions(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3263]; 주면 명령 본문은 아무것도 안 하고 끝난다, 대신 $animate 미들웨어가 애니메이션으로 바꾼다 [src:math3d/src/app/math3d/command-manager/command-manager.ts:101-141]; 생략하면 본문이 바로 바꾼다 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3265]",
    "조용히 끝남(아무것도 안 함): !object || payload.animate 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3265]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.setSphereRadius",
   "command": "object.setSphereRadius",
   "params": [
    {
     "name": "id",
     "type": "ref",
     "optional": false,
     "accepts": "any"
    },
    {
     "name": "radius",
     "type": "number|string",
     "optional": false
    },
    {
     "name": "animate",
     "type": "enum:AnimationOptions",
     "optional": true
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.setSphereRadius\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3269-3274]",
    "앞에 있어야 하는 것: id = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3269-3274]",
    "본문이 확인하는 종류: sphere [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3269-3274]",
    "바꾸는 속성: radius, expressionProperty [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3273]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "id: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3269]",
    "radius: 형식 number|string(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3269]; 문자열이면 슬라이더 변수식으로 계산된다 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3269]",
    "animate?: 형식 enum:AnimationOptions(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3269]; 주면 명령 본문은 아무것도 안 하고 끝난다, 대신 $animate 미들웨어가 애니메이션으로 바꾼다 [src:math3d/src/app/math3d/command-manager/command-manager.ts:101-141]; 생략하면 본문이 바로 바꾼다 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3271]",
    "조용히 끝남(아무것도 안 함): !isObjectType(sphere, \"sphere\") || sphere.category === \"sphereFromCenterAndPoint\" || payl… 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3271]"
   ]
  },
  {
   "tool": "math3d",
   "backend": "command",
   "name": "object.setCylindroconicalRadius",
   "command": "object.setCylindroconicalRadius",
   "params": [
    {
     "name": "id",
     "type": "ref",
     "optional": false,
     "accepts": "any"
    },
    {
     "name": "radius",
     "type": "number|string",
     "optional": false
    },
    {
     "name": "animate",
     "type": "enum:AnimationOptions",
     "optional": true
    }
   ],
   "source": "object.cmd.ts",
   "usage": [
    "용도: 원천 근거 없음(미확인)",
    "호출: commandManager.execute(\"object.setCylindroconicalRadius\", payload) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3276-3281]",
    "앞에 있어야 하는 것: id = 아무 개체 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3276-3281]",
    "본문이 확인하는 종류: cylindroconical [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3276-3281]",
    "바꾸는 속성: radius, expressionProperty [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3280]"
   ],
   "range": [
    "payload 형식은 실행 시 검사하지 않는다(명령 존재만 검사, 미들웨어는 $animate 하나) [src:math3d/src/app/math3d/command-manager/command-manager.ts:34-45] [src:math3d/src/app/math3d/command-manager/command-manager.ts:101]",
    "id: 형식 ref(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3276]",
    "radius: 형식 number|string(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3276]; 문자열이면 슬라이더 변수식으로 계산된다 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3276]",
    "animate?: 형식 enum:AnimationOptions(TS 선언) [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3276]; 주면 명령 본문은 아무것도 안 하고 끝난다, 대신 $animate 미들웨어가 애니메이션으로 바꾼다 [src:math3d/src/app/math3d/command-manager/command-manager.ts:101-141]; 생략하면 본문이 바로 바꾼다 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3278]",
    "조용히 끝남(아무것도 안 함): !isObjectType(cylindroconical, \"cylindroconical\") || payload.animate 이면 반환 [src:math3d/src/app/math3d/command-manager/commands/object.cmd.ts:3278]"
   ]
  }
 ]
}
